import { jsx as e, jsxs as t, Fragment as me } from "react/jsx-runtime";
import { C as ne } from "./Card-1TvXi1hD.js";
import { B as u, I as ue } from "./Input-s7q1Bymv.js";
import { B as ae } from "./Badge-CljJSGSb.js";
import { A as je } from "./Avatar-BzalLvjS.js";
import { T as a } from "./Typography-DjQwU5Xn.js";
import { c as l } from "./classnames-DLUjLwnh.js";
import "isomorphic-dompurify";
import "./deprecation-Hz1LRzMC.js";
import { X as he } from "./x-5QknLR1d.js";
import { C as fe } from "./check-CVfLJTWr.js";
import { a as Le, b as Me, T as Re, d as Ke, Z as Be, C as Et, e as Lt, G as dt, M as wa, P as la, c as ka, S as Ca } from "./zap-CrDt2RgH.js";
import { E as Ma, b as gt, G as ot, C as vt, a as za, A as ja } from "./grid-3x3-D_KKntnt.js";
import { c as J } from "./createLucideIcon-OVU-vHz1.js";
import Ae, { useState as P, useCallback as te, useRef as Ee, useEffect as qe, useMemo as Ce } from "react";
import { U as lt } from "./upload-rP6dtNbf.js";
import { S as we, L as ye } from "./search-B4CsPni9.js";
import { T as ze } from "./triangle-alert-BRauxpWT.js";
import { C as Ie } from "./chevron-up-Bxd1ocyl.js";
import { C as xe } from "./chevron-down-CAS1zUor.js";
import { P as Pe } from "./plus-B9IpBnee.js";
import { C as Ne } from "./chevron-right-RGp43GeY.js";
import { a as Oe, S as Tt } from "./settings-DDvWy7ax.js";
import { B as We } from "./bell-CKvlyBv5.js";
import { a as $e, L as Pt, S as Ue, C as Ht, F as Kt } from "./star-DOuYjd62.js";
import { L as ia } from "./list-C0p4YHSI.js";
import { C as He } from "./Checkbox-CdsRlkOT.js";
import { P as na } from "./Progress-C8VQkpiO.js";
import { C as Ft, B as Vt } from "./corner-down-left-BKmjNWYn.js";
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Aa = [
  ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8", key: "1s80jp" }],
  ["path", { d: "M10 12h4", key: "a56b0p" }]
], $a = J("archive", Aa);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _a = [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M11 4h10", key: "1w87gc" }],
  ["path", { d: "M11 8h7", key: "djye34" }],
  ["path", { d: "M11 12h4", key: "q8tih4" }]
], Ta = J("arrow-down-wide-narrow", _a);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sa = [
  ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
  ["path", { d: "M19 12H5", key: "x3x0zl" }]
], ca = J("arrow-left", Sa);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Da = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }]
], Fe = J("arrow-right", Da);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ea = [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M11 12h4", key: "q8tih4" }],
  ["path", { d: "M11 16h7", key: "uosisv" }],
  ["path", { d: "M11 20h10", key: "jvxblo" }]
], La = J("arrow-up-narrow-wide", Ea);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pa = [
  ["path", { d: "M7 7h10v10", key: "1tivn9" }],
  ["path", { d: "M7 17 17 7", key: "1vkiza" }]
], Ha = J("arrow-up-right", Pa);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qa = [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  [
    "path",
    {
      d: "M17 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 .258-1.742",
      key: "178tsu"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M8.668 3.01A6 6 0 0 1 18 8c0 2.687.77 4.653 1.707 6.05", key: "1hqiys" }]
], da = J("bell-off", qa);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ia = [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }]
], Oa = J("bookmark", Ia);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ra = [
  ["path", { d: "M12 20v-9", key: "1qisl0" }],
  ["path", { d: "M14 7a4 4 0 0 1 4 4v3a6 6 0 0 1-12 0v-3a4 4 0 0 1 4-4z", key: "uouzyp" }],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M21 21a4 4 0 0 0-3.81-4", key: "1b0z45" }],
  ["path", { d: "M21 5a4 4 0 0 1-3.55 3.97", key: "5cxbf6" }],
  ["path", { d: "M22 13h-4", key: "1jl80f" }],
  ["path", { d: "M3 21a4 4 0 0 1 3.81-4", key: "1fjd4g" }],
  ["path", { d: "M3 5a4 4 0 0 0 3.55 3.97", key: "1d7oge" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "m8 2 1.88 1.88", key: "fmnt4t" }],
  ["path", { d: "M9 7.13V6a3 3 0 1 1 6 0v1.13", key: "1vgav8" }]
], Ka = J("bug", Ra);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fa = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M16 14h.01", key: "1gbofw" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M16 18h.01", key: "kzsmim" }]
], Va = J("calendar-days", Fa);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ua = [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "m19 9-5 5-4-4-3 3", key: "2osh9i" }]
], Ut = J("chart-line", Ua);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ba = [
  ["path", { d: "M5 21v-6", key: "1hz6c0" }],
  ["path", { d: "M12 21V3", key: "1lcnhd" }],
  ["path", { d: "M19 21V9", key: "unv183" }]
], Wa = J("chart-no-axes-column", Ba);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ya = [
  [
    "path",
    {
      d: "M21 12c.552 0 1.005-.449.95-.998a10 10 0 0 0-8.953-8.951c-.55-.055-.998.398-.998.95v8a1 1 0 0 0 1 1z",
      key: "pzmjnu"
    }
  ],
  ["path", { d: "M21.21 15.89A10 10 0 1 1 8 2.83", key: "k2fpak" }]
], Bt = J("chart-pie", Ya);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qa = [
  ["path", { d: "M18 6 7 17l-5-5", key: "116fxf" }],
  ["path", { d: "m22 10-7.5 7.5L13 16", key: "ke71qq" }]
], Ga = J("check-check", Qa);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ja = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], Ye = J("circle-check", Ja);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xa = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], oa = J("circle-question-mark", Xa);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Za = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["rect", { x: "9", y: "9", width: "6", height: "6", rx: "1", key: "1ssd4o" }]
], er = J("circle-stop", Za);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tr = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
], et = J("circle-x", tr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ar = [
  [
    "path",
    { d: "M15 6v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3", key: "11bfej" }
  ]
], it = J("command", ar);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rr = [
  ["rect", { width: "20", height: "14", x: "2", y: "5", rx: "2", key: "ynyp8z" }],
  ["line", { x1: "2", x2: "22", y1: "10", y2: "10", key: "1b3vmo" }]
], Wt = J("credit-card", rr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sr = [
  [
    "path",
    {
      d: "M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z",
      key: "1vdc57"
    }
  ],
  ["path", { d: "M5 21h14", key: "11awu3" }]
], lr = J("crown", sr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ir = [
  [
    "path",
    {
      d: "M10 5a2 2 0 0 0-1.344.519l-6.328 5.74a1 1 0 0 0 0 1.481l6.328 5.741A2 2 0 0 0 10 19h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z",
      key: "1yo7s0"
    }
  ],
  ["path", { d: "m12 9 6 6", key: "anjzzh" }],
  ["path", { d: "m18 9-6 6", key: "1fp51s" }]
], nr = J("delete", ir);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cr = [
  ["path", { d: "M12 15V3", key: "m9g1x1" }],
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["path", { d: "m7 10 5 5 5-5", key: "brsn70" }]
], _e = J("download", cr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dr = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
], qt = J("ellipsis-vertical", dr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const or = [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "M10 14 21 3", key: "gplh6r" }],
  ["path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6", key: "a6xqqp" }]
], at = J("external-link", or);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mr = [
  [
    "path",
    {
      d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
      key: "ct8e1f"
    }
  ],
  ["path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242", key: "151rxh" }],
  [
    "path",
    {
      d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
      key: "13bj9a"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], It = J("eye-off", mr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hr = [
  [
    "path",
    {
      d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
      key: "1nclc0"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], Ve = J("eye", hr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ur = [
  [
    "path",
    {
      d: "M13.659 22H18a2 2 0 0 0 2-2V8a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 14 2H6a2 2 0 0 0-2 2v11.5",
      key: "4pqfef"
    }
  ],
  ["path", { d: "M14 2v5a1 1 0 0 0 1 1h5", key: "wfsgrz" }],
  ["path", { d: "M8 12v-1", key: "1ej8lb" }],
  ["path", { d: "M8 18v-2", key: "qcmpov" }],
  ["path", { d: "M8 7V6", key: "1nbb54" }],
  ["circle", { cx: "8", cy: "20", r: "2", key: "ckkr5m" }]
], pr = J("file-archive", ur);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fr = [
  [
    "path",
    {
      d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
      key: "1oefj6"
    }
  ],
  ["path", { d: "M14 2v5a1 1 0 0 0 1 1h5", key: "wfsgrz" }],
  [
    "path",
    { d: "M10 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1", key: "1oajmo" }
  ],
  [
    "path",
    { d: "M14 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1", key: "mpwhp6" }
  ]
], gr = J("file-braces", fr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vr = [
  [
    "path",
    {
      d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
      key: "1oefj6"
    }
  ],
  ["path", { d: "M14 2v5a1 1 0 0 0 1 1h5", key: "wfsgrz" }],
  ["path", { d: "M10 12.5 8 15l2 2.5", key: "1tg20x" }],
  ["path", { d: "m14 12.5 2 2.5-2 2.5", key: "yinavb" }]
], xr = J("file-code", vr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nr = [
  [
    "path",
    {
      d: "M4 6.835V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2h-.343",
      key: "1vfytu"
    }
  ],
  ["path", { d: "M14 2v5a1 1 0 0 0 1 1h5", key: "wfsgrz" }],
  [
    "path",
    {
      d: "M2 19a2 2 0 0 1 4 0v1a2 2 0 0 1-4 0v-4a6 6 0 0 1 12 0v4a2 2 0 0 1-4 0v-1a2 2 0 0 1 4 0",
      key: "1etmh7"
    }
  ]
], br = J("file-headphone", Nr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yr = [
  [
    "path",
    {
      d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
      key: "1oefj6"
    }
  ],
  ["path", { d: "M14 2v5a1 1 0 0 0 1 1h5", key: "wfsgrz" }],
  ["circle", { cx: "10", cy: "12", r: "2", key: "737tya" }],
  ["path", { d: "m20 17-1.296-1.296a2.41 2.41 0 0 0-3.408 0L9 22", key: "wt3hpn" }]
], ma = J("file-image", yr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wr = [
  [
    "path",
    {
      d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
      key: "1oefj6"
    }
  ],
  ["path", { d: "M14 2v5a1 1 0 0 0 1 1h5", key: "wfsgrz" }],
  [
    "path",
    {
      d: "M15.033 13.44a.647.647 0 0 1 0 1.12l-4.065 2.352a.645.645 0 0 1-.968-.56v-4.704a.645.645 0 0 1 .967-.56z",
      key: "1tzo1f"
    }
  ]
], kr = J("file-play", wr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cr = [
  [
    "path",
    {
      d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
      key: "1oefj6"
    }
  ],
  ["path", { d: "M14 2v5a1 1 0 0 0 1 1h5", key: "wfsgrz" }],
  ["path", { d: "M8 13h2", key: "yr2amv" }],
  ["path", { d: "M14 13h2", key: "un5t4a" }],
  ["path", { d: "M8 17h2", key: "2yhykz" }],
  ["path", { d: "M14 17h2", key: "10kma7" }]
], mt = J("file-spreadsheet", Cr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mr = [
  [
    "path",
    {
      d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
      key: "1oefj6"
    }
  ],
  ["path", { d: "M14 2v5a1 1 0 0 0 1 1h5", key: "wfsgrz" }],
  ["path", { d: "M10 9H8", key: "b1mrlr" }],
  ["path", { d: "M16 13H8", key: "t4e002" }],
  ["path", { d: "M16 17H8", key: "z1uh3a" }]
], rt = J("file-text", Mr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zr = [
  [
    "path",
    {
      d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
      key: "1oefj6"
    }
  ],
  ["path", { d: "M14 2v5a1 1 0 0 0 1 1h5", key: "wfsgrz" }]
], ha = J("file", zr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jr = [
  [
    "path",
    {
      d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
      key: "usdka0"
    }
  ]
], ua = J("folder-open", jr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ar = [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ]
], pa = J("folder", Ar);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $r = [
  [
    "path",
    {
      d: "M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z",
      key: "sc7q7i"
    }
  ]
], Je = J("funnel", $r);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _r = [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["line", { x1: "3", x2: "9", y1: "12", y2: "12", key: "1dyftd" }],
  ["line", { x1: "15", x2: "21", y1: "12", y2: "12", key: "oup4p8" }]
], fa = J("git-commit-horizontal", _r);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tr = [
  [
    "path",
    {
      d: "M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5",
      key: "mvr1a0"
    }
  ]
], Sr = J("heart", Tr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dr = [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["path", { d: "M12 7v5l4 2", key: "1fdv2h" }]
], Ge = J("history", Dr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Er = [
  ["path", { d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8", key: "5wwlr5" }],
  [
    "path",
    {
      d: "M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
      key: "r6nss1"
    }
  ]
], Lr = J("house", Er);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pr = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
], St = J("image", Pr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hr = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
], Dt = J("info", Hr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qr = [
  ["path", { d: "m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4", key: "g0fldk" }],
  ["path", { d: "m21 2-9.6 9.6", key: "1j0ho8" }],
  ["circle", { cx: "7.5", cy: "15.5", r: "5.5", key: "yqb3hr" }]
], nt = J("key", qr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ir = [
  ["path", { d: "M10 8h.01", key: "1r9ogq" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M14 8h.01", key: "1primd" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }],
  ["path", { d: "M18 8h.01", key: "emo2bl" }],
  ["path", { d: "M6 8h.01", key: "x9i8wu" }],
  ["path", { d: "M7 16h10", key: "wp8him" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }]
], Yt = J("keyboard", Ir);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Or = [
  [
    "path",
    {
      d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5",
      key: "1gvzjb"
    }
  ],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["path", { d: "M10 22h4", key: "ceow96" }]
], Rr = J("lightbulb", Or);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kr = [
  ["path", { d: "M9 17H7A5 5 0 0 1 7 7h2", key: "8i5ue5" }],
  ["path", { d: "M15 7h2a5 5 0 1 1 0 10h-2", key: "1b9ql8" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
], ht = J("link-2", Kr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fr = [
  [
    "path",
    {
      d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z",
      key: "c2jq9f"
    }
  ],
  ["rect", { width: "4", height: "12", x: "2", y: "9", key: "mk3on5" }],
  ["circle", { cx: "4", cy: "4", r: "2", key: "bt5ra8" }]
], Vr = J("linkedin", Fr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ur = [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 9.9-1", key: "1mm8w8" }]
], ga = J("lock-open", Ur);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Br = [
  ["path", { d: "m16 17 5-5-5-5", key: "1bji2h" }],
  ["path", { d: "M21 12H9", key: "dn1m92" }],
  ["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", key: "1uf3rs" }]
], Wr = J("log-out", Br);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yr = [
  ["path", { d: "m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7", key: "132q7q" }],
  ["rect", { x: "2", y: "4", width: "20", height: "16", rx: "2", key: "izxlao" }]
], xt = J("mail", Yr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qr = [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }]
], Gr = J("map-pin", Qr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jr = [
  [
    "path",
    {
      d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
      key: "1sd12s"
    }
  ]
], Xr = J("message-circle", Jr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zr = [
  [
    "path",
    {
      d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
      key: "18887p"
    }
  ]
], ut = J("message-square", Zr);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const es = [
  ["path", { d: "M12 19v3", key: "npa21l" }],
  ["path", { d: "M15 9.34V5a3 3 0 0 0-5.68-1.33", key: "1gzdoj" }],
  ["path", { d: "M16.95 16.95A7 7 0 0 1 5 12v-2", key: "cqa7eg" }],
  ["path", { d: "M18.89 13.23A7 7 0 0 0 19 12v-2", key: "16hl24" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M9 9v3a3 3 0 0 0 5.12 2.12", key: "r2i35w" }]
], ts = J("mic-off", es);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const as = [
  ["path", { d: "M12 19v3", key: "npa21l" }],
  ["path", { d: "M19 10v2a7 7 0 0 1-14 0v-2", key: "1vc78b" }],
  ["rect", { x: "9", y: "2", width: "6", height: "13", rx: "3", key: "s6n7sd" }]
], rs = J("mic", as);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ss = [["path", { d: "M5 12h14", key: "1ays0h" }]], va = J("minus", ss);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ls = [
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["line", { x1: "8", x2: "16", y1: "21", y2: "21", key: "1svkeh" }],
  ["line", { x1: "12", x2: "12", y1: "17", y2: "21", key: "vw1qmm" }]
], xa = J("monitor", ls);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const is = [
  [
    "path",
    {
      d: "M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401",
      key: "kfwtm"
    }
  ]
], ns = J("moon", is);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cs = [
  [
    "path",
    {
      d: "M4.037 4.688a.495.495 0 0 1 .651-.651l16 6.5a.5.5 0 0 1-.063.947l-6.124 1.58a2 2 0 0 0-1.438 1.435l-1.579 6.126a.5.5 0 0 1-.947.063z",
      key: "edeuup"
    }
  ]
], ds = J("mouse-pointer-2", cs);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const os = [
  [
    "path",
    {
      d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z",
      key: "1a0edw"
    }
  ],
  ["path", { d: "M12 22V12", key: "d0xqtd" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }]
], ms = J("package", os);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hs = [
  [
    "path",
    {
      d: "M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z",
      key: "e79jfc"
    }
  ],
  ["circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor", key: "1okk4w" }],
  ["circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor", key: "f64h9f" }],
  ["circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor", key: "qy21gx" }],
  ["circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor", key: "fotxhn" }]
], us = J("palette", hs);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ps = [
  [
    "path",
    {
      d: "m16 6-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551",
      key: "1miecu"
    }
  ]
], kt = J("paperclip", ps);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fs = [
  ["path", { d: "M13 21h8", key: "1jsn5i" }],
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ]
], gs = J("pen-line", fs);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vs = [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ]
], xs = J("pen", vs);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ns = [
  ["path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8", key: "v9h5vc" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16", key: "3uifl3" }],
  ["path", { d: "M8 16H3v5", key: "1cv678" }]
], Xe = J("refresh-cw", Ns);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bs = [
  [
    "path",
    {
      d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z",
      key: "m3kijz"
    }
  ],
  [
    "path",
    {
      d: "m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z",
      key: "1fmvmk"
    }
  ],
  ["path", { d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0", key: "1f8sc4" }],
  ["path", { d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5", key: "qeys4" }]
], ys = J("rocket", bs);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ws = [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }]
], Qe = J("rotate-ccw", ws);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ks = [
  [
    "path",
    {
      d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
      key: "1ffxy3"
    }
  ],
  ["path", { d: "m21.854 2.147-10.94 10.939", key: "12cjpa" }]
], tt = J("send", ks);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cs = [
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }],
  ["circle", { cx: "6", cy: "12", r: "3", key: "w7nqdw" }],
  ["circle", { cx: "18", cy: "19", r: "3", key: "1xt0gg" }],
  ["line", { x1: "8.59", x2: "15.42", y1: "13.51", y2: "17.49", key: "47mynk" }],
  ["line", { x1: "15.41", x2: "8.59", y1: "6.51", y2: "10.49", key: "1n3mei" }]
], ct = J("share-2", Cs);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ms = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  ["path", { d: "M12 16h.01", key: "1drbdi" }]
], zs = J("shield-alert", Ms);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const js = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], As = J("shield-check", js);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $s = [
  ["rect", { width: "3", height: "8", x: "13", y: "2", rx: "1.5", key: "diqz80" }],
  ["path", { d: "M19 8.5V10h1.5A1.5 1.5 0 1 0 19 8.5", key: "183iwg" }],
  ["rect", { width: "3", height: "8", x: "8", y: "14", rx: "1.5", key: "hqg7r1" }],
  ["path", { d: "M5 15.5V14H3.5A1.5 1.5 0 1 0 5 15.5", key: "76g71w" }],
  ["rect", { width: "8", height: "3", x: "14", y: "13", rx: "1.5", key: "1kmz0a" }],
  ["path", { d: "M15.5 19H14v1.5a1.5 1.5 0 1 0 1.5-1.5", key: "jc4sz0" }],
  ["rect", { width: "8", height: "3", x: "2", y: "8", rx: "1.5", key: "1omvl4" }],
  ["path", { d: "M8.5 5H10V3.5A1.5 1.5 0 1 0 8.5 5", key: "16f3cl" }]
], _s = J("slack", $s);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ts = [
  ["path", { d: "M10 5H3", key: "1qgfaw" }],
  ["path", { d: "M12 19H3", key: "yhmn1j" }],
  ["path", { d: "M14 3v4", key: "1sua03" }],
  ["path", { d: "M16 17v4", key: "1q0r14" }],
  ["path", { d: "M21 12h-9", key: "1o4lsq" }],
  ["path", { d: "M21 19h-5", key: "1rlt1p" }],
  ["path", { d: "M21 5h-7", key: "1oszz2" }],
  ["path", { d: "M8 10v4", key: "tgpxqk" }],
  ["path", { d: "M8 12H3", key: "a7s4jb" }]
], Ss = J("sliders-horizontal", Ts);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ds = [
  [
    "path",
    {
      d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
      key: "1s2grr"
    }
  ],
  ["path", { d: "M20 2v4", key: "1rf3ol" }],
  ["path", { d: "M22 4h-4", key: "gwowj6" }],
  ["circle", { cx: "4", cy: "20", r: "2", key: "6kqj1y" }]
], Te = J("sparkles", Ds);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Es = [
  ["path", { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7", key: "1m0v6g" }],
  [
    "path",
    {
      d: "M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z",
      key: "ohrbg2"
    }
  ]
], Na = J("square-pen", Es);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ls = [
  ["path", { d: "M8.34 8.34 2 9.27l5 4.87L5.82 21 12 17.77 18.18 21l-.59-3.43", key: "16m0ql" }],
  ["path", { d: "M18.42 12.76 22 9.27l-6.91-1L12 2l-1.44 2.91", key: "1vt8nq" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
], Ot = J("star-off", Ls);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ps = [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "m17.66 17.66 1.41 1.41", key: "ptbguv" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m6.34 17.66-1.41 1.41", key: "1m8zz5" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }]
], Hs = J("sun", Ps);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qs = [
  [
    "path",
    {
      d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z",
      key: "vktsd0"
    }
  ],
  ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" }]
], st = J("tag", qs);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Is = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
], Os = J("target", Is);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rs = [
  [
    "path",
    {
      d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z",
      key: "m61m77"
    }
  ],
  ["path", { d: "M17 14V2", key: "8ymqnk" }]
], Rt = J("thumbs-down", Rs);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ks = [
  [
    "path",
    {
      d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z",
      key: "emmmcr"
    }
  ],
  ["path", { d: "M7 10v12", key: "1qc93n" }]
], pt = J("thumbs-up", Ks);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fs = [
  ["path", { d: "M16 17h6v-6", key: "t6n2it" }],
  ["path", { d: "m22 17-8.5-8.5-5 5L2 7", key: "x473p" }]
], Vs = J("trending-down", Fs);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Us = [
  ["path", { d: "M16 7h6v6", key: "box55l" }],
  ["path", { d: "m22 7-8.5 8.5-5-5L2 17", key: "1t1m79" }]
], Nt = J("trending-up", Us);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bs = [
  [
    "path",
    {
      d: "M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z",
      key: "pff0z6"
    }
  ]
], Ws = J("twitter", Bs);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ys = [
  ["path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2", key: "975kel" }],
  ["circle", { cx: "12", cy: "7", r: "4", key: "17ys0d" }]
], ft = J("user", Ys);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qs = [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["path", { d: "M16 3.128a4 4 0 0 1 0 7.744", key: "16gr8j" }],
  ["path", { d: "M22 21v-2a4 4 0 0 0-3-3.87", key: "kshegd" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }]
], Se = J("users", Qs);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gs = [
  [
    "path",
    {
      d: "m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5",
      key: "ftymec"
    }
  ],
  ["rect", { x: "2", y: "6", width: "14", height: "12", rx: "2", key: "158x01" }]
], Js = J("video", Gs);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xs = [
  [
    "path",
    {
      d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72",
      key: "ul74o6"
    }
  ],
  ["path", { d: "m14 7 3 3", key: "1r5n42" }],
  ["path", { d: "M5 6v4", key: "ilb8ba" }],
  ["path", { d: "M19 14v4", key: "blhpug" }],
  ["path", { d: "M10 2v2", key: "7u0qdc" }],
  ["path", { d: "M7 8H3", key: "zfb6yr" }],
  ["path", { d: "M21 16h-4", key: "1cnmox" }],
  ["path", { d: "M11 3H9", key: "1obp7u" }]
], ba = J("wand-sparkles", Xs);
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zs = [
  [
    "path",
    {
      d: "M18 16.98h-5.99c-1.1 0-1.95.94-2.48 1.9A4 4 0 0 1 2 17c.01-.7.2-1.4.57-2",
      key: "q3hayz"
    }
  ],
  ["path", { d: "m6 17 3.13-5.78c.53-.97.1-2.18-.5-3.1a4 4 0 1 1 6.89-4.06", key: "1go1hn" }],
  ["path", { d: "m12 6 3.13 5.73C15.66 12.7 16.9 13 18 13a4 4 0 0 1 0 8", key: "qlwsc0" }]
], Ct = J("webhook", Zs), el = {
  pending: { label: "Pending", variant: "yellow", icon: /* @__PURE__ */ e(Me, { className: "h-3 w-3" }) },
  approved: { label: "Approved", variant: "green", icon: /* @__PURE__ */ e(fe, { className: "h-3 w-3" }) },
  rejected: { label: "Rejected", variant: "red", icon: /* @__PURE__ */ e(he, { className: "h-3 w-3" }) },
  expired: { label: "Expired", variant: "default", icon: /* @__PURE__ */ e(Le, { className: "h-3 w-3" }) }
}, tl = ({
  title: r,
  description: C,
  status: i,
  requester: n,
  createdAt: p,
  deadline: j,
  approvers: D,
  onApprove: E,
  onReject: y,
  onViewDetails: N,
  canAct: A = !1,
  isLoading: _ = !1,
  metadata: w,
  className: s
}) => {
  const S = el[i], g = i === "pending", m = (M) => new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit"
  }).format(M), d = j && /* @__PURE__ */ new Date() > j && g;
  return /* @__PURE__ */ e(ne, { className: l("p-4", s), variant: "outlined", children: /* @__PURE__ */ t("div", { className: "flex items-start justify-between gap-4", children: [
    /* @__PURE__ */ t("div", { className: "flex items-start gap-3 flex-1 min-w-0", children: [
      /* @__PURE__ */ e(
        je,
        {
          src: n.avatar,
          fallback: n.name.charAt(0),
          size: "md"
        }
      ),
      /* @__PURE__ */ t("div", { className: "flex-1 min-w-0", children: [
        /* @__PURE__ */ t("div", { className: "flex items-center gap-2 flex-wrap", children: [
          /* @__PURE__ */ e(a, { variant: "body", className: "font-medium truncate", children: r }),
          /* @__PURE__ */ t(ae, { variant: S.variant, className: "flex items-center gap-1", children: [
            S.icon,
            S.label
          ] }),
          d && /* @__PURE__ */ e(ae, { variant: "red", children: "Overdue" })
        ] }),
        C && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground mt-1 line-clamp-2", children: C }),
        /* @__PURE__ */ t("div", { className: "flex items-center gap-4 mt-2 text-xs text-muted-foreground", children: [
          /* @__PURE__ */ t("span", { children: [
            "Requested by ",
            n.name
          ] }),
          /* @__PURE__ */ e("span", { children: m(p) }),
          j && /* @__PURE__ */ t("span", { className: d ? "text-destructive" : "", children: [
            "Due ",
            m(j)
          ] })
        ] }),
        w && w.length > 0 && /* @__PURE__ */ e("div", { className: "flex gap-4 mt-2", children: w.map((M) => /* @__PURE__ */ t("div", { className: "text-xs", children: [
          /* @__PURE__ */ t("span", { className: "text-muted-foreground", children: [
            M.label,
            ": "
          ] }),
          /* @__PURE__ */ e("span", { className: "font-medium", children: M.value })
        ] }, M.label)) }),
        D && D.length > 0 && /* @__PURE__ */ t("div", { className: "flex items-center gap-2 mt-3", children: [
          /* @__PURE__ */ e("span", { className: "text-xs text-muted-foreground", children: "Approvers:" }),
          /* @__PURE__ */ e("div", { className: "flex -space-x-2", children: D.map((M) => /* @__PURE__ */ e(
            je,
            {
              src: M.avatar,
              fallback: M.name.charAt(0),
              size: "sm",
              className: l(
                "ring-2 ring-background",
                M.status === "approved" && "ring-success",
                M.status === "rejected" && "ring-destructive"
              )
            },
            M.id
          )) })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ t("div", { className: "flex items-center gap-2 shrink-0", children: [
      N && /* @__PURE__ */ e(u, { variant: "ghost", size: "sm", onClick: N, children: "Details" }),
      A && g && /* @__PURE__ */ t(me, { children: [
        /* @__PURE__ */ t(
          u,
          {
            variant: "outline",
            size: "sm",
            onClick: y,
            disabled: _,
            className: "text-destructive hover:text-destructive",
            children: [
              /* @__PURE__ */ e(he, { className: "h-4 w-4 mr-1" }),
              "Reject"
            ]
          }
        ),
        /* @__PURE__ */ t(
          u,
          {
            variant: "primary",
            size: "sm",
            onClick: E,
            isLoading: _,
            children: [
              /* @__PURE__ */ e(fe, { className: "h-4 w-4 mr-1" }),
              "Approve"
            ]
          }
        )
      ] })
    ] })
  ] }) });
};
tl.displayName = "ApprovalRequest";
const al = ({
  selectedCount: r,
  totalCount: C,
  actions: i,
  onClearSelection: n,
  isLoading: p = !1,
  position: j = "floating",
  className: D
}) => r === 0 ? null : /* @__PURE__ */ t(
  "div",
  {
    className: l(
      "flex items-center gap-3 px-4 py-2 bg-primary text-primary-foreground rounded-lg",
      {
        top: "sticky top-0 z-10",
        bottom: "sticky bottom-0 z-10",
        floating: "fixed bottom-6 left-1/2 -translate-x-1/2 z-50 shadow-lg"
      }[j],
      D
    ),
    role: "toolbar",
    "aria-label": `Bulk actions for ${r} selected items`,
    children: [
      /* @__PURE__ */ e(
        u,
        {
          variant: "ghost",
          size: "sm",
          onClick: n,
          className: "text-primary-foreground hover:bg-primary-foreground/10 p-1",
          "aria-label": "Clear selection",
          children: /* @__PURE__ */ e(he, { className: "h-4 w-4" })
        }
      ),
      /* @__PURE__ */ t(a, { variant: "caption", className: "font-medium whitespace-nowrap", children: [
        r,
        " selected",
        C && ` of ${C}`
      ] }),
      /* @__PURE__ */ e("div", { className: "h-4 w-px bg-primary-foreground/30 mx-1" }),
      /* @__PURE__ */ t("div", { className: "flex items-center gap-1", children: [
        i.slice(0, 4).map((y) => /* @__PURE__ */ t(
          u,
          {
            variant: "ghost",
            size: "sm",
            onClick: y.onClick,
            disabled: y.disabled || p,
            className: l(
              "text-primary-foreground hover:bg-primary-foreground/10",
              y.variant === "danger" && "hover:bg-destructive/20"
            ),
            children: [
              y.icon && /* @__PURE__ */ e("span", { className: "mr-1.5", children: y.icon }),
              y.label
            ]
          },
          y.id
        )),
        i.length > 4 && /* @__PURE__ */ e(
          u,
          {
            variant: "ghost",
            size: "sm",
            className: "text-primary-foreground hover:bg-primary-foreground/10",
            children: /* @__PURE__ */ e(Ma, { className: "h-4 w-4" })
          }
        )
      ] })
    ]
  }
);
al.displayName = "BulkActionBar";
const tn = {
  delete: (r) => ({
    id: "delete",
    label: "Delete",
    icon: /* @__PURE__ */ e(Re, { className: "h-4 w-4" }),
    variant: "danger",
    onClick: r
  }),
  archive: (r) => ({
    id: "archive",
    label: "Archive",
    icon: /* @__PURE__ */ e($a, { className: "h-4 w-4" }),
    onClick: r
  }),
  export: (r) => ({
    id: "export",
    label: "Export",
    icon: /* @__PURE__ */ e(_e, { className: "h-4 w-4" }),
    onClick: r
  }),
  tag: (r) => ({
    id: "tag",
    label: "Add Tag",
    icon: /* @__PURE__ */ e(st, { className: "h-4 w-4" }),
    onClick: r
  })
}, rl = ({
  title: r = "Import Data",
  acceptedTypes: C = [".csv", ".xlsx", ".xls"],
  maxSizeMB: i = 10,
  targetFields: n,
  onFileSelect: p,
  onParse: j,
  onMappingConfirm: D,
  onValidate: E,
  onImport: y,
  onComplete: N,
  onCancel: A,
  className: _
}) => {
  const [w, s] = P("upload"), [S, g] = P(null), [m, d] = P(null), [M, K] = P([]), [Y, h] = P(null), [z, U] = P(null), [T, L] = P(!1), [G, Q] = P(null), v = [
    { id: "upload", label: "Upload" },
    { id: "preview", label: "Preview" },
    { id: "mapping", label: "Map Fields" },
    { id: "validation", label: "Validate" },
    { id: "importing", label: "Import" },
    { id: "complete", label: "Done" }
  ], b = v.findIndex((x) => x.id === w), c = te(async (x) => {
    var O;
    const f = (O = x.target.files) == null ? void 0 : O[0];
    if (f) {
      if (f.size > i * 1024 * 1024) {
        Q(`File size must be less than ${i}MB`);
        return;
      }
      if (g(f), Q(null), p == null || p(f), j) {
        L(!0);
        try {
          const F = await j(f);
          d(F);
          const de = F.headers.map((I) => {
            const se = n.find(
              (oe) => oe.label.toLowerCase() === I.toLowerCase() || oe.id.toLowerCase() === I.toLowerCase()
            );
            return {
              sourceColumn: I,
              targetField: (se == null ? void 0 : se.id) || "",
              isRequired: (se == null ? void 0 : se.required) || !1,
              isMatched: !!se
            };
          });
          K(de), s("preview");
        } catch {
          Q("Failed to parse file. Please check the format.");
        } finally {
          L(!1);
        }
      }
    }
  }, [i, p, j, n]), $ = async () => {
    L(!0), Q(null);
    try {
      switch (w) {
        case "preview":
          s("mapping");
          break;
        case "mapping":
          if (D == null || D(M), E) {
            const x = await E(M);
            h(x);
          }
          s("validation");
          break;
        case "validation":
          if (s("importing"), y) {
            const x = await y();
            U(x);
          }
          s("complete");
          break;
        case "complete":
          N == null || N();
          break;
      }
    } catch {
      Q("An error occurred. Please try again.");
    } finally {
      L(!1);
    }
  }, o = () => {
    const x = b - 1;
    x >= 0 && s(v[x].id);
  };
  return /* @__PURE__ */ t(ne, { className: l("p-6 max-w-2xl mx-auto", _), children: [
    /* @__PURE__ */ e(a, { variant: "h3", className: "mb-2", children: r }),
    /* @__PURE__ */ e("div", { className: "flex items-center gap-2 mb-6", children: v.map((x, f) => /* @__PURE__ */ t(Ae.Fragment, { children: [
      /* @__PURE__ */ e(
        "div",
        {
          className: l(
            "flex items-center justify-center w-8 h-8 rounded-full text-sm font-medium",
            f < b && "bg-success text-success-foreground",
            f === b && "bg-primary text-primary-foreground",
            f > b && "bg-muted text-muted-foreground"
          ),
          children: f < b ? /* @__PURE__ */ e(fe, { className: "h-4 w-4" }) : f + 1
        }
      ),
      f < v.length - 1 && /* @__PURE__ */ e("div", { className: l("h-0.5 flex-1", f < b ? "bg-success" : "bg-muted") })
    ] }, x.id)) }),
    G && /* @__PURE__ */ t("div", { className: "flex items-center gap-2 p-3 mb-4 bg-destructive/10 text-destructive rounded-lg", children: [
      /* @__PURE__ */ e(Le, { className: "h-4 w-4" }),
      /* @__PURE__ */ e(a, { variant: "caption", children: G })
    ] }),
    /* @__PURE__ */ t("div", { className: "min-h-[200px]", children: [
      w === "upload" && /* @__PURE__ */ t("label", { className: "flex flex-col items-center justify-center p-8 border-2 border-dashed border-border rounded-lg cursor-pointer hover:border-primary transition-colors", children: [
        /* @__PURE__ */ e(lt, { className: "h-10 w-10 text-muted-foreground mb-3" }),
        /* @__PURE__ */ e(a, { variant: "body", className: "text-center mb-1", children: "Drop your file here or click to browse" }),
        /* @__PURE__ */ t(a, { variant: "caption", className: "text-muted-foreground", children: [
          "Accepted: ",
          C.join(", "),
          " (max ",
          i,
          "MB)"
        ] }),
        /* @__PURE__ */ e(
          "input",
          {
            type: "file",
            accept: C.join(","),
            onChange: c,
            className: "hidden"
          }
        )
      ] }),
      w === "preview" && m && /* @__PURE__ */ t("div", { children: [
        /* @__PURE__ */ t("div", { className: "flex items-center gap-2 mb-4", children: [
          /* @__PURE__ */ e(mt, { className: "h-5 w-5 text-muted-foreground" }),
          /* @__PURE__ */ e(a, { variant: "body", className: "font-medium", children: S == null ? void 0 : S.name }),
          /* @__PURE__ */ t(ae, { variant: "default", children: [
            m.rows.length,
            " rows"
          ] })
        ] }),
        /* @__PURE__ */ e("div", { className: "overflow-x-auto border rounded-lg", children: /* @__PURE__ */ t("table", { className: "w-full text-sm", children: [
          /* @__PURE__ */ e("thead", { className: "bg-muted", children: /* @__PURE__ */ e("tr", { children: m.headers.map((x) => /* @__PURE__ */ e("th", { className: "px-3 py-2 text-left font-medium", children: x }, x)) }) }),
          /* @__PURE__ */ e("tbody", { children: m.rows.slice(0, 5).map((x, f) => /* @__PURE__ */ e("tr", { className: "border-t", children: m.headers.map((O) => /* @__PURE__ */ e("td", { className: "px-3 py-2 truncate max-w-[150px]", children: x[O] }, O)) }, f)) })
        ] }) }),
        m.rows.length > 5 && /* @__PURE__ */ t(a, { variant: "caption", className: "text-muted-foreground mt-2", children: [
          "Showing first 5 of ",
          m.rows.length,
          " rows"
        ] })
      ] }),
      w === "mapping" && /* @__PURE__ */ t("div", { className: "space-y-3", children: [
        /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: "Map your file columns to the corresponding fields" }),
        M.map((x, f) => /* @__PURE__ */ t("div", { className: "flex items-center gap-3", children: [
          /* @__PURE__ */ e("div", { className: "flex-1 p-2 bg-muted rounded text-sm", children: x.sourceColumn }),
          /* @__PURE__ */ e(Fe, { className: "h-4 w-4 text-muted-foreground" }),
          /* @__PURE__ */ t(
            "select",
            {
              value: x.targetField,
              onChange: (O) => {
                const F = [...M];
                F[f].targetField = O.target.value, F[f].isMatched = !!O.target.value, K(F);
              },
              className: "flex-1 p-2 border rounded text-sm bg-background",
              children: [
                /* @__PURE__ */ e("option", { value: "", children: "-- Skip --" }),
                n.map((O) => /* @__PURE__ */ t("option", { value: O.id, children: [
                  O.label,
                  " ",
                  O.required && "*"
                ] }, O.id))
              ]
            }
          )
        ] }, x.sourceColumn))
      ] }),
      w === "validation" && Y && /* @__PURE__ */ t("div", { className: "space-y-4", children: [
        /* @__PURE__ */ t("div", { className: "flex items-center gap-4", children: [
          /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ e(fe, { className: "h-5 w-5 text-success" }),
            /* @__PURE__ */ t(a, { variant: "body", children: [
              Y.valid,
              " valid rows"
            ] })
          ] }),
          Y.errors.length > 0 && /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ e(Le, { className: "h-5 w-5 text-destructive" }),
            /* @__PURE__ */ t(a, { variant: "body", children: [
              Y.errors.length,
              " errors"
            ] })
          ] })
        ] }),
        Y.errors.length > 0 && /* @__PURE__ */ e("div", { className: "border rounded-lg p-3 max-h-[200px] overflow-auto", children: Y.errors.slice(0, 10).map((x, f) => /* @__PURE__ */ t("div", { className: "text-sm text-destructive mb-1", children: [
          "Row ",
          x.row,
          ": ",
          x.column,
          " - ",
          x.message
        ] }, f)) })
      ] }),
      w === "complete" && z && /* @__PURE__ */ t("div", { className: "text-center py-8", children: [
        /* @__PURE__ */ e("div", { className: "w-16 h-16 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-4", children: /* @__PURE__ */ e(fe, { className: "h-8 w-8 text-success" }) }),
        /* @__PURE__ */ e(a, { variant: "h4", className: "mb-2", children: "Import Complete!" }),
        /* @__PURE__ */ t(a, { variant: "body", className: "text-muted-foreground", children: [
          "Successfully imported ",
          z.imported,
          " records",
          z.failed > 0 && ` (${z.failed} failed)`
        ] })
      ] })
    ] }),
    /* @__PURE__ */ t("div", { className: "flex justify-between mt-6 pt-4 border-t", children: [
      /* @__PURE__ */ e(
        u,
        {
          variant: "ghost",
          onClick: w === "upload" ? A : o,
          disabled: T,
          children: w === "upload" ? "Cancel" : /* @__PURE__ */ t(me, { children: [
            /* @__PURE__ */ e(ca, { className: "h-4 w-4 mr-1" }),
            "Back"
          ] })
        }
      ),
      w !== "upload" && /* @__PURE__ */ t(
        u,
        {
          variant: "primary",
          onClick: $,
          isLoading: T,
          children: [
            w === "complete" ? "Done" : "Continue",
            w !== "complete" && /* @__PURE__ */ e(Fe, { className: "h-4 w-4 ml-1" })
          ]
        }
      )
    ] })
  ] });
};
rl.displayName = "DataImportWizard";
const sl = ({
  actions: r,
  placeholder: C = "Type a command or search...",
  isOpen: i,
  onClose: n,
  triggerShortcut: p = "⌘K",
  recentActionIds: j = [],
  maxResults: D = 10,
  className: E
}) => {
  const [y, N] = P(""), [A, _] = P(0), w = Ee(null), s = Ee(null), S = Ae.useMemo(() => {
    let d = r.filter((M) => !M.disabled);
    if (y) {
      const M = y.toLowerCase();
      d = d.filter(
        (K) => {
          var Y, h;
          return K.label.toLowerCase().includes(M) || ((Y = K.description) == null ? void 0 : Y.toLowerCase().includes(M)) || ((h = K.category) == null ? void 0 : h.toLowerCase().includes(M));
        }
      );
    } else
      d = [...d].sort((M, K) => {
        const Y = j.indexOf(M.id), h = j.indexOf(K.id);
        return Y !== -1 && h === -1 ? -1 : Y === -1 && h !== -1 ? 1 : Y !== -1 && h !== -1 ? Y - h : 0;
      });
    return d.slice(0, D);
  }, [r, y, j, D]), g = Ae.useMemo(() => {
    const d = {};
    return S.forEach((M) => {
      const K = M.category || "Actions";
      d[K] || (d[K] = []), d[K].push(M);
    }), d;
  }, [S]);
  qe(() => {
    i && (N(""), _(0), setTimeout(() => {
      var d;
      return (d = w.current) == null ? void 0 : d.focus();
    }, 0));
  }, [i]);
  const m = te(
    (d) => {
      switch (d.key) {
        case "ArrowDown":
          d.preventDefault(), _((M) => Math.min(M + 1, S.length - 1));
          break;
        case "ArrowUp":
          d.preventDefault(), _((M) => Math.max(M - 1, 0));
          break;
        case "Enter":
          d.preventDefault(), S[A] && (S[A].onSelect(), n());
          break;
        case "Escape":
          d.preventDefault(), n();
          break;
      }
    },
    [S, A, n]
  );
  return qe(() => {
    var M;
    const d = (M = s.current) == null ? void 0 : M.querySelector(`[data-index="${A}"]`);
    d == null || d.scrollIntoView({ block: "nearest" });
  }, [A]), i ? /* @__PURE__ */ t(
    "div",
    {
      className: "fixed inset-0 z-50 flex items-start justify-center pt-[15vh]",
      onClick: n,
      children: [
        /* @__PURE__ */ e("div", { className: "fixed inset-0 bg-background/80 backdrop-blur-sm" }),
        /* @__PURE__ */ t(
          "div",
          {
            className: l(
              "relative w-full max-w-lg bg-popover border rounded-xl shadow-2xl overflow-hidden",
              E
            ),
            onClick: (d) => d.stopPropagation(),
            role: "dialog",
            "aria-modal": "true",
            "aria-label": "Quick actions",
            children: [
              /* @__PURE__ */ t("div", { className: "flex items-center gap-3 px-4 border-b", children: [
                /* @__PURE__ */ e(we, { className: "h-4 w-4 text-muted-foreground shrink-0" }),
                /* @__PURE__ */ e(
                  "input",
                  {
                    ref: w,
                    type: "text",
                    value: y,
                    onChange: (d) => {
                      N(d.target.value), _(0);
                    },
                    onKeyDown: m,
                    placeholder: C,
                    className: "flex-1 py-3 bg-transparent outline-none text-foreground placeholder:text-muted-foreground"
                  }
                ),
                /* @__PURE__ */ t("kbd", { className: "hidden sm:inline-flex items-center gap-1 px-2 py-1 text-xs text-muted-foreground bg-muted rounded", children: [
                  /* @__PURE__ */ e(it, { className: "h-3 w-3" }),
                  "K"
                ] })
              ] }),
              /* @__PURE__ */ e("div", { ref: s, className: "max-h-[300px] overflow-auto p-2", children: S.length === 0 ? /* @__PURE__ */ e("div", { className: "py-8 text-center text-muted-foreground", children: /* @__PURE__ */ e(a, { variant: "caption", children: "No results found" }) }) : Object.entries(g).map(([d, M]) => /* @__PURE__ */ t("div", { children: [
                /* @__PURE__ */ e(
                  a,
                  {
                    variant: "caption",
                    className: "px-2 py-1.5 text-muted-foreground font-medium",
                    children: d
                  }
                ),
                M.map((K) => {
                  const Y = S.indexOf(K), h = Y === A;
                  return /* @__PURE__ */ t(
                    "button",
                    {
                      "data-index": Y,
                      onClick: () => {
                        K.onSelect(), n();
                      },
                      onMouseEnter: () => _(Y),
                      className: l(
                        "w-full flex items-center gap-3 px-3 py-2 rounded-lg text-left transition-colors",
                        h ? "bg-accent text-accent-foreground" : "hover:bg-accent/50"
                      ),
                      children: [
                        K.icon && /* @__PURE__ */ e("span", { className: "shrink-0 text-muted-foreground", children: K.icon }),
                        /* @__PURE__ */ t("div", { className: "flex-1 min-w-0", children: [
                          /* @__PURE__ */ e(a, { variant: "body", className: "font-medium truncate", children: K.label }),
                          K.description && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground truncate", children: K.description })
                        ] }),
                        K.shortcut && /* @__PURE__ */ e("kbd", { className: "shrink-0 px-2 py-0.5 text-xs bg-muted rounded", children: K.shortcut }),
                        h && /* @__PURE__ */ e(Fe, { className: "h-4 w-4 shrink-0" })
                      ]
                    },
                    K.id
                  );
                })
              ] }, d)) }),
              /* @__PURE__ */ t("div", { className: "flex items-center gap-4 px-4 py-2 border-t text-xs text-muted-foreground", children: [
                /* @__PURE__ */ t("span", { children: [
                  /* @__PURE__ */ e("kbd", { className: "px-1 py-0.5 bg-muted rounded", children: "↑↓" }),
                  " Navigate"
                ] }),
                /* @__PURE__ */ t("span", { children: [
                  /* @__PURE__ */ e("kbd", { className: "px-1 py-0.5 bg-muted rounded", children: "↵" }),
                  " Select"
                ] }),
                /* @__PURE__ */ t("span", { children: [
                  /* @__PURE__ */ e("kbd", { className: "px-1 py-0.5 bg-muted rounded", children: "esc" }),
                  " Close"
                ] })
              ] })
            ]
          }
        )
      ]
    }
  ) : null;
};
sl.displayName = "QuickActions";
const ll = ({
  title: r,
  description: C,
  image: i,
  badge: n = "New",
  primaryAction: p,
  secondaryAction: j,
  onDismiss: D,
  variant: E = "banner",
  dismissible: y = !0,
  className: N
}) => {
  const [A, _] = P(!0), w = () => {
    _(!1), D == null || D();
  };
  return A ? E === "banner" ? /* @__PURE__ */ t(
    "div",
    {
      className: l(
        "relative flex items-center justify-between gap-4 px-4 py-3 bg-primary/10 border-b border-primary/20",
        N
      ),
      role: "alert",
      children: [
        /* @__PURE__ */ t("div", { className: "flex items-center gap-3", children: [
          /* @__PURE__ */ e(Te, { className: "h-5 w-5 text-primary shrink-0" }),
          /* @__PURE__ */ t("div", { className: "flex items-center gap-2 flex-wrap", children: [
            n && /* @__PURE__ */ e(ae, { variant: "blue", children: n }),
            /* @__PURE__ */ e(a, { variant: "body", className: "font-medium", children: r }),
            /* @__PURE__ */ t(a, { variant: "caption", className: "text-muted-foreground hidden sm:inline", children: [
              "— ",
              C
            ] })
          ] })
        ] }),
        /* @__PURE__ */ t("div", { className: "flex items-center gap-2 shrink-0", children: [
          p && /* @__PURE__ */ t(u, { size: "sm", variant: "primary", onClick: p.onClick, children: [
            p.label,
            /* @__PURE__ */ e(Fe, { className: "h-3 w-3 ml-1" })
          ] }),
          y && /* @__PURE__ */ e(
            u,
            {
              size: "sm",
              variant: "ghost",
              onClick: w,
              className: "p-1",
              "aria-label": "Dismiss",
              children: /* @__PURE__ */ e(he, { className: "h-4 w-4" })
            }
          )
        ] })
      ]
    }
  ) : E === "modal" ? /* @__PURE__ */ t("div", { className: "fixed inset-0 z-50 flex items-center justify-center p-4", children: [
    /* @__PURE__ */ e("div", { className: "fixed inset-0 bg-background/80 backdrop-blur-sm", onClick: w }),
    /* @__PURE__ */ t(
      "div",
      {
        className: l(
          "relative bg-popover border rounded-xl shadow-2xl max-w-md w-full overflow-hidden",
          N
        ),
        role: "dialog",
        "aria-modal": "true",
        children: [
          y && /* @__PURE__ */ e(
            u,
            {
              size: "sm",
              variant: "ghost",
              onClick: w,
              className: "absolute top-3 right-3 p-1 z-10",
              "aria-label": "Dismiss",
              children: /* @__PURE__ */ e(he, { className: "h-4 w-4" })
            }
          ),
          i && /* @__PURE__ */ e("div", { className: "w-full h-40 bg-gradient-to-br from-primary/20 to-primary/5 flex items-center justify-center", children: /* @__PURE__ */ e("img", { src: i, alt: "", className: "max-h-full object-contain" }) }),
          /* @__PURE__ */ t("div", { className: "p-6", children: [
            /* @__PURE__ */ e("div", { className: "flex items-center gap-2 mb-2", children: n && /* @__PURE__ */ e(ae, { variant: "blue", children: n }) }),
            /* @__PURE__ */ e(a, { variant: "h3", className: "mb-2", children: r }),
            /* @__PURE__ */ e(a, { variant: "body", className: "text-muted-foreground mb-6", children: C }),
            /* @__PURE__ */ t("div", { className: "flex items-center gap-3", children: [
              p && /* @__PURE__ */ e(u, { variant: "primary", onClick: p.onClick, className: "flex-1", children: p.label }),
              j && /* @__PURE__ */ t(
                u,
                {
                  variant: "ghost",
                  onClick: j.onClick,
                  ...j.href && { as: "a", href: j.href },
                  children: [
                    j.label,
                    j.href && /* @__PURE__ */ e(at, { className: "h-3 w-3 ml-1" })
                  ]
                }
              )
            ] })
          ] })
        ]
      }
    )
  ] }) : /* @__PURE__ */ t(
    "div",
    {
      className: l(
        "relative flex gap-4 p-4 bg-primary/5 border border-primary/20 rounded-lg",
        N
      ),
      role: "alert",
      children: [
        i && /* @__PURE__ */ e("div", { className: "w-20 h-20 shrink-0 bg-primary/10 rounded-lg flex items-center justify-center", children: /* @__PURE__ */ e("img", { src: i, alt: "", className: "max-h-full object-contain" }) }),
        /* @__PURE__ */ t("div", { className: "flex-1 min-w-0", children: [
          /* @__PURE__ */ t("div", { className: "flex items-center gap-2 mb-1", children: [
            n && /* @__PURE__ */ e(ae, { variant: "blue", children: n }),
            /* @__PURE__ */ e(a, { variant: "body", className: "font-medium", children: r })
          ] }),
          /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground mb-3", children: C }),
          /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
            p && /* @__PURE__ */ e(u, { size: "sm", variant: "primary", onClick: p.onClick, children: p.label }),
            j && /* @__PURE__ */ e(
              u,
              {
                size: "sm",
                variant: "ghost",
                onClick: j.onClick,
                ...j.href && { as: "a", href: j.href },
                children: j.label
              }
            )
          ] })
        ] }),
        y && /* @__PURE__ */ e(
          u,
          {
            size: "sm",
            variant: "ghost",
            onClick: w,
            className: "absolute top-2 right-2 p-1",
            "aria-label": "Dismiss",
            children: /* @__PURE__ */ e(he, { className: "h-4 w-4" })
          }
        )
      ]
    }
  ) : null;
};
ll.displayName = "FeatureAnnouncement";
const Qt = {
  completed: {
    icon: /* @__PURE__ */ e(fe, { className: "h-3 w-3" }),
    color: "text-success",
    bgColor: "bg-success"
  },
  current: {
    icon: /* @__PURE__ */ e(gt, { className: "h-2 w-2 fill-current" }),
    color: "text-primary",
    bgColor: "bg-primary"
  },
  pending: {
    icon: /* @__PURE__ */ e(Me, { className: "h-3 w-3" }),
    color: "text-muted-foreground",
    bgColor: "bg-muted"
  },
  error: {
    icon: /* @__PURE__ */ e(Le, { className: "h-3 w-3" }),
    color: "text-destructive",
    bgColor: "bg-destructive"
  },
  skipped: {
    icon: /* @__PURE__ */ e(Fe, { className: "h-3 w-3" }),
    color: "text-muted-foreground",
    bgColor: "bg-muted"
  }
}, il = ({
  events: r,
  title: C,
  showTimestamps: i = !0,
  orientation: n = "vertical",
  size: p = "md",
  className: j
}) => {
  const D = (N) => new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit"
  }).format(N), y = {
    sm: { icon: "w-5 h-5", text: "text-xs", gap: "gap-2" },
    md: { icon: "w-7 h-7", text: "text-sm", gap: "gap-3" },
    lg: { icon: "w-9 h-9", text: "text-base", gap: "gap-4" }
  }[p];
  return n === "horizontal" ? /* @__PURE__ */ t("div", { className: l("w-full", j), children: [
    C && /* @__PURE__ */ e(a, { variant: "h4", className: "mb-4", children: C }),
    /* @__PURE__ */ e("div", { className: "flex items-start", children: r.map((N, A) => {
      const _ = Qt[N.status], w = A === r.length - 1;
      return /* @__PURE__ */ t("div", { className: l("flex-1 flex flex-col items-center", !w && "relative"), children: [
        !w && /* @__PURE__ */ e(
          "div",
          {
            className: l(
              "absolute top-3.5 left-1/2 w-full h-0.5",
              N.status === "completed" ? "bg-success" : "bg-border"
            )
          }
        ),
        /* @__PURE__ */ e(
          "div",
          {
            className: l(
              "relative z-10 flex items-center justify-center rounded-full text-white",
              y.icon,
              _.bgColor
            ),
            children: _.icon
          }
        ),
        /* @__PURE__ */ t("div", { className: "mt-2 text-center", children: [
          /* @__PURE__ */ e(
            a,
            {
              variant: "caption",
              className: l("font-medium", N.status === "pending" && "text-muted-foreground"),
              children: N.title
            }
          ),
          i && N.timestamp && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground block", children: D(N.timestamp) })
        ] })
      ] }, N.id);
    }) })
  ] }) : /* @__PURE__ */ t("div", { className: l("w-full", j), children: [
    C && /* @__PURE__ */ e(a, { variant: "h4", className: "mb-4", children: C }),
    /* @__PURE__ */ e("div", { className: "relative", children: r.map((N, A) => {
      const _ = Qt[N.status], w = A === r.length - 1;
      return /* @__PURE__ */ t("div", { className: l("flex", y.gap, !w && "pb-6"), children: [
        /* @__PURE__ */ t("div", { className: "flex flex-col items-center", children: [
          /* @__PURE__ */ e(
            "div",
            {
              className: l(
                "flex items-center justify-center rounded-full text-white shrink-0",
                y.icon,
                _.bgColor
              ),
              children: _.icon
            }
          ),
          !w && /* @__PURE__ */ e(
            "div",
            {
              className: l(
                "w-0.5 flex-1 mt-2",
                N.status === "completed" ? "bg-success" : "bg-border"
              )
            }
          )
        ] }),
        /* @__PURE__ */ t("div", { className: "flex-1 min-w-0 pt-0.5", children: [
          /* @__PURE__ */ t("div", { className: "flex items-start justify-between gap-2", children: [
            /* @__PURE__ */ t("div", { children: [
              /* @__PURE__ */ e(
                a,
                {
                  variant: "body",
                  className: l(
                    "font-medium",
                    y.text,
                    N.status === "pending" && "text-muted-foreground"
                  ),
                  children: N.title
                }
              ),
              N.description && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground mt-0.5", children: N.description })
            ] }),
            i && N.timestamp && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground whitespace-nowrap", children: D(N.timestamp) })
          ] }),
          N.actor && /* @__PURE__ */ t("div", { className: "flex items-center gap-2 mt-2", children: [
            /* @__PURE__ */ e(
              je,
              {
                src: N.actor.avatar,
                fallback: N.actor.name.charAt(0),
                size: "sm"
              }
            ),
            /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: N.actor.name })
          ] }),
          N.metadata && Object.keys(N.metadata).length > 0 && /* @__PURE__ */ e("div", { className: "flex flex-wrap gap-2 mt-2", children: Object.entries(N.metadata).map(([s, S]) => /* @__PURE__ */ t(ae, { variant: "default", children: [
            s,
            ": ",
            S
          ] }, s)) })
        ] })
      ] }, N.id);
    }) })
  ] });
};
il.displayName = "StatusTimeline";
const nl = ({
  title: r,
  description: C,
  features: i,
  options: n,
  showFeatureTable: p = !0,
  selectedId: j,
  onSelect: D,
  layout: E = "cards",
  className: y
}) => {
  const [N, A] = P(null), _ = (s) => s == null || s === "" ? /* @__PURE__ */ e(he, { className: "h-4 w-4 text-muted-foreground" }) : typeof s == "boolean" ? s ? /* @__PURE__ */ e(fe, { className: "h-4 w-4 text-success" }) : /* @__PURE__ */ e(he, { className: "h-4 w-4 text-muted-foreground" }) : /* @__PURE__ */ e("span", { className: "text-sm font-medium", children: s }), w = (s, S) => {
    var g;
    return (g = s.features) == null ? void 0 : g[S];
  };
  return E === "table" ? /* @__PURE__ */ t("div", { className: l("w-full overflow-x-auto", y), children: [
    r && /* @__PURE__ */ t("div", { className: "mb-6", children: [
      /* @__PURE__ */ e(a, { variant: "h3", children: r }),
      C && /* @__PURE__ */ e(a, { variant: "body", className: "text-muted-foreground mt-1", children: C })
    ] }),
    /* @__PURE__ */ t("table", { className: "w-full border-collapse", children: [
      /* @__PURE__ */ e("thead", { children: /* @__PURE__ */ t("tr", { children: [
        /* @__PURE__ */ e("th", { className: "text-left p-4 border-b" }),
        n.map((s) => /* @__PURE__ */ t(
          "th",
          {
            className: l(
              "p-4 border-b text-center min-w-[180px]",
              s.recommended && "bg-primary/5"
            ),
            children: [
              s.badge && /* @__PURE__ */ e(ae, { variant: "blue", className: "mb-2", children: s.badge }),
              /* @__PURE__ */ e(a, { variant: "h4", children: s.name }),
              s.price && /* @__PURE__ */ t("div", { className: "mt-1", children: [
                /* @__PURE__ */ e("span", { className: "text-2xl font-bold", children: s.price }),
                s.priceDetail && /* @__PURE__ */ e("span", { className: "text-muted-foreground text-sm ml-1", children: s.priceDetail })
              ] })
            ]
          },
          s.id
        ))
      ] }) }),
      /* @__PURE__ */ t("tbody", { children: [
        i.map((s) => /* @__PURE__ */ t("tr", { className: "border-b hover:bg-muted/30", children: [
          /* @__PURE__ */ e("td", { className: "p-4", children: /* @__PURE__ */ t("div", { className: "flex items-center gap-1", children: [
            /* @__PURE__ */ e("span", { className: "text-sm", children: s.label }),
            s.tooltip && /* @__PURE__ */ e(oa, { className: "h-3 w-3 text-muted-foreground" })
          ] }) }),
          n.map((S) => /* @__PURE__ */ e(
            "td",
            {
              className: l(
                "p-4 text-center",
                S.recommended && "bg-primary/5"
              ),
              children: _(w(S, s.id))
            },
            S.id
          ))
        ] }, s.id)),
        /* @__PURE__ */ t("tr", { children: [
          /* @__PURE__ */ e("td", { className: "p-4" }),
          n.map((s) => /* @__PURE__ */ e(
            "td",
            {
              className: l("p-4 text-center", s.recommended && "bg-primary/5"),
              children: s.cta && /* @__PURE__ */ e(
                u,
                {
                  variant: s.recommended ? "primary" : "outline",
                  onClick: s.cta.onClick,
                  disabled: s.disabled,
                  className: "w-full",
                  children: s.cta.label
                }
              )
            },
            s.id
          ))
        ] })
      ] })
    ] })
  ] }) : /* @__PURE__ */ t("div", { className: l("w-full", y), children: [
    r && /* @__PURE__ */ t("div", { className: "text-center mb-8", children: [
      /* @__PURE__ */ e(a, { variant: "h2", children: r }),
      C && /* @__PURE__ */ e(a, { variant: "body", className: "text-muted-foreground mt-2", children: C })
    ] }),
    /* @__PURE__ */ e("div", { className: l("grid gap-6", `grid-cols-1 md:grid-cols-${Math.max(1, Math.min(n.length, 3))}`), children: n.map((s) => {
      const S = j === s.id, g = N === s.id;
      return /* @__PURE__ */ t(
        ne,
        {
          className: l(
            "relative p-6 flex flex-col transition-all",
            s.recommended && "border-primary ring-1 ring-primary",
            S && "border-primary bg-primary/5",
            g && !S && "border-primary/50",
            s.disabled && "opacity-60"
          ),
          onMouseEnter: () => A(s.id),
          onMouseLeave: () => A(null),
          children: [
            s.recommended && /* @__PURE__ */ e(
              ae,
              {
                variant: "blue",
                className: "absolute -top-3 left-1/2 -translate-x-1/2",
                children: "Recommended"
              }
            ),
            /* @__PURE__ */ t("div", { className: "text-center mb-6", children: [
              s.badge && !s.recommended && /* @__PURE__ */ e(ae, { variant: "default", className: "mb-2", children: s.badge }),
              /* @__PURE__ */ e(a, { variant: "h3", children: s.name }),
              s.description && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground mt-1", children: s.description }),
              s.price && /* @__PURE__ */ t("div", { className: "mt-4", children: [
                /* @__PURE__ */ e("span", { className: "text-4xl font-bold", children: s.price }),
                s.priceDetail && /* @__PURE__ */ e("span", { className: "text-muted-foreground ml-1", children: s.priceDetail })
              ] })
            ] }),
            p && /* @__PURE__ */ e("ul", { className: "space-y-3 flex-1 mb-6", children: i.map((m) => {
              const d = w(s, m.id), M = d === !0 || typeof d == "string" && d;
              return /* @__PURE__ */ t("li", { className: "flex items-center gap-2", children: [
                M ? /* @__PURE__ */ e(fe, { className: "h-4 w-4 text-success shrink-0" }) : /* @__PURE__ */ e(he, { className: "h-4 w-4 text-muted-foreground shrink-0" }),
                /* @__PURE__ */ e("span", { className: l("text-sm", !M && "text-muted-foreground"), children: typeof d == "string" ? `${m.label}: ${d}` : m.label })
              ] }, m.id);
            }) }),
            s.cta && /* @__PURE__ */ e(
              u,
              {
                variant: s.recommended || S ? "primary" : "outline",
                onClick: () => {
                  var m;
                  D == null || D(s.id), (m = s.cta) == null || m.onClick();
                },
                disabled: s.disabled,
                className: "w-full",
                children: s.cta.label
              }
            )
          ]
        },
        s.id
      );
    }) })
  ] });
};
nl.displayName = "ComparisonPicker";
const cl = ({
  title: r = "Something went wrong",
  message: C,
  technicalDetails: i,
  errorCode: n,
  recoverySteps: p,
  primaryAction: j,
  secondaryAction: D,
  onCopyError: E,
  severity: y = "error",
  showTechnicalDetails: N = !1,
  className: A
}) => {
  const [_, w] = Ae.useState(N), [s, S] = Ae.useState(!1), m = {
    warning: {
      bg: "bg-warning/10",
      border: "border-warning/30",
      icon: "text-warning"
    },
    error: {
      bg: "bg-destructive/10",
      border: "border-destructive/30",
      icon: "text-destructive"
    },
    critical: {
      bg: "bg-destructive/20",
      border: "border-destructive",
      icon: "text-destructive"
    }
  }[y], d = async () => {
    const M = [
      `Error: ${r}`,
      `Message: ${C}`,
      n && `Code: ${n}`,
      i && `Details: ${i}`,
      `Timestamp: ${(/* @__PURE__ */ new Date()).toISOString()}`
    ].filter(Boolean).join(`
`);
    try {
      await navigator.clipboard.writeText(M), S(!0), E == null || E(), setTimeout(() => S(!1), 2e3);
    } catch {
    }
  };
  return /* @__PURE__ */ e(ne, { className: l("p-6", m.bg, m.border, A), children: /* @__PURE__ */ t("div", { className: "flex gap-4", children: [
    /* @__PURE__ */ e(
      "div",
      {
        className: l(
          "w-10 h-10 rounded-full flex items-center justify-center shrink-0",
          y === "critical" ? "bg-destructive text-destructive-foreground" : "bg-background"
        ),
        children: /* @__PURE__ */ e(ze, { className: l("h-5 w-5", m.icon) })
      }
    ),
    /* @__PURE__ */ t("div", { className: "flex-1 min-w-0", children: [
      /* @__PURE__ */ t("div", { className: "flex items-start justify-between gap-2", children: [
        /* @__PURE__ */ t("div", { children: [
          /* @__PURE__ */ e(a, { variant: "h4", className: "mb-1", children: r }),
          n && /* @__PURE__ */ t(a, { variant: "caption", className: "text-muted-foreground", children: [
            "Error code: ",
            n
          ] })
        ] }),
        (i || n) && /* @__PURE__ */ t(
          u,
          {
            variant: "ghost",
            size: "sm",
            onClick: d,
            className: "shrink-0",
            children: [
              /* @__PURE__ */ e(Ke, { className: "h-4 w-4 mr-1" }),
              s ? "Copied!" : "Copy"
            ]
          }
        )
      ] }),
      /* @__PURE__ */ e(a, { variant: "body", className: "mt-2 text-muted-foreground", children: C }),
      p && p.length > 0 && /* @__PURE__ */ t("div", { className: "mt-4", children: [
        /* @__PURE__ */ e(a, { variant: "caption", className: "font-medium mb-2 block", children: "Try these steps:" }),
        /* @__PURE__ */ e("ol", { className: "space-y-2", children: p.map((M, K) => /* @__PURE__ */ t("li", { className: "flex items-start gap-2", children: [
          /* @__PURE__ */ e("span", { className: "w-5 h-5 rounded-full bg-muted flex items-center justify-center text-xs font-medium shrink-0", children: K + 1 }),
          /* @__PURE__ */ t("div", { className: "flex-1", children: [
            /* @__PURE__ */ e(a, { variant: "caption", children: M.label }),
            M.action && /* @__PURE__ */ e(
              u,
              {
                variant: "link",
                size: "sm",
                onClick: M.action,
                className: "h-auto p-0 ml-2",
                children: "Do this"
              }
            )
          ] })
        ] }, M.id)) })
      ] }),
      i && /* @__PURE__ */ t("div", { className: "mt-4", children: [
        /* @__PURE__ */ t(
          "button",
          {
            onClick: () => w(!_),
            className: "flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground transition-colors",
            children: [
              _ ? /* @__PURE__ */ e(Ie, { className: "h-3 w-3" }) : /* @__PURE__ */ e(xe, { className: "h-3 w-3" }),
              "Technical details"
            ]
          }
        ),
        _ && /* @__PURE__ */ e("pre", { className: "mt-2 p-3 bg-muted rounded text-xs overflow-x-auto max-h-[200px]", children: i })
      ] }),
      /* @__PURE__ */ t("div", { className: "flex items-center gap-3 mt-6", children: [
        j && /* @__PURE__ */ t(
          u,
          {
            variant: "primary",
            onClick: j.onClick,
            isLoading: j.isLoading,
            children: [
              /* @__PURE__ */ e(Xe, { className: "h-4 w-4 mr-1" }),
              j.label
            ]
          }
        ),
        D && /* @__PURE__ */ t(u, { variant: "outline", onClick: D.onClick, children: [
          /* @__PURE__ */ e(oa, { className: "h-4 w-4 mr-1" }),
          D.label
        ] })
      ] })
    ] })
  ] }) });
};
cl.displayName = "ErrorRecovery";
const dl = ({
  title: r = "Invite team members",
  description: C = "Add people to your team by email",
  roles: i,
  defaultRole: n,
  maxInvites: p = 10,
  currentTeamSize: j,
  teamSizeLimit: D,
  onSendInvites: E,
  onCopyInviteLink: y,
  isLoading: N = !1,
  variant: A = "card",
  className: _
}) => {
  var O;
  const w = i ?? [], s = w.length > 0, [S, g] = P([]), [m, d] = P(""), [M, K] = P(n || ((O = w[0]) == null ? void 0 : O.id) || ""), [Y, h] = P(null), [z, U] = P(!1), [T, L] = P(!1), [G, Q] = P(!1), v = (F) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(F), b = () => {
    const F = m.trim().toLowerCase();
    if (!s || !M) {
      h("No roles are available to assign");
      return;
    }
    if (!F) {
      h("Please enter an email address");
      return;
    }
    if (!v(F)) {
      h("Please enter a valid email address");
      return;
    }
    if (S.some((de) => de.email === F)) {
      h("This email has already been added");
      return;
    }
    if (p > 0 && S.length >= p) {
      h(`Maximum ${p} invites allowed at once`);
      return;
    }
    g([...S, { email: F, role: M }]), d(""), h(null);
  }, c = (F) => {
    g(S.filter((de) => de.email !== F));
  }, $ = async () => {
    if (S.length === 0) {
      h("Add at least one email to invite");
      return;
    }
    U(!0), h(null);
    try {
      await E(S), Q(!0), g([]), setTimeout(() => Q(!1), 3e3);
    } catch {
      h("Failed to send invites. Please try again.");
    } finally {
      U(!1);
    }
  }, o = async () => {
    if (y)
      try {
        const F = await y();
        await navigator.clipboard.writeText(F), L(!0), setTimeout(() => L(!1), 2e3);
      } catch {
        h("Failed to copy invite link");
      }
  }, f = /* @__PURE__ */ t(me, { children: [
    /* @__PURE__ */ t("div", { className: "mb-4", children: [
      /* @__PURE__ */ e(a, { variant: "h4", children: r }),
      /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: C }),
      j !== void 0 && D !== void 0 && /* @__PURE__ */ t("div", { className: "flex items-center gap-2 mt-2", children: [
        /* @__PURE__ */ e(Se, { className: "h-4 w-4 text-muted-foreground" }),
        /* @__PURE__ */ t(a, { variant: "caption", className: "text-muted-foreground", children: [
          j,
          " / ",
          D,
          " members"
        ] })
      ] })
    ] }),
    /* @__PURE__ */ t("div", { className: "mb-3 flex flex-col gap-2 sm:flex-row", children: [
      /* @__PURE__ */ t("div", { className: "relative min-w-0 flex-1", children: [
        /* @__PURE__ */ e(xt, { className: "absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" }),
        /* @__PURE__ */ e(
          "input",
          {
            type: "email",
            value: m,
            onChange: (F) => {
              d(F.target.value), h(null);
            },
            onKeyDown: (F) => {
              F.key === "Enter" && (F.preventDefault(), b());
            },
            placeholder: "colleague@company.com",
            className: "w-full rounded-lg border bg-background py-2 pl-10 pr-4 text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary",
            disabled: N || z
          }
        )
      ] }),
      /* @__PURE__ */ t(
        "select",
        {
          value: M,
          onChange: (F) => K(F.target.value),
          className: "w-full rounded-lg border bg-background px-3 py-2 text-foreground focus:outline-none focus:ring-2 focus:ring-primary disabled:cursor-not-allowed disabled:opacity-60 sm:w-auto sm:min-w-32",
          disabled: N || z || !s,
          children: [
            !s && /* @__PURE__ */ e("option", { value: "", children: "No roles" }),
            w.map((F) => /* @__PURE__ */ e("option", { value: F.id, children: F.name || F.id }, F.id))
          ]
        }
      ),
      /* @__PURE__ */ e(
        u,
        {
          variant: "secondary",
          onClick: b,
          disabled: !m.trim() || N || z,
          className: "shrink-0",
          children: /* @__PURE__ */ e(Pe, { className: "h-4 w-4" })
        }
      )
    ] }),
    Y && /* @__PURE__ */ e(a, { variant: "caption", className: "text-destructive mb-3 block", children: Y }),
    G && /* @__PURE__ */ t("div", { className: "flex items-center gap-2 p-3 mb-3 bg-success/10 text-success rounded-lg", children: [
      /* @__PURE__ */ e(fe, { className: "h-4 w-4" }),
      /* @__PURE__ */ e(a, { variant: "caption", children: "Invites sent successfully!" })
    ] }),
    S.length > 0 && /* @__PURE__ */ e("div", { className: "space-y-2 mb-4", children: S.map((F) => {
      const de = w.find((I) => I.id === F.role);
      return /* @__PURE__ */ t(
        "div",
        {
          className: "flex items-center justify-between gap-2 p-2 bg-muted rounded-lg",
          children: [
            /* @__PURE__ */ t("div", { className: "flex items-center gap-2 min-w-0", children: [
              /* @__PURE__ */ e(je, { fallback: F.email.charAt(0).toUpperCase(), size: "sm" }),
              /* @__PURE__ */ e(a, { variant: "caption", className: "truncate", children: F.email })
            ] }),
            /* @__PURE__ */ t("div", { className: "flex items-center gap-2 shrink-0", children: [
              /* @__PURE__ */ e(ae, { variant: "default", children: de == null ? void 0 : de.name }),
              /* @__PURE__ */ e(
                u,
                {
                  variant: "ghost",
                  size: "sm",
                  onClick: () => c(F.email),
                  className: "p-1",
                  children: /* @__PURE__ */ e(he, { className: "h-4 w-4" })
                }
              )
            ] })
          ]
        },
        F.email
      );
    }) }),
    /* @__PURE__ */ t("div", { className: "flex items-center justify-between gap-3 pt-4 border-t", children: [
      y && /* @__PURE__ */ e(u, { variant: "ghost", onClick: o, disabled: N, children: T ? /* @__PURE__ */ t(me, { children: [
        /* @__PURE__ */ e(fe, { className: "h-4 w-4 mr-1" }),
        "Copied!"
      ] }) : /* @__PURE__ */ t(me, { children: [
        /* @__PURE__ */ e(Ke, { className: "h-4 w-4 mr-1" }),
        "Copy invite link"
      ] }) }),
      /* @__PURE__ */ t(
        u,
        {
          variant: "primary",
          onClick: $,
          disabled: S.length === 0 || N || z,
          isLoading: z,
          className: y ? "" : "w-full",
          children: [
            /* @__PURE__ */ e(tt, { className: "h-4 w-4 mr-1" }),
            "Send ",
            S.length > 0 ? `${S.length} invite${S.length > 1 ? "s" : ""}` : "invites"
          ]
        }
      )
    ] })
  ] });
  return A === "inline" ? /* @__PURE__ */ e("div", { className: l("w-full", _), children: f }) : /* @__PURE__ */ e(ne, { className: l("w-full max-w-2xl p-6", _), children: f });
};
dl.displayName = "InviteMember";
const ol = ({
  placeholder: r = "Search...",
  value: C,
  onChange: i,
  onSearch: n,
  onResultSelect: p,
  filters: j = [],
  onFilterRemove: D,
  onGetSuggestions: E,
  results: y,
  isSearching: N = !1,
  recentSearches: A = [],
  popularSearches: _ = [],
  showSuggestions: w,
  debounceMs: s = 300,
  className: S
}) => {
  const [g, m] = P(""), [d, M] = P([]), [K, Y] = P(!1), [h, z] = P(-1), U = Ee(null), T = Ee(null), L = Ee(), G = C ?? g, Q = w ?? K, v = Ae.useMemo(() => {
    if (d.length > 0) return d;
    const f = [];
    return G || (A.slice(0, 3).forEach((O, F) => {
      f.push({ id: `recent-${F}`, text: O, type: "recent" });
    }), _.slice(0, 3).forEach((O, F) => {
      f.push({ id: `popular-${F}`, text: O, type: "popular" });
    })), f;
  }, [d, G, A, _]);
  qe(() => {
    if (!E || !G) {
      M([]);
      return;
    }
    return L.current && clearTimeout(L.current), L.current = setTimeout(async () => {
      try {
        const f = await E(G);
        M(f);
      } catch {
        M([]);
      }
    }, s), () => {
      L.current && clearTimeout(L.current);
    };
  }, [G, E, s]), qe(() => {
    const f = (O) => {
      var F;
      T.current && !T.current.contains(O.target) && !((F = U.current) != null && F.contains(O.target)) && Y(!1);
    };
    return document.addEventListener("mousedown", f), () => document.removeEventListener("mousedown", f);
  }, []);
  const b = te(
    (f) => {
      const O = f.target.value;
      m(O), i == null || i(O), z(-1), Y(!0);
    },
    [i]
  ), c = te(
    (f) => {
      const O = f ?? G;
      n == null || n(O, j), Y(!1);
    },
    [G, j, n]
  ), $ = te(
    (f) => {
      m(f.text), i == null || i(f.text), c(f.text);
    },
    [i, c]
  ), o = te(
    (f) => {
      const O = v.length - 1;
      switch (f.key) {
        case "ArrowDown":
          f.preventDefault(), z((F) => Math.min(F + 1, O));
          break;
        case "ArrowUp":
          f.preventDefault(), z((F) => Math.max(F - 1, -1));
          break;
        case "Enter":
          f.preventDefault(), h >= 0 && v[h] ? $(v[h]) : c();
          break;
        case "Escape":
          Y(!1);
          break;
      }
    },
    [v, h, $, c]
  ), x = (f) => {
    switch (f) {
      case "recent":
        return /* @__PURE__ */ e(Me, { className: "h-4 w-4 text-muted-foreground" });
      case "popular":
        return /* @__PURE__ */ e(Nt, { className: "h-4 w-4 text-muted-foreground" });
      default:
        return /* @__PURE__ */ e(we, { className: "h-4 w-4 text-muted-foreground" });
    }
  };
  return /* @__PURE__ */ t("div", { className: l("relative w-full", S), children: [
    /* @__PURE__ */ t("div", { className: "flex items-center gap-2 px-3 py-2 border rounded-lg bg-background focus-within:ring-2 focus-within:ring-primary", children: [
      /* @__PURE__ */ e(we, { className: "h-4 w-4 text-muted-foreground shrink-0" }),
      j.map((f) => /* @__PURE__ */ t(ae, { variant: "default", className: "shrink-0 gap-1", children: [
        f.label,
        ": ",
        f.value,
        f.removable !== !1 && D && /* @__PURE__ */ e(
          "button",
          {
            onClick: () => D(f.id),
            className: "ml-1 hover:text-destructive",
            children: /* @__PURE__ */ e(he, { className: "h-3 w-3" })
          }
        )
      ] }, f.id)),
      /* @__PURE__ */ e(
        "input",
        {
          ref: U,
          type: "text",
          value: G,
          onChange: b,
          onFocus: () => Y(!0),
          onKeyDown: o,
          placeholder: r,
          className: "flex-1 min-w-[120px] bg-transparent outline-none text-foreground placeholder:text-muted-foreground"
        }
      ),
      G && /* @__PURE__ */ e(
        "button",
        {
          onClick: () => {
            var f;
            m(""), i == null || i(""), (f = U.current) == null || f.focus();
          },
          className: "text-muted-foreground hover:text-foreground",
          children: /* @__PURE__ */ e(he, { className: "h-4 w-4" })
        }
      ),
      N && /* @__PURE__ */ e("div", { className: "w-4 h-4 border-2 border-primary border-t-transparent rounded-full animate-spin" })
    ] }),
    Q && v.length > 0 && /* @__PURE__ */ t(
      "div",
      {
        ref: T,
        className: "absolute top-full left-0 right-0 mt-1 bg-popover border rounded-lg shadow-lg overflow-hidden z-50",
        children: [
          !G && A.length > 0 && /* @__PURE__ */ e("div", { className: "px-3 py-2 border-b", children: /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground font-medium", children: "Recent searches" }) }),
          v.map((f, O) => /* @__PURE__ */ t(
            "button",
            {
              onClick: () => $(f),
              onMouseEnter: () => z(O),
              className: l(
                "w-full flex items-center gap-3 px-3 py-2 text-left transition-colors",
                O === h ? "bg-accent" : "hover:bg-accent/50"
              ),
              children: [
                x(f.type),
                /* @__PURE__ */ e("span", { className: "flex-1 truncate", children: f.text }),
                f.category && /* @__PURE__ */ e(ae, { variant: "default", className: "text-xs", children: f.category }),
                O === h && /* @__PURE__ */ e(Fe, { className: "h-4 w-4" })
              ]
            },
            f.id
          ))
        ]
      }
    ),
    y && y.length > 0 && Q && /* @__PURE__ */ e(
      "div",
      {
        ref: T,
        className: "absolute top-full left-0 right-0 mt-1 bg-popover border rounded-lg shadow-lg overflow-hidden z-50 max-h-[400px] overflow-y-auto",
        children: y.map((f) => /* @__PURE__ */ t(
          "button",
          {
            onClick: () => p == null ? void 0 : p(f),
            className: "w-full flex items-start gap-3 px-3 py-3 text-left hover:bg-accent transition-colors border-b last:border-b-0",
            children: [
              f.icon && /* @__PURE__ */ e("span", { className: "shrink-0 text-muted-foreground", children: f.icon }),
              /* @__PURE__ */ t("div", { className: "flex-1 min-w-0", children: [
                /* @__PURE__ */ e(a, { variant: "body", className: "font-medium truncate", children: f.title }),
                f.description && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground line-clamp-1", children: f.description })
              ] }),
              f.category && /* @__PURE__ */ e(ae, { variant: "default", className: "shrink-0", children: f.category })
            ]
          },
          f.id
        ))
      }
    )
  ] });
};
ol.displayName = "SmartSearch";
const ml = ({
  title: r = "Getting started",
  subtitle: C,
  items: i,
  onDismiss: n,
  onComplete: p,
  showDismiss: j = !0,
  collapseCompleted: D = !1,
  variant: E = "card",
  position: y = "bottom-right",
  className: N
}) => {
  const A = i.filter((m) => m.completed).length, _ = i.length, w = _ > 0 ? A / _ * 100 : 0, s = A === _;
  Ae.useEffect(() => {
    s && p && p();
  }, [s, p]);
  const S = D ? i.filter((m) => !m.completed || m.active) : i, g = /* @__PURE__ */ t(me, { children: [
    /* @__PURE__ */ t("div", { className: "flex items-start justify-between gap-4 mb-4", children: [
      /* @__PURE__ */ t("div", { children: [
        /* @__PURE__ */ e(a, { variant: "h4", className: "font-semibold", children: r }),
        C && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: C })
      ] }),
      j && n && /* @__PURE__ */ e(
        "button",
        {
          onClick: n,
          className: "text-muted-foreground hover:text-foreground transition-colors",
          "aria-label": "Dismiss",
          children: /* @__PURE__ */ e(he, { className: "h-4 w-4" })
        }
      )
    ] }),
    /* @__PURE__ */ t("div", { className: "mb-4", children: [
      /* @__PURE__ */ t("div", { className: "flex items-center justify-between text-sm mb-1", children: [
        /* @__PURE__ */ t("span", { className: "text-muted-foreground", children: [
          A,
          " of ",
          _,
          " complete"
        ] }),
        /* @__PURE__ */ t("span", { className: "font-medium", children: [
          Math.round(w),
          "%"
        ] })
      ] }),
      /* @__PURE__ */ e("div", { className: "h-2 bg-muted rounded-full overflow-hidden", children: /* @__PURE__ */ e(
        "div",
        {
          className: "h-full bg-primary transition-all duration-500 ease-out rounded-full",
          style: { width: `${w}%` }
        }
      ) })
    ] }),
    /* @__PURE__ */ e("div", { className: "space-y-2", children: S.map((m) => /* @__PURE__ */ t(
      "div",
      {
        className: l(
          "flex items-start gap-3 p-3 rounded-lg transition-colors",
          m.active && "bg-primary/5 border border-primary/20",
          !m.active && !m.completed && "hover:bg-muted/50"
        ),
        children: [
          /* @__PURE__ */ e("div", { className: "shrink-0 mt-0.5", children: m.completed ? /* @__PURE__ */ e("div", { className: "h-5 w-5 rounded-full bg-success flex items-center justify-center", children: /* @__PURE__ */ e(fe, { className: "h-3 w-3 text-success-foreground" }) }) : /* @__PURE__ */ e(gt, { className: l(
            "h-5 w-5",
            m.active ? "text-primary" : "text-muted-foreground"
          ) }) }),
          /* @__PURE__ */ t("div", { className: "flex-1 min-w-0", children: [
            /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ e(
                a,
                {
                  variant: "body",
                  className: l(
                    "font-medium",
                    m.completed && "line-through text-muted-foreground"
                  ),
                  children: m.title
                }
              ),
              m.timeEstimate && !m.completed && /* @__PURE__ */ e("span", { className: "text-xs text-muted-foreground", children: m.timeEstimate })
            ] }),
            m.description && !m.completed && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: m.description })
          ] }),
          m.action && !m.completed && /* @__PURE__ */ t(
            u,
            {
              variant: "ghost",
              size: "sm",
              onClick: m.action.onClick,
              className: "shrink-0",
              children: [
                m.action.label,
                /* @__PURE__ */ e(Ne, { className: "h-4 w-4 ml-1" })
              ]
            }
          )
        ]
      },
      m.id
    )) }),
    s && /* @__PURE__ */ e("div", { className: "mt-4 p-3 bg-success/10 rounded-lg text-center", children: /* @__PURE__ */ e(a, { variant: "body", className: "font-medium text-success", children: "All done! You're all set up." }) })
  ] });
  return E === "floating" ? /* @__PURE__ */ e(
    "div",
    {
      className: l(
        "fixed z-50 w-80",
        y === "bottom-right" && "bottom-4 right-4",
        y === "bottom-left" && "bottom-4 left-4",
        N
      ),
      children: /* @__PURE__ */ e(ne, { className: "p-4 shadow-lg", children: g })
    }
  ) : E === "inline" ? /* @__PURE__ */ e("div", { className: l("p-4", N), children: g }) : /* @__PURE__ */ e(ne, { className: l("p-4", N), children: g });
};
ml.displayName = "OnboardingChecklist";
const hl = ({
  daysRemaining: r,
  endDate: C,
  planName: i = "Pro",
  onUpgrade: n,
  onDismiss: p,
  dismissible: j = !0,
  message: D,
  urgencyThreshold: E = 3,
  variant: y = "bar",
  position: N = "top",
  className: A
}) => {
  const _ = r <= E, w = r <= 0, S = D || (w ? `Your ${i} trial has ended. Upgrade now to keep your features.` : r === 1 ? `Last day of your ${i} trial! Upgrade to keep your features.` : `${r} days left in your ${i} trial.`), g = (m) => new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric"
  }).format(m);
  return y === "minimal" ? /* @__PURE__ */ t(
    "div",
    {
      className: l(
        "inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm",
        w && "bg-destructive/10 text-destructive",
        _ && !w && "bg-warning/10 text-warning",
        !_ && !w && "bg-primary/10 text-primary",
        A
      ),
      children: [
        /* @__PURE__ */ e(Me, { className: "h-3.5 w-3.5" }),
        /* @__PURE__ */ e("span", { className: "font-medium", children: w ? "Trial ended" : `${r}d left` }),
        /* @__PURE__ */ e(
          u,
          {
            variant: "ghost",
            size: "sm",
            onClick: n,
            className: "h-auto py-0.5 px-2 text-xs",
            children: "Upgrade"
          }
        )
      ]
    }
  ) : y === "card" ? /* @__PURE__ */ t(
    "div",
    {
      className: l(
        "relative p-4 rounded-lg border",
        w && "bg-destructive/5 border-destructive/20",
        _ && !w && "bg-warning/5 border-warning/20",
        !_ && !w && "bg-primary/5 border-primary/20",
        A
      ),
      children: [
        j && p && /* @__PURE__ */ e(
          "button",
          {
            onClick: p,
            className: "absolute top-2 right-2 text-muted-foreground hover:text-foreground",
            "aria-label": "Dismiss",
            children: /* @__PURE__ */ e(he, { className: "h-4 w-4" })
          }
        ),
        /* @__PURE__ */ t("div", { className: "flex items-start gap-3", children: [
          /* @__PURE__ */ e("div", { className: l(
            "p-2 rounded-lg",
            w && "bg-destructive/10",
            _ && !w && "bg-warning/10",
            !_ && !w && "bg-primary/10"
          ), children: w || _ ? /* @__PURE__ */ e(ze, { className: l(
            "h-5 w-5",
            w ? "text-destructive" : "text-warning"
          ) }) : /* @__PURE__ */ e(Me, { className: "h-5 w-5 text-primary" }) }),
          /* @__PURE__ */ t("div", { className: "flex-1", children: [
            /* @__PURE__ */ e(a, { variant: "body", className: "font-medium", children: S }),
            C && /* @__PURE__ */ t(a, { variant: "caption", className: "text-muted-foreground", children: [
              "Trial ends ",
              g(C)
            ] }),
            /* @__PURE__ */ t("div", { className: "mt-3 flex items-center gap-2", children: [
              /* @__PURE__ */ t(
                u,
                {
                  variant: _ ? "primary" : "outline",
                  size: "sm",
                  onClick: n,
                  children: [
                    /* @__PURE__ */ e(Be, { className: "h-4 w-4 mr-1" }),
                    "Upgrade now"
                  ]
                }
              ),
              !w && /* @__PURE__ */ t(a, { variant: "caption", className: "text-muted-foreground", children: [
                "Keep all your ",
                i,
                " features"
              ] })
            ] })
          ] })
        ] })
      ]
    }
  ) : /* @__PURE__ */ e(
    "div",
    {
      className: l(
        "w-full px-4 py-2",
        w && "bg-destructive text-destructive-foreground",
        _ && !w && "bg-warning text-warning-foreground",
        !_ && !w && "bg-primary text-primary-foreground",
        N === "top" && "fixed top-0 left-0 right-0 z-50",
        N === "bottom" && "fixed bottom-0 left-0 right-0 z-50",
        A
      ),
      children: /* @__PURE__ */ t("div", { className: "max-w-7xl mx-auto flex items-center justify-between gap-4", children: [
        /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
          w || _ ? /* @__PURE__ */ e(ze, { className: "h-4 w-4 shrink-0" }) : /* @__PURE__ */ e(Me, { className: "h-4 w-4 shrink-0" }),
          /* @__PURE__ */ e(a, { variant: "body", className: "text-sm", children: S })
        ] }),
        /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ t(
            u,
            {
              variant: "secondary",
              size: "sm",
              onClick: n,
              className: l(
                w && "bg-destructive-foreground text-destructive hover:bg-destructive-foreground/90",
                _ && !w && "bg-warning-foreground text-warning hover:bg-warning-foreground/90",
                !_ && !w && "bg-primary-foreground text-primary hover:bg-primary-foreground/90"
              ),
              children: [
                /* @__PURE__ */ e(Be, { className: "h-4 w-4 mr-1" }),
                "Upgrade"
              ]
            }
          ),
          j && p && /* @__PURE__ */ e(
            "button",
            {
              onClick: p,
              className: "p-1 hover:opacity-80 transition-opacity",
              "aria-label": "Dismiss",
              children: /* @__PURE__ */ e(he, { className: "h-4 w-4" })
            }
          )
        ] })
      ] })
    }
  );
};
hl.displayName = "TrialBanner";
const ul = {
  "no-data": {
    icon: /* @__PURE__ */ e(rt, { className: "h-12 w-12" }),
    title: "No data yet",
    description: "Get started by adding your first item."
  },
  "no-results": {
    icon: /* @__PURE__ */ e(we, { className: "h-12 w-12" }),
    title: "No results found",
    description: "Try adjusting your search or filters."
  },
  "no-projects": {
    icon: /* @__PURE__ */ e(ua, { className: "h-12 w-12" }),
    title: "No projects yet",
    description: "Create your first project to get started."
  },
  "no-team": {
    icon: /* @__PURE__ */ e(Se, { className: "h-12 w-12" }),
    title: "No team members",
    description: "Invite people to collaborate with you."
  },
  "no-notifications": {
    icon: /* @__PURE__ */ e(We, { className: "h-12 w-12" }),
    title: "All caught up!",
    description: "You don't have any notifications right now."
  },
  error: {
    icon: /* @__PURE__ */ e(Xe, { className: "h-12 w-12" }),
    title: "Something went wrong",
    description: "We had trouble loading this content. Please try again."
  },
  custom: {
    icon: /* @__PURE__ */ e(Oe, { className: "h-12 w-12" }),
    title: "Nothing here",
    description: "This section is empty."
  }
}, bt = ({
  preset: r = "no-data",
  icon: C,
  title: i,
  description: n,
  action: p,
  secondaryAction: j,
  size: D = "md",
  bordered: E = !1,
  className: y
}) => {
  const N = ul[r], A = C || N.icon, _ = i || N.title, w = n || N.description, s = {
    sm: "py-8",
    md: "py-12",
    lg: "py-16"
  }, S = {
    sm: "[&>svg]:h-8 [&>svg]:w-8",
    md: "[&>svg]:h-12 [&>svg]:w-12",
    lg: "[&>svg]:h-16 [&>svg]:w-16"
  }, g = /* @__PURE__ */ t(
    "div",
    {
      className: l(
        "flex flex-col items-center justify-center text-center px-4",
        s[D],
        y
      ),
      children: [
        /* @__PURE__ */ e(
          "div",
          {
            className: l(
              "text-muted-foreground/50 mb-4",
              S[D]
            ),
            children: A
          }
        ),
        /* @__PURE__ */ e(
          a,
          {
            variant: D === "lg" ? "h3" : D === "sm" ? "body" : "h4",
            className: "font-semibold mb-2",
            children: _
          }
        ),
        /* @__PURE__ */ e(
          a,
          {
            variant: D === "sm" ? "caption" : "body",
            className: "text-muted-foreground max-w-md mb-6",
            children: w
          }
        ),
        (p || j) && /* @__PURE__ */ t("div", { className: "flex items-center gap-3", children: [
          p && /* @__PURE__ */ t(
            u,
            {
              variant: p.variant || "primary",
              size: D === "sm" ? "sm" : "md",
              onClick: p.onClick,
              children: [
                p.icon,
                p.label
              ]
            }
          ),
          j && /* @__PURE__ */ t(
            u,
            {
              variant: j.variant || "outline",
              size: D === "sm" ? "sm" : "md",
              onClick: j.onClick,
              children: [
                j.icon,
                j.label
              ]
            }
          )
        ] })
      ]
    }
  );
  return E ? /* @__PURE__ */ e("div", { className: "border border-dashed rounded-lg", children: g }) : g;
}, an = (r) => /* @__PURE__ */ e(bt, { preset: "no-data", ...r }), rn = (r) => /* @__PURE__ */ e(bt, { preset: "no-results", ...r }), sn = (r) => /* @__PURE__ */ e(bt, { preset: "error", ...r });
bt.displayName = "EmptyState";
const pl = ({
  type: r = "rating",
  question: C,
  placeholder: i = "Tell us more (optional)...",
  onSubmit: n,
  onDismiss: p,
  showThankYou: j = !0,
  thankYouMessage: D = "Thank you for your feedback!",
  dismissible: E = !0,
  variant: y = "card",
  position: N = "bottom-right",
  className: A
}) => {
  const [_, w] = P(null), [s, S] = P(""), [g, m] = P(!1), [d, M] = P(null), Y = C || {
    nps: "How likely are you to recommend us to a friend or colleague?",
    rating: "How would you rate your experience?",
    thumbs: "Was this helpful?",
    text: "What can we improve?",
    combined: "How was your experience?"
  }[r], h = () => {
    n({
      type: r,
      score: _ ?? void 0,
      text: s || void 0,
      timestamp: /* @__PURE__ */ new Date()
    }), m(!0);
  }, z = () => /* @__PURE__ */ t("div", { className: "space-y-3", children: [
    /* @__PURE__ */ t("div", { className: "flex justify-between text-xs text-muted-foreground", children: [
      /* @__PURE__ */ e("span", { children: "Not likely" }),
      /* @__PURE__ */ e("span", { children: "Very likely" })
    ] }),
    /* @__PURE__ */ e("div", { className: "flex gap-1", children: Array.from({ length: 11 }, (Q, v) => /* @__PURE__ */ e(
      "button",
      {
        onClick: () => w(v),
        className: l(
          "flex-1 h-10 rounded text-sm font-medium transition-all",
          _ === v ? v <= 6 ? "bg-destructive text-destructive-foreground" : v <= 8 ? "bg-warning text-warning-foreground" : "bg-success text-success-foreground" : "bg-muted hover:bg-muted/80"
        ),
        children: v
      },
      v
    )) })
  ] }), U = () => /* @__PURE__ */ e("div", { className: "flex gap-1 justify-center", children: Array.from({ length: 5 }, (Q, v) => {
    const b = v + 1, c = (d ?? _ ?? 0) >= b;
    return /* @__PURE__ */ e(
      "button",
      {
        onClick: () => w(b),
        onMouseEnter: () => M(b),
        onMouseLeave: () => M(null),
        className: "p-1 transition-transform hover:scale-110",
        children: /* @__PURE__ */ e(
          $e,
          {
            className: l(
              "h-8 w-8 transition-colors",
              c ? "fill-warning text-warning" : "text-muted-foreground"
            )
          }
        )
      },
      v
    );
  }) }), T = () => /* @__PURE__ */ t("div", { className: "flex gap-4 justify-center", children: [
    /* @__PURE__ */ e(
      "button",
      {
        onClick: () => w(1),
        className: l(
          "p-4 rounded-lg transition-all",
          _ === 1 ? "bg-success/20 text-success ring-2 ring-success" : "bg-muted hover:bg-muted/80"
        ),
        children: /* @__PURE__ */ e(pt, { className: "h-8 w-8" })
      }
    ),
    /* @__PURE__ */ e(
      "button",
      {
        onClick: () => w(0),
        className: l(
          "p-4 rounded-lg transition-all",
          _ === 0 ? "bg-destructive/20 text-destructive ring-2 ring-destructive" : "bg-muted hover:bg-muted/80"
        ),
        children: /* @__PURE__ */ e(Rt, { className: "h-8 w-8" })
      }
    )
  ] }), L = () => /* @__PURE__ */ e(
    "textarea",
    {
      value: s,
      onChange: (Q) => S(Q.target.value),
      placeholder: i,
      rows: 3,
      className: "w-full px-3 py-2 border rounded-lg bg-background resize-none focus:outline-none focus:ring-2 focus:ring-primary"
    }
  );
  if (g && j) {
    const Q = /* @__PURE__ */ t("div", { className: "text-center py-6", children: [
      /* @__PURE__ */ e("div", { className: "w-12 h-12 mx-auto mb-3 rounded-full bg-success/20 flex items-center justify-center", children: /* @__PURE__ */ e(pt, { className: "h-6 w-6 text-success" }) }),
      /* @__PURE__ */ e(a, { variant: "body", className: "font-medium", children: D })
    ] });
    return y === "floating" ? /* @__PURE__ */ e("div", { className: l(
      "fixed z-50 w-80",
      N === "bottom-right" && "bottom-4 right-4",
      N === "bottom-left" && "bottom-4 left-4",
      N === "bottom-center" && "bottom-4 left-1/2 -translate-x-1/2",
      A
    ), children: /* @__PURE__ */ e(ne, { className: "p-4 shadow-lg", children: Q }) }) : y === "card" ? /* @__PURE__ */ e(ne, { className: l("p-4", A), children: Q }) : /* @__PURE__ */ e("div", { className: A, children: Q });
  }
  const G = /* @__PURE__ */ t(me, { children: [
    /* @__PURE__ */ t("div", { className: "flex items-start justify-between gap-4 mb-4", children: [
      /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ e(ut, { className: "h-5 w-5 text-muted-foreground" }),
        /* @__PURE__ */ e(a, { variant: "body", className: "font-medium", children: Y })
      ] }),
      E && p && /* @__PURE__ */ e(
        "button",
        {
          onClick: p,
          className: "text-muted-foreground hover:text-foreground",
          children: /* @__PURE__ */ e(he, { className: "h-4 w-4" })
        }
      )
    ] }),
    /* @__PURE__ */ t("div", { className: "space-y-4", children: [
      r === "nps" && z(),
      r === "rating" && U(),
      r === "thumbs" && T(),
      r === "text" && L(),
      r === "combined" && /* @__PURE__ */ t(me, { children: [
        U(),
        /* @__PURE__ */ e("div", { className: "mt-4", children: L() })
      ] }),
      r !== "text" && _ !== null && /* @__PURE__ */ e("div", { className: "mt-4", children: L() })
    ] }),
    (_ !== null || r === "text") && /* @__PURE__ */ e("div", { className: "mt-4 flex justify-end", children: /* @__PURE__ */ t(
      u,
      {
        variant: "primary",
        onClick: h,
        disabled: r === "text" && !s.trim(),
        children: [
          /* @__PURE__ */ e(tt, { className: "h-4 w-4 mr-2" }),
          "Submit feedback"
        ]
      }
    ) })
  ] });
  return y === "floating" ? /* @__PURE__ */ e("div", { className: l(
    "fixed z-50 w-96",
    N === "bottom-right" && "bottom-4 right-4",
    N === "bottom-left" && "bottom-4 left-4",
    N === "bottom-center" && "bottom-4 left-1/2 -translate-x-1/2",
    A
  ), children: /* @__PURE__ */ e(ne, { className: "p-4 shadow-lg", children: G }) }) : y === "card" ? /* @__PURE__ */ e(ne, { className: l("p-4", A), children: G }) : /* @__PURE__ */ e("div", { className: l("p-4", A), children: G });
};
pl.displayName = "FeedbackCollector";
const fl = ({
  title: r,
  description: C,
  items: i,
  collapsible: n = !1,
  defaultCollapsed: p = !1,
  onSave: j,
  onCancel: D,
  showActions: E = !1,
  isSaving: y = !1,
  hasChanges: N = !1,
  icon: A,
  className: _
}) => {
  const [w, s] = P(p), S = (g) => {
    const m = g.href || g.onClick;
    return /* @__PURE__ */ t(
      m ? "button" : "div",
      {
        onClick: g.onClick,
        className: l(
          "w-full flex items-center gap-4 py-4 border-b last:border-b-0",
          m && "hover:bg-muted/30 -mx-4 px-4 transition-colors text-left",
          g.dangerous && "hover:bg-destructive/5"
        ),
        children: [
          /* @__PURE__ */ t("div", { className: "flex-1 min-w-0", children: [
            /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ e(
                a,
                {
                  variant: "body",
                  className: l(
                    "font-medium",
                    g.dangerous && "text-destructive"
                  ),
                  children: g.label
                }
              ),
              g.locked && /* @__PURE__ */ e(Pt, { className: "h-3.5 w-3.5 text-muted-foreground" }),
              g.badge && /* @__PURE__ */ e(ae, { variant: g.badge.variant || "default", children: g.badge.label })
            ] }),
            g.description && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: g.description }),
            g.locked && g.lockMessage && /* @__PURE__ */ t(a, { variant: "caption", className: "text-warning flex items-center gap-1 mt-1", children: [
              /* @__PURE__ */ e(Le, { className: "h-3 w-3" }),
              g.lockMessage
            ] })
          ] }),
          /* @__PURE__ */ t("div", { className: "shrink-0 flex items-center gap-2", children: [
            g.value && !g.control && /* @__PURE__ */ e(a, { variant: "body", className: "text-muted-foreground", children: g.value }),
            g.control && !g.locked && g.control,
            g.locked && /* @__PURE__ */ e(u, { variant: "outline", size: "sm", children: "Upgrade" }),
            m && /* @__PURE__ */ e(Ne, { className: "h-4 w-4 text-muted-foreground" })
          ] })
        ]
      },
      g.id
    );
  };
  return /* @__PURE__ */ t(ne, { className: l("overflow-hidden", _), children: [
    /* @__PURE__ */ e(
      "div",
      {
        className: l(
          "px-6 py-4 border-b bg-muted/30",
          n && "cursor-pointer hover:bg-muted/50 transition-colors"
        ),
        onClick: n ? () => s(!w) : void 0,
        children: /* @__PURE__ */ t("div", { className: "flex items-center gap-3", children: [
          A && /* @__PURE__ */ e("div", { className: "text-muted-foreground", children: A }),
          /* @__PURE__ */ t("div", { className: "flex-1", children: [
            /* @__PURE__ */ e(a, { variant: "h4", className: "font-semibold", children: r }),
            C && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: C })
          ] }),
          n && /* @__PURE__ */ e(
            Ne,
            {
              className: l(
                "h-5 w-5 text-muted-foreground transition-transform",
                !w && "rotate-90"
              )
            }
          )
        ] })
      }
    ),
    !w && /* @__PURE__ */ e("div", { className: "px-6", children: i.map(S) }),
    E && !w && /* @__PURE__ */ t("div", { className: "px-6 py-4 border-t bg-muted/20 flex items-center justify-between", children: [
      /* @__PURE__ */ e("div", { children: N && /* @__PURE__ */ e(a, { variant: "caption", className: "text-warning", children: "You have unsaved changes" }) }),
      /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
        D && /* @__PURE__ */ e(
          u,
          {
            variant: "ghost",
            onClick: D,
            disabled: y,
            children: "Cancel"
          }
        ),
        j && /* @__PURE__ */ e(
          u,
          {
            variant: "primary",
            onClick: j,
            isLoading: y,
            disabled: !N,
            children: "Save changes"
          }
        )
      ] })
    ] })
  ] });
};
fl.displayName = "SettingsSection";
const gl = ({
  title: r = "Usage",
  period: C,
  metrics: i,
  onUpgrade: n,
  onViewDetails: p,
  planName: j,
  daysUntilReset: D,
  variant: E = "card",
  className: y
}) => {
  const N = (g, m) => Math.min(g / m * 100, 100), A = (g) => {
    const m = N(g.current, g.limit), d = g.warnAt ?? 80;
    return g.current >= g.limit ? g.softLimit ? "exceeded" : "maxed" : m >= d ? "warning" : "normal";
  }, _ = (g, m) => g >= 1e6 ? `${(g / 1e6).toFixed(1)}M${m ? ` ${m}` : ""}` : g >= 1e3 ? `${(g / 1e3).toFixed(1)}K${m ? ` ${m}` : ""}` : `${g}${m ? ` ${m}` : ""}`, w = i.some((g) => {
    const m = A(g);
    return m === "warning" || m === "exceeded" || m === "maxed";
  }), s = (g) => {
    const m = N(g.current, g.limit), d = A(g);
    return /* @__PURE__ */ t("div", { className: "space-y-2", children: [
      /* @__PURE__ */ t("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
          g.icon && /* @__PURE__ */ e("span", { className: "text-muted-foreground", children: g.icon }),
          /* @__PURE__ */ e(a, { variant: "body", className: "font-medium", children: g.label })
        ] }),
        /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ t(a, { variant: "body", className: "text-sm", children: [
            /* @__PURE__ */ e("span", { className: l(
              d === "maxed" && "text-destructive font-semibold",
              d === "exceeded" && "text-warning font-semibold",
              d === "warning" && "text-warning"
            ), children: _(g.current) }),
            /* @__PURE__ */ t("span", { className: "text-muted-foreground", children: [
              " / ",
              _(g.limit, g.unit)
            ] })
          ] }),
          d === "maxed" && /* @__PURE__ */ e(ae, { variant: "red", children: "Limit reached" }),
          d === "exceeded" && /* @__PURE__ */ e(ae, { variant: "yellow", children: "Over limit" })
        ] })
      ] }),
      /* @__PURE__ */ e("div", { className: "h-2 bg-muted rounded-full overflow-hidden", children: /* @__PURE__ */ e(
        "div",
        {
          className: l(
            "h-full rounded-full transition-all duration-500",
            d === "normal" && "bg-primary",
            d === "warning" && "bg-warning",
            (d === "exceeded" || d === "maxed") && "bg-destructive"
          ),
          style: { width: `${Math.min(m, 100)}%` }
        }
      ) })
    ] }, g.id);
  };
  if (E === "compact")
    return /* @__PURE__ */ e("div", { className: l("space-y-3", y), children: i.map((g) => {
      const m = N(g.current, g.limit), d = A(g);
      return /* @__PURE__ */ t("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ e(a, { variant: "caption", className: "w-24 truncate", children: g.label }),
        /* @__PURE__ */ e("div", { className: "flex-1 h-1.5 bg-muted rounded-full overflow-hidden", children: /* @__PURE__ */ e(
          "div",
          {
            className: l(
              "h-full rounded-full",
              d === "normal" && "bg-primary",
              d === "warning" && "bg-warning",
              (d === "exceeded" || d === "maxed") && "bg-destructive"
            ),
            style: { width: `${Math.min(m, 100)}%` }
          }
        ) }),
        /* @__PURE__ */ t(a, { variant: "caption", className: "w-16 text-right text-muted-foreground", children: [
          Math.round(m),
          "%"
        ] })
      ] }, g.id);
    }) });
  const S = /* @__PURE__ */ t(me, { children: [
    /* @__PURE__ */ t("div", { className: "flex items-start justify-between mb-6", children: [
      /* @__PURE__ */ t("div", { children: [
        /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ e(a, { variant: "h4", className: "font-semibold", children: r }),
          w && /* @__PURE__ */ e(ze, { className: "h-4 w-4 text-warning" })
        ] }),
        (C || j) && /* @__PURE__ */ t("div", { className: "flex items-center gap-2 mt-1", children: [
          j && /* @__PURE__ */ t(ae, { variant: "default", children: [
            j,
            " plan"
          ] }),
          C && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: C })
        ] })
      ] }),
      D !== void 0 && /* @__PURE__ */ t("div", { className: "text-right", children: [
        /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: "Resets in" }),
        /* @__PURE__ */ t(a, { variant: "body", className: "font-semibold", children: [
          D,
          " days"
        ] })
      ] })
    ] }),
    /* @__PURE__ */ e("div", { className: "space-y-4", children: i.map(s) }),
    (n || p) && /* @__PURE__ */ t("div", { className: "mt-6 flex items-center gap-3", children: [
      n && w && /* @__PURE__ */ t(u, { variant: "primary", onClick: n, children: [
        /* @__PURE__ */ e(Be, { className: "h-4 w-4 mr-2" }),
        "Upgrade for more"
      ] }),
      p && /* @__PURE__ */ t(u, { variant: "ghost", onClick: p, children: [
        /* @__PURE__ */ e(Nt, { className: "h-4 w-4 mr-2" }),
        "View details"
      ] })
    ] })
  ] });
  return E === "detailed" ? /* @__PURE__ */ e("div", { className: l("p-6", y), children: S }) : /* @__PURE__ */ e(ne, { className: l("p-6", y), children: S });
};
gl.displayName = "UsageMeter";
const Mt = {
  visa: "Visa",
  mastercard: "Mastercard",
  amex: "Amex",
  discover: "Discover",
  other: "Card"
}, vl = ({
  cards: r = [],
  onAddCard: C,
  onSetDefault: i,
  onRemoveCard: n,
  onUpdateCard: p,
  isLoading: j = !1,
  loadingCardId: D,
  maxCards: E = 5,
  title: y = "Payment methods",
  className: N
}) => {
  const [A, _] = P(null), w = Array.isArray(r) ? r : [], s = w.length < E, S = (d, M) => !Number.isFinite(d) || !Number.isFinite(M) ? "N/A" : `${String(d).padStart(2, "0")}/${String(M).slice(-2)}`, g = (d) => {
    if (typeof d != "string") return Mt.other;
    const M = d.toLowerCase();
    return Mt[M] ?? Mt.other;
  }, m = (d) => {
    const M = j && D === d.id, K = A === d.id;
    return /* @__PURE__ */ t(
      "div",
      {
        className: l(
          "flex items-center gap-4 p-4 border rounded-lg",
          d.isDefault && "border-primary bg-primary/5",
          d.isExpired && "border-destructive/50 bg-destructive/5",
          d.isExpiring && !d.isExpired && "border-warning/50 bg-warning/5"
        ),
        children: [
          /* @__PURE__ */ e("div", { className: "shrink-0 w-12 h-8 bg-muted rounded flex items-center justify-center", children: /* @__PURE__ */ e(Wt, { className: "h-5 w-5 text-muted-foreground" }) }),
          /* @__PURE__ */ t("div", { className: "flex-1 min-w-0", children: [
            /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ t(a, { variant: "body", className: "font-medium", children: [
                g(d.brand),
                " •••• ",
                d.last4 ?? "----"
              ] }),
              d.isDefault && /* @__PURE__ */ e(ae, { variant: "blue", children: "Default" }),
              d.isExpired && /* @__PURE__ */ e(ae, { variant: "red", children: "Expired" }),
              d.isExpiring && !d.isExpired && /* @__PURE__ */ e(ae, { variant: "yellow", children: "Expiring soon" })
            ] }),
            /* @__PURE__ */ t(a, { variant: "caption", className: "text-muted-foreground", children: [
              "Expires ",
              S(d.expMonth, d.expYear)
            ] })
          ] }),
          /* @__PURE__ */ e("div", { className: "shrink-0 flex items-center gap-2", children: K ? /* @__PURE__ */ t(me, { children: [
            /* @__PURE__ */ e(a, { variant: "caption", className: "text-destructive mr-2", children: "Remove card?" }),
            /* @__PURE__ */ e(
              u,
              {
                variant: "ghost",
                size: "sm",
                onClick: () => _(null),
                disabled: M,
                children: "Cancel"
              }
            ),
            /* @__PURE__ */ e(
              u,
              {
                variant: "primary",
                size: "sm",
                onClick: () => {
                  n(d.id), _(null);
                },
                isLoading: M,
                className: "bg-destructive hover:bg-destructive/90",
                children: "Remove"
              }
            )
          ] }) : /* @__PURE__ */ t(me, { children: [
            (d.isExpired || d.isExpiring) && p && /* @__PURE__ */ e(
              u,
              {
                variant: "outline",
                size: "sm",
                onClick: () => p(d.id),
                disabled: M,
                children: "Update"
              }
            ),
            !d.isDefault && !d.isExpired && /* @__PURE__ */ t(
              u,
              {
                variant: "ghost",
                size: "sm",
                onClick: () => i(d.id),
                disabled: M,
                children: [
                  /* @__PURE__ */ e(fe, { className: "h-4 w-4 mr-1" }),
                  "Set default"
                ]
              }
            ),
            w.length > 1 && /* @__PURE__ */ e(
              u,
              {
                variant: "ghost",
                size: "sm",
                onClick: () => _(d.id),
                disabled: M,
                className: "text-muted-foreground hover:text-destructive",
                children: /* @__PURE__ */ e(Re, { className: "h-4 w-4" })
              }
            )
          ] }) })
        ]
      },
      d.id
    );
  };
  return /* @__PURE__ */ t(ne, { className: l("p-6", N), children: [
    /* @__PURE__ */ t("div", { className: "flex items-center justify-between mb-4", children: [
      /* @__PURE__ */ e(a, { variant: "h4", className: "font-semibold", children: y }),
      s && /* @__PURE__ */ t(
        u,
        {
          variant: "outline",
          size: "sm",
          onClick: C,
          disabled: j,
          children: [
            /* @__PURE__ */ e(Pe, { className: "h-4 w-4 mr-1" }),
            "Add card"
          ]
        }
      )
    ] }),
    w.length === 0 ? /* @__PURE__ */ t("div", { className: "text-center py-8 border border-dashed rounded-lg", children: [
      /* @__PURE__ */ e(Wt, { className: "h-12 w-12 mx-auto text-muted-foreground/50 mb-3" }),
      /* @__PURE__ */ e(a, { variant: "body", className: "font-medium mb-1", children: "No payment methods" }),
      /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground mb-4", children: "Add a card to enable billing" }),
      /* @__PURE__ */ t(u, { variant: "primary", onClick: C, children: [
        /* @__PURE__ */ e(Pe, { className: "h-4 w-4 mr-2" }),
        "Add payment method"
      ] })
    ] }) : /* @__PURE__ */ e("div", { className: "space-y-3", children: w.map(m) }),
    w.some((d) => d.isExpired) && /* @__PURE__ */ t("div", { className: "mt-4 p-3 bg-destructive/10 rounded-lg flex items-start gap-2", children: [
      /* @__PURE__ */ e(Le, { className: "h-4 w-4 text-destructive shrink-0 mt-0.5" }),
      /* @__PURE__ */ e(a, { variant: "caption", className: "text-destructive", children: "You have expired payment methods. Please update them to avoid service interruption." })
    ] }),
    !s && /* @__PURE__ */ t(a, { variant: "caption", className: "text-muted-foreground mt-4 block", children: [
      "Maximum of ",
      E,
      " payment methods allowed."
    ] })
  ] });
};
vl.displayName = "PaymentMethod";
const xl = [
  {
    format: "csv",
    label: "CSV",
    description: "Comma-separated values, works with Excel",
    icon: /* @__PURE__ */ e(mt, { className: "h-5 w-5" })
  },
  {
    format: "xlsx",
    label: "Excel",
    description: "Native Excel format with formatting",
    icon: /* @__PURE__ */ e(mt, { className: "h-5 w-5" })
  },
  {
    format: "json",
    label: "JSON",
    description: "Structured data for developers",
    icon: /* @__PURE__ */ e(gr, { className: "h-5 w-5" })
  },
  {
    format: "pdf",
    label: "PDF",
    description: "Printable document format",
    icon: /* @__PURE__ */ e(rt, { className: "h-5 w-5" })
  }
], Nl = ({
  title: r = "Export data",
  description: C,
  formats: i = xl,
  onExport: n,
  recordCount: p,
  dateRange: j,
  allowFormatSelection: D = !0,
  defaultFormat: E = "csv",
  isExporting: y = !1,
  progress: N,
  successMessage: A,
  errorMessage: _,
  className: w
}) => {
  var U;
  const [s, S] = P(E), [g, m] = P("idle"), [d, M] = P(null), K = (T) => new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric"
  }).format(T), Y = async () => {
    m("exporting"), M(null);
    try {
      await n(s), m("success");
    } catch (T) {
      m("error"), M(T instanceof Error ? T.message : "Export failed");
    }
  }, h = _ || d, z = g === "success" && !h;
  return /* @__PURE__ */ t(ne, { className: l("p-6", w), children: [
    /* @__PURE__ */ t("div", { className: "mb-6", children: [
      /* @__PURE__ */ t("div", { className: "flex items-center gap-2 mb-1", children: [
        /* @__PURE__ */ e(_e, { className: "h-5 w-5 text-muted-foreground" }),
        /* @__PURE__ */ e(a, { variant: "h4", className: "font-semibold", children: r })
      ] }),
      C && /* @__PURE__ */ e(a, { variant: "body", className: "text-muted-foreground", children: C })
    ] }),
    (p || j) && /* @__PURE__ */ e("div", { className: "mb-6 p-4 bg-muted/30 rounded-lg", children: /* @__PURE__ */ t("div", { className: "flex flex-wrap gap-4 text-sm", children: [
      p && /* @__PURE__ */ t("div", { children: [
        /* @__PURE__ */ e("span", { className: "text-muted-foreground", children: "Records: " }),
        /* @__PURE__ */ e("span", { className: "font-medium", children: p.toLocaleString() })
      ] }),
      j && /* @__PURE__ */ t("div", { children: [
        /* @__PURE__ */ e("span", { className: "text-muted-foreground", children: "Date range: " }),
        /* @__PURE__ */ t("span", { className: "font-medium", children: [
          K(j.start),
          " - ",
          K(j.end)
        ] })
      ] })
    ] }) }),
    D && /* @__PURE__ */ t("div", { className: "mb-6", children: [
      /* @__PURE__ */ e(a, { variant: "body", className: "font-medium mb-3", children: "Select format" }),
      /* @__PURE__ */ e("div", { className: "grid grid-cols-2 gap-3", children: i.map((T) => /* @__PURE__ */ t(
        "button",
        {
          onClick: () => !T.disabled && S(T.format),
          disabled: T.disabled || y || g === "exporting",
          className: l(
            "flex items-start gap-3 p-4 border rounded-lg text-left transition-all",
            s === T.format ? "border-primary bg-primary/5 ring-1 ring-primary" : "hover:border-primary/50 hover:bg-muted/30",
            T.disabled && "opacity-50 cursor-not-allowed"
          ),
          children: [
            /* @__PURE__ */ e("div", { className: l(
              "shrink-0",
              s === T.format ? "text-primary" : "text-muted-foreground"
            ), children: T.icon || /* @__PURE__ */ e(ha, { className: "h-5 w-5" }) }),
            /* @__PURE__ */ t("div", { className: "flex-1 min-w-0", children: [
              /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ e(a, { variant: "body", className: "font-medium", children: T.label }),
                T.estimatedSize && /* @__PURE__ */ t(ae, { variant: "default", className: "text-xs", children: [
                  "~",
                  T.estimatedSize
                ] })
              ] }),
              T.description && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: T.description }),
              T.disabled && T.disabledReason && /* @__PURE__ */ e(a, { variant: "caption", className: "text-warning", children: T.disabledReason })
            ] }),
            s === T.format && /* @__PURE__ */ e(fe, { className: "h-4 w-4 text-primary shrink-0" })
          ]
        },
        T.format
      )) })
    ] }),
    (y || g === "exporting") && /* @__PURE__ */ t("div", { className: "mb-6", children: [
      /* @__PURE__ */ t("div", { className: "flex items-center justify-between mb-2", children: [
        /* @__PURE__ */ e(a, { variant: "body", className: "text-sm", children: "Preparing your export..." }),
        N !== void 0 && /* @__PURE__ */ t(a, { variant: "body", className: "text-sm font-medium", children: [
          N,
          "%"
        ] })
      ] }),
      /* @__PURE__ */ e("div", { className: "h-2 bg-muted rounded-full overflow-hidden", children: /* @__PURE__ */ e(
        "div",
        {
          className: "h-full bg-primary rounded-full transition-all duration-300",
          style: { width: N !== void 0 ? `${N}%` : "30%" }
        }
      ) })
    ] }),
    z && /* @__PURE__ */ t("div", { className: "mb-6 p-4 bg-success/10 rounded-lg flex items-center gap-3", children: [
      /* @__PURE__ */ e(fe, { className: "h-5 w-5 text-success shrink-0" }),
      /* @__PURE__ */ e(a, { variant: "body", className: "text-success", children: A || "Export completed! Your download should start automatically." })
    ] }),
    h && /* @__PURE__ */ t("div", { className: "mb-6 p-4 bg-destructive/10 rounded-lg flex items-center gap-3", children: [
      /* @__PURE__ */ e(Le, { className: "h-5 w-5 text-destructive shrink-0" }),
      /* @__PURE__ */ e("div", { className: "flex-1", children: /* @__PURE__ */ e(a, { variant: "body", className: "text-destructive", children: h }) }),
      /* @__PURE__ */ e(
        u,
        {
          variant: "ghost",
          size: "sm",
          onClick: () => {
            m("idle"), M(null);
          },
          children: "Try again"
        }
      )
    ] }),
    /* @__PURE__ */ e(
      u,
      {
        variant: "primary",
        onClick: Y,
        disabled: y || g === "exporting",
        className: "w-full",
        children: y || g === "exporting" ? /* @__PURE__ */ t(me, { children: [
          /* @__PURE__ */ e(ye, { className: "h-4 w-4 mr-2 animate-spin" }),
          "Exporting..."
        ] }) : /* @__PURE__ */ t(me, { children: [
          /* @__PURE__ */ e(_e, { className: "h-4 w-4 mr-2" }),
          "Export as ",
          ((U = i.find((T) => T.format === s)) == null ? void 0 : U.label) || s.toUpperCase()
        ] })
      }
    )
  ] });
};
Nl.displayName = "ExportData";
const bl = ({
  isOpen: r,
  onClose: C,
  onConfirm: i,
  title: n,
  description: p,
  consequences: j = [],
  confirmationText: D,
  confirmationHint: E,
  confirmLabel: y = "Delete",
  cancelLabel: N = "Cancel",
  isLoading: A = !1,
  icon: _,
  requireCheckbox: w = !1,
  checkboxLabel: s = "I understand this action cannot be undone",
  className: S
}) => {
  const [g, m] = P(""), [d, M] = P(!1), K = !!D, Y = !K || g === D, z = Y && (!w || d) && !A;
  if (Ae.useEffect(() => {
    r || (m(""), M(!1));
  }, [r]), !r) return null;
  const U = {
    info: "text-muted-foreground",
    warning: "text-warning",
    critical: "text-destructive"
  }, T = {
    info: "bg-muted-foreground",
    warning: "bg-warning",
    critical: "bg-destructive"
  };
  return /* @__PURE__ */ t(
    "div",
    {
      className: "fixed inset-0 z-50 flex items-start sm:items-center justify-center p-4 overflow-y-auto",
      onClick: C,
      children: [
        /* @__PURE__ */ e("div", { className: "fixed inset-0 bg-background/80 backdrop-blur-sm" }),
        /* @__PURE__ */ t(
          "div",
          {
            className: l(
              "relative w-full max-w-md my-4 sm:my-8 bg-popover border rounded-xl shadow-2xl overflow-hidden",
              S
            ),
            onClick: (L) => L.stopPropagation(),
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "destructive-title",
            "aria-describedby": "destructive-description",
            children: [
              /* @__PURE__ */ e("div", { className: "p-6 pb-4", children: /* @__PURE__ */ t("div", { className: "flex items-start gap-4", children: [
                /* @__PURE__ */ e("div", { className: "shrink-0 p-3 bg-destructive/10 rounded-full", children: _ || /* @__PURE__ */ e(ze, { className: "h-6 w-6 text-destructive" }) }),
                /* @__PURE__ */ t("div", { className: "flex-1 min-w-0", children: [
                  /* @__PURE__ */ e(
                    a,
                    {
                      id: "destructive-title",
                      variant: "h4",
                      className: "font-semibold text-destructive",
                      children: n
                    }
                  ),
                  p && /* @__PURE__ */ e(
                    a,
                    {
                      id: "destructive-description",
                      variant: "body",
                      className: "text-muted-foreground mt-1",
                      children: p
                    }
                  )
                ] }),
                /* @__PURE__ */ e(
                  "button",
                  {
                    onClick: C,
                    className: "shrink-0 text-muted-foreground hover:text-foreground transition-colors",
                    "aria-label": "Close",
                    children: /* @__PURE__ */ e(he, { className: "h-5 w-5" })
                  }
                )
              ] }) }),
              j.length > 0 && /* @__PURE__ */ e("div", { className: "px-6 pb-4", children: /* @__PURE__ */ t("div", { className: "p-4 bg-destructive/5 border border-destructive/20 rounded-lg", children: [
                /* @__PURE__ */ e(a, { variant: "body", className: "font-medium mb-2", children: "This action will:" }),
                /* @__PURE__ */ e("ul", { className: "space-y-2", children: j.map((L, G) => /* @__PURE__ */ t("li", { className: "flex items-start gap-2", children: [
                  /* @__PURE__ */ e(
                    "span",
                    {
                      className: l(
                        "shrink-0 w-1.5 h-1.5 rounded-full mt-2",
                        T[L.severity || "info"]
                      )
                    }
                  ),
                  /* @__PURE__ */ e(
                    a,
                    {
                      variant: "body",
                      className: l("text-sm", U[L.severity || "info"]),
                      children: L.description
                    }
                  )
                ] }, G)) })
              ] }) }),
              K && /* @__PURE__ */ e("div", { className: "px-6 pb-4", children: /* @__PURE__ */ t("label", { className: "block", children: [
                /* @__PURE__ */ e(a, { variant: "body", className: "text-sm mb-2", children: E || `Type "${D}" to confirm` }),
                /* @__PURE__ */ e(
                  "input",
                  {
                    type: "text",
                    value: g,
                    onChange: (L) => m(L.target.value),
                    placeholder: D,
                    className: l(
                      "w-full px-3 py-2 border rounded-lg bg-background",
                      "focus:outline-none focus:ring-2 focus:ring-destructive",
                      Y && g && "border-success ring-1 ring-success"
                    ),
                    autoComplete: "off",
                    autoFocus: !0
                  }
                )
              ] }) }),
              w && /* @__PURE__ */ e("div", { className: "px-6 pb-4", children: /* @__PURE__ */ t("label", { className: "flex items-start gap-3 cursor-pointer", children: [
                /* @__PURE__ */ e(
                  "input",
                  {
                    type: "checkbox",
                    checked: d,
                    onChange: (L) => M(L.target.checked),
                    className: "mt-1 h-4 w-4 rounded border-muted-foreground text-destructive focus:ring-destructive"
                  }
                ),
                /* @__PURE__ */ e(a, { variant: "body", className: "text-sm", children: s })
              ] }) }),
              /* @__PURE__ */ t("div", { className: "px-6 py-4 bg-muted/30 border-t flex items-center justify-end gap-3", children: [
                /* @__PURE__ */ e(
                  u,
                  {
                    variant: "ghost",
                    onClick: C,
                    disabled: A,
                    children: N
                  }
                ),
                /* @__PURE__ */ t(
                  u,
                  {
                    variant: "primary",
                    onClick: i,
                    disabled: !z,
                    isLoading: A,
                    className: "bg-destructive hover:bg-destructive/90 text-destructive-foreground",
                    children: [
                      /* @__PURE__ */ e(Re, { className: "h-4 w-4 mr-2" }),
                      y
                    ]
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
};
bl.displayName = "ConfirmDestructive";
const yl = {
  info: { bg: "bg-primary/10", border: "border-primary/20", icon: "text-primary" },
  success: { bg: "bg-success/10", border: "border-success/20", icon: "text-success" },
  warning: { bg: "bg-warning/10", border: "border-warning/20", icon: "text-warning" },
  error: { bg: "bg-destructive/10", border: "border-destructive/20", icon: "text-destructive" },
  mention: { bg: "bg-primary/10", border: "border-primary/20", icon: "text-primary" },
  update: { bg: "bg-muted", border: "border-border", icon: "text-muted-foreground" }
}, wl = ({
  id: r,
  type: C = "info",
  title: i,
  message: n,
  timestamp: p,
  isRead: j = !1,
  actor: D,
  action: E,
  secondaryAction: y,
  onDismiss: N,
  onMarkRead: A,
  onClick: _,
  href: w,
  icon: s,
  variant: S = "default",
  position: g = "top-right",
  autoDismissMs: m,
  className: d
}) => {
  const M = yl[C];
  Ae.useEffect(() => {
    if (S === "toast" && m && N) {
      const z = setTimeout(N, m);
      return () => clearTimeout(z);
    }
  }, [S, m, N]);
  const K = (z) => {
    const T = (/* @__PURE__ */ new Date()).getTime() - z.getTime(), L = Math.floor(T / 6e4), G = Math.floor(T / 36e5), Q = Math.floor(T / 864e5);
    return L < 1 ? "Just now" : L < 60 ? `${L}m ago` : G < 24 ? `${G}h ago` : Q < 7 ? `${Q}d ago` : new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric" }).format(z);
  }, Y = w ? "a" : _ ? "button" : "div", h = w ? { href: w, target: "_blank", rel: "noopener noreferrer" } : _ ? { onClick: _ } : {};
  return S === "toast" ? /* @__PURE__ */ e(
    "div",
    {
      className: l(
        "fixed z-50 w-96 max-w-[calc(100vw-2rem)]",
        g === "top-right" && "top-4 right-4",
        g === "top-left" && "top-4 left-4",
        g === "bottom-right" && "bottom-4 right-4",
        g === "bottom-left" && "bottom-4 left-4",
        "animate-in slide-in-from-top-2 fade-in duration-300",
        d
      ),
      children: /* @__PURE__ */ e(
        "div",
        {
          className: l(
            "p-4 rounded-lg border shadow-lg bg-popover",
            M.border
          ),
          children: /* @__PURE__ */ t("div", { className: "flex items-start gap-3", children: [
            D ? /* @__PURE__ */ e(
              je,
              {
                src: D.avatar,
                fallback: D.name.charAt(0),
                size: "sm"
              }
            ) : s ? /* @__PURE__ */ e("div", { className: l("shrink-0", M.icon), children: s }) : /* @__PURE__ */ e(We, { className: l("h-5 w-5 shrink-0", M.icon) }),
            /* @__PURE__ */ t("div", { className: "flex-1 min-w-0", children: [
              /* @__PURE__ */ e(a, { variant: "body", className: "font-medium", children: i }),
              n && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground line-clamp-2", children: n }),
              (E || y) && /* @__PURE__ */ t("div", { className: "flex items-center gap-2 mt-2", children: [
                E && /* @__PURE__ */ e(
                  u,
                  {
                    variant: E.variant || "primary",
                    size: "sm",
                    onClick: (z) => {
                      z.stopPropagation(), E.onClick();
                    },
                    children: E.label
                  }
                ),
                y && /* @__PURE__ */ e(
                  u,
                  {
                    variant: y.variant || "ghost",
                    size: "sm",
                    onClick: (z) => {
                      z.stopPropagation(), y.onClick();
                    },
                    children: y.label
                  }
                )
              ] })
            ] }),
            N && /* @__PURE__ */ e(
              "button",
              {
                onClick: (z) => {
                  z.stopPropagation(), N();
                },
                className: "shrink-0 text-muted-foreground hover:text-foreground",
                children: /* @__PURE__ */ e(he, { className: "h-4 w-4" })
              }
            )
          ] })
        }
      )
    }
  ) : S === "compact" ? /* @__PURE__ */ t(
    Y,
    {
      ...h,
      className: l(
        "flex items-center gap-3 p-2 rounded-lg transition-colors w-full text-left",
        !j && "bg-primary/5",
        (w || _) && "hover:bg-muted/50 cursor-pointer",
        d
      ),
      children: [
        !j && /* @__PURE__ */ e("span", { className: "shrink-0 w-2 h-2 rounded-full bg-primary" }),
        /* @__PURE__ */ e(a, { variant: "caption", className: l("flex-1 truncate", j && "text-muted-foreground"), children: i }),
        p && /* @__PURE__ */ e(a, { variant: "caption", className: "shrink-0 text-muted-foreground", children: K(p) })
      ]
    }
  ) : /* @__PURE__ */ t(
    Y,
    {
      ...h,
      className: l(
        "flex items-start gap-4 p-4 rounded-lg border transition-colors w-full text-left",
        !j && M.bg,
        !j && M.border,
        j && "bg-background border-border",
        (w || _) && "hover:bg-muted/50 cursor-pointer",
        d
      ),
      children: [
        !j && /* @__PURE__ */ e("span", { className: "shrink-0 w-2 h-2 rounded-full bg-primary mt-2" }),
        D ? /* @__PURE__ */ e(
          je,
          {
            src: D.avatar,
            fallback: D.name.charAt(0),
            size: "md"
          }
        ) : s ? /* @__PURE__ */ e("div", { className: l("shrink-0 p-2 rounded-full", M.bg, M.icon), children: s }) : null,
        /* @__PURE__ */ t("div", { className: "flex-1 min-w-0", children: [
          /* @__PURE__ */ t("div", { className: "flex items-start justify-between gap-2", children: [
            /* @__PURE__ */ t("div", { children: [
              /* @__PURE__ */ e(a, { variant: "body", className: "font-medium", children: i }),
              n && /* @__PURE__ */ e(a, { variant: "body", className: "text-muted-foreground text-sm mt-0.5", children: n })
            ] }),
            p && /* @__PURE__ */ e(a, { variant: "caption", className: "shrink-0 text-muted-foreground", children: K(p) })
          ] }),
          (E || y || A) && /* @__PURE__ */ t("div", { className: "flex items-center gap-2 mt-3", children: [
            E && /* @__PURE__ */ e(
              u,
              {
                variant: E.variant || "primary",
                size: "sm",
                onClick: (z) => {
                  z.stopPropagation(), E.onClick();
                },
                children: E.label
              }
            ),
            y && /* @__PURE__ */ e(
              u,
              {
                variant: y.variant || "outline",
                size: "sm",
                onClick: (z) => {
                  z.stopPropagation(), y.onClick();
                },
                children: y.label
              }
            ),
            !j && A && /* @__PURE__ */ t(
              u,
              {
                variant: "ghost",
                size: "sm",
                onClick: (z) => {
                  z.stopPropagation(), A();
                },
                children: [
                  /* @__PURE__ */ e(fe, { className: "h-4 w-4 mr-1" }),
                  "Mark read"
                ]
              }
            )
          ] })
        ] }),
        w && /* @__PURE__ */ e(at, { className: "h-4 w-4 text-muted-foreground shrink-0" }),
        N && !w && !_ && /* @__PURE__ */ e(
          "button",
          {
            onClick: (z) => {
              z.stopPropagation(), N();
            },
            className: "shrink-0 text-muted-foreground hover:text-foreground",
            children: /* @__PURE__ */ e(he, { className: "h-4 w-4" })
          }
        )
      ]
    }
  );
};
wl.displayName = "ActivityNotification";
const kl = ({
  placeholder: r = "Ask AI anything...",
  value: C,
  onChange: i,
  onSubmit: n,
  onCancel: p,
  onRegenerate: j,
  onFeedback: D,
  suggestions: E = [],
  messages: y = [],
  isGenerating: N = !1,
  streamingText: A,
  showHistory: _ = !0,
  enableVoice: w = !1,
  enableAttachments: s = !1,
  acceptedFileTypes: S = ["image/*", ".pdf", ".txt"],
  maxFiles: g = 5,
  showReasoning: m = !0,
  assistant: d = { name: "AI Assistant" },
  size: M = "md",
  variant: K = "chat",
  className: Y
}) => {
  const [h, z] = P(""), [U, T] = P([]), [L, G] = P(!1), [Q, v] = P(/* @__PURE__ */ new Set()), [b, c] = P(null), [$, o] = P(!0), x = Ee(null), f = Ee(null), O = Ee(null), F = C ?? h, I = {
    sm: { input: "text-sm py-2 min-h-[40px]", button: "h-8 w-8", avatar: "sm" },
    md: { input: "text-base py-3 min-h-[48px]", button: "h-10 w-10", avatar: "md" },
    lg: { input: "text-lg py-4 min-h-[56px]", button: "h-12 w-12", avatar: "lg" }
  }[M];
  qe(() => {
    _ && O.current && O.current.scrollIntoView({ behavior: "smooth" });
  }, [y, A, _]), qe(() => {
    x.current && (x.current.style.height = "auto", x.current.style.height = `${Math.min(x.current.scrollHeight, 200)}px`);
  }, [F]);
  const se = te(
    (k) => {
      const W = k.target.value;
      z(W), i == null || i(W);
    },
    [i]
  ), oe = te(() => {
    const k = F.trim();
    !k && U.length === 0 || (n == null || n(k, U.length > 0 ? U : void 0), z(""), i == null || i(""), T([]), o(!1));
  }, [F, U, n, i]), Z = te(
    (k) => {
      k.key === "Enter" && !k.shiftKey && (k.preventDefault(), oe());
    },
    [oe]
  ), V = te(
    (k) => {
      var re;
      const W = k.prompt ?? k.label;
      z(W), i == null || i(W), (re = x.current) == null || re.focus();
    },
    [i]
  ), ie = te(
    (k) => {
      const W = Array.from(k.target.files || []), re = [...U, ...W].slice(0, g);
      T(re), k.target.value = "";
    },
    [U, g]
  ), X = te((k) => {
    T((W) => W.filter((re, ge) => ge !== k));
  }, []), R = te(() => {
    G((k) => !k);
  }, []), H = te((k) => {
    v((W) => {
      const re = new Set(W);
      return re.has(k) ? re.delete(k) : re.add(k), re;
    });
  }, []), ce = te(async (k, W) => {
    try {
      await navigator.clipboard.writeText(W), c(k), setTimeout(() => c(null), 2e3);
    } catch {
    }
  }, []), q = (k) => new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit"
  }).format(k), le = (k) => {
    var B, ve;
    const W = k.role === "user", re = k.role === "assistant", ge = ((B = k.metadata) == null ? void 0 : B.reasoning) && m, ke = Q.has(k.id);
    return /* @__PURE__ */ t(
      "div",
      {
        className: l(
          "flex gap-3 py-4",
          W && "flex-row-reverse"
        ),
        children: [
          /* @__PURE__ */ e(
            je,
            {
              src: re ? d.avatar : void 0,
              fallback: re ? d.name.charAt(0) : "U",
              size: I.avatar,
              className: "shrink-0"
            }
          ),
          /* @__PURE__ */ t("div", { className: l("flex-1 min-w-0", W && "text-right"), children: [
            /* @__PURE__ */ t("div", { className: l("flex items-center gap-2 mb-1", W && "justify-end"), children: [
              /* @__PURE__ */ e(a, { variant: "caption", className: "font-medium", children: W ? "You" : d.name }),
              k.timestamp && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: q(k.timestamp) })
            ] }),
            k.attachments && k.attachments.length > 0 && /* @__PURE__ */ e("div", { className: l("flex flex-wrap gap-2 mb-2", W && "justify-end"), children: k.attachments.map((De) => /* @__PURE__ */ t(
              "div",
              {
                className: "flex items-center gap-2 px-3 py-1.5 bg-muted rounded-lg text-sm",
                children: [
                  De.type === "image" ? /* @__PURE__ */ e(St, { className: "h-4 w-4 text-muted-foreground" }) : /* @__PURE__ */ e(kt, { className: "h-4 w-4 text-muted-foreground" }),
                  /* @__PURE__ */ e("span", { className: "truncate max-w-[150px]", children: De.name })
                ]
              },
              De.id
            )) }),
            ge && /* @__PURE__ */ t(
              "button",
              {
                onClick: () => H(k.id),
                className: l(
                  "flex items-center gap-2 text-sm text-muted-foreground mb-2 hover:text-foreground transition-colors",
                  W && "ml-auto"
                ),
                children: [
                  /* @__PURE__ */ e(Te, { className: "h-3.5 w-3.5" }),
                  /* @__PURE__ */ e("span", { children: ke ? "Hide reasoning" : "Show reasoning" }),
                  ke ? /* @__PURE__ */ e(Ie, { className: "h-3.5 w-3.5" }) : /* @__PURE__ */ e(xe, { className: "h-3.5 w-3.5" })
                ]
              }
            ),
            ge && ke && /* @__PURE__ */ e("div", { className: "mb-3 p-3 bg-muted/50 rounded-lg border-l-2 border-primary/50 text-sm text-muted-foreground whitespace-pre-wrap", children: (ve = k.metadata) == null ? void 0 : ve.reasoning }),
            /* @__PURE__ */ e(
              "div",
              {
                className: l(
                  "inline-block px-4 py-2.5 rounded-2xl max-w-[85%] whitespace-pre-wrap",
                  W ? "bg-primary text-primary-foreground rounded-br-md" : "bg-muted rounded-bl-md",
                  k.isStreaming && "animate-pulse"
                ),
                children: /* @__PURE__ */ t(a, { variant: "body", className: "break-words", children: [
                  k.content,
                  k.isStreaming && /* @__PURE__ */ e("span", { className: "inline-block w-1.5 h-4 ml-0.5 bg-current animate-pulse" })
                ] })
              }
            ),
            k.metadata && !k.isStreaming && re && /* @__PURE__ */ t("div", { className: "flex items-center gap-3 mt-2 text-xs text-muted-foreground", children: [
              k.metadata.model && /* @__PURE__ */ e("span", { children: k.metadata.model }),
              k.metadata.tokens && /* @__PURE__ */ t("span", { children: [
                k.metadata.tokens,
                " tokens"
              ] }),
              k.metadata.duration && /* @__PURE__ */ t("span", { children: [
                (k.metadata.duration / 1e3).toFixed(1),
                "s"
              ] })
            ] }),
            re && !k.isStreaming && /* @__PURE__ */ t("div", { className: "flex items-center gap-1 mt-2", children: [
              /* @__PURE__ */ e(
                "button",
                {
                  onClick: () => ce(k.id, k.content),
                  className: "p-1.5 rounded hover:bg-muted transition-colors text-muted-foreground hover:text-foreground",
                  title: "Copy to clipboard",
                  children: b === k.id ? /* @__PURE__ */ e(fe, { className: "h-4 w-4 text-success" }) : /* @__PURE__ */ e(Ke, { className: "h-4 w-4" })
                }
              ),
              D && /* @__PURE__ */ t(me, { children: [
                /* @__PURE__ */ e(
                  "button",
                  {
                    onClick: () => D(k.id, "positive"),
                    className: l(
                      "p-1.5 rounded hover:bg-muted transition-colors",
                      k.feedback === "positive" ? "text-success" : "text-muted-foreground hover:text-foreground"
                    ),
                    title: "Good response",
                    children: /* @__PURE__ */ e(pt, { className: "h-4 w-4" })
                  }
                ),
                /* @__PURE__ */ e(
                  "button",
                  {
                    onClick: () => D(k.id, "negative"),
                    className: l(
                      "p-1.5 rounded hover:bg-muted transition-colors",
                      k.feedback === "negative" ? "text-destructive" : "text-muted-foreground hover:text-foreground"
                    ),
                    title: "Bad response",
                    children: /* @__PURE__ */ e(Rt, { className: "h-4 w-4" })
                  }
                )
              ] })
            ] })
          ] })
        ]
      },
      k.id
    );
  }, ee = A ? {
    id: "streaming",
    role: "assistant",
    content: A,
    isStreaming: !0
  } : null;
  return /* @__PURE__ */ t("div", { className: l("flex flex-col", Y), children: [
    _ && K === "chat" && (y.length > 0 || ee) && /* @__PURE__ */ t("div", { className: "flex-1 overflow-y-auto px-4 divide-y divide-border/50", children: [
      y.map(le),
      ee && le(ee),
      /* @__PURE__ */ e("div", { ref: O })
    ] }),
    $ && E.length > 0 && !N && K !== "minimal" && /* @__PURE__ */ t("div", { className: "px-4 py-3 border-t bg-muted/30", children: [
      /* @__PURE__ */ t("div", { className: "flex items-center gap-2 mb-2", children: [
        /* @__PURE__ */ e(Te, { className: "h-4 w-4 text-primary" }),
        /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground font-medium", children: "Suggestions" })
      ] }),
      /* @__PURE__ */ e("div", { className: "flex flex-wrap gap-2", children: E.map((k) => /* @__PURE__ */ t(
        "button",
        {
          onClick: () => V(k),
          className: "flex items-center gap-1.5 px-3 py-1.5 text-sm bg-background border rounded-full hover:border-primary hover:bg-primary/5 transition-colors",
          children: [
            k.icon,
            /* @__PURE__ */ e("span", { children: k.label })
          ]
        },
        k.id
      )) })
    ] }),
    U.length > 0 && /* @__PURE__ */ e("div", { className: "px-4 py-2 border-t bg-muted/30", children: /* @__PURE__ */ e("div", { className: "flex flex-wrap gap-2", children: U.map((k, W) => /* @__PURE__ */ t(
      "div",
      {
        className: "flex items-center gap-2 px-3 py-1.5 bg-background border rounded-lg text-sm",
        children: [
          k.type.startsWith("image/") ? /* @__PURE__ */ e(St, { className: "h-4 w-4 text-muted-foreground" }) : /* @__PURE__ */ e(kt, { className: "h-4 w-4 text-muted-foreground" }),
          /* @__PURE__ */ e("span", { className: "truncate max-w-[150px]", children: k.name }),
          /* @__PURE__ */ e(
            "button",
            {
              onClick: () => X(W),
              className: "text-muted-foreground hover:text-foreground",
              children: /* @__PURE__ */ e(he, { className: "h-3.5 w-3.5" })
            }
          )
        ]
      },
      W
    )) }) }),
    /* @__PURE__ */ t(
      "div",
      {
        className: l(
          "border-t bg-background p-4",
          K === "inline" && "border rounded-lg"
        ),
        children: [
          /* @__PURE__ */ t(
            "div",
            {
              className: l(
                "flex items-end gap-2 bg-muted/30 rounded-xl border focus-within:ring-2 focus-within:ring-primary focus-within:border-primary",
                K === "inline" && "border-0 bg-transparent"
              ),
              children: [
                s && /* @__PURE__ */ t(me, { children: [
                  /* @__PURE__ */ e(
                    "input",
                    {
                      ref: f,
                      type: "file",
                      accept: S.join(","),
                      multiple: !0,
                      onChange: ie,
                      className: "hidden"
                    }
                  ),
                  /* @__PURE__ */ e(
                    "button",
                    {
                      onClick: () => {
                        var k;
                        return (k = f.current) == null ? void 0 : k.click();
                      },
                      disabled: N || U.length >= g,
                      className: l(
                        "p-2 ml-2 text-muted-foreground hover:text-foreground transition-colors disabled:opacity-50",
                        I.button
                      ),
                      title: "Attach files",
                      children: /* @__PURE__ */ e(kt, { className: "h-5 w-5" })
                    }
                  )
                ] }),
                /* @__PURE__ */ e(
                  "textarea",
                  {
                    ref: x,
                    value: F,
                    onChange: se,
                    onKeyDown: Z,
                    placeholder: r,
                    disabled: N,
                    rows: 1,
                    className: l(
                      "flex-1 resize-none bg-transparent outline-none placeholder:text-muted-foreground disabled:opacity-50",
                      I.input,
                      !s && "ml-4"
                    )
                  }
                ),
                w && /* @__PURE__ */ e(
                  "button",
                  {
                    onClick: R,
                    disabled: N,
                    className: l(
                      "p-2 transition-colors disabled:opacity-50",
                      L ? "text-destructive animate-pulse" : "text-muted-foreground hover:text-foreground",
                      I.button
                    ),
                    title: L ? "Stop recording" : "Start voice input",
                    children: L ? /* @__PURE__ */ e(ts, { className: "h-5 w-5" }) : /* @__PURE__ */ e(rs, { className: "h-5 w-5" })
                  }
                ),
                N ? /* @__PURE__ */ e("div", { className: "flex items-center gap-1 mr-2", children: /* @__PURE__ */ e(
                  "button",
                  {
                    onClick: p,
                    className: l(
                      "p-2 text-destructive hover:bg-destructive/10 rounded-lg transition-colors",
                      I.button
                    ),
                    title: "Stop generating",
                    children: /* @__PURE__ */ e(er, { className: "h-5 w-5" })
                  }
                ) }) : /* @__PURE__ */ e(
                  u,
                  {
                    variant: "ghost",
                    size: "sm",
                    onClick: oe,
                    disabled: !F.trim() && U.length === 0,
                    className: l(
                      "mr-2 text-primary hover:bg-primary/10 disabled:opacity-50",
                      I.button
                    ),
                    children: /* @__PURE__ */ e(tt, { className: "h-5 w-5" })
                  }
                )
              ]
            }
          ),
          N && /* @__PURE__ */ t("div", { className: "flex items-center justify-center gap-2 mt-3 text-sm text-muted-foreground", children: [
            /* @__PURE__ */ e(ye, { className: "h-4 w-4 animate-spin" }),
            /* @__PURE__ */ e("span", { children: "Generating response..." })
          ] }),
          !N && y.length > 0 && j && /* @__PURE__ */ e("div", { className: "flex justify-center mt-3", children: /* @__PURE__ */ t(
            "button",
            {
              onClick: j,
              className: "flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors",
              children: [
                /* @__PURE__ */ e(Qe, { className: "h-4 w-4" }),
                /* @__PURE__ */ e("span", { children: "Regenerate response" })
              ]
            }
          ) })
        ]
      }
    )
  ] });
};
kl.displayName = "NaturalLanguageInput";
const Cl = ({
  template: r,
  isSelected: C,
  viewMode: i,
  onSelect: n,
  onPreview: p,
  onFavorite: j
}) => {
  const [D, E] = P(!1);
  return i === "list" ? /* @__PURE__ */ t(
    "div",
    {
      onClick: n,
      onMouseEnter: () => E(!0),
      onMouseLeave: () => E(!1),
      className: l(
        "flex items-center gap-4 p-4 border rounded-lg cursor-pointer transition-all",
        C ? "border-primary bg-primary/5 ring-1 ring-primary" : "hover:border-primary/50 hover:bg-muted/30"
      ),
      children: [
        r.thumbnail ? /* @__PURE__ */ e(
          "img",
          {
            src: r.thumbnail,
            alt: r.name,
            className: "w-20 h-14 object-cover rounded-md bg-muted"
          }
        ) : /* @__PURE__ */ e("div", { className: "w-20 h-14 bg-gradient-to-br from-primary/20 to-primary/5 rounded-md flex items-center justify-center", children: /* @__PURE__ */ e(ot, { className: "h-6 w-6 text-primary/50" }) }),
        /* @__PURE__ */ t("div", { className: "flex-1 min-w-0", children: [
          /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ e(a, { variant: "body", className: "font-medium truncate", children: r.name }),
            r.isNew && /* @__PURE__ */ e(ae, { variant: "default", className: "bg-success text-success-foreground text-xs", children: "New" }),
            r.isPremium && /* @__PURE__ */ t(ae, { variant: "default", className: "bg-warning text-warning-foreground text-xs", children: [
              /* @__PURE__ */ e(Be, { className: "h-3 w-3 mr-1" }),
              "Pro"
            ] })
          ] }),
          r.description && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground line-clamp-1", children: r.description }),
          r.tags && r.tags.length > 0 && /* @__PURE__ */ e("div", { className: "flex flex-wrap gap-1 mt-1", children: r.tags.slice(0, 3).map((y) => /* @__PURE__ */ e(ae, { variant: "secondary", className: "text-xs", children: y }, y)) })
        ] }),
        r.stats && /* @__PURE__ */ t("div", { className: "flex items-center gap-4 text-sm text-muted-foreground", children: [
          r.stats.uses !== void 0 && /* @__PURE__ */ t("span", { className: "flex items-center gap-1", children: [
            /* @__PURE__ */ e(_e, { className: "h-4 w-4" }),
            r.stats.uses.toLocaleString()
          ] }),
          r.stats.rating !== void 0 && /* @__PURE__ */ t("span", { className: "flex items-center gap-1", children: [
            /* @__PURE__ */ e($e, { className: "h-4 w-4 fill-warning text-warning" }),
            r.stats.rating.toFixed(1)
          ] })
        ] }),
        /* @__PURE__ */ t("div", { className: l("flex items-center gap-1", !D && "opacity-0"), children: [
          p && /* @__PURE__ */ e(
            u,
            {
              variant: "ghost",
              size: "sm",
              onClick: (y) => {
                y.stopPropagation(), p();
              },
              className: "h-8 w-8 p-0",
              children: /* @__PURE__ */ e(Ve, { className: "h-4 w-4" })
            }
          ),
          j && /* @__PURE__ */ e(
            u,
            {
              variant: "ghost",
              size: "sm",
              onClick: (y) => {
                y.stopPropagation(), j(!r.isFavorite);
              },
              className: "h-8 w-8 p-0",
              children: r.isFavorite ? /* @__PURE__ */ e($e, { className: "h-4 w-4 fill-warning text-warning" }) : /* @__PURE__ */ e(Ot, { className: "h-4 w-4" })
            }
          )
        ] }),
        C && /* @__PURE__ */ e(fe, { className: "h-5 w-5 text-primary shrink-0" })
      ]
    }
  ) : /* @__PURE__ */ t(
    ne,
    {
      onClick: n,
      onMouseEnter: () => E(!0),
      onMouseLeave: () => E(!1),
      className: l(
        "overflow-hidden cursor-pointer transition-all group",
        C ? "ring-2 ring-primary" : "hover:ring-1 hover:ring-primary/50"
      ),
      children: [
        /* @__PURE__ */ t("div", { className: "relative aspect-[4/3] bg-muted", children: [
          r.thumbnail ? /* @__PURE__ */ e(
            "img",
            {
              src: r.thumbnail,
              alt: r.name,
              className: "w-full h-full object-cover"
            }
          ) : /* @__PURE__ */ e("div", { className: "w-full h-full bg-gradient-to-br from-primary/20 to-primary/5 flex items-center justify-center", children: /* @__PURE__ */ e(ot, { className: "h-12 w-12 text-primary/30" }) }),
          /* @__PURE__ */ t("div", { className: "absolute top-2 left-2 flex gap-1", children: [
            r.isNew && /* @__PURE__ */ e(ae, { variant: "default", className: "bg-success text-success-foreground text-xs", children: "New" }),
            r.isPremium && /* @__PURE__ */ t(ae, { variant: "default", className: "bg-warning text-warning-foreground text-xs", children: [
              /* @__PURE__ */ e(Be, { className: "h-3 w-3 mr-1" }),
              "Pro"
            ] })
          ] }),
          /* @__PURE__ */ t(
            "div",
            {
              className: l(
                "absolute inset-0 bg-black/60 flex items-center justify-center gap-2 transition-opacity",
                D ? "opacity-100" : "opacity-0"
              ),
              children: [
                /* @__PURE__ */ e(u, { variant: "secondary", size: "sm", onClick: n, children: "Use Template" }),
                p && /* @__PURE__ */ e(
                  u,
                  {
                    variant: "ghost",
                    size: "sm",
                    onClick: (y) => {
                      y.stopPropagation(), p();
                    },
                    className: "text-white hover:bg-white/20",
                    children: /* @__PURE__ */ e(Ve, { className: "h-4 w-4" })
                  }
                )
              ]
            }
          ),
          j && /* @__PURE__ */ e(
            "button",
            {
              onClick: (y) => {
                y.stopPropagation(), j(!r.isFavorite);
              },
              className: l(
                "absolute top-2 right-2 p-1.5 rounded-full bg-black/40 hover:bg-black/60 transition-all",
                D || r.isFavorite ? "opacity-100" : "opacity-0"
              ),
              children: r.isFavorite ? /* @__PURE__ */ e($e, { className: "h-4 w-4 fill-warning text-warning" }) : /* @__PURE__ */ e($e, { className: "h-4 w-4 text-white" })
            }
          ),
          C && /* @__PURE__ */ e("div", { className: "absolute bottom-2 right-2 p-1 rounded-full bg-primary", children: /* @__PURE__ */ e(fe, { className: "h-4 w-4 text-primary-foreground" }) })
        ] }),
        /* @__PURE__ */ t("div", { className: "p-4", children: [
          /* @__PURE__ */ e(a, { variant: "body", className: "font-medium line-clamp-1", children: r.name }),
          r.description && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground line-clamp-2 mt-1", children: r.description }),
          /* @__PURE__ */ t("div", { className: "flex items-center justify-between mt-3 pt-3 border-t", children: [
            r.author && /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
              r.author.avatar ? /* @__PURE__ */ e(
                "img",
                {
                  src: r.author.avatar,
                  alt: r.author.name,
                  className: "w-5 h-5 rounded-full"
                }
              ) : /* @__PURE__ */ e(Se, { className: "h-4 w-4 text-muted-foreground" }),
              /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: r.author.name })
            ] }),
            r.stats && /* @__PURE__ */ t("div", { className: "flex items-center gap-3 text-xs text-muted-foreground", children: [
              r.stats.uses !== void 0 && /* @__PURE__ */ t("span", { className: "flex items-center gap-1", children: [
                /* @__PURE__ */ e(_e, { className: "h-3.5 w-3.5" }),
                r.stats.uses >= 1e3 ? `${(r.stats.uses / 1e3).toFixed(1)}k` : r.stats.uses
              ] }),
              r.stats.likes !== void 0 && /* @__PURE__ */ t("span", { className: "flex items-center gap-1", children: [
                /* @__PURE__ */ e(Sr, { className: "h-3.5 w-3.5" }),
                r.stats.likes
              ] })
            ] })
          ] })
        ] })
      ]
    }
  );
}, Ml = ({
  templates: r,
  categories: C = [],
  onSelect: i,
  onPreview: n,
  onFavorite: p,
  onLoadMore: j,
  hasMore: D = !1,
  isLoading: E = !1,
  selectedId: y,
  title: N = "Templates",
  description: A,
  showSearch: _ = !0,
  showCategories: w = !0,
  showViewToggle: s = !0,
  defaultView: S = "grid",
  columns: g = 3,
  emptyState: m,
  renderTemplate: d,
  className: M
}) => {
  const [K, Y] = P(""), [h, z] = P(null), [U, T] = P(S), [L, G] = P("popular"), [Q, v] = P(!1), b = Ce(() => {
    let o = [...r];
    if (K) {
      const x = K.toLowerCase();
      o = o.filter(
        (f) => {
          var O, F;
          return f.name.toLowerCase().includes(x) || ((O = f.description) == null ? void 0 : O.toLowerCase().includes(x)) || ((F = f.tags) == null ? void 0 : F.some((de) => de.toLowerCase().includes(x)));
        }
      );
    }
    switch (h && (o = o.filter((x) => x.category === h)), L) {
      case "popular":
        o.sort((x, f) => {
          var O, F;
          return (((O = f.stats) == null ? void 0 : O.uses) ?? 0) - (((F = x.stats) == null ? void 0 : F.uses) ?? 0);
        });
        break;
      case "recent":
        o.sort((x, f) => {
          const O = x.updatedAt ?? x.createdAt ?? /* @__PURE__ */ new Date(0);
          return (f.updatedAt ?? f.createdAt ?? /* @__PURE__ */ new Date(0)).getTime() - O.getTime();
        });
        break;
      case "name":
        o.sort((x, f) => x.name.localeCompare(f.name));
        break;
    }
    return o;
  }, [r, K, h, L]), c = te(
    (o) => {
      i == null || i(o);
    },
    [i]
  ), $ = {
    2: "grid-cols-1 sm:grid-cols-2",
    3: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
    4: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
  };
  return /* @__PURE__ */ t("div", { className: l("flex flex-col h-full", M), children: [
    /* @__PURE__ */ t("div", { className: "shrink-0 pb-4 border-b", children: [
      /* @__PURE__ */ t("div", { className: "flex items-start justify-between gap-4 mb-4", children: [
        /* @__PURE__ */ t("div", { children: [
          /* @__PURE__ */ e(a, { variant: "h3", className: "font-semibold", children: N }),
          A && /* @__PURE__ */ e(a, { variant: "body", className: "text-muted-foreground mt-1", children: A })
        ] }),
        s && /* @__PURE__ */ t("div", { className: "flex items-center border rounded-lg overflow-hidden", children: [
          /* @__PURE__ */ e(
            "button",
            {
              onClick: () => T("grid"),
              className: l(
                "p-2 transition-colors",
                U === "grid" ? "bg-muted" : "hover:bg-muted/50"
              ),
              children: /* @__PURE__ */ e(ot, { className: "h-4 w-4" })
            }
          ),
          /* @__PURE__ */ e(
            "button",
            {
              onClick: () => T("list"),
              className: l(
                "p-2 transition-colors",
                U === "list" ? "bg-muted" : "hover:bg-muted/50"
              ),
              children: /* @__PURE__ */ e(ia, { className: "h-4 w-4" })
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ t("div", { className: "flex items-center gap-3", children: [
        _ && /* @__PURE__ */ t("div", { className: "flex-1 relative", children: [
          /* @__PURE__ */ e(we, { className: "absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" }),
          /* @__PURE__ */ e(
            ue,
            {
              value: K,
              onChange: (o) => Y(o.target.value),
              placeholder: "Search templates...",
              className: "pl-10"
            }
          ),
          K && /* @__PURE__ */ e(
            "button",
            {
              onClick: () => Y(""),
              className: "absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground",
              children: /* @__PURE__ */ e(he, { className: "h-4 w-4" })
            }
          )
        ] }),
        /* @__PURE__ */ t(
          "button",
          {
            onClick: () => v(!Q),
            className: l(
              "flex items-center gap-2 px-3 py-2 border rounded-lg transition-colors",
              Q ? "bg-muted" : "hover:bg-muted/50"
            ),
            children: [
              /* @__PURE__ */ e(Je, { className: "h-4 w-4" }),
              /* @__PURE__ */ e("span", { className: "text-sm", children: "Filters" }),
              Q ? /* @__PURE__ */ e(xe, { className: "h-4 w-4" }) : /* @__PURE__ */ e(Ne, { className: "h-4 w-4" })
            ]
          }
        ),
        /* @__PURE__ */ t(
          "select",
          {
            value: L,
            onChange: (o) => G(o.target.value),
            className: "px-3 py-2 border rounded-lg bg-background text-sm cursor-pointer hover:bg-muted/50",
            children: [
              /* @__PURE__ */ e("option", { value: "popular", children: "Most Popular" }),
              /* @__PURE__ */ e("option", { value: "recent", children: "Most Recent" }),
              /* @__PURE__ */ e("option", { value: "name", children: "Alphabetical" })
            ]
          }
        )
      ] }),
      Q && w && C.length > 0 && /* @__PURE__ */ t("div", { className: "mt-4 pt-4 border-t", children: [
        /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground font-medium mb-2 block", children: "Categories" }),
        /* @__PURE__ */ t("div", { className: "flex flex-wrap gap-2", children: [
          /* @__PURE__ */ t(
            "button",
            {
              onClick: () => z(null),
              className: l(
                "flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-full border transition-colors",
                h ? "hover:bg-muted/50" : "bg-primary text-primary-foreground border-primary"
              ),
              children: [
                /* @__PURE__ */ e(Te, { className: "h-3.5 w-3.5" }),
                "All",
                /* @__PURE__ */ e(ae, { variant: "secondary", className: "ml-1 text-xs", children: r.length })
              ]
            }
          ),
          C.map((o) => /* @__PURE__ */ t(
            "button",
            {
              onClick: () => z(o.id),
              className: l(
                "flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-full border transition-colors",
                h === o.id ? "bg-primary text-primary-foreground border-primary" : "hover:bg-muted/50"
              ),
              children: [
                o.icon,
                o.label,
                o.count !== void 0 && /* @__PURE__ */ e(ae, { variant: "secondary", className: "ml-1 text-xs", children: o.count })
              ]
            },
            o.id
          ))
        ] })
      ] })
    ] }),
    /* @__PURE__ */ t("div", { className: "shrink-0 py-3 flex items-center justify-between text-sm text-muted-foreground", children: [
      /* @__PURE__ */ t("span", { children: [
        b.length,
        " template",
        b.length !== 1 ? "s" : "",
        K && ` matching "${K}"`
      ] }),
      h && /* @__PURE__ */ t(
        "button",
        {
          onClick: () => z(null),
          className: "flex items-center gap-1 hover:text-foreground",
          children: [
            "Clear filter",
            /* @__PURE__ */ e(he, { className: "h-3.5 w-3.5" })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ t("div", { className: "flex-1 overflow-y-auto", children: [
      b.length === 0 ? m ?? /* @__PURE__ */ t("div", { className: "flex flex-col items-center justify-center py-16 text-center", children: [
        /* @__PURE__ */ e(we, { className: "h-12 w-12 text-muted-foreground/50 mb-4" }),
        /* @__PURE__ */ e(a, { variant: "h4", className: "font-medium mb-2", children: "No templates found" }),
        /* @__PURE__ */ e(a, { variant: "body", className: "text-muted-foreground max-w-md", children: K ? `No templates match "${K}". Try a different search term.` : "No templates available in this category." }),
        (K || h) && /* @__PURE__ */ e(
          u,
          {
            variant: "outline",
            onClick: () => {
              Y(""), z(null);
            },
            className: "mt-4",
            children: "Clear all filters"
          }
        )
      ] }) : /* @__PURE__ */ e(
        "div",
        {
          className: l(
            U === "grid" ? `grid ${$[g]} gap-4` : "flex flex-col gap-3"
          ),
          children: b.map((o) => {
            const x = {
              template: o,
              isSelected: o.id === y,
              viewMode: U,
              onSelect: () => c(o),
              onPreview: n ? () => n(o) : void 0,
              onFavorite: p ? (f) => p(o.id, f) : void 0
            };
            return d ? /* @__PURE__ */ e(Ae.Fragment, { children: d(o, x) }, o.id) : /* @__PURE__ */ e(Cl, { ...x }, o.id);
          })
        }
      ),
      D && /* @__PURE__ */ e("div", { className: "flex justify-center py-8", children: /* @__PURE__ */ e(
        u,
        {
          variant: "outline",
          onClick: j,
          disabled: E,
          children: E ? /* @__PURE__ */ t(me, { children: [
            /* @__PURE__ */ e(ye, { className: "h-4 w-4 mr-2 animate-spin" }),
            "Loading..."
          ] }) : "Load more templates"
        }
      ) })
    ] })
  ] });
};
Ml.displayName = "TemplateGallery";
const zt = {
  online: "bg-success",
  idle: "bg-warning",
  busy: "bg-destructive",
  offline: "bg-muted-foreground"
}, zl = {
  viewing: /* @__PURE__ */ e(Ve, { className: "h-3 w-3" }),
  editing: /* @__PURE__ */ e(gs, { className: "h-3 w-3" }),
  commenting: /* @__PURE__ */ e(Xr, { className: "h-3 w-3" }),
  selecting: /* @__PURE__ */ e(ds, { className: "h-3 w-3" }),
  idle: /* @__PURE__ */ e(gt, { className: "h-2 w-2" })
}, jt = {
  viewing: "Viewing",
  editing: "Editing",
  commenting: "Commenting",
  selecting: "Selecting",
  idle: "Idle"
}, At = ({ collaborator: r, containerRef: C }) => {
  var p;
  if (!((p = r.cursor) != null && p.visible)) return null;
  const { x: i, y: n } = r.cursor;
  return /* @__PURE__ */ t(
    "div",
    {
      className: "fixed pointer-events-none z-50 transition-all duration-75",
      style: {
        left: i,
        top: n,
        transform: "translate(-2px, -2px)"
      },
      children: [
        /* @__PURE__ */ e(
          "svg",
          {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            className: "drop-shadow-md",
            children: /* @__PURE__ */ e(
              "path",
              {
                d: "M5 3L19 12L12 12L9 19L5 3Z",
                fill: r.color,
                stroke: "white",
                strokeWidth: "1.5"
              }
            )
          }
        ),
        /* @__PURE__ */ e(
          "div",
          {
            className: "absolute left-4 top-4 px-2 py-0.5 rounded text-xs font-medium text-white whitespace-nowrap",
            style: { backgroundColor: r.color },
            children: r.name
          }
        )
      ]
    }
  );
}, jl = ({
  collaborators: r,
  currentUserId: C,
  onCollaboratorClick: i,
  onFollowCollaborator: n,
  followingId: p,
  showCursors: j = !0,
  showActivity: D = !0,
  maxVisible: E = 4,
  variant: y = "avatars",
  cursorContainerRef: N,
  defaultExpanded: A = !1,
  className: _
}) => {
  const [w, s] = P(A), [S, g] = P(null), m = r.filter((h) => h.id !== C), d = m.filter((h) => h.status !== "offline").length, M = m.slice(0, E), K = Math.max(0, m.length - E), Y = (h) => {
    const U = (/* @__PURE__ */ new Date()).getTime() - h.getTime(), T = Math.floor(U / 6e4);
    if (T < 1) return "Just now";
    if (T < 60) return `${T}m ago`;
    const L = Math.floor(T / 60);
    return L < 24 ? `${L}h ago` : `${Math.floor(L / 24)}d ago`;
  };
  return y === "minimal" ? /* @__PURE__ */ t("div", { className: l("flex items-center gap-2", _), children: [
    /* @__PURE__ */ t("div", { className: "flex items-center gap-1.5 px-2 py-1 bg-muted rounded-full", children: [
      /* @__PURE__ */ e(Se, { className: "h-3.5 w-3.5 text-muted-foreground" }),
      /* @__PURE__ */ t(a, { variant: "caption", className: "font-medium", children: [
        d,
        " online"
      ] })
    ] }),
    j && m.map((h) => /* @__PURE__ */ e(
      At,
      {
        collaborator: h,
        containerRef: N
      },
      h.id
    ))
  ] }) : y === "list" ? /* @__PURE__ */ t("div", { className: l("w-full", _), children: [
    /* @__PURE__ */ t(
      "button",
      {
        onClick: () => s(!w),
        className: "w-full flex items-center justify-between px-3 py-2 hover:bg-muted/50 rounded-lg transition-colors",
        children: [
          /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ e(Se, { className: "h-4 w-4 text-muted-foreground" }),
            /* @__PURE__ */ t(a, { variant: "body", className: "font-medium text-sm", children: [
              d,
              " collaborator",
              d !== 1 ? "s" : "",
              " online"
            ] })
          ] }),
          w ? /* @__PURE__ */ e(Ie, { className: "h-4 w-4 text-muted-foreground" }) : /* @__PURE__ */ e(xe, { className: "h-4 w-4 text-muted-foreground" })
        ]
      }
    ),
    w && /* @__PURE__ */ e("div", { className: "mt-1 space-y-1", children: m.map((h) => /* @__PURE__ */ t(
      "button",
      {
        onClick: () => i == null ? void 0 : i(h),
        className: l(
          "w-full flex items-center gap-3 px-3 py-2 rounded-lg transition-colors text-left",
          p === h.id ? "bg-primary/10" : "hover:bg-muted/50"
        ),
        children: [
          /* @__PURE__ */ t("div", { className: "relative", children: [
            /* @__PURE__ */ e(
              je,
              {
                src: h.avatar,
                fallback: h.name.charAt(0),
                size: "sm",
                style: { borderColor: h.color, borderWidth: 2 }
              }
            ),
            /* @__PURE__ */ e(
              "div",
              {
                className: l(
                  "absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full border-2 border-background",
                  zt[h.status]
                )
              }
            )
          ] }),
          /* @__PURE__ */ t("div", { className: "flex-1 min-w-0", children: [
            /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ e(a, { variant: "caption", className: "font-medium truncate", children: h.name }),
              p === h.id && /* @__PURE__ */ e(ae, { variant: "default", className: "text-xs bg-primary", children: "Following" })
            ] }),
            D && h.activity && /* @__PURE__ */ t("div", { className: "flex items-center gap-1.5 text-xs text-muted-foreground", children: [
              /* @__PURE__ */ e(
                "span",
                {
                  className: "flex items-center justify-center w-4 h-4",
                  style: { color: h.color },
                  children: zl[h.activity]
                }
              ),
              /* @__PURE__ */ t("span", { children: [
                jt[h.activity],
                h.activityTarget && ` ${h.activityTarget}`
              ] })
            ] })
          ] }),
          n && h.status !== "offline" && /* @__PURE__ */ e(
            "button",
            {
              onClick: (z) => {
                z.stopPropagation(), n(
                  p === h.id ? null : h.id
                );
              },
              className: "p-1.5 rounded hover:bg-muted transition-colors",
              title: p === h.id ? "Stop following" : "Follow view",
              children: /* @__PURE__ */ e(
                Ve,
                {
                  className: l(
                    "h-4 w-4",
                    p === h.id ? "text-primary" : "text-muted-foreground"
                  )
                }
              )
            }
          )
        ]
      },
      h.id
    )) }),
    j && m.map((h) => /* @__PURE__ */ e(
      At,
      {
        collaborator: h,
        containerRef: N
      },
      h.id
    ))
  ] }) : /* @__PURE__ */ t("div", { className: l("flex items-center", _), children: [
    /* @__PURE__ */ t("div", { className: "flex -space-x-2", children: [
      M.map((h, z) => /* @__PURE__ */ t(
        "div",
        {
          className: "relative group",
          style: { zIndex: E - z },
          onMouseEnter: () => g(h.id),
          onMouseLeave: () => g(null),
          children: [
            /* @__PURE__ */ t(
              "button",
              {
                onClick: () => i == null ? void 0 : i(h),
                className: l(
                  "relative rounded-full transition-transform hover:scale-110 hover:z-10",
                  p === h.id && "ring-2 ring-primary ring-offset-2"
                ),
                style: {
                  boxShadow: `0 0 0 2px ${h.color}`
                },
                children: [
                  /* @__PURE__ */ e(
                    je,
                    {
                      src: h.avatar,
                      fallback: h.name.charAt(0),
                      size: "sm"
                    }
                  ),
                  /* @__PURE__ */ e(
                    "div",
                    {
                      className: l(
                        "absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full border-2 border-background",
                        zt[h.status]
                      )
                    }
                  )
                ]
              }
            ),
            S === h.id && /* @__PURE__ */ t("div", { className: "absolute top-full left-1/2 -translate-x-1/2 mt-2 px-3 py-2 bg-popover border rounded-lg shadow-lg z-50 whitespace-nowrap", children: [
              /* @__PURE__ */ t("div", { className: "flex items-center gap-2 mb-1", children: [
                /* @__PURE__ */ e(a, { variant: "caption", className: "font-medium", children: h.name }),
                h.status !== "offline" && D && h.activity && /* @__PURE__ */ e(
                  "span",
                  {
                    className: "inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-xs font-semibold text-white",
                    style: { backgroundColor: h.color },
                    children: jt[h.activity]
                  }
                )
              ] }),
              h.activityTarget && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground text-xs", children: h.activityTarget }),
              h.lastActive && h.status === "offline" && /* @__PURE__ */ t(a, { variant: "caption", className: "text-muted-foreground text-xs", children: [
                "Last seen ",
                Y(h.lastActive)
              ] }),
              n && h.status !== "offline" && /* @__PURE__ */ t(
                "button",
                {
                  onClick: (U) => {
                    U.stopPropagation(), n(
                      p === h.id ? null : h.id
                    );
                  },
                  className: "flex items-center gap-1.5 mt-2 text-xs text-primary hover:underline",
                  children: [
                    /* @__PURE__ */ e(Ve, { className: "h-3 w-3" }),
                    p === h.id ? "Stop following" : "Follow view"
                  ]
                }
              ),
              /* @__PURE__ */ e("div", { className: "absolute -top-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-popover border-l border-t rotate-45" })
            ] })
          ]
        },
        h.id
      )),
      K > 0 && /* @__PURE__ */ t(
        "button",
        {
          onClick: () => s(!w),
          className: "relative w-8 h-8 rounded-full bg-muted border-2 border-background flex items-center justify-center text-xs font-medium text-muted-foreground hover:bg-muted/80 transition-colors",
          children: [
            "+",
            K
          ]
        }
      )
    ] }),
    d > 0 && /* @__PURE__ */ t("div", { className: "ml-3 flex items-center gap-1.5", children: [
      /* @__PURE__ */ e("div", { className: "w-2 h-2 rounded-full bg-success animate-pulse" }),
      /* @__PURE__ */ t(a, { variant: "caption", className: "text-muted-foreground", children: [
        d,
        " online"
      ] })
    ] }),
    w && K > 0 && /* @__PURE__ */ e("div", { className: "absolute top-full right-0 mt-2 w-64 bg-popover border rounded-lg shadow-lg z-50 p-2", children: m.slice(E).map((h) => /* @__PURE__ */ t(
      "button",
      {
        onClick: () => {
          i == null || i(h), s(!1);
        },
        className: "w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-muted transition-colors text-left",
        children: [
          /* @__PURE__ */ t("div", { className: "relative", children: [
            /* @__PURE__ */ e(
              je,
              {
                src: h.avatar,
                fallback: h.name.charAt(0),
                size: "sm",
                style: { borderColor: h.color, borderWidth: 2 }
              }
            ),
            /* @__PURE__ */ e(
              "div",
              {
                className: l(
                  "absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 rounded-full border-2 border-background",
                  zt[h.status]
                )
              }
            )
          ] }),
          /* @__PURE__ */ t("div", { className: "flex-1 min-w-0", children: [
            /* @__PURE__ */ e(a, { variant: "caption", className: "font-medium truncate block", children: h.name }),
            D && h.activity && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground text-xs", children: jt[h.activity] })
          ] })
        ]
      },
      h.id
    )) }),
    j && m.map((h) => /* @__PURE__ */ e(
      At,
      {
        collaborator: h,
        containerRef: N
      },
      h.id
    ))
  ] });
};
jl.displayName = "CollaborationPresence";
const Al = {
  improvement: {
    icon: /* @__PURE__ */ e(Rr, { className: "h-4 w-4" }),
    color: "text-primary",
    bgColor: "bg-primary/10",
    label: "Improvement"
  },
  optimization: {
    icon: /* @__PURE__ */ e(Be, { className: "h-4 w-4" }),
    color: "text-warning",
    bgColor: "bg-warning/10",
    label: "Optimization"
  },
  warning: {
    icon: /* @__PURE__ */ e(ze, { className: "h-4 w-4" }),
    color: "text-destructive",
    bgColor: "bg-destructive/10",
    label: "Warning"
  },
  tip: {
    icon: /* @__PURE__ */ e(Te, { className: "h-4 w-4" }),
    color: "text-success",
    bgColor: "bg-success/10",
    label: "Tip"
  },
  action: {
    icon: /* @__PURE__ */ e(ba, { className: "h-4 w-4" }),
    color: "text-violet-500",
    bgColor: "bg-violet-500/10",
    label: "Quick Action"
  },
  insight: {
    icon: /* @__PURE__ */ e(Nt, { className: "h-4 w-4" }),
    color: "text-blue-500",
    bgColor: "bg-blue-500/10",
    label: "Insight"
  },
  security: {
    icon: /* @__PURE__ */ e(Ue, { className: "h-4 w-4" }),
    color: "text-red-500",
    bgColor: "bg-red-500/10",
    label: "Security"
  },
  performance: {
    icon: /* @__PURE__ */ e(Me, { className: "h-4 w-4" }),
    color: "text-orange-500",
    bgColor: "bg-orange-500/10",
    label: "Performance"
  }
}, $l = {
  icon: /* @__PURE__ */ e(Te, { className: "h-4 w-4" }),
  color: "text-muted-foreground",
  bgColor: "bg-muted",
  label: "Suggestion"
}, ya = (r) => (r ? Al[r] : void 0) ?? $l, Gt = {
  low: { color: "text-muted-foreground", label: "Low" },
  medium: { color: "text-warning", label: "Medium" },
  high: { color: "text-orange-500", label: "High" },
  critical: { color: "text-destructive", label: "Critical" }
}, Jt = ({ suggestion: r, onDismiss: C, onFeedback: i, compact: n = !1 }) => {
  var _;
  const [p, j] = P(!1), [D, E] = P(!1), y = ya(r.type), N = async () => {
    if (r.action) {
      j(!0);
      try {
        await r.action.onClick();
      } finally {
        j(!1);
      }
    }
  }, A = (w) => {
    const S = (/* @__PURE__ */ new Date()).getTime() - w.getTime(), g = Math.floor(S / 6e4);
    return g < 1 ? "Just now" : g < 60 ? `${g}m ago` : `${Math.floor(g / 60)}h ago`;
  };
  return /* @__PURE__ */ t(
    "div",
    {
      className: l(
        "group relative border rounded-lg transition-all",
        r.applied && "opacity-60",
        n ? "p-3" : "p-4"
      ),
      children: [
        r.dismissible !== !1 && C && /* @__PURE__ */ e(
          "button",
          {
            onClick: C,
            className: "absolute top-2 right-2 p-1 rounded opacity-0 group-hover:opacity-100 hover:bg-muted transition-all",
            children: /* @__PURE__ */ e(he, { className: "h-3.5 w-3.5 text-muted-foreground" })
          }
        ),
        /* @__PURE__ */ t("div", { className: "flex items-start gap-3", children: [
          /* @__PURE__ */ e("div", { className: l("p-2 rounded-lg shrink-0", y.bgColor, y.color), children: y.icon }),
          /* @__PURE__ */ t("div", { className: "flex-1 min-w-0", children: [
            /* @__PURE__ */ t("div", { className: "flex items-center gap-2 mb-1", children: [
              /* @__PURE__ */ e(
                a,
                {
                  variant: n ? "caption" : "body",
                  className: "font-medium line-clamp-1",
                  children: r.title
                }
              ),
              r.priority && r.priority !== "low" && /* @__PURE__ */ e(
                ae,
                {
                  variant: "default",
                  className: l("text-xs", Gt[r.priority].color),
                  children: Gt[r.priority].label
                }
              ),
              r.applied && /* @__PURE__ */ t(ae, { variant: "default", className: "text-xs bg-success text-success-foreground", children: [
                /* @__PURE__ */ e(Et, { className: "h-3 w-3 mr-1" }),
                "Applied"
              ] })
            ] }),
            /* @__PURE__ */ e(
              a,
              {
                variant: "caption",
                className: l(
                  "text-muted-foreground",
                  n ? "line-clamp-1" : "line-clamp-2"
                ),
                children: r.description
              }
            ),
            r.target && /* @__PURE__ */ t("div", { className: "flex items-center gap-1.5 mt-2 text-xs text-muted-foreground", children: [
              /* @__PURE__ */ e(Fe, { className: "h-3 w-3" }),
              /* @__PURE__ */ t("span", { children: [
                r.target.type,
                ":"
              ] }),
              /* @__PURE__ */ e("span", { className: "font-medium", children: r.target.name })
            ] }),
            (r.context || r.confidence !== void 0) && /* @__PURE__ */ t(
              "button",
              {
                onClick: () => E(!D),
                className: "flex items-center gap-1 mt-2 text-xs text-muted-foreground hover:text-foreground transition-colors",
                children: [
                  D ? /* @__PURE__ */ e(Ie, { className: "h-3 w-3" }) : /* @__PURE__ */ e(xe, { className: "h-3 w-3" }),
                  /* @__PURE__ */ t("span", { children: [
                    D ? "Hide" : "Show",
                    " details"
                  ] })
                ]
              }
            ),
            D && /* @__PURE__ */ t("div", { className: "mt-2 p-2 bg-muted/50 rounded text-xs space-y-1", children: [
              r.context && /* @__PURE__ */ t("div", { children: [
                /* @__PURE__ */ e("span", { className: "text-muted-foreground", children: "Context: " }),
                r.context
              ] }),
              r.confidence !== void 0 && /* @__PURE__ */ t("div", { children: [
                /* @__PURE__ */ e("span", { className: "text-muted-foreground", children: "Confidence: " }),
                r.confidence,
                "%"
              ] }),
              r.timestamp && /* @__PURE__ */ t("div", { children: [
                /* @__PURE__ */ e("span", { className: "text-muted-foreground", children: "Generated: " }),
                A(r.timestamp)
              ] })
            ] })
          ] })
        ] }),
        (r.action || r.secondaryActions || i) && /* @__PURE__ */ t("div", { className: "flex items-center justify-between mt-3 pt-3 border-t", children: [
          /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
            r.action && !r.applied && /* @__PURE__ */ e(
              u,
              {
                variant: "primary",
                size: "sm",
                onClick: N,
                disabled: p,
                children: p ? /* @__PURE__ */ t(me, { children: [
                  /* @__PURE__ */ e(ye, { className: "h-3.5 w-3.5 mr-1.5 animate-spin" }),
                  "Applying..."
                ] }) : /* @__PURE__ */ t(me, { children: [
                  /* @__PURE__ */ e(ba, { className: "h-3.5 w-3.5 mr-1.5" }),
                  r.action.label
                ] })
              }
            ),
            (_ = r.secondaryActions) == null ? void 0 : _.map((w, s) => /* @__PURE__ */ e(
              u,
              {
                variant: "ghost",
                size: "sm",
                onClick: w.onClick,
                children: w.label
              },
              s
            ))
          ] }),
          i && !r.feedback && /* @__PURE__ */ t("div", { className: "flex items-center gap-1", children: [
            /* @__PURE__ */ e(
              "button",
              {
                onClick: () => i("positive"),
                className: "p-1.5 rounded hover:bg-muted transition-colors text-muted-foreground hover:text-success",
                title: "Helpful",
                children: /* @__PURE__ */ e(pt, { className: "h-3.5 w-3.5" })
              }
            ),
            /* @__PURE__ */ e(
              "button",
              {
                onClick: () => i("negative"),
                className: "p-1.5 rounded hover:bg-muted transition-colors text-muted-foreground hover:text-destructive",
                title: "Not helpful",
                children: /* @__PURE__ */ e(Rt, { className: "h-3.5 w-3.5" })
              }
            )
          ] }),
          r.feedback && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: "Thanks for feedback" })
        ] })
      ]
    }
  );
}, _l = ({
  suggestions: r,
  onDismiss: C,
  onFeedback: i,
  onRefresh: n,
  onDismissAll: p,
  isLoading: j = !1,
  showHeader: D = !0,
  title: E = "AI Suggestions",
  collapsible: y = !0,
  defaultCollapsed: N = !1,
  maxVisible: A = 5,
  groupByType: _ = !1,
  emptyState: w,
  variant: s = "panel",
  position: S = "bottom-right",
  className: g
}) => {
  const [m, d] = P(N), [M, K] = P(!1), [Y, h] = P(!1), z = r.filter((v) => !v.applied), U = _ ? z.reduce((v, b) => (v[b.type] || (v[b.type] = []), v[b.type].push(b), v), {}) : null, T = M ? z : z.slice(0, A), L = z.length > A, G = {
    "top-right": "fixed top-4 right-4",
    "bottom-right": "fixed bottom-4 right-4",
    "top-left": "fixed top-4 left-4",
    "bottom-left": "fixed bottom-4 left-4"
  };
  if (Y && s === "floating")
    return /* @__PURE__ */ t(
      "button",
      {
        onClick: () => h(!1),
        className: l(
          G[S],
          "p-3 bg-primary rounded-full shadow-lg hover:scale-110 transition-transform z-50"
        ),
        children: [
          /* @__PURE__ */ e(Te, { className: "h-5 w-5 text-primary-foreground" }),
          z.length > 0 && /* @__PURE__ */ e("span", { className: "absolute -top-1 -right-1 w-5 h-5 bg-destructive text-destructive-foreground text-xs rounded-full flex items-center justify-center", children: z.length })
        ]
      }
    );
  const Q = /* @__PURE__ */ t(me, { children: [
    D && /* @__PURE__ */ t("div", { className: "flex items-center justify-between pb-3 border-b", children: [
      /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
        y && /* @__PURE__ */ e(
          "button",
          {
            onClick: () => d(!m),
            className: "p-1 rounded hover:bg-muted transition-colors",
            children: m ? /* @__PURE__ */ e(Ne, { className: "h-4 w-4" }) : /* @__PURE__ */ e(xe, { className: "h-4 w-4" })
          }
        ),
        /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ e(Te, { className: "h-4 w-4 text-primary" }),
          /* @__PURE__ */ e(a, { variant: "body", className: "font-medium", children: E }),
          z.length > 0 && /* @__PURE__ */ e(ae, { variant: "default", className: "text-xs", children: z.length })
        ] })
      ] }),
      /* @__PURE__ */ t("div", { className: "flex items-center gap-1", children: [
        n && /* @__PURE__ */ e(
          "button",
          {
            onClick: n,
            disabled: j,
            className: "p-1.5 rounded hover:bg-muted transition-colors text-muted-foreground hover:text-foreground disabled:opacity-50",
            title: "Refresh suggestions",
            children: /* @__PURE__ */ e(Qe, { className: l("h-4 w-4", j && "animate-spin") })
          }
        ),
        s === "floating" && /* @__PURE__ */ e(
          "button",
          {
            onClick: () => h(!0),
            className: "p-1.5 rounded hover:bg-muted transition-colors text-muted-foreground hover:text-foreground",
            title: "Minimize",
            children: /* @__PURE__ */ e(It, { className: "h-4 w-4" })
          }
        ),
        p && z.length > 0 && /* @__PURE__ */ e(
          "button",
          {
            onClick: p,
            className: "p-1.5 rounded hover:bg-muted transition-colors text-muted-foreground hover:text-foreground",
            title: "Dismiss all",
            children: /* @__PURE__ */ e(he, { className: "h-4 w-4" })
          }
        )
      ] })
    ] }),
    !m && /* @__PURE__ */ e("div", { className: "pt-3", children: j ? /* @__PURE__ */ t("div", { className: "flex flex-col items-center justify-center py-8 text-center", children: [
      /* @__PURE__ */ e(ye, { className: "h-8 w-8 text-primary animate-spin mb-3" }),
      /* @__PURE__ */ e(a, { variant: "body", className: "text-muted-foreground", children: "Analyzing..." })
    ] }) : z.length === 0 ? w ?? /* @__PURE__ */ t("div", { className: "flex flex-col items-center justify-center py-8 text-center", children: [
      /* @__PURE__ */ e(Et, { className: "h-10 w-10 text-success/50 mb-3" }),
      /* @__PURE__ */ e(a, { variant: "body", className: "font-medium mb-1", children: "All caught up!" }),
      /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: "No suggestions at the moment" })
    ] }) : _ && U ? /* @__PURE__ */ e("div", { className: "space-y-4", children: Object.entries(U).map(
      ([v, b]) => /* @__PURE__ */ t("div", { children: [
        (() => {
          const c = ya(v);
          return /* @__PURE__ */ t("div", { className: "flex items-center gap-2 mb-2", children: [
            /* @__PURE__ */ e("span", { className: c.color, children: c.icon }),
            /* @__PURE__ */ e(a, { variant: "caption", className: "font-medium", children: c.label }),
            /* @__PURE__ */ e(ae, { variant: "secondary", className: "text-xs", children: b.length })
          ] });
        })(),
        /* @__PURE__ */ e("div", { className: "space-y-2", children: b.map((c) => /* @__PURE__ */ e(
          Jt,
          {
            suggestion: c,
            onDismiss: C ? () => C(c.id) : void 0,
            onFeedback: i ? ($) => i(c.id, $) : void 0,
            compact: s === "inline"
          },
          c.id
        )) })
      ] }, v)
    ) }) : /* @__PURE__ */ t("div", { className: "space-y-3", children: [
      T.map((v) => /* @__PURE__ */ e(
        Jt,
        {
          suggestion: v,
          onDismiss: C ? () => C(v.id) : void 0,
          onFeedback: i ? (b) => i(v.id, b) : void 0,
          compact: s === "inline"
        },
        v.id
      )),
      L && /* @__PURE__ */ e(
        "button",
        {
          onClick: () => K(!M),
          className: "w-full py-2 text-sm text-center text-muted-foreground hover:text-foreground transition-colors",
          children: M ? "Show less" : `Show ${z.length - A} more`
        }
      )
    ] }) })
  ] });
  return s === "inline" ? /* @__PURE__ */ e("div", { className: g, children: Q }) : s === "floating" ? /* @__PURE__ */ e(
    ne,
    {
      className: l(
        G[S],
        "w-80 max-h-[70vh] overflow-y-auto shadow-xl z-50",
        g
      ),
      children: /* @__PURE__ */ e("div", { className: "p-4", children: Q })
    }
  ) : /* @__PURE__ */ e(ne, { className: l("p-4", g), children: Q });
};
_l.displayName = "AISuggestions";
const Tl = [
  {
    format: "png",
    label: "PNG",
    description: "High-quality raster image with transparency",
    icon: /* @__PURE__ */ e(ma, { className: "h-5 w-5" })
  },
  {
    format: "svg",
    label: "SVG",
    description: "Scalable vector graphics, perfect for web",
    icon: /* @__PURE__ */ e(Lt, { className: "h-5 w-5" })
  },
  {
    format: "pdf",
    label: "PDF",
    description: "Print-ready document format",
    icon: /* @__PURE__ */ e(rt, { className: "h-5 w-5" })
  },
  {
    format: "jpg",
    label: "JPG",
    description: "Compressed image, smaller file size",
    icon: /* @__PURE__ */ e(St, { className: "h-5 w-5" })
  }
], Sl = [
  { platform: "link", label: "Copy Link", icon: /* @__PURE__ */ e(ht, { className: "h-4 w-4" }) },
  { platform: "email", label: "Email", icon: /* @__PURE__ */ e(xt, { className: "h-4 w-4" }) },
  { platform: "twitter", label: "Twitter", icon: /* @__PURE__ */ e(Ws, { className: "h-4 w-4" }) },
  { platform: "linkedin", label: "LinkedIn", icon: /* @__PURE__ */ e(Vr, { className: "h-4 w-4" }) },
  { platform: "slack", label: "Slack", icon: /* @__PURE__ */ e(_s, { className: "h-4 w-4" }) },
  { platform: "embed", label: "Embed", icon: /* @__PURE__ */ e(Lt, { className: "h-4 w-4" }) }
], Dl = [
  { value: 1, label: "1x", description: "Standard" },
  { value: 2, label: "2x", description: "Retina" },
  { value: 3, label: "3x", description: "High DPI" }
], El = [
  { value: "transparent", label: "Transparent", icon: "🔲" },
  { value: "white", label: "White", icon: "⬜" },
  { value: "dark", label: "Dark", icon: "⬛" }
], Ll = ({
  title: r = "Export",
  description: C,
  preview: i,
  assetName: n = "export",
  formats: p = Tl,
  shareOptions: j = Sl,
  onExport: D,
  onShare: E,
  onGenerateEmbed: y,
  onGenerateLink: N,
  isExporting: A = !1,
  progress: _,
  errorMessage: w,
  onSuccess: s,
  showAdvancedSettings: S = !0,
  defaultSettings: g = {},
  variant: m = "full",
  className: d
}) => {
  var X, R;
  const [M, K] = P(((X = p[0]) == null ? void 0 : X.format) || "png"), [Y, h] = P("export"), [z, U] = P(!1), [T, L] = P("idle"), [G, Q] = P(null), [v, b] = P(!1), [c, $] = P(null), [o, x] = P(null), [f, O] = P({
    scale: g.scale ?? 2,
    background: g.background ?? "transparent",
    quality: g.quality ?? 90,
    padding: g.padding ?? 20,
    filename: g.filename ?? n
  }), F = (H, ce) => {
    O((q) => ({ ...q, [H]: ce }));
  }, de = async () => {
    L("exporting"), Q(null);
    try {
      const H = await D(M, f);
      if (H instanceof Blob) {
        const ce = URL.createObjectURL(H), q = document.createElement("a");
        q.href = ce, q.download = `${f.filename || n}.${M}`, document.body.appendChild(q), q.click(), document.body.removeChild(q), URL.revokeObjectURL(ce);
      }
      L("success"), s == null || s(M), setTimeout(() => L("idle"), 3e3);
    } catch (H) {
      L("error"), Q(H instanceof Error ? H.message : "Export failed");
    }
  }, I = async () => {
    try {
      let H = o;
      !H && N && (H = await N(), x(H)), H && (await navigator.clipboard.writeText(H), b(!0), setTimeout(() => b(!1), 2e3));
    } catch {
    }
  }, se = async () => {
    if (y) {
      const H = await y();
      $(H);
    }
  }, oe = async (H) => {
    H === "link" ? await I() : H === "embed" ? await se() : E && await E(H);
  }, Z = w || G, V = ["png", "jpg", "webp"].includes(M), ie = ["png", "svg", "webp"].includes(M);
  return /* @__PURE__ */ t(ne, { className: l("overflow-hidden", m === "compact" && "p-4", d), children: [
    m !== "compact" && /* @__PURE__ */ t("div", { className: "p-4 border-b", children: [
      /* @__PURE__ */ t("div", { className: "flex items-center gap-2 mb-1", children: [
        /* @__PURE__ */ e(_e, { className: "h-5 w-5 text-muted-foreground" }),
        /* @__PURE__ */ e(a, { variant: "h4", className: "font-semibold", children: r })
      ] }),
      C && /* @__PURE__ */ e(a, { variant: "body", className: "text-muted-foreground", children: C })
    ] }),
    (E || N) && m !== "compact" && /* @__PURE__ */ t("div", { className: "flex border-b", children: [
      /* @__PURE__ */ t(
        "button",
        {
          onClick: () => h("export"),
          className: l(
            "flex-1 py-3 text-sm font-medium transition-colors relative",
            Y === "export" ? "text-foreground" : "text-muted-foreground hover:text-foreground"
          ),
          children: [
            /* @__PURE__ */ t("div", { className: "flex items-center justify-center gap-2", children: [
              /* @__PURE__ */ e(_e, { className: "h-4 w-4" }),
              "Export"
            ] }),
            Y === "export" && /* @__PURE__ */ e("div", { className: "absolute bottom-0 left-0 right-0 h-0.5 bg-primary" })
          ]
        }
      ),
      /* @__PURE__ */ t(
        "button",
        {
          onClick: () => h("share"),
          className: l(
            "flex-1 py-3 text-sm font-medium transition-colors relative",
            Y === "share" ? "text-foreground" : "text-muted-foreground hover:text-foreground"
          ),
          children: [
            /* @__PURE__ */ t("div", { className: "flex items-center justify-center gap-2", children: [
              /* @__PURE__ */ e(ct, { className: "h-4 w-4" }),
              "Share"
            ] }),
            Y === "share" && /* @__PURE__ */ e("div", { className: "absolute bottom-0 left-0 right-0 h-0.5 bg-primary" })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ t("div", { className: l(m !== "compact" && "p-4"), children: [
      i && m === "full" && /* @__PURE__ */ e("div", { className: "mb-4 p-4 bg-muted/30 rounded-lg border-2 border-dashed", children: /* @__PURE__ */ e("div", { className: "aspect-video flex items-center justify-center overflow-hidden rounded", children: i }) }),
      Y === "export" ? /* @__PURE__ */ t(me, { children: [
        /* @__PURE__ */ t("div", { className: "mb-4", children: [
          /* @__PURE__ */ e(a, { variant: "body", className: "font-medium mb-3", children: "Format" }),
          /* @__PURE__ */ e("div", { className: l(
            "grid gap-2",
            m === "compact" ? "grid-cols-2" : "grid-cols-2 md:grid-cols-4"
          ), children: p.map((H) => /* @__PURE__ */ t(
            "button",
            {
              onClick: () => !H.disabled && K(H.format),
              disabled: H.disabled || A,
              className: l(
                "flex flex-col items-center gap-2 p-3 border rounded-lg transition-all text-center",
                M === H.format ? "border-primary bg-primary/5 ring-1 ring-primary" : "hover:border-primary/50 hover:bg-muted/30",
                H.disabled && "opacity-50 cursor-not-allowed"
              ),
              children: [
                /* @__PURE__ */ e("div", { className: l(
                  M === H.format ? "text-primary" : "text-muted-foreground"
                ), children: H.icon }),
                /* @__PURE__ */ t("div", { className: "flex items-center gap-1", children: [
                  /* @__PURE__ */ e(a, { variant: "caption", className: "font-medium", children: H.label }),
                  H.isPremium && /* @__PURE__ */ e(ae, { variant: "default", className: "text-xs bg-warning text-warning-foreground", children: "Pro" })
                ] }),
                m !== "compact" && H.description && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground text-xs", children: H.description })
              ]
            },
            H.format
          )) })
        ] }),
        S && /* @__PURE__ */ t("div", { className: "mb-4", children: [
          /* @__PURE__ */ t(
            "button",
            {
              onClick: () => U(!z),
              className: "flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors",
              children: [
                /* @__PURE__ */ e(Oe, { className: "h-4 w-4" }),
                /* @__PURE__ */ e("span", { children: "Advanced settings" }),
                z ? /* @__PURE__ */ e(Ie, { className: "h-4 w-4" }) : /* @__PURE__ */ e(xe, { className: "h-4 w-4" })
              ]
            }
          ),
          z && /* @__PURE__ */ t("div", { className: "mt-4 p-4 bg-muted/30 rounded-lg space-y-4", children: [
            V && /* @__PURE__ */ t("div", { children: [
              /* @__PURE__ */ e(a, { variant: "caption", className: "font-medium mb-2 block", children: "Scale" }),
              /* @__PURE__ */ e("div", { className: "flex gap-2", children: Dl.map((H) => /* @__PURE__ */ t(
                "button",
                {
                  onClick: () => F("scale", H.value),
                  className: l(
                    "flex-1 py-2 px-3 border rounded-lg text-sm transition-all",
                    f.scale === H.value ? "border-primary bg-primary/5" : "hover:border-primary/50"
                  ),
                  children: [
                    /* @__PURE__ */ e("div", { className: "font-medium", children: H.label }),
                    /* @__PURE__ */ e("div", { className: "text-xs text-muted-foreground", children: H.description })
                  ]
                },
                H.value
              )) })
            ] }),
            ie && /* @__PURE__ */ t("div", { children: [
              /* @__PURE__ */ e(a, { variant: "caption", className: "font-medium mb-2 block", children: "Background" }),
              /* @__PURE__ */ e("div", { className: "flex gap-2", children: El.map((H) => /* @__PURE__ */ t(
                "button",
                {
                  onClick: () => F("background", H.value),
                  className: l(
                    "flex items-center gap-2 py-2 px-3 border rounded-lg text-sm transition-all",
                    f.background === H.value ? "border-primary bg-primary/5" : "hover:border-primary/50"
                  ),
                  children: [
                    /* @__PURE__ */ e("span", { children: H.icon }),
                    /* @__PURE__ */ e("span", { children: H.label })
                  ]
                },
                H.value
              )) })
            ] }),
            ["jpg", "webp"].includes(M) && /* @__PURE__ */ t("div", { children: [
              /* @__PURE__ */ t(a, { variant: "caption", className: "font-medium mb-2 block", children: [
                "Quality: ",
                f.quality,
                "%"
              ] }),
              /* @__PURE__ */ e(
                "input",
                {
                  type: "range",
                  min: "10",
                  max: "100",
                  step: "10",
                  value: f.quality,
                  onChange: (H) => F("quality", parseInt(H.target.value)),
                  className: "w-full"
                }
              )
            ] }),
            /* @__PURE__ */ t("div", { children: [
              /* @__PURE__ */ e(a, { variant: "caption", className: "font-medium mb-2 block", children: "Filename" }),
              /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ e(
                  ue,
                  {
                    value: f.filename,
                    onChange: (H) => F("filename", H.target.value),
                    placeholder: "export",
                    className: "flex-1"
                  }
                ),
                /* @__PURE__ */ t("span", { className: "text-muted-foreground", children: [
                  ".",
                  M
                ] })
              ] })
            ] })
          ] })
        ] }),
        (A || T === "exporting") && /* @__PURE__ */ t("div", { className: "mb-4", children: [
          /* @__PURE__ */ t("div", { className: "flex items-center justify-between mb-2", children: [
            /* @__PURE__ */ e(a, { variant: "body", className: "text-sm", children: "Exporting..." }),
            _ !== void 0 && /* @__PURE__ */ t(a, { variant: "body", className: "text-sm font-medium", children: [
              _,
              "%"
            ] })
          ] }),
          /* @__PURE__ */ e("div", { className: "h-2 bg-muted rounded-full overflow-hidden", children: /* @__PURE__ */ e(
            "div",
            {
              className: "h-full bg-primary rounded-full transition-all duration-300",
              style: { width: _ !== void 0 ? `${_}%` : "30%" }
            }
          ) })
        ] }),
        T === "success" && /* @__PURE__ */ t("div", { className: "mb-4 p-3 bg-success/10 rounded-lg flex items-center gap-3", children: [
          /* @__PURE__ */ e(fe, { className: "h-5 w-5 text-success shrink-0" }),
          /* @__PURE__ */ e(a, { variant: "body", className: "text-success text-sm", children: "Export complete! Your download should start automatically." })
        ] }),
        Z && /* @__PURE__ */ t("div", { className: "mb-4 p-3 bg-destructive/10 rounded-lg flex items-center gap-3", children: [
          /* @__PURE__ */ e(Le, { className: "h-5 w-5 text-destructive shrink-0" }),
          /* @__PURE__ */ e("div", { className: "flex-1", children: /* @__PURE__ */ e(a, { variant: "body", className: "text-destructive text-sm", children: Z }) }),
          /* @__PURE__ */ e(
            u,
            {
              variant: "ghost",
              size: "sm",
              onClick: () => {
                L("idle"), Q(null);
              },
              children: "Retry"
            }
          )
        ] }),
        /* @__PURE__ */ e(
          u,
          {
            variant: "primary",
            onClick: de,
            disabled: A || T === "exporting",
            className: "w-full",
            children: A || T === "exporting" ? /* @__PURE__ */ t(me, { children: [
              /* @__PURE__ */ e(ye, { className: "h-4 w-4 mr-2 animate-spin" }),
              "Exporting..."
            ] }) : /* @__PURE__ */ t(me, { children: [
              /* @__PURE__ */ e(_e, { className: "h-4 w-4 mr-2" }),
              "Export as ",
              (R = p.find((H) => H.format === M)) == null ? void 0 : R.label
            ] })
          }
        )
      ] }) : (
        /* Share tab */
        /* @__PURE__ */ t("div", { className: "space-y-4", children: [
          /* @__PURE__ */ t("div", { children: [
            /* @__PURE__ */ e(a, { variant: "body", className: "font-medium mb-3", children: "Share via" }),
            /* @__PURE__ */ e("div", { className: "flex flex-wrap gap-2", children: j.map((H) => /* @__PURE__ */ t(
              u,
              {
                variant: "outline",
                size: "sm",
                onClick: () => oe(H.platform),
                disabled: H.disabled,
                className: "flex items-center gap-2",
                children: [
                  H.icon,
                  H.label
                ]
              },
              H.platform
            )) })
          ] }),
          N && /* @__PURE__ */ t("div", { children: [
            /* @__PURE__ */ e(a, { variant: "body", className: "font-medium mb-3", children: "Share link" }),
            /* @__PURE__ */ t("div", { className: "flex gap-2", children: [
              /* @__PURE__ */ e(
                ue,
                {
                  value: o || "Click to generate link...",
                  readOnly: !0,
                  className: "flex-1 bg-muted"
                }
              ),
              /* @__PURE__ */ e(
                u,
                {
                  variant: "outline",
                  onClick: I,
                  children: v ? /* @__PURE__ */ t(me, { children: [
                    /* @__PURE__ */ e(fe, { className: "h-4 w-4 mr-2" }),
                    "Copied"
                  ] }) : /* @__PURE__ */ t(me, { children: [
                    /* @__PURE__ */ e(Ke, { className: "h-4 w-4 mr-2" }),
                    "Copy"
                  ] })
                }
              )
            ] })
          ] }),
          y && /* @__PURE__ */ t("div", { children: [
            /* @__PURE__ */ e(a, { variant: "body", className: "font-medium mb-3", children: "Embed code" }),
            c ? /* @__PURE__ */ t("div", { className: "relative", children: [
              /* @__PURE__ */ e("pre", { className: "p-3 bg-muted rounded-lg text-xs overflow-x-auto", children: c }),
              /* @__PURE__ */ e(
                u,
                {
                  variant: "ghost",
                  size: "sm",
                  onClick: async () => {
                    await navigator.clipboard.writeText(c);
                  },
                  className: "absolute top-2 right-2",
                  children: /* @__PURE__ */ e(Ke, { className: "h-4 w-4" })
                }
              )
            ] }) : /* @__PURE__ */ t(
              u,
              {
                variant: "outline",
                onClick: se,
                className: "w-full",
                children: [
                  /* @__PURE__ */ e(Lt, { className: "h-4 w-4 mr-2" }),
                  "Generate embed code"
                ]
              }
            )
          ] })
        ] })
      )
    ] })
  ] });
};
Ll.displayName = "ExportAsset";
const $t = {
  manual: {
    icon: /* @__PURE__ */ e(fa, { className: "h-3.5 w-3.5" }),
    label: "Saved",
    color: "text-primary"
  },
  auto: {
    icon: /* @__PURE__ */ e(Me, { className: "h-3.5 w-3.5" }),
    label: "Auto-saved",
    color: "text-muted-foreground"
  },
  checkpoint: {
    icon: /* @__PURE__ */ e(st, { className: "h-3.5 w-3.5" }),
    label: "Checkpoint",
    color: "text-success"
  },
  branch: {
    icon: /* @__PURE__ */ e(dt, { className: "h-3.5 w-3.5" }),
    label: "Branch",
    color: "text-warning"
  },
  merge: {
    icon: /* @__PURE__ */ e(dt, { className: "h-3.5 w-3.5" }),
    label: "Merge",
    color: "text-violet-500"
  }
}, _t = {
  added: {
    icon: /* @__PURE__ */ e(Pe, { className: "h-3 w-3" }),
    color: "text-success",
    bgColor: "bg-success/10"
  },
  removed: {
    icon: /* @__PURE__ */ e(va, { className: "h-3 w-3" }),
    color: "text-destructive",
    bgColor: "bg-destructive/10"
  },
  modified: {
    icon: /* @__PURE__ */ e(fa, { className: "h-3 w-3" }),
    color: "text-warning",
    bgColor: "bg-warning/10"
  },
  unchanged: {
    icon: /* @__PURE__ */ e(fe, { className: "h-3 w-3" }),
    color: "text-muted-foreground",
    bgColor: "bg-muted"
  }
}, Pl = (r) => typeof r != "string" ? $t.manual : $t[r] ?? $t.manual, Hl = (r) => typeof r != "string" ? _t.modified : _t[r] ?? _t.modified, ql = ({
  version: r,
  isSelected: C,
  isComparing: i,
  compareMode: n,
  onSelect: p,
  onCompareSelect: j,
  onPreview: D,
  onRestore: E,
  onStar: y,
  onDelete: N,
  onExport: A,
  variant: _
}) => {
  var h;
  const [w, s] = P(!1), [S, g] = P(!1), [m, d] = P(!1), M = Pl(r.type), K = (z) => {
    if (!z) return "Unknown time";
    const U = z instanceof Date ? z : new Date(z);
    if (Number.isNaN(U.getTime())) return "Unknown time";
    const L = (/* @__PURE__ */ new Date()).getTime() - U.getTime(), G = Math.floor(L / 6e4);
    if (G < 1) return "Just now";
    if (G < 60) return `${G}m ago`;
    const Q = Math.floor(G / 60);
    if (Q < 24) return `${Q}h ago`;
    const v = Math.floor(Q / 24);
    return v < 7 ? `${v}d ago` : U.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  }, Y = async () => {
    if (E) {
      g(!0);
      try {
        await E();
      } finally {
        g(!1);
      }
    }
  };
  return /* @__PURE__ */ t(
    "div",
    {
      onClick: n ? j : p,
      onMouseEnter: () => s(!0),
      onMouseLeave: () => s(!1),
      className: l(
        "relative group cursor-pointer transition-all",
        _ === "timeline" && "flex gap-4",
        _ === "list" && "flex items-center gap-4 p-4 border rounded-lg",
        _ === "compact" && "flex items-center gap-3 p-2 rounded-lg hover:bg-muted/50",
        C && "ring-2 ring-primary",
        i && "ring-2 ring-warning bg-warning/5",
        r.isCurrent && "border-primary"
      ),
      children: [
        _ === "timeline" && /* @__PURE__ */ t("div", { className: "flex flex-col items-center", children: [
          /* @__PURE__ */ e(
            "div",
            {
              className: l(
                "w-8 h-8 rounded-full flex items-center justify-center shrink-0",
                r.isCurrent ? "bg-primary text-primary-foreground" : "bg-muted border-2",
                M.color
              ),
              children: M.icon
            }
          ),
          /* @__PURE__ */ e("div", { className: "w-0.5 flex-1 bg-border" })
        ] }),
        /* @__PURE__ */ t("div", { className: l("flex-1 min-w-0", _ === "timeline" && "pb-6"), children: [
          /* @__PURE__ */ t("div", { className: "flex items-start justify-between gap-2", children: [
            /* @__PURE__ */ t("div", { className: "flex-1 min-w-0", children: [
              /* @__PURE__ */ t("div", { className: "flex items-center gap-2 flex-wrap", children: [
                r.name ? /* @__PURE__ */ e(a, { variant: "body", className: "font-medium truncate", children: r.name }) : /* @__PURE__ */ e(a, { variant: "body", className: "text-muted-foreground", children: M.label }),
                r.isCurrent && /* @__PURE__ */ e(ae, { variant: "default", className: "text-xs bg-primary", children: "Current" }),
                r.isStarred && /* @__PURE__ */ e($e, { className: "h-3.5 w-3.5 fill-warning text-warning" }),
                (h = r.tags) == null ? void 0 : h.map((z) => /* @__PURE__ */ e(ae, { variant: "secondary", className: "text-xs", children: z }, z))
              ] }),
              r.description && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground mt-0.5 line-clamp-1", children: r.description })
            ] }),
            /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground whitespace-nowrap", children: K(r.timestamp) })
          ] }),
          _ !== "compact" && /* @__PURE__ */ t("div", { className: "flex items-center gap-4 mt-2 text-sm", children: [
            r.author && /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ e(
                je,
                {
                  src: r.author.avatar,
                  fallback: r.author.name.charAt(0),
                  size: "sm",
                  className: "w-5 h-5"
                }
              ),
              /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: r.author.name })
            ] }),
            r.changeCount && /* @__PURE__ */ t("div", { className: "flex items-center gap-2 text-xs", children: [
              r.changeCount.added > 0 && /* @__PURE__ */ t("span", { className: "text-success", children: [
                "+",
                r.changeCount.added
              ] }),
              r.changeCount.removed > 0 && /* @__PURE__ */ t("span", { className: "text-destructive", children: [
                "-",
                r.changeCount.removed
              ] }),
              r.changeCount.modified > 0 && /* @__PURE__ */ t("span", { className: "text-warning", children: [
                "~",
                r.changeCount.modified
              ] })
            ] })
          ] }),
          r.changes && r.changes.length > 0 && _ !== "compact" && /* @__PURE__ */ t(me, { children: [
            /* @__PURE__ */ t(
              "button",
              {
                onClick: (z) => {
                  z.stopPropagation(), d(!m);
                },
                className: "flex items-center gap-1 mt-2 text-xs text-muted-foreground hover:text-foreground transition-colors",
                children: [
                  m ? /* @__PURE__ */ e(xe, { className: "h-3 w-3" }) : /* @__PURE__ */ e(Ne, { className: "h-3 w-3" }),
                  /* @__PURE__ */ t("span", { children: [
                    r.changes.length,
                    " change",
                    r.changes.length !== 1 ? "s" : ""
                  ] })
                ]
              }
            ),
            m && /* @__PURE__ */ t("div", { className: "mt-2 space-y-1", children: [
              r.changes.slice(0, 10).map((z, U) => {
                const T = typeof z == "string" ? { type: "modified", path: z } : z, L = Hl(T == null ? void 0 : T.type);
                return /* @__PURE__ */ t(
                  "div",
                  {
                    className: l(
                      "flex items-center gap-2 px-2 py-1 rounded text-xs",
                      L.bgColor
                    ),
                    children: [
                      /* @__PURE__ */ e("span", { className: L.color, children: L.icon }),
                      /* @__PURE__ */ e("span", { className: "font-mono truncate", children: (T == null ? void 0 : T.path) || "unknown" }),
                      (T == null ? void 0 : T.description) && /* @__PURE__ */ e("span", { className: "text-muted-foreground truncate", children: T.description })
                    ]
                  },
                  U
                );
              }),
              r.changes.length > 10 && /* @__PURE__ */ t(a, { variant: "caption", className: "text-muted-foreground px-2", children: [
                "+",
                r.changes.length - 10,
                " more changes"
              ] })
            ] })
          ] }),
          (w || C) && _ !== "compact" && /* @__PURE__ */ t("div", { className: "flex items-center gap-1 mt-3", children: [
            D && /* @__PURE__ */ t(
              u,
              {
                variant: "ghost",
                size: "sm",
                onClick: (z) => {
                  z.stopPropagation(), D();
                },
                children: [
                  /* @__PURE__ */ e(Ve, { className: "h-3.5 w-3.5 mr-1.5" }),
                  "Preview"
                ]
              }
            ),
            E && !r.isCurrent && /* @__PURE__ */ t(
              u,
              {
                variant: "ghost",
                size: "sm",
                onClick: (z) => {
                  z.stopPropagation(), Y();
                },
                disabled: S,
                children: [
                  S ? /* @__PURE__ */ e(ye, { className: "h-3.5 w-3.5 mr-1.5 animate-spin" }) : /* @__PURE__ */ e(Qe, { className: "h-3.5 w-3.5 mr-1.5" }),
                  "Restore"
                ]
              }
            ),
            y && /* @__PURE__ */ e(
              u,
              {
                variant: "ghost",
                size: "sm",
                onClick: (z) => {
                  z.stopPropagation(), y(!r.isStarred);
                },
                children: r.isStarred ? /* @__PURE__ */ e($e, { className: "h-3.5 w-3.5 fill-warning text-warning" }) : /* @__PURE__ */ e(Ot, { className: "h-3.5 w-3.5" })
              }
            ),
            A && /* @__PURE__ */ e(
              u,
              {
                variant: "ghost",
                size: "sm",
                onClick: (z) => {
                  z.stopPropagation(), A();
                },
                children: /* @__PURE__ */ e(_e, { className: "h-3.5 w-3.5" })
              }
            ),
            N && !r.isCurrent && /* @__PURE__ */ e(
              u,
              {
                variant: "ghost",
                size: "sm",
                onClick: (z) => {
                  z.stopPropagation(), N();
                },
                className: "text-destructive hover:text-destructive",
                children: /* @__PURE__ */ e(Re, { className: "h-3.5 w-3.5" })
              }
            )
          ] })
        ] }),
        n && /* @__PURE__ */ e("div", { className: "flex items-center", children: /* @__PURE__ */ e(
          "div",
          {
            className: l(
              "w-5 h-5 rounded border-2 flex items-center justify-center",
              i ? "bg-warning border-warning" : "border-muted-foreground"
            ),
            children: i && /* @__PURE__ */ e(fe, { className: "h-3 w-3 text-warning-foreground" })
          }
        ) })
      ]
    }
  );
}, Il = ({
  versions: r = [],
  currentVersionId: C,
  onPreview: i,
  onRestore: n,
  onCompare: p,
  onStar: j,
  onDelete: D,
  onRename: E,
  onCreateCheckpoint: y,
  onExport: N,
  isLoading: A = !1,
  showDiff: _ = !0,
  title: w = "Version History",
  variant: s = "timeline",
  groupByDate: S = !0,
  maxVisible: g = 20,
  showFilters: m = !0,
  className: d
}) => {
  const [M, K] = P(""), [Y, h] = P("all"), [z, U] = P(null), [T, L] = P(null), [G, Q] = P(!1), [v, b] = P([]), [c, $] = P(!1), o = Ce(() => r.map((Z) => ({
    ...Z,
    isCurrent: Z.id === C
  })), [r, C]), x = Ce(() => {
    let Z = [...o];
    if (M) {
      const V = M.toLowerCase();
      Z = Z.filter(
        (ie) => {
          var X, R, H, ce;
          return ((X = ie.name) == null ? void 0 : X.toLowerCase().includes(V)) || ((R = ie.description) == null ? void 0 : R.toLowerCase().includes(V)) || ((H = ie.author) == null ? void 0 : H.name.toLowerCase().includes(V)) || ((ce = ie.tags) == null ? void 0 : ce.some((q) => q.toLowerCase().includes(V)));
        }
      );
    }
    return Y !== "all" && (Z = Z.filter((V) => V.type === Y)), z && (Z = Z.filter((V) => {
      var ie;
      return ((ie = V.author) == null ? void 0 : ie.id) === z;
    })), Z;
  }, [o, M, Y, z]), f = Ce(() => {
    if (!S) return null;
    const Z = {}, V = /* @__PURE__ */ new Date(), ie = new Date(V);
    return ie.setDate(ie.getDate() - 1), x.forEach((X) => {
      const R = new Date(X.timestamp);
      let H;
      R.toDateString() === V.toDateString() ? H = "Today" : R.toDateString() === ie.toDateString() ? H = "Yesterday" : H = R.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: R.getFullYear() !== V.getFullYear() ? "numeric" : void 0
      }), Z[H] || (Z[H] = []), Z[H].push(X);
    }), Z;
  }, [x, S]), O = c ? x : x.slice(0, g), F = x.length > g, de = Ce(() => {
    const Z = /* @__PURE__ */ new Map();
    return r.forEach((V) => {
      V.author && Z.set(V.author.id, V.author);
    }), Array.from(Z.values());
  }, [r]), I = (Z) => {
    b((V) => V.includes(Z) ? V.filter((ie) => ie !== Z) : V.length >= 2 ? [V[1], Z] : [...V, Z]);
  }, se = () => {
    if (v.length === 2 && p) {
      const [Z, V] = v, ie = r.find((R) => R.id === Z), X = r.find((R) => R.id === V);
      ie && X && p(ie, X);
    }
  }, oe = (Z) => /* @__PURE__ */ e("div", { className: l(
    s === "timeline" && "space-y-0",
    s === "list" && "space-y-2",
    s === "compact" && "space-y-1"
  ), children: Z.map((V) => /* @__PURE__ */ e(
    ql,
    {
      version: V,
      isSelected: T === V.id,
      isComparing: v.includes(V.id),
      compareMode: G,
      onSelect: () => L(V.id),
      onCompareSelect: () => I(V.id),
      onPreview: i ? () => i(V) : void 0,
      onRestore: n ? () => n(V) : void 0,
      onStar: j ? (ie) => j(V.id, ie) : void 0,
      onDelete: D ? () => D(V.id) : void 0,
      onExport: N ? () => N(V) : void 0,
      variant: s
    },
    V.id
  )) });
  return /* @__PURE__ */ t(ne, { className: l("flex flex-col", d), children: [
    /* @__PURE__ */ t("div", { className: "p-4 border-b", children: [
      /* @__PURE__ */ t("div", { className: "flex items-center justify-between mb-4", children: [
        /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ e(Ge, { className: "h-5 w-5 text-muted-foreground" }),
          /* @__PURE__ */ e(a, { variant: "h4", className: "font-semibold", children: w }),
          /* @__PURE__ */ e(ae, { variant: "secondary", className: "text-xs", children: x.length })
        ] }),
        /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
          p && /* @__PURE__ */ t(
            u,
            {
              variant: G ? "default" : "outline",
              size: "sm",
              onClick: () => {
                Q(!G), b([]);
              },
              children: [
                /* @__PURE__ */ e(dt, { className: "h-4 w-4 mr-1.5" }),
                "Compare"
              ]
            }
          ),
          y && /* @__PURE__ */ t(
            u,
            {
              variant: "outline",
              size: "sm",
              onClick: y,
              disabled: A,
              children: [
                /* @__PURE__ */ e(st, { className: "h-4 w-4 mr-1.5" }),
                "Create Checkpoint"
              ]
            }
          )
        ] })
      ] }),
      m && /* @__PURE__ */ t("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ t("div", { className: "flex-1 relative", children: [
          /* @__PURE__ */ e(we, { className: "absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" }),
          /* @__PURE__ */ e(
            "input",
            {
              value: M,
              onChange: (Z) => K(Z.target.value),
              placeholder: "Search versions...",
              className: "w-full pl-10 pr-3 py-2 border rounded-lg bg-background text-sm outline-none focus:ring-2 focus:ring-primary"
            }
          )
        ] }),
        /* @__PURE__ */ t(
          "select",
          {
            value: Y,
            onChange: (Z) => h(Z.target.value),
            className: "px-3 py-2 border rounded-lg bg-background text-sm cursor-pointer",
            children: [
              /* @__PURE__ */ e("option", { value: "all", children: "All types" }),
              /* @__PURE__ */ e("option", { value: "manual", children: "Saved" }),
              /* @__PURE__ */ e("option", { value: "auto", children: "Auto-saved" }),
              /* @__PURE__ */ e("option", { value: "checkpoint", children: "Checkpoints" })
            ]
          }
        ),
        de.length > 1 && /* @__PURE__ */ t(
          "select",
          {
            value: z || "",
            onChange: (Z) => U(Z.target.value || null),
            className: "px-3 py-2 border rounded-lg bg-background text-sm cursor-pointer",
            children: [
              /* @__PURE__ */ e("option", { value: "", children: "All authors" }),
              de.map((Z) => /* @__PURE__ */ e("option", { value: Z.id, children: Z.name }, Z.id))
            ]
          }
        )
      ] }),
      G && /* @__PURE__ */ t("div", { className: "mt-4 p-3 bg-warning/10 rounded-lg flex items-center justify-between", children: [
        /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ e(dt, { className: "h-4 w-4 text-warning" }),
          /* @__PURE__ */ t(a, { variant: "caption", children: [
            "Select 2 versions to compare (",
            v.length,
            "/2 selected)"
          ] })
        ] }),
        /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ e(
            u,
            {
              variant: "ghost",
              size: "sm",
              onClick: () => b([]),
              disabled: v.length === 0,
              children: "Clear"
            }
          ),
          /* @__PURE__ */ e(
            u,
            {
              variant: "default",
              size: "sm",
              onClick: se,
              disabled: v.length !== 2,
              children: "Compare"
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ e("div", { className: "flex-1 overflow-y-auto p-4", children: A ? /* @__PURE__ */ t("div", { className: "flex flex-col items-center justify-center py-12", children: [
      /* @__PURE__ */ e(ye, { className: "h-8 w-8 text-primary animate-spin mb-3" }),
      /* @__PURE__ */ e(a, { variant: "body", className: "text-muted-foreground", children: "Loading history..." })
    ] }) : x.length === 0 ? /* @__PURE__ */ t("div", { className: "flex flex-col items-center justify-center py-12 text-center", children: [
      /* @__PURE__ */ e(Ge, { className: "h-12 w-12 text-muted-foreground/50 mb-4" }),
      /* @__PURE__ */ e(a, { variant: "h4", className: "font-medium mb-2", children: "No versions found" }),
      /* @__PURE__ */ e(a, { variant: "body", className: "text-muted-foreground", children: M ? "No versions match your search." : "No version history available yet." })
    ] }) : S && f ? /* @__PURE__ */ e("div", { className: "space-y-6", children: Object.entries(f).map(([Z, V]) => /* @__PURE__ */ t("div", { children: [
      /* @__PURE__ */ e(a, { variant: "caption", className: "font-medium text-muted-foreground mb-3 block", children: Z }),
      oe(V)
    ] }, Z)) }) : /* @__PURE__ */ t(me, { children: [
      oe(O),
      F && /* @__PURE__ */ e("div", { className: "flex justify-center pt-4", children: /* @__PURE__ */ e(
        u,
        {
          variant: "ghost",
          onClick: () => $(!c),
          children: c ? "Show less" : `Show ${x.length - g} more`
        }
      ) })
    ] }) })
  ] });
};
Il.displayName = "VersionHistory";
const Ol = {
  info: { icon: /* @__PURE__ */ e(Dt, { className: "h-4 w-4" }), color: "text-blue-500" },
  success: { icon: /* @__PURE__ */ e(Et, { className: "h-4 w-4" }), color: "text-green-500" },
  warning: { icon: /* @__PURE__ */ e(ze, { className: "h-4 w-4" }), color: "text-yellow-500" },
  error: { icon: /* @__PURE__ */ e(Le, { className: "h-4 w-4" }), color: "text-red-500" },
  message: { icon: /* @__PURE__ */ e(ut, { className: "h-4 w-4" }), color: "text-purple-500" },
  mention: { icon: /* @__PURE__ */ e(ut, { className: "h-4 w-4" }), color: "text-indigo-500" },
  update: { icon: /* @__PURE__ */ e(We, { className: "h-4 w-4" }), color: "text-cyan-500" },
  reminder: { icon: /* @__PURE__ */ e(We, { className: "h-4 w-4" }), color: "text-orange-500" }
}, Rl = {
  in_app: { icon: /* @__PURE__ */ e(We, { className: "h-4 w-4" }), label: "In-App" },
  email: { icon: /* @__PURE__ */ e(xt, { className: "h-4 w-4" }), label: "Email" },
  push: { icon: /* @__PURE__ */ e(We, { className: "h-4 w-4" }), label: "Push" },
  sms: { icon: /* @__PURE__ */ e(ut, { className: "h-4 w-4" }), label: "SMS" }
}, Kl = ({
  notifications: r,
  preferences: C,
  unreadCount: i,
  isLoading: n = !1,
  onMarkAsRead: p,
  onMarkAllAsRead: j,
  onDelete: D,
  onClearAll: E,
  onClick: y,
  onPreferenceChange: N,
  onOpenSettings: A,
  filterOptions: _,
  currentFilter: w,
  onFilterChange: s,
  showPreferences: S = !1,
  maxHeight: g = "400px",
  className: m
}) => {
  const [d, M] = P("notifications"), [K, Y] = P(/* @__PURE__ */ new Set()), h = (T) => {
    const G = (/* @__PURE__ */ new Date()).getTime() - T.getTime(), Q = Math.floor(G / 6e4), v = Math.floor(G / 36e5), b = Math.floor(G / 864e5);
    return Q < 1 ? "Just now" : Q < 60 ? `${Q}m ago` : v < 24 ? `${v}h ago` : b < 7 ? `${b}d ago` : new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric" }).format(T);
  }, z = r.filter((T) => !T.read), U = i ?? z.length;
  return /* @__PURE__ */ t(ne, { className: l("flex flex-col", m), variant: "elevated", children: [
    /* @__PURE__ */ t("div", { className: "flex items-center justify-between p-4 border-b", children: [
      /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ e(a, { variant: "h4", className: "font-semibold", children: "Notifications" }),
        U > 0 && /* @__PURE__ */ e(ae, { variant: "blue", children: U })
      ] }),
      /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
        C && /* @__PURE__ */ e(
          u,
          {
            variant: d === "preferences" ? "secondary" : "ghost",
            size: "sm",
            onClick: () => M(d === "preferences" ? "notifications" : "preferences"),
            children: /* @__PURE__ */ e(Oe, { className: "h-4 w-4" })
          }
        ),
        j && z.length > 0 && /* @__PURE__ */ t(u, { variant: "ghost", size: "sm", onClick: j, children: [
          /* @__PURE__ */ e(Ga, { className: "h-4 w-4 mr-1" }),
          "Mark all read"
        ] })
      ] })
    ] }),
    _ && _.length > 0 && d === "notifications" && /* @__PURE__ */ t("div", { className: "flex items-center gap-2 p-2 border-b bg-muted/30", children: [
      /* @__PURE__ */ e(Je, { className: "h-4 w-4 text-muted-foreground" }),
      _.map((T) => /* @__PURE__ */ e(
        u,
        {
          variant: w === T.value ? "secondary" : "ghost",
          size: "sm",
          onClick: () => s == null ? void 0 : s(T.value),
          children: T.label
        },
        T.value
      ))
    ] }),
    d === "notifications" ? /* @__PURE__ */ e("div", { className: "flex-1 overflow-y-auto", style: { maxHeight: g }, children: n ? /* @__PURE__ */ e("div", { className: "flex items-center justify-center p-8", children: /* @__PURE__ */ e("div", { className: "animate-spin rounded-full h-6 w-6 border-2 border-primary border-t-transparent" }) }) : r.length === 0 ? /* @__PURE__ */ t("div", { className: "flex flex-col items-center justify-center p-8 text-center", children: [
      /* @__PURE__ */ e(da, { className: "h-12 w-12 text-muted-foreground mb-2" }),
      /* @__PURE__ */ e(a, { variant: "body", className: "text-muted-foreground", children: "No notifications" }),
      /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: "You're all caught up!" })
    ] }) : /* @__PURE__ */ e("div", { className: "divide-y", children: r.map((T) => {
      const L = Ol[T.type];
      return /* @__PURE__ */ t(
        "div",
        {
          className: l(
            "flex items-start gap-3 p-4 hover:bg-muted/50 transition-colors cursor-pointer",
            !T.read && "bg-primary/5"
          ),
          onClick: () => y == null ? void 0 : y(T),
          children: [
            T.sender ? /* @__PURE__ */ e(
              je,
              {
                src: T.sender.avatar,
                fallback: T.sender.name.charAt(0),
                size: "sm"
              }
            ) : /* @__PURE__ */ e("div", { className: l("mt-0.5", L.color), children: L.icon }),
            /* @__PURE__ */ t("div", { className: "flex-1 min-w-0", children: [
              /* @__PURE__ */ t("div", { className: "flex items-start justify-between gap-2", children: [
                /* @__PURE__ */ t("div", { className: "flex-1 min-w-0", children: [
                  /* @__PURE__ */ e(
                    a,
                    {
                      variant: "body",
                      className: l("line-clamp-1", !T.read && "font-semibold"),
                      children: T.title
                    }
                  ),
                  /* @__PURE__ */ e(
                    a,
                    {
                      variant: "caption",
                      className: "text-muted-foreground line-clamp-2 mt-0.5",
                      children: T.message
                    }
                  )
                ] }),
                /* @__PURE__ */ e("div", { className: "flex items-center gap-1 shrink-0", children: !T.read && /* @__PURE__ */ e("div", { className: "w-2 h-2 rounded-full bg-primary" }) })
              ] }),
              /* @__PURE__ */ t("div", { className: "flex items-center justify-between mt-2", children: [
                /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: h(T.timestamp) }),
                /* @__PURE__ */ t("div", { className: "flex items-center gap-1", children: [
                  !T.read && p && /* @__PURE__ */ e(
                    u,
                    {
                      variant: "ghost",
                      size: "sm",
                      onClick: (G) => {
                        G.stopPropagation(), p(T.id);
                      },
                      className: "h-6 px-2",
                      children: /* @__PURE__ */ e(fe, { className: "h-3 w-3" })
                    }
                  ),
                  D && /* @__PURE__ */ e(
                    u,
                    {
                      variant: "ghost",
                      size: "sm",
                      onClick: (G) => {
                        G.stopPropagation(), D(T.id);
                      },
                      className: "h-6 px-2 text-muted-foreground hover:text-destructive",
                      children: /* @__PURE__ */ e(Re, { className: "h-3 w-3" })
                    }
                  )
                ] })
              ] })
            ] })
          ]
        },
        T.id
      );
    }) }) }) : (
      /* Preferences Panel */
      /* @__PURE__ */ t("div", { className: "flex-1 overflow-y-auto p-4", style: { maxHeight: g }, children: [
        /* @__PURE__ */ e(a, { variant: "body", className: "font-medium mb-4", children: "Notification Preferences" }),
        /* @__PURE__ */ e("div", { className: "space-y-4", children: C == null ? void 0 : C.map((T) => /* @__PURE__ */ t("div", { className: "border rounded-lg p-4", children: [
          /* @__PURE__ */ e(a, { variant: "body", className: "font-medium", children: T.label }),
          T.description && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: T.description }),
          /* @__PURE__ */ e("div", { className: "flex items-center gap-4 mt-3", children: T.channels.map((L) => {
            const G = Rl[L.channel];
            return /* @__PURE__ */ t(
              "label",
              {
                className: "flex items-center gap-2 cursor-pointer",
                children: [
                  /* @__PURE__ */ e(
                    He,
                    {
                      checked: L.enabled,
                      onCheckedChange: (Q) => N == null ? void 0 : N(T.category, L.channel, Q)
                    }
                  ),
                  /* @__PURE__ */ t("span", { className: "flex items-center gap-1 text-sm", children: [
                    G.icon,
                    G.label
                  ] })
                ]
              },
              L.channel
            );
          }) })
        ] }, T.category)) })
      ] })
    ),
    E && r.length > 0 && d === "notifications" && /* @__PURE__ */ e("div", { className: "p-2 border-t", children: /* @__PURE__ */ e(u, { variant: "ghost", size: "sm", onClick: E, className: "w-full", children: "Clear all notifications" }) })
  ] });
};
Kl.displayName = "NotificationCenter";
const Fl = [
  { value: "none", label: "No access", description: "Cannot access this resource" },
  { value: "view", label: "Viewer", description: "Can view but not edit" },
  { value: "edit", label: "Editor", description: "Can view and edit" },
  { value: "admin", label: "Admin", description: "Full access including settings" },
  { value: "owner", label: "Owner", description: "Full access and can transfer ownership" }
], Vl = {
  user: { icon: /* @__PURE__ */ e(ft, { className: "h-4 w-4" }), label: "User" },
  role: { icon: /* @__PURE__ */ e(Ue, { className: "h-4 w-4" }), label: "Role" },
  team: { icon: /* @__PURE__ */ e(Se, { className: "h-4 w-4" }), label: "Team" },
  public: { icon: /* @__PURE__ */ e(ga, { className: "h-4 w-4" }), label: "Public" },
  link: { icon: /* @__PURE__ */ e(ht, { className: "h-4 w-4" }), label: "Link" }
}, Ul = {
  none: { icon: /* @__PURE__ */ e(Pt, { className: "h-4 w-4" }), color: "text-muted-foreground" },
  view: { icon: /* @__PURE__ */ e(Ve, { className: "h-4 w-4" }), color: "text-blue-500" },
  edit: { icon: /* @__PURE__ */ e(Na, { className: "h-4 w-4" }), color: "text-green-500" },
  admin: { icon: /* @__PURE__ */ e(As, { className: "h-4 w-4" }), color: "text-purple-500" },
  owner: { icon: /* @__PURE__ */ e(zs, { className: "h-4 w-4" }), color: "text-orange-500" }
}, Bl = ({
  resource: r,
  accessList: C,
  roles: i,
  shareSettings: n,
  canManage: p = !1,
  isLoading: j = !1,
  onAccessChange: D,
  onAccessRevoke: E,
  onInvite: y,
  onRoleAssign: N,
  onShareSettingsChange: A,
  onCopyLink: _,
  onCreateRole: w,
  onEditRole: s,
  permissionLevels: S = Fl,
  className: g
}) => {
  const [m, d] = P("people"), [M, K] = P(""), [Y, h] = P("view"), [z, U] = P(""), [T, L] = P(/* @__PURE__ */ new Set()), G = C.filter(
    (b) => {
      var c;
      return b.name.toLowerCase().includes(z.toLowerCase()) || ((c = b.email) == null ? void 0 : c.toLowerCase().includes(z.toLowerCase()));
    }
  ), Q = (b) => {
    const c = new Set(T);
    c.has(b) ? c.delete(b) : c.add(b), L(c);
  }, v = () => {
    M && y && (y(M, Y), K(""));
  };
  return /* @__PURE__ */ t(ne, { className: l("flex flex-col", g), variant: "elevated", children: [
    /* @__PURE__ */ t("div", { className: "p-4 border-b", children: [
      /* @__PURE__ */ t("div", { className: "flex items-center gap-2 mb-1", children: [
        /* @__PURE__ */ e(Ue, { className: "h-5 w-5 text-muted-foreground" }),
        /* @__PURE__ */ e(a, { variant: "h4", className: "font-semibold", children: "Manage Access" })
      ] }),
      /* @__PURE__ */ t(a, { variant: "caption", className: "text-muted-foreground", children: [
        r.type,
        ": ",
        r.name
      ] })
    ] }),
    /* @__PURE__ */ t("div", { className: "flex border-b", children: [
      /* @__PURE__ */ t(
        "button",
        {
          className: l(
            "flex-1 px-4 py-2 text-sm font-medium border-b-2 transition-colors",
            m === "people" ? "border-primary text-primary" : "border-transparent text-muted-foreground hover:text-foreground"
          ),
          onClick: () => d("people"),
          children: [
            /* @__PURE__ */ e(Se, { className: "h-4 w-4 inline-block mr-1" }),
            "People"
          ]
        }
      ),
      i && /* @__PURE__ */ t(
        "button",
        {
          className: l(
            "flex-1 px-4 py-2 text-sm font-medium border-b-2 transition-colors",
            m === "roles" ? "border-primary text-primary" : "border-transparent text-muted-foreground hover:text-foreground"
          ),
          onClick: () => d("roles"),
          children: [
            /* @__PURE__ */ e(Ue, { className: "h-4 w-4 inline-block mr-1" }),
            "Roles"
          ]
        }
      ),
      n !== void 0 && /* @__PURE__ */ t(
        "button",
        {
          className: l(
            "flex-1 px-4 py-2 text-sm font-medium border-b-2 transition-colors",
            m === "sharing" ? "border-primary text-primary" : "border-transparent text-muted-foreground hover:text-foreground"
          ),
          onClick: () => d("sharing"),
          children: [
            /* @__PURE__ */ e(ht, { className: "h-4 w-4 inline-block mr-1" }),
            "Sharing"
          ]
        }
      )
    ] }),
    /* @__PURE__ */ t("div", { className: "flex-1 overflow-y-auto", children: [
      m === "people" && /* @__PURE__ */ t("div", { className: "p-4 space-y-4", children: [
        p && y && /* @__PURE__ */ t("div", { className: "flex gap-2", children: [
          /* @__PURE__ */ t("div", { className: "flex-1 relative", children: [
            /* @__PURE__ */ e(xt, { className: "absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" }),
            /* @__PURE__ */ e(
              ue,
              {
                placeholder: "Enter email to invite...",
                value: M,
                onChange: (b) => K(b.target.value),
                className: "pl-9"
              }
            )
          ] }),
          /* @__PURE__ */ e(
            "select",
            {
              value: Y,
              onChange: (b) => h(b.target.value),
              className: "px-3 py-2 border rounded-md text-sm bg-background",
              children: S.filter((b) => b.value !== "none" && b.value !== "owner").map((b) => /* @__PURE__ */ e("option", { value: b.value, children: b.label }, b.value))
            }
          ),
          /* @__PURE__ */ t(u, { onClick: v, disabled: !M, children: [
            /* @__PURE__ */ e(Pe, { className: "h-4 w-4 mr-1" }),
            "Invite"
          ] })
        ] }),
        C.length > 5 && /* @__PURE__ */ t("div", { className: "relative", children: [
          /* @__PURE__ */ e(we, { className: "absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" }),
          /* @__PURE__ */ e(
            ue,
            {
              placeholder: "Search people...",
              value: z,
              onChange: (b) => U(b.target.value),
              className: "pl-9"
            }
          )
        ] }),
        /* @__PURE__ */ e("div", { className: "space-y-2", children: j ? /* @__PURE__ */ e("div", { className: "flex items-center justify-center py-8", children: /* @__PURE__ */ e("div", { className: "animate-spin rounded-full h-6 w-6 border-2 border-primary border-t-transparent" }) }) : G.length === 0 ? /* @__PURE__ */ t("div", { className: "text-center py-8 text-muted-foreground", children: [
          /* @__PURE__ */ e(Se, { className: "h-8 w-8 mx-auto mb-2 opacity-50" }),
          /* @__PURE__ */ e(a, { variant: "body", children: "No people with access" })
        ] }) : G.map((b) => {
          var $;
          Vl[b.type];
          const c = Ul[b.level];
          return /* @__PURE__ */ t(
            "div",
            {
              className: "flex items-center gap-3 p-3 rounded-lg border hover:bg-muted/50 transition-colors",
              children: [
                /* @__PURE__ */ e(
                  je,
                  {
                    src: b.avatar,
                    fallback: b.name.charAt(0),
                    size: "sm"
                  }
                ),
                /* @__PURE__ */ t("div", { className: "flex-1 min-w-0", children: [
                  /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
                    /* @__PURE__ */ e(a, { variant: "body", className: "font-medium truncate", children: b.name }),
                    b.level === "owner" && /* @__PURE__ */ e(ae, { variant: "yellow", className: "text-xs", children: "Owner" })
                  ] }),
                  b.email && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground truncate", children: b.email })
                ] }),
                /* @__PURE__ */ e("div", { className: "flex items-center gap-2", children: p && b.level !== "owner" ? /* @__PURE__ */ t(me, { children: [
                  /* @__PURE__ */ e(
                    "select",
                    {
                      value: b.level,
                      onChange: (o) => D == null ? void 0 : D(b.id, o.target.value),
                      className: "px-2 py-1 border rounded text-sm bg-background",
                      children: S.filter((o) => o.value !== "owner").map((o) => /* @__PURE__ */ e("option", { value: o.value, children: o.label }, o.value))
                    }
                  ),
                  E && /* @__PURE__ */ e(
                    u,
                    {
                      variant: "ghost",
                      size: "sm",
                      onClick: () => E(b.id),
                      className: "text-destructive hover:text-destructive",
                      children: /* @__PURE__ */ e(he, { className: "h-4 w-4" })
                    }
                  )
                ] }) : /* @__PURE__ */ t(ae, { variant: "default", className: c.color, children: [
                  c.icon,
                  /* @__PURE__ */ e("span", { className: "ml-1", children: ($ = S.find((o) => o.value === b.level)) == null ? void 0 : $.label })
                ] }) })
              ]
            },
            b.id
          );
        }) })
      ] }),
      m === "roles" && i && /* @__PURE__ */ t("div", { className: "p-4 space-y-4", children: [
        p && w && /* @__PURE__ */ t(u, { variant: "outline", className: "w-full", children: [
          /* @__PURE__ */ e(Pe, { className: "h-4 w-4 mr-1" }),
          "Create New Role"
        ] }),
        /* @__PURE__ */ e("div", { className: "space-y-2", children: i.map((b) => /* @__PURE__ */ t("div", { className: "border rounded-lg", children: [
          /* @__PURE__ */ t(
            "button",
            {
              className: "flex items-center gap-3 p-3 w-full hover:bg-muted/50 transition-colors",
              onClick: () => Q(b.id),
              children: [
                T.has(b.id) ? /* @__PURE__ */ e(xe, { className: "h-4 w-4 text-muted-foreground" }) : /* @__PURE__ */ e(Ne, { className: "h-4 w-4 text-muted-foreground" }),
                /* @__PURE__ */ e(
                  Ue,
                  {
                    className: "h-4 w-4",
                    style: { color: b.color || "currentColor" }
                  }
                ),
                /* @__PURE__ */ t("div", { className: "flex-1 text-left", children: [
                  /* @__PURE__ */ e(a, { variant: "body", className: "font-medium", children: b.name }),
                  b.description && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: b.description })
                ] }),
                b.userCount !== void 0 && /* @__PURE__ */ t(ae, { variant: "default", children: [
                  b.userCount,
                  " users"
                ] }),
                b.isSystem && /* @__PURE__ */ e(ae, { variant: "default", className: "text-xs", children: "System" })
              ]
            }
          ),
          T.has(b.id) && /* @__PURE__ */ t("div", { className: "px-4 pb-3 pt-1 border-t bg-muted/30", children: [
            /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground mb-2 block", children: "Permissions" }),
            /* @__PURE__ */ e("div", { className: "space-y-1", children: b.permissions.map((c) => /* @__PURE__ */ t(
              "div",
              {
                className: "flex items-center justify-between py-1",
                children: [
                  /* @__PURE__ */ t("span", { className: "text-sm", children: [
                    c.resource,
                    ": ",
                    c.action
                  ] }),
                  c.granted ? /* @__PURE__ */ e(fe, { className: "h-4 w-4 text-green-500" }) : /* @__PURE__ */ e(he, { className: "h-4 w-4 text-red-500" })
                ]
              },
              c.id
            )) })
          ] })
        ] }, b.id)) })
      ] }),
      m === "sharing" && n && /* @__PURE__ */ t("div", { className: "p-4 space-y-4", children: [
        /* @__PURE__ */ t("div", { className: "flex items-center justify-between p-3 border rounded-lg", children: [
          /* @__PURE__ */ t("div", { className: "flex items-center gap-3", children: [
            /* @__PURE__ */ e(ga, { className: "h-5 w-5 text-muted-foreground" }),
            /* @__PURE__ */ t("div", { children: [
              /* @__PURE__ */ e(a, { variant: "body", className: "font-medium", children: "Public Access" }),
              /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: "Anyone with the link can view" })
            ] })
          ] }),
          /* @__PURE__ */ e(
            He,
            {
              checked: n.isPublic,
              onCheckedChange: (b) => A == null ? void 0 : A({ isPublic: b }),
              disabled: !p
            }
          )
        ] }),
        n.linkAccess && /* @__PURE__ */ t("div", { className: "border rounded-lg p-3 space-y-3", children: [
          /* @__PURE__ */ t("div", { className: "flex items-center justify-between", children: [
            /* @__PURE__ */ t("div", { className: "flex items-center gap-3", children: [
              /* @__PURE__ */ e(ht, { className: "h-5 w-5 text-muted-foreground" }),
              /* @__PURE__ */ t("div", { children: [
                /* @__PURE__ */ e(a, { variant: "body", className: "font-medium", children: "Share via Link" }),
                /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: "Create a shareable link" })
              ] })
            ] }),
            /* @__PURE__ */ e(
              He,
              {
                checked: n.linkAccess.enabled,
                onCheckedChange: (b) => A == null ? void 0 : A({
                  linkAccess: { ...n.linkAccess, enabled: b }
                }),
                disabled: !p
              }
            )
          ] }),
          n.linkAccess.enabled && /* @__PURE__ */ t("div", { className: "pt-3 border-t space-y-3", children: [
            /* @__PURE__ */ t("div", { className: "flex gap-2", children: [
              /* @__PURE__ */ e(
                ue,
                {
                  value: `https://app.example.com/share/${r.id}`,
                  readOnly: !0,
                  className: "flex-1 text-sm"
                }
              ),
              /* @__PURE__ */ e(u, { variant: "outline", onClick: _, children: /* @__PURE__ */ e(Ke, { className: "h-4 w-4" }) })
            ] }),
            p && /* @__PURE__ */ e(me, { children: /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ e("span", { className: "text-sm text-muted-foreground", children: "Access level:" }),
              /* @__PURE__ */ t(
                "select",
                {
                  value: n.linkAccess.level,
                  onChange: (b) => A == null ? void 0 : A({
                    linkAccess: {
                      ...n.linkAccess,
                      level: b.target.value
                    }
                  }),
                  className: "px-2 py-1 border rounded text-sm bg-background",
                  children: [
                    /* @__PURE__ */ e("option", { value: "view", children: "Can view" }),
                    /* @__PURE__ */ e("option", { value: "edit", children: "Can edit" })
                  ]
                }
              )
            ] }) })
          ] })
        ] }),
        /* @__PURE__ */ t("div", { className: "space-y-2", children: [
          /* @__PURE__ */ e(a, { variant: "body", className: "font-medium", children: "Additional Options" }),
          /* @__PURE__ */ t("label", { className: "flex items-center justify-between p-3 border rounded-lg cursor-pointer hover:bg-muted/50", children: [
            /* @__PURE__ */ e("span", { className: "text-sm", children: "Allow copying" }),
            /* @__PURE__ */ e(
              He,
              {
                checked: n.allowCopy,
                onCheckedChange: (b) => A == null ? void 0 : A({ allowCopy: b }),
                disabled: !p
              }
            )
          ] }),
          /* @__PURE__ */ t("label", { className: "flex items-center justify-between p-3 border rounded-lg cursor-pointer hover:bg-muted/50", children: [
            /* @__PURE__ */ e("span", { className: "text-sm", children: "Allow downloading" }),
            /* @__PURE__ */ e(
              He,
              {
                checked: n.allowDownload,
                onCheckedChange: (b) => A == null ? void 0 : A({ allowDownload: b }),
                disabled: !p
              }
            )
          ] })
        ] })
      ] })
    ] })
  ] });
};
Bl.displayName = "PermissionManager";
const Xt = {
  meeting: { color: "bg-blue-500", icon: /* @__PURE__ */ e(Se, { className: "h-3 w-3" }) },
  reminder: { color: "bg-yellow-500", icon: /* @__PURE__ */ e(Me, { className: "h-3 w-3" }) },
  task: { color: "bg-green-500", icon: /* @__PURE__ */ e(fe, { className: "h-3 w-3" }) },
  blocked: { color: "bg-gray-500", icon: /* @__PURE__ */ e(he, { className: "h-3 w-3" }) },
  available: { color: "bg-emerald-500", icon: /* @__PURE__ */ e(fe, { className: "h-3 w-3" }) }
}, Wl = ({
  events: r,
  availableSlots: C,
  selectedDate: i = /* @__PURE__ */ new Date(),
  view: n = "week",
  conflicts: p,
  isLoading: j = !1,
  onDateSelect: D,
  onSlotSelect: E,
  onEventCreate: y,
  onEventUpdate: N,
  onEventDelete: A,
  onEventClick: _,
  onViewChange: w,
  onConflictResolve: s,
  minDuration: S = 15,
  maxDuration: g = 480,
  workingHoursStart: m = 9,
  workingHoursEnd: d = 17,
  timezone: M,
  canCreate: K = !0,
  className: Y
}) => {
  var F, de;
  const [h, z] = P("calendar"), [U, T] = P({
    type: "meeting",
    start: /* @__PURE__ */ new Date(),
    end: new Date(Date.now() + 36e5)
  }), L = (I) => new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: !0
  }).format(I), G = (I) => new Intl.DateTimeFormat("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric"
  }).format(I), Q = (I) => new Intl.DateTimeFormat("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric"
  }).format(I), v = (I) => {
    const se = new Date(I);
    return se.setDate(I.getDate() - I.getDay()), Array.from({ length: 7 }, (oe, Z) => {
      const V = new Date(se);
      return V.setDate(se.getDate() + Z), V;
    });
  }, b = () => Array.from({ length: d - m + 1 }, (I, se) => m + se), c = (I) => r.filter((se) => {
    const oe = new Date(se.start);
    return oe.getDate() === I.getDate() && oe.getMonth() === I.getMonth() && oe.getFullYear() === I.getFullYear();
  }), $ = (I) => {
    const se = /* @__PURE__ */ new Date();
    return I.getDate() === se.getDate() && I.getMonth() === se.getMonth() && I.getFullYear() === se.getFullYear();
  }, o = (I) => I.getDate() === i.getDate() && I.getMonth() === i.getMonth() && I.getFullYear() === i.getFullYear(), x = (I) => {
    const se = new Date(i);
    se.setDate(i.getDate() + (I === "next" ? 7 : -7)), D == null || D(se);
  }, f = v(i), O = b();
  return /* @__PURE__ */ t(ne, { className: l("flex flex-col h-full", Y), variant: "elevated", children: [
    /* @__PURE__ */ t("div", { className: "flex items-center justify-between p-4 border-b", children: [
      /* @__PURE__ */ t("div", { className: "flex items-center gap-4", children: [
        /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ e(u, { variant: "ghost", size: "sm", onClick: () => x("prev"), children: /* @__PURE__ */ e(vt, { className: "h-4 w-4" }) }),
          /* @__PURE__ */ e(u, { variant: "ghost", size: "sm", onClick: () => D == null ? void 0 : D(/* @__PURE__ */ new Date()), children: "Today" }),
          /* @__PURE__ */ e(u, { variant: "ghost", size: "sm", onClick: () => x("next"), children: /* @__PURE__ */ e(Ne, { className: "h-4 w-4" }) })
        ] }),
        /* @__PURE__ */ e(a, { variant: "h4", className: "font-semibold", children: Q(i) }),
        M && /* @__PURE__ */ e(ae, { variant: "default", className: "text-xs", children: M })
      ] }),
      /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
        p && p.length > 0 && /* @__PURE__ */ t(
          u,
          {
            variant: h === "conflicts" ? "secondary" : "outline",
            size: "sm",
            onClick: () => z(h === "conflicts" ? "calendar" : "conflicts"),
            className: "text-yellow-600",
            children: [
              /* @__PURE__ */ e(ze, { className: "h-4 w-4 mr-1" }),
              p.length,
              " Conflict",
              p.length > 1 ? "s" : ""
            ]
          }
        ),
        K && /* @__PURE__ */ t(
          u,
          {
            variant: h === "create" ? "secondary" : "primary",
            size: "sm",
            onClick: () => z(h === "create" ? "calendar" : "create"),
            children: [
              /* @__PURE__ */ e(Pe, { className: "h-4 w-4 mr-1" }),
              "New Event"
            ]
          }
        ),
        /* @__PURE__ */ e("div", { className: "flex border rounded-lg overflow-hidden", children: ["day", "week", "month"].map((I) => /* @__PURE__ */ e(
          u,
          {
            variant: n === I ? "secondary" : "ghost",
            size: "sm",
            onClick: () => w == null ? void 0 : w(I),
            className: "rounded-none",
            children: I.charAt(0).toUpperCase() + I.slice(1)
          },
          I
        )) })
      ] })
    ] }),
    h === "calendar" && /* @__PURE__ */ e("div", { className: "flex-1 overflow-auto", children: j ? /* @__PURE__ */ e("div", { className: "flex items-center justify-center h-full", children: /* @__PURE__ */ e("div", { className: "animate-spin rounded-full h-8 w-8 border-2 border-primary border-t-transparent" }) }) : n === "week" ? /* @__PURE__ */ t("div", { className: "min-w-[800px]", children: [
      /* @__PURE__ */ t("div", { className: "grid grid-cols-8 border-b sticky top-0 bg-background z-10", children: [
        /* @__PURE__ */ e("div", { className: "p-2 text-center text-xs text-muted-foreground border-r", children: "Time" }),
        f.map((I) => /* @__PURE__ */ t(
          "div",
          {
            className: l(
              "p-2 text-center border-r cursor-pointer hover:bg-muted/50",
              $(I) && "bg-primary/10",
              o(I) && "bg-primary/20"
            ),
            onClick: () => D == null ? void 0 : D(I),
            children: [
              /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: G(I).split(",")[0] }),
              /* @__PURE__ */ e(
                a,
                {
                  variant: "body",
                  className: l("font-semibold", $(I) && "text-primary"),
                  children: I.getDate()
                }
              )
            ]
          },
          I.toISOString()
        ))
      ] }),
      /* @__PURE__ */ e("div", { className: "grid grid-cols-8", children: O.map((I) => /* @__PURE__ */ t(Ae.Fragment, { children: [
        /* @__PURE__ */ e("div", { className: "p-2 text-xs text-muted-foreground border-r border-b text-right pr-3", children: I === 0 ? "12 AM" : I < 12 ? `${I} AM` : I === 12 ? "12 PM" : `${I - 12} PM` }),
        f.map((se) => {
          const oe = c(se).filter((X) => new Date(X.start).getHours() === I), Z = new Date(se);
          Z.setHours(I, 0, 0, 0);
          const V = new Date(se);
          V.setHours(I + 1, 0, 0, 0);
          const ie = C == null ? void 0 : C.some(
            (X) => X.available && X.start <= Z && X.end >= V
          );
          return /* @__PURE__ */ e(
            "div",
            {
              className: l(
                "min-h-[60px] border-r border-b p-1 relative cursor-pointer hover:bg-muted/30",
                ie && "bg-green-50 dark:bg-green-950/20"
              ),
              onClick: () => {
                ie && (E == null || E({ start: Z, end: V, available: !0 }));
              },
              children: oe.map((X) => {
                const R = Xt[X.type];
                return /* @__PURE__ */ t(
                  "div",
                  {
                    className: l(
                      "text-xs p-1 rounded mb-1 text-white cursor-pointer",
                      R.color,
                      X.color
                    ),
                    style: X.color ? { backgroundColor: X.color } : void 0,
                    onClick: (H) => {
                      H.stopPropagation(), _ == null || _(X);
                    },
                    children: [
                      /* @__PURE__ */ t("div", { className: "flex items-center gap-1", children: [
                        R.icon,
                        /* @__PURE__ */ e("span", { className: "truncate font-medium", children: X.title })
                      ] }),
                      /* @__PURE__ */ t("span", { className: "opacity-80", children: [
                        L(X.start),
                        " - ",
                        L(X.end)
                      ] })
                    ]
                  },
                  X.id
                );
              })
            },
            `${se.toISOString()}-${I}`
          );
        })
      ] }, I)) })
    ] }) : /* @__PURE__ */ t("div", { className: "p-4 text-center text-muted-foreground", children: [
      n === "day" ? "Day view" : "Month view",
      " - Coming soon"
    ] }) }),
    h === "conflicts" && p && /* @__PURE__ */ t("div", { className: "flex-1 overflow-auto p-4 space-y-4", children: [
      /* @__PURE__ */ t(a, { variant: "h4", className: "font-semibold flex items-center gap-2", children: [
        /* @__PURE__ */ e(ze, { className: "h-5 w-5 text-yellow-500" }),
        "Scheduling Conflicts"
      ] }),
      p.map((I, se) => /* @__PURE__ */ e(ne, { variant: "outlined", className: "p-4", children: /* @__PURE__ */ t("div", { className: "flex items-start justify-between gap-4", children: [
        /* @__PURE__ */ t("div", { className: "flex-1", children: [
          /* @__PURE__ */ t("div", { className: "flex items-center gap-2 mb-2", children: [
            /* @__PURE__ */ e(a, { variant: "body", className: "font-medium", children: I.event.title }),
            /* @__PURE__ */ t(
              ae,
              {
                variant: I.severity === "high" ? "red" : I.severity === "medium" ? "yellow" : "default",
                children: [
                  I.severity,
                  " severity"
                ]
              }
            )
          ] }),
          /* @__PURE__ */ t(a, { variant: "caption", className: "text-muted-foreground", children: [
            G(I.event.start),
            ", ",
            L(I.event.start),
            " -",
            " ",
            L(I.event.end)
          ] }),
          /* @__PURE__ */ t("div", { className: "mt-2", children: [
            /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: "Conflicts with:" }),
            I.conflictingEvents.map((oe) => /* @__PURE__ */ t("div", { className: "text-sm ml-2", children: [
              "• ",
              oe.title,
              " (",
              L(oe.start),
              " - ",
              L(oe.end),
              ")"
            ] }, oe.id))
          ] })
        ] }),
        /* @__PURE__ */ t("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ e(
            u,
            {
              variant: "outline",
              size: "sm",
              onClick: () => s == null ? void 0 : s(I, "keep_both"),
              children: "Keep Both"
            }
          ),
          /* @__PURE__ */ e(
            u,
            {
              variant: "outline",
              size: "sm",
              onClick: () => s == null ? void 0 : s(I, "replace"),
              children: "Replace"
            }
          ),
          /* @__PURE__ */ e(
            u,
            {
              variant: "ghost",
              size: "sm",
              onClick: () => s == null ? void 0 : s(I, "cancel"),
              className: "text-destructive",
              children: "Cancel New"
            }
          )
        ] })
      ] }) }, se))
    ] }),
    h === "create" && /* @__PURE__ */ t("div", { className: "flex-1 overflow-auto p-4 space-y-4", children: [
      /* @__PURE__ */ t(a, { variant: "h4", className: "font-semibold flex items-center gap-2", children: [
        /* @__PURE__ */ e(Va, { className: "h-5 w-5" }),
        "Create New Event"
      ] }),
      /* @__PURE__ */ t("div", { className: "space-y-4", children: [
        /* @__PURE__ */ t("div", { children: [
          /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground mb-1 block", children: "Event Title" }),
          /* @__PURE__ */ e(
            ue,
            {
              placeholder: "Enter event title...",
              value: U.title || "",
              onChange: (I) => T({ ...U, title: I.target.value })
            }
          )
        ] }),
        /* @__PURE__ */ t("div", { children: [
          /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground mb-1 block", children: "Event Type" }),
          /* @__PURE__ */ e("div", { className: "flex gap-2", children: Object.entries(Xt).map(([I, se]) => /* @__PURE__ */ t(
            u,
            {
              variant: U.type === I ? "secondary" : "outline",
              size: "sm",
              onClick: () => T({ ...U, type: I }),
              className: "flex items-center gap-1",
              children: [
                /* @__PURE__ */ e("div", { className: l("w-2 h-2 rounded-full", se.color) }),
                I.charAt(0).toUpperCase() + I.slice(1)
              ]
            },
            I
          )) })
        ] }),
        /* @__PURE__ */ t("div", { className: "grid grid-cols-2 gap-4", children: [
          /* @__PURE__ */ t("div", { children: [
            /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground mb-1 block", children: "Start Time" }),
            /* @__PURE__ */ e(
              ue,
              {
                type: "datetime-local",
                value: ((F = U.start) == null ? void 0 : F.toISOString().slice(0, 16)) || "",
                onChange: (I) => T({ ...U, start: new Date(I.target.value) })
              }
            )
          ] }),
          /* @__PURE__ */ t("div", { children: [
            /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground mb-1 block", children: "End Time" }),
            /* @__PURE__ */ e(
              ue,
              {
                type: "datetime-local",
                value: ((de = U.end) == null ? void 0 : de.toISOString().slice(0, 16)) || "",
                onChange: (I) => T({ ...U, end: new Date(I.target.value) })
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ t("div", { children: [
          /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground mb-1 block", children: "Location" }),
          /* @__PURE__ */ t("div", { className: "flex gap-2", children: [
            /* @__PURE__ */ e(
              ue,
              {
                placeholder: "Add location...",
                value: U.location || "",
                onChange: (I) => T({ ...U, location: I.target.value }),
                className: "flex-1"
              }
            ),
            /* @__PURE__ */ t(
              u,
              {
                variant: U.isVirtual ? "secondary" : "outline",
                onClick: () => T({ ...U, isVirtual: !U.isVirtual }),
                children: [
                  /* @__PURE__ */ e(Js, { className: "h-4 w-4 mr-1" }),
                  "Virtual"
                ]
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ t("div", { className: "flex items-center gap-4", children: [
          /* @__PURE__ */ t("label", { className: "flex items-center gap-2 cursor-pointer", children: [
            /* @__PURE__ */ e(
              He,
              {
                checked: U.isAllDay || !1,
                onCheckedChange: (I) => T({ ...U, isAllDay: I })
              }
            ),
            /* @__PURE__ */ e("span", { className: "text-sm", children: "All day" })
          ] }),
          /* @__PURE__ */ t("label", { className: "flex items-center gap-2 cursor-pointer", children: [
            /* @__PURE__ */ e(
              He,
              {
                checked: U.isPrivate || !1,
                onCheckedChange: (I) => T({ ...U, isPrivate: I })
              }
            ),
            /* @__PURE__ */ e("span", { className: "text-sm", children: "Private" })
          ] })
        ] }),
        /* @__PURE__ */ t("div", { className: "flex justify-end gap-2 pt-4 border-t", children: [
          /* @__PURE__ */ e(u, { variant: "ghost", onClick: () => z("calendar"), children: "Cancel" }),
          /* @__PURE__ */ e(
            u,
            {
              onClick: () => {
                U.title && U.start && U.end && (y == null || y(U), z("calendar"), T({ type: "meeting", start: /* @__PURE__ */ new Date(), end: new Date(Date.now() + 36e5) }));
              },
              disabled: !U.title,
              children: "Create Event"
            }
          )
        ] })
      ] })
    ] })
  ] });
};
Wl.displayName = "SchedulingCalendar";
const Yl = [
  { value: "today", label: "Today" },
  { value: "yesterday", label: "Yesterday" },
  { value: "7d", label: "Last 7 days" },
  { value: "30d", label: "Last 30 days" },
  { value: "90d", label: "Last 90 days" },
  { value: "ytd", label: "Year to date" },
  { value: "custom", label: "Custom range" }
], Zt = {
  up: {
    icon: /* @__PURE__ */ e(Nt, { className: "h-4 w-4" }),
    color: "text-green-600 dark:text-green-400",
    bgColor: "bg-green-100 dark:bg-green-900/30"
  },
  down: {
    icon: /* @__PURE__ */ e(Vs, { className: "h-4 w-4" }),
    color: "text-red-600 dark:text-red-400",
    bgColor: "bg-red-100 dark:bg-red-900/30"
  },
  neutral: {
    icon: /* @__PURE__ */ e(va, { className: "h-4 w-4" }),
    color: "text-gray-600 dark:text-gray-400",
    bgColor: "bg-gray-100 dark:bg-gray-800/30"
  }
}, ea = {
  line: /* @__PURE__ */ e(Ut, { className: "h-4 w-4" }),
  bar: /* @__PURE__ */ e(Wa, { className: "h-4 w-4" }),
  pie: /* @__PURE__ */ e(Bt, { className: "h-4 w-4" }),
  area: /* @__PURE__ */ e(Ut, { className: "h-4 w-4" }),
  donut: /* @__PURE__ */ e(Bt, { className: "h-4 w-4" })
}, Ql = ({
  metrics: r,
  charts: C,
  comparisons: i,
  timeRange: n = "30d",
  timeRangeOptions: p = Yl,
  customDateRange: j,
  isLoading: D = !1,
  isRefreshing: E = !1,
  lastUpdated: y,
  autoRefreshInterval: N,
  onTimeRangeChange: A,
  onRefresh: _,
  onMetricDrillDown: w,
  onChartDrillDown: s,
  onExport: S,
  onExpandChart: g,
  metricColumns: m = 4,
  title: d,
  description: M,
  filters: K,
  filterValues: Y,
  onFilterChange: h,
  className: z
}) => {
  var $;
  const [U, T] = P(!1), [L, G] = P(/* @__PURE__ */ new Set()), Q = (o, x, f, O) => {
    if (typeof o == "string") return `${f || ""}${o}${O || ""}`;
    let F;
    switch (x) {
      case "currency":
        F = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(o);
        break;
      case "percent":
        F = `${o.toFixed(1)}%`;
        break;
      case "duration":
        const de = Math.floor(o / 3600), I = Math.floor(o % 3600 / 60);
        F = de > 0 ? `${de}h ${I}m` : `${I}m`;
        break;
      default:
        F = new Intl.NumberFormat("en-US").format(o);
    }
    return `${f || ""}${F}${O || ""}`;
  }, v = (o) => {
    const f = (/* @__PURE__ */ new Date()).getTime() - o.getTime(), O = Math.floor(f / 6e4);
    return O < 1 ? "Just now" : O < 60 ? `${O}m ago` : new Intl.DateTimeFormat("en-US", { hour: "numeric", minute: "2-digit" }).format(o);
  }, b = (o) => {
    const x = new Set(L);
    x.has(o) ? x.delete(o) : x.add(o), G(x);
  }, c = {
    2: "grid-cols-1 sm:grid-cols-2",
    3: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
    4: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4",
    5: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5",
    6: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6"
  }[m];
  return /* @__PURE__ */ t("div", { className: l("space-y-6", z), children: [
    /* @__PURE__ */ t("div", { className: "flex flex-col sm:flex-row sm:items-center justify-between gap-4", children: [
      /* @__PURE__ */ t("div", { children: [
        d && /* @__PURE__ */ e(a, { variant: "h3", className: "font-semibold", children: d }),
        M && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: M })
      ] }),
      /* @__PURE__ */ t("div", { className: "flex items-center gap-2 flex-wrap", children: [
        K && K.length > 0 && /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ e(Je, { className: "h-4 w-4 text-muted-foreground" }),
          K.map((o) => /* @__PURE__ */ t(
            "select",
            {
              value: (Y == null ? void 0 : Y[o.id]) || "",
              onChange: (x) => h == null ? void 0 : h(o.id, x.target.value),
              className: "px-2 py-1 border rounded text-sm bg-background",
              children: [
                /* @__PURE__ */ e("option", { value: "", children: o.label }),
                o.options.map((x) => /* @__PURE__ */ e("option", { value: x.value, children: x.label }, x.value))
              ]
            },
            o.id
          ))
        ] }),
        /* @__PURE__ */ t("div", { className: "relative", children: [
          /* @__PURE__ */ t(
            u,
            {
              variant: "outline",
              size: "sm",
              onClick: () => T(!U),
              className: "min-w-[140px] justify-between",
              children: [
                /* @__PURE__ */ e(Ht, { className: "h-4 w-4 mr-2" }),
                (($ = p.find((o) => o.value === n)) == null ? void 0 : $.label) || "Select range",
                /* @__PURE__ */ e(xe, { className: "h-4 w-4 ml-2" })
              ]
            }
          ),
          U && /* @__PURE__ */ e("div", { className: "absolute right-0 top-full mt-1 bg-background border rounded-lg shadow-lg z-20 min-w-[140px]", children: p.map((o) => /* @__PURE__ */ e(
            "button",
            {
              className: l(
                "w-full px-3 py-2 text-left text-sm hover:bg-muted",
                n === o.value && "bg-muted font-medium"
              ),
              onClick: () => {
                A == null || A(o.value), T(!1);
              },
              children: o.label
            },
            o.value
          )) })
        ] }),
        _ && /* @__PURE__ */ e(u, { variant: "outline", size: "sm", onClick: _, disabled: E, children: /* @__PURE__ */ e(Xe, { className: l("h-4 w-4", E && "animate-spin") }) }),
        S && /* @__PURE__ */ e(u, { variant: "outline", size: "sm", onClick: () => S("csv"), children: /* @__PURE__ */ e(_e, { className: "h-4 w-4" }) })
      ] })
    ] }),
    y && /* @__PURE__ */ t(a, { variant: "caption", className: "text-muted-foreground", children: [
      "Last updated: ",
      v(y),
      N && ` • Auto-refreshes every ${N}s`
    ] }),
    D ? /* @__PURE__ */ e("div", { className: l("grid gap-4", c), children: Array.from({ length: m }).map((o, x) => /* @__PURE__ */ t(ne, { className: "p-4 animate-pulse", children: [
      /* @__PURE__ */ e("div", { className: "h-4 bg-muted rounded w-1/2 mb-2" }),
      /* @__PURE__ */ e("div", { className: "h-8 bg-muted rounded w-3/4 mb-2" }),
      /* @__PURE__ */ e("div", { className: "h-3 bg-muted rounded w-1/3" })
    ] }, x)) }) : /* @__PURE__ */ e("div", { className: l("grid gap-4", c), children: r.map((o) => {
      const x = o.trend || "neutral", f = Zt[x], O = o.goal ? Math.min(Number(o.value) / o.goal * 100, 100) : null;
      return /* @__PURE__ */ t(
        ne,
        {
          className: l(
            "p-4 cursor-pointer hover:shadow-md transition-shadow",
            w && "hover:border-primary"
          ),
          onClick: () => w == null ? void 0 : w(o),
          variant: "outlined",
          children: [
            /* @__PURE__ */ t("div", { className: "flex items-start justify-between mb-2", children: [
              /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: o.label }),
              w && /* @__PURE__ */ e(Ha, { className: "h-4 w-4 text-muted-foreground" })
            ] }),
            /* @__PURE__ */ e(
              a,
              {
                variant: "h3",
                className: "font-bold mb-1",
                style: o.color ? { color: o.color } : void 0,
                children: Q(o.value, o.format, o.prefix, o.suffix)
              }
            ),
            (o.changePercent !== void 0 || o.changeValue !== void 0) && /* @__PURE__ */ t("div", { className: l("flex items-center gap-1 text-sm", f.color), children: [
              f.icon,
              /* @__PURE__ */ t("span", { children: [
                o.changePercent !== void 0 && `${o.changePercent > 0 ? "+" : ""}${o.changePercent.toFixed(1)}%`,
                o.changeValue !== void 0 && ` (${Q(o.changeValue, o.format)})`
              ] }),
              /* @__PURE__ */ e("span", { className: "text-muted-foreground ml-1", children: "vs prev" })
            ] }),
            o.sparklineData && o.sparklineData.length > 0 && /* @__PURE__ */ e("div", { className: "mt-2 h-8 flex items-end gap-0.5", children: o.sparklineData.map((F, de) => {
              const I = Math.max(...o.sparklineData), se = F / I * 100;
              return /* @__PURE__ */ e(
                "div",
                {
                  className: "flex-1 bg-primary/30 rounded-t",
                  style: { height: `${se}%` }
                },
                de
              );
            }) }),
            O !== null && /* @__PURE__ */ t("div", { className: "mt-2", children: [
              /* @__PURE__ */ t("div", { className: "flex justify-between text-xs mb-1", children: [
                /* @__PURE__ */ e("span", { className: "text-muted-foreground", children: "Goal Progress" }),
                /* @__PURE__ */ t("span", { children: [
                  O.toFixed(0),
                  "%"
                ] })
              ] }),
              /* @__PURE__ */ e("div", { className: "h-1.5 bg-muted rounded-full overflow-hidden", children: /* @__PURE__ */ e(
                "div",
                {
                  className: "h-full bg-primary rounded-full transition-all",
                  style: { width: `${O}%` }
                }
              ) })
            ] })
          ]
        },
        o.id
      );
    }) }),
    C && C.length > 0 && /* @__PURE__ */ e("div", { className: "grid grid-cols-1 lg:grid-cols-2 gap-4", children: C.map((o) => /* @__PURE__ */ t(ne, { className: "p-4", variant: "outlined", children: [
      /* @__PURE__ */ t("div", { className: "flex items-center justify-between mb-4", children: [
        /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
          ea[o.type],
          /* @__PURE__ */ t("div", { children: [
            /* @__PURE__ */ e(a, { variant: "body", className: "font-medium", children: o.title }),
            o.description && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: o.description })
          ] })
        ] }),
        /* @__PURE__ */ t("div", { className: "flex items-center gap-1", children: [
          g && /* @__PURE__ */ e(
            u,
            {
              variant: "ghost",
              size: "sm",
              onClick: () => g(o.id),
              children: /* @__PURE__ */ e(wa, { className: "h-4 w-4" })
            }
          ),
          /* @__PURE__ */ e(u, { variant: "ghost", size: "sm", children: /* @__PURE__ */ e(qt, { className: "h-4 w-4" }) })
        ] })
      ] }),
      /* @__PURE__ */ e(
        "div",
        {
          className: "bg-muted/30 rounded-lg flex items-center justify-center",
          style: { height: o.height || 200 },
          children: /* @__PURE__ */ t("div", { className: "text-center text-muted-foreground", children: [
            ea[o.type],
            /* @__PURE__ */ e(a, { variant: "caption", className: "block mt-1", children: "Chart visualization placeholder" })
          ] })
        }
      ),
      o.drillDownEnabled && s && /* @__PURE__ */ t(
        u,
        {
          variant: "ghost",
          size: "sm",
          className: "w-full mt-2",
          onClick: () => s(o),
          children: [
            "View Details",
            /* @__PURE__ */ e(Ne, { className: "h-4 w-4 ml-1" })
          ]
        }
      )
    ] }, o.id)) }),
    i && i.length > 0 && /* @__PURE__ */ t(ne, { className: "p-4", variant: "outlined", children: [
      /* @__PURE__ */ e(a, { variant: "body", className: "font-medium mb-4", children: "Period Comparisons" }),
      /* @__PURE__ */ e("div", { className: "space-y-3", children: i.map((o) => {
        const x = L.has(o.id), f = o.changePercent ?? 0, O = f > 0 ? "up" : f < 0 ? "down" : "neutral", F = Zt[O];
        return /* @__PURE__ */ t(
          "div",
          {
            className: "border rounded-lg p-3 cursor-pointer hover:bg-muted/50",
            onClick: () => b(o.id),
            children: [
              /* @__PURE__ */ t("div", { className: "flex items-center justify-between", children: [
                /* @__PURE__ */ t("div", { className: "flex items-center gap-3", children: [
                  x ? /* @__PURE__ */ e(xe, { className: "h-4 w-4 text-muted-foreground" }) : /* @__PURE__ */ e(Ne, { className: "h-4 w-4 text-muted-foreground" }),
                  /* @__PURE__ */ e(a, { variant: "body", children: o.label })
                ] }),
                /* @__PURE__ */ t("div", { className: l("flex items-center gap-1", F.color), children: [
                  F.icon,
                  /* @__PURE__ */ t("span", { children: [
                    f > 0 ? "+" : "",
                    f.toFixed(1),
                    "%"
                  ] })
                ] })
              ] }),
              x && /* @__PURE__ */ t("div", { className: "mt-3 pt-3 border-t grid grid-cols-2 gap-4", children: [
                /* @__PURE__ */ t("div", { children: [
                  /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: o.currentLabel || "Current Period" }),
                  /* @__PURE__ */ e(a, { variant: "h4", className: "font-semibold", children: Q(o.currentValue, o.format) })
                ] }),
                /* @__PURE__ */ t("div", { children: [
                  /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: o.previousLabel || "Previous Period" }),
                  /* @__PURE__ */ e(a, { variant: "h4", className: "font-semibold text-muted-foreground", children: Q(o.previousValue, o.format) })
                ] })
              ] })
            ]
          },
          o.id
        );
      }) })
    ] })
  ] });
};
Ql.displayName = "AnalyticsDashboard";
const Gl = {
  next: "Continue",
  back: "Back",
  skip: "Skip",
  finish: "Complete",
  cancel: "Cancel",
  saveDraft: "Save Draft"
}, Jl = ({
  steps: r,
  currentStep: C,
  renderStepContent: i,
  initialData: n = {},
  onStepChange: p,
  onComplete: j,
  onCancel: D,
  onDataChange: E,
  onSaveDraft: y,
  isLoading: N = !1,
  isSubmitting: A = !1,
  showProgress: _ = !0,
  showStepNumbers: w = !0,
  allowJump: s = !0,
  allowSkip: S = !0,
  labels: g = Gl,
  layout: m = "horizontal",
  stepperPosition: d = "top",
  validationErrors: M,
  showSummary: K = !1,
  className: Y
}) => {
  const [h, z] = P(0), [U, T] = P(() => {
    const H = {};
    return r.forEach((ce, q) => {
      H[ce.id] = q === 0 ? "current" : "pending";
    }), H;
  }), [L, G] = P(n), [Q, v] = P(!1), b = C ?? h, c = r[b], $ = b === 0, o = b === r.length - 1, x = (b + 1) / r.length * 100, f = te((H, ce) => {
    T((q) => ({ ...q, [H]: ce }));
  }, []), O = te(
    async (H, ce) => {
      if (H < 0 || H >= r.length) return;
      const q = r[b];
      if (ce === "next" && q.beforeNext) {
        v(!0);
        try {
          if (!await q.beforeNext()) {
            v(!1);
            return;
          }
        } catch {
          v(!1);
          return;
        }
        v(!1);
      }
      ce === "back" && q.beforeBack && !await q.beforeBack() || (ce === "next" && f(q.id, "completed"), f(r[H].id, "current"), C === void 0 && z(H), p == null || p(H, ce));
    },
    [b, r, C, p, f]
  ), F = te(() => {
    o ? j == null || j(L) : O(b + 1, "next");
  }, [o, b, O, j, L]), de = te(() => {
    O(b - 1, "back");
  }, [b, O]), I = te(() => {
    (c.canSkip || c.optional) && (f(c.id, "skipped"), O(b + 1, "next"));
  }, [c, b, O, f]), se = te(
    (H) => {
      if (!s) return;
      const ce = U[r[H].id];
      (ce === "completed" || ce === "current" || H < b) && O(H, "jump");
    },
    [s, U, r, b, O]
  ), oe = (H) => U[r[H].id] || "pending", Z = M && Object.keys(M).length > 0, V = M == null ? void 0 : M[c.id], ie = () => /* @__PURE__ */ e(
    "div",
    {
      className: l(
        "flex",
        m === "vertical" ? "flex-col space-y-2" : "items-center justify-between"
      ),
      children: r.map((H, ce) => {
        const q = oe(ce), le = ce === b, ee = s && (q === "completed" || ce < b);
        return /* @__PURE__ */ t(
          "div",
          {
            className: l(
              "flex items-center",
              m === "vertical" ? "gap-3" : "flex-1",
              ce < r.length - 1 && m === "horizontal" && "mr-2"
            ),
            children: [
              /* @__PURE__ */ e(
                "button",
                {
                  type: "button",
                  className: l(
                    "flex items-center justify-center rounded-full transition-all shrink-0",
                    w ? "w-8 h-8" : "w-6 h-6",
                    le && "bg-primary text-primary-foreground ring-4 ring-primary/20",
                    q === "completed" && "bg-green-500 text-white",
                    q === "error" && "bg-red-500 text-white",
                    q === "skipped" && "bg-yellow-500 text-white",
                    q === "pending" && "bg-muted text-muted-foreground",
                    ee && "cursor-pointer hover:ring-2 hover:ring-primary/40",
                    !ee && !le && "cursor-default"
                  ),
                  onClick: () => ee && se(ce),
                  disabled: !ee && !le,
                  children: q === "completed" ? /* @__PURE__ */ e(fe, { className: "h-4 w-4" }) : q === "error" ? /* @__PURE__ */ e(Le, { className: "h-4 w-4" }) : q === "skipped" ? /* @__PURE__ */ e(Ne, { className: "h-4 w-4" }) : w ? /* @__PURE__ */ e("span", { className: "text-sm font-medium", children: ce + 1 }) : /* @__PURE__ */ e(gt, { className: "h-3 w-3" })
                }
              ),
              /* @__PURE__ */ t("div", { className: l("flex-1 min-w-0", m === "horizontal" && "hidden sm:block ml-2"), children: [
                /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
                  /* @__PURE__ */ e(
                    a,
                    {
                      variant: "caption",
                      className: l(
                        "font-medium truncate",
                        le && "text-primary",
                        q === "completed" && "text-green-600",
                        q === "error" && "text-red-600"
                      ),
                      children: H.title
                    }
                  ),
                  H.optional && /* @__PURE__ */ e(ae, { variant: "default", className: "text-xs", children: "Optional" })
                ] }),
                m === "vertical" && H.description && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground truncate", children: H.description })
              ] }),
              ce < r.length - 1 && m === "horizontal" && /* @__PURE__ */ e(
                "div",
                {
                  className: l(
                    "flex-1 h-0.5 mx-2",
                    q === "completed" ? "bg-green-500" : "bg-muted"
                  )
                }
              )
            ]
          },
          H.id
        );
      })
    }
  ), X = () => /* @__PURE__ */ t("div", { className: "flex-1 min-h-0", children: [
    /* @__PURE__ */ t("div", { className: "mb-6", children: [
      /* @__PURE__ */ e(a, { variant: "h4", className: "font-semibold", children: c.title }),
      c.description && /* @__PURE__ */ e(a, { variant: "body", className: "text-muted-foreground mt-1", children: c.description })
    ] }),
    V && V.length > 0 && /* @__PURE__ */ t("div", { className: "mb-4 p-3 bg-red-50 dark:bg-red-950/20 border border-red-200 dark:border-red-800 rounded-lg", children: [
      /* @__PURE__ */ t("div", { className: "flex items-center gap-2 text-red-600 dark:text-red-400", children: [
        /* @__PURE__ */ e(Le, { className: "h-4 w-4" }),
        /* @__PURE__ */ e(a, { variant: "body", className: "font-medium", children: "Please fix the following errors:" })
      ] }),
      /* @__PURE__ */ e("ul", { className: "mt-2 space-y-1 text-sm text-red-600 dark:text-red-400", children: V.map((H, ce) => /* @__PURE__ */ t("li", { children: [
        "• ",
        H
      ] }, ce)) })
    ] }),
    N ? /* @__PURE__ */ e("div", { className: "flex items-center justify-center py-12", children: /* @__PURE__ */ e(ye, { className: "h-8 w-8 animate-spin text-primary" }) }) : i(c, b)
  ] }), R = () => /* @__PURE__ */ t("div", { className: "flex items-center justify-between pt-4 border-t mt-6", children: [
    /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
      D && /* @__PURE__ */ t(u, { variant: "ghost", onClick: D, disabled: A, children: [
        /* @__PURE__ */ e(he, { className: "h-4 w-4 mr-1" }),
        g.cancel
      ] }),
      y && /* @__PURE__ */ t(u, { variant: "outline", onClick: () => y(L), disabled: A, children: [
        /* @__PURE__ */ e(Tt, { className: "h-4 w-4 mr-1" }),
        g.saveDraft
      ] })
    ] }),
    /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
      !$ && /* @__PURE__ */ t(u, { variant: "outline", onClick: de, disabled: A || Q, children: [
        /* @__PURE__ */ e(vt, { className: "h-4 w-4 mr-1" }),
        g.back
      ] }),
      S && (c.optional || c.canSkip) && !o && /* @__PURE__ */ t(u, { variant: "ghost", onClick: I, disabled: A || Q, children: [
        g.skip,
        /* @__PURE__ */ e(Ne, { className: "h-4 w-4 ml-1" })
      ] }),
      /* @__PURE__ */ t(
        u,
        {
          variant: "primary",
          onClick: F,
          disabled: A || Q || Z,
          isLoading: A || Q,
          children: [
            o ? g.finish : g.next,
            !o && /* @__PURE__ */ e(Ne, { className: "h-4 w-4 ml-1" })
          ]
        }
      )
    ] })
  ] });
  return /* @__PURE__ */ t(ne, { className: l("flex flex-col", Y), variant: "elevated", children: [
    _ && /* @__PURE__ */ t("div", { className: "px-6 pt-4", children: [
      /* @__PURE__ */ t("div", { className: "flex items-center justify-between text-sm text-muted-foreground mb-2", children: [
        /* @__PURE__ */ t("span", { children: [
          "Step ",
          b + 1,
          " of ",
          r.length
        ] }),
        /* @__PURE__ */ t("span", { children: [
          Math.round(x),
          "% complete"
        ] })
      ] }),
      /* @__PURE__ */ e(na, { value: x, className: "h-2" })
    ] }),
    /* @__PURE__ */ t(
      "div",
      {
        className: l(
          "flex-1 p-6",
          d === "left" && "flex gap-6",
          d === "right" && "flex flex-row-reverse gap-6"
        ),
        children: [
          d === "top" ? /* @__PURE__ */ e("div", { className: "mb-6", children: ie() }) : /* @__PURE__ */ e("div", { className: "w-48 shrink-0", children: ie() }),
          /* @__PURE__ */ t("div", { className: "flex-1 flex flex-col", children: [
            X(),
            R()
          ] })
        ]
      }
    )
  ] });
};
Jl.displayName = "MultiStepWizard";
const be = {
  file: { icon: /* @__PURE__ */ e(ha, { className: "h-5 w-5" }), color: "text-gray-500" },
  folder: { icon: /* @__PURE__ */ e(pa, { className: "h-5 w-5" }), color: "text-yellow-500" },
  image: { icon: /* @__PURE__ */ e(ma, { className: "h-5 w-5" }), color: "text-green-500" },
  video: { icon: /* @__PURE__ */ e(kr, { className: "h-5 w-5" }), color: "text-purple-500" },
  audio: { icon: /* @__PURE__ */ e(br, { className: "h-5 w-5" }), color: "text-pink-500" },
  document: { icon: /* @__PURE__ */ e(rt, { className: "h-5 w-5" }), color: "text-blue-500" },
  archive: { icon: /* @__PURE__ */ e(pr, { className: "h-5 w-5" }), color: "text-orange-500" },
  spreadsheet: { icon: /* @__PURE__ */ e(mt, { className: "h-5 w-5" }), color: "text-emerald-500" },
  code: { icon: /* @__PURE__ */ e(xr, { className: "h-5 w-5" }), color: "text-cyan-500" }
}, Xl = be.file, ta = (r) => {
  const C = be[r.type];
  if (C) return C;
  const i = `${r.mimeType ?? r.type ?? ""}`.toLowerCase();
  if (i.startsWith("image/")) return be.image;
  if (i.startsWith("video/")) return be.video;
  if (i.startsWith("audio/")) return be.audio;
  if (i.includes("zip") || i.includes("tar") || i.includes("rar") || i.includes("archive"))
    return be.archive;
  if (i.includes("sheet") || i.includes("excel") || i.includes("csv"))
    return be.spreadsheet;
  if (i.includes("code") || i.includes("json") || i.includes("javascript"))
    return be.code;
  if (i.includes("pdf") || i.includes("text") || i.includes("document"))
    return be.document;
  const n = `${r.extension ?? ""}`.toLowerCase();
  return ["png", "jpg", "jpeg", "gif", "webp", "svg"].includes(n) ? be.image : ["mp4", "mov", "avi", "mkv"].includes(n) ? be.video : ["mp3", "wav", "flac", "aac"].includes(n) ? be.audio : ["zip", "tar", "gz", "rar", "7z"].includes(n) ? be.archive : ["xls", "xlsx", "csv", "ods"].includes(n) ? be.spreadsheet : ["ts", "tsx", "js", "jsx", "json", "py", "go", "rs"].includes(n) ? be.code : ["pdf", "txt", "doc", "docx", "md"].includes(n) ? be.document : Xl;
}, Zl = (r) => {
  if (r === void 0) return "-";
  const C = ["B", "KB", "MB", "GB", "TB"];
  let i = r, n = 0;
  for (; i >= 1024 && n < C.length - 1; )
    i /= 1024, n++;
  return `${i.toFixed(n > 0 ? 1 : 0)} ${C[n]}`;
}, ei = (r) => {
  if (!r) return "-";
  const C = r instanceof Date ? r : new Date(r);
  return Number.isNaN(C.getTime()) ? "-" : new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric"
  }).format(C);
}, ti = ({
  items: r = [],
  currentPath: C = "/",
  breadcrumbs: i = [],
  selectedIds: n = [],
  viewMode: p = "grid",
  sortBy: j = "name",
  sortOrder: D = "asc",
  uploadProgress: E = [],
  isLoading: y = !1,
  multiSelect: N = !0,
  enableDragDrop: A = !0,
  acceptedFileTypes: _,
  maxFileSize: w,
  onNavigate: s,
  onSelectionChange: S,
  onPreview: g,
  onDownload: m,
  onDelete: d,
  onRename: M,
  onMove: K,
  onCopy: Y,
  onCreateFolder: h,
  onUpload: z,
  onShare: U,
  onToggleStar: T,
  onViewModeChange: L,
  onSortChange: G,
  searchQuery: Q = "",
  onSearchChange: v,
  filterType: b = "all",
  onFilterChange: c,
  className: $
}) => {
  const [o, x] = P(!1), [f, O] = P(null), [F, de] = P(""), [I, se] = P(!1), [oe, Z] = P(""), [V, ie] = P(null), X = Ee(null), R = te((B) => {
    A && (B.preventDefault(), x(!0));
  }, [A]), H = te((B) => {
    B.preventDefault(), x(!1);
  }, []), ce = te((B) => {
    if (!A) return;
    B.preventDefault(), x(!1);
    const ve = Array.from(B.dataTransfer.files);
    ve.length > 0 && (z == null || z(ve));
  }, [A, z]), q = te((B) => {
    const ve = Array.from(B.target.files || []);
    ve.length > 0 && (z == null || z(ve)), X.current && (X.current.value = "");
  }, [z]), le = te((B, ve) => {
    if (B.type === "folder")
      s == null || s(B.id);
    else if (ve.detail === 2)
      g == null || g(B);
    else if (N && (ve.ctrlKey || ve.metaKey)) {
      const De = n.includes(B.id) ? n.filter((Ze) => Ze !== B.id) : [...n, B.id];
      S == null || S(De);
    } else
      S == null || S([B.id]);
  }, [s, g, N, n, S]), ee = te(() => {
    n.length === r.length ? S == null || S([]) : S == null || S(r.map((B) => B.id));
  }, [n, r, S]), k = (B) => {
    O(B.id), de(B.name);
  }, W = () => {
    if (f && F.trim()) {
      const B = r.find((ve) => ve.id === f);
      B && (M == null || M(B, F.trim()));
    }
    O(null), de("");
  }, re = () => {
    oe.trim() && (h == null || h(oe.trim()), Z(""), se(!1));
  }, ge = r.filter((B) => n.includes(B.id)), ke = n.length > 0;
  return /* @__PURE__ */ t(
    ne,
    {
      className: l("flex flex-col h-full", o && "ring-2 ring-primary", $),
      variant: "elevated",
      onDragOver: R,
      onDragLeave: H,
      onDrop: ce,
      children: [
        /* @__PURE__ */ e(
          "input",
          {
            ref: X,
            type: "file",
            multiple: !0,
            className: "hidden",
            accept: _ == null ? void 0 : _.join(","),
            onChange: q
          }
        ),
        /* @__PURE__ */ t("div", { className: "flex items-center justify-between p-4 border-b", children: [
          /* @__PURE__ */ e("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ t("div", { className: "flex items-center gap-1 text-sm", children: [
            /* @__PURE__ */ e(
              "button",
              {
                className: "flex items-center gap-1 text-muted-foreground hover:text-foreground",
                onClick: () => s == null ? void 0 : s(null),
                children: /* @__PURE__ */ e(Lr, { className: "h-4 w-4" })
              }
            ),
            i.map((B, ve) => /* @__PURE__ */ t(Ae.Fragment, { children: [
              /* @__PURE__ */ e(Ne, { className: "h-4 w-4 text-muted-foreground" }),
              /* @__PURE__ */ e(
                "button",
                {
                  className: l(
                    "hover:text-foreground",
                    ve === i.length - 1 ? "font-medium text-foreground" : "text-muted-foreground"
                  ),
                  onClick: () => s == null ? void 0 : s(B.id),
                  children: B.name
                }
              )
            ] }, B.id))
          ] }) }),
          /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ t("div", { className: "relative", children: [
              /* @__PURE__ */ e(we, { className: "absolute left-2 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" }),
              /* @__PURE__ */ e(
                ue,
                {
                  placeholder: "Search files...",
                  value: Q,
                  onChange: (B) => v == null ? void 0 : v(B.target.value),
                  className: "pl-8 w-48"
                }
              )
            ] }),
            /* @__PURE__ */ t(
              "select",
              {
                value: b,
                onChange: (B) => c == null ? void 0 : c(B.target.value),
                className: "px-2 py-1.5 border rounded text-sm bg-background",
                children: [
                  /* @__PURE__ */ e("option", { value: "all", children: "All types" }),
                  Object.keys(be).map((B) => /* @__PURE__ */ t("option", { value: B, children: [
                    B.charAt(0).toUpperCase() + B.slice(1),
                    "s"
                  ] }, B))
                ]
              }
            ),
            /* @__PURE__ */ e(
              u,
              {
                variant: "outline",
                size: "sm",
                onClick: () => G == null ? void 0 : G(j, D === "asc" ? "desc" : "asc"),
                children: D === "asc" ? /* @__PURE__ */ e(La, { className: "h-4 w-4" }) : /* @__PURE__ */ e(Ta, { className: "h-4 w-4" })
              }
            ),
            /* @__PURE__ */ t("div", { className: "flex border rounded-lg overflow-hidden", children: [
              /* @__PURE__ */ e(
                u,
                {
                  variant: p === "grid" ? "secondary" : "ghost",
                  size: "sm",
                  onClick: () => L == null ? void 0 : L("grid"),
                  className: "rounded-none",
                  children: /* @__PURE__ */ e(ot, { className: "h-4 w-4" })
                }
              ),
              /* @__PURE__ */ e(
                u,
                {
                  variant: p === "list" ? "secondary" : "ghost",
                  size: "sm",
                  onClick: () => L == null ? void 0 : L("list"),
                  className: "rounded-none",
                  children: /* @__PURE__ */ e(ia, { className: "h-4 w-4" })
                }
              )
            ] }),
            /* @__PURE__ */ t(u, { onClick: () => {
              var B;
              return (B = X.current) == null ? void 0 : B.click();
            }, children: [
              /* @__PURE__ */ e(lt, { className: "h-4 w-4 mr-1" }),
              "Upload"
            ] }),
            /* @__PURE__ */ e(u, { variant: "outline", onClick: () => se(!0), children: /* @__PURE__ */ e(Kt, { className: "h-4 w-4" }) })
          ] })
        ] }),
        ke && /* @__PURE__ */ t("div", { className: "flex items-center justify-between px-4 py-2 bg-primary/10 border-b", children: [
          /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ e(
              He,
              {
                checked: n.length === r.length,
                onCheckedChange: ee
              }
            ),
            /* @__PURE__ */ t(a, { variant: "caption", children: [
              n.length,
              " selected"
            ] })
          ] }),
          /* @__PURE__ */ t("div", { className: "flex items-center gap-1", children: [
            m && /* @__PURE__ */ t(u, { variant: "ghost", size: "sm", onClick: () => m(ge), children: [
              /* @__PURE__ */ e(_e, { className: "h-4 w-4 mr-1" }),
              "Download"
            ] }),
            U && /* @__PURE__ */ t(u, { variant: "ghost", size: "sm", onClick: () => U(ge), children: [
              /* @__PURE__ */ e(ct, { className: "h-4 w-4 mr-1" }),
              "Share"
            ] }),
            d && /* @__PURE__ */ t(
              u,
              {
                variant: "ghost",
                size: "sm",
                onClick: () => d(ge),
                className: "text-destructive hover:text-destructive",
                children: [
                  /* @__PURE__ */ e(Re, { className: "h-4 w-4 mr-1" }),
                  "Delete"
                ]
              }
            )
          ] })
        ] }),
        I && /* @__PURE__ */ t("div", { className: "flex items-center gap-2 p-3 border-b bg-muted/30", children: [
          /* @__PURE__ */ e(Kt, { className: "h-5 w-5 text-yellow-500" }),
          /* @__PURE__ */ e(
            ue,
            {
              placeholder: "New folder name...",
              value: oe,
              onChange: (B) => Z(B.target.value),
              onKeyDown: (B) => {
                B.key === "Enter" && re(), B.key === "Escape" && se(!1);
              },
              className: "flex-1",
              autoFocus: !0
            }
          ),
          /* @__PURE__ */ e(u, { size: "sm", onClick: re, disabled: !oe.trim(), children: /* @__PURE__ */ e(fe, { className: "h-4 w-4" }) }),
          /* @__PURE__ */ e(u, { variant: "ghost", size: "sm", onClick: () => se(!1), children: /* @__PURE__ */ e(he, { className: "h-4 w-4" }) })
        ] }),
        E.length > 0 && /* @__PURE__ */ e("div", { className: "p-3 border-b space-y-2", children: E.map((B) => /* @__PURE__ */ t("div", { className: "flex items-center gap-3", children: [
          /* @__PURE__ */ e(lt, { className: "h-4 w-4 text-muted-foreground" }),
          /* @__PURE__ */ t("div", { className: "flex-1 min-w-0", children: [
            /* @__PURE__ */ t("div", { className: "flex items-center justify-between mb-1", children: [
              /* @__PURE__ */ e(a, { variant: "caption", className: "truncate", children: B.fileName }),
              /* @__PURE__ */ t(a, { variant: "caption", className: "text-muted-foreground", children: [
                B.progress,
                "%"
              ] })
            ] }),
            /* @__PURE__ */ e("div", { className: "h-1.5 bg-muted rounded-full overflow-hidden", children: /* @__PURE__ */ e(
              "div",
              {
                className: l(
                  "h-full rounded-full transition-all",
                  B.status === "error" ? "bg-red-500" : "bg-primary"
                ),
                style: { width: `${B.progress}%` }
              }
            ) })
          ] }),
          B.status === "completed" && /* @__PURE__ */ e(fe, { className: "h-4 w-4 text-green-500" }),
          B.status === "error" && /* @__PURE__ */ e(he, { className: "h-4 w-4 text-red-500" })
        ] }, B.fileId)) }),
        /* @__PURE__ */ e("div", { className: "flex-1 overflow-auto p-4", children: y ? /* @__PURE__ */ e("div", { className: "flex items-center justify-center h-full", children: /* @__PURE__ */ e("div", { className: "animate-spin rounded-full h-8 w-8 border-2 border-primary border-t-transparent" }) }) : r.length === 0 ? /* @__PURE__ */ t(
          "div",
          {
            className: l(
              "flex flex-col items-center justify-center h-full text-center",
              A && "border-2 border-dashed rounded-lg"
            ),
            children: [
              /* @__PURE__ */ e(pa, { className: "h-16 w-16 text-muted-foreground mb-4 opacity-50" }),
              /* @__PURE__ */ e(a, { variant: "body", className: "text-muted-foreground mb-1", children: Q ? "No files found" : "This folder is empty" }),
              A && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: "Drag and drop files here or click Upload" })
            ]
          }
        ) : p === "grid" ? /* @__PURE__ */ e("div", { className: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4", children: r.map((B) => {
          const ve = ta(B), De = n.includes(B.id), Ze = f === B.id;
          return /* @__PURE__ */ t(
            "div",
            {
              className: l(
                "group relative rounded-lg border p-3 cursor-pointer transition-all hover:shadow-md",
                De && "ring-2 ring-primary bg-primary/5"
              ),
              onClick: (pe) => le(B, pe),
              onContextMenu: (pe) => {
                pe.preventDefault(), ie({ x: pe.clientX, y: pe.clientY, item: B });
              },
              children: [
                N && /* @__PURE__ */ e("div", { className: "absolute top-2 left-2 opacity-0 group-hover:opacity-100 transition-opacity", children: /* @__PURE__ */ e(
                  He,
                  {
                    checked: De,
                    onCheckedChange: (pe) => {
                      const yt = pe ? [...n, B.id] : n.filter((wt) => wt !== B.id);
                      S == null || S(yt);
                    },
                    onClick: (pe) => pe.stopPropagation()
                  }
                ) }),
                T && /* @__PURE__ */ e(
                  "button",
                  {
                    className: "absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity",
                    onClick: (pe) => {
                      pe.stopPropagation(), T(B);
                    },
                    children: B.starred ? /* @__PURE__ */ e($e, { className: "h-4 w-4 fill-yellow-400 text-yellow-400" }) : /* @__PURE__ */ e(Ot, { className: "h-4 w-4 text-muted-foreground hover:text-yellow-400" })
                  }
                ),
                /* @__PURE__ */ e("div", { className: "aspect-square flex items-center justify-center mb-2 rounded bg-muted/30", children: B.thumbnailUrl ? /* @__PURE__ */ e(
                  "img",
                  {
                    src: B.thumbnailUrl,
                    alt: B.name,
                    className: "max-h-full max-w-full object-contain rounded"
                  }
                ) : /* @__PURE__ */ e("div", { className: ve.color, children: ve.icon }) }),
                Ze ? /* @__PURE__ */ e(
                  ue,
                  {
                    value: F,
                    onChange: (pe) => de(pe.target.value),
                    onBlur: W,
                    onKeyDown: (pe) => {
                      pe.key === "Enter" && W(), pe.key === "Escape" && O(null);
                    },
                    className: "text-sm h-7",
                    autoFocus: !0,
                    onClick: (pe) => pe.stopPropagation()
                  }
                ) : /* @__PURE__ */ e(
                  a,
                  {
                    variant: "caption",
                    className: "truncate text-center block",
                    title: B.name,
                    children: B.name
                  }
                ),
                B.shared && /* @__PURE__ */ e("div", { className: "absolute bottom-2 right-2", children: /* @__PURE__ */ e(ct, { className: "h-3 w-3 text-muted-foreground" }) })
              ]
            },
            B.id
          );
        }) }) : /* @__PURE__ */ e("div", { className: "space-y-1", children: r.map((B) => {
          const ve = ta(B), De = n.includes(B.id), Ze = f === B.id;
          return /* @__PURE__ */ t(
            "div",
            {
              className: l(
                "group flex items-center gap-3 p-2 rounded-lg cursor-pointer hover:bg-muted/50 transition-colors",
                De && "bg-primary/10"
              ),
              onClick: (pe) => le(B, pe),
              children: [
                N && /* @__PURE__ */ e(
                  He,
                  {
                    checked: De,
                    onCheckedChange: (pe) => {
                      const yt = pe ? [...n, B.id] : n.filter((wt) => wt !== B.id);
                      S == null || S(yt);
                    },
                    onClick: (pe) => pe.stopPropagation()
                  }
                ),
                /* @__PURE__ */ e("div", { className: ve.color, children: ve.icon }),
                /* @__PURE__ */ e("div", { className: "flex-1 min-w-0", children: Ze ? /* @__PURE__ */ e(
                  ue,
                  {
                    value: F,
                    onChange: (pe) => de(pe.target.value),
                    onBlur: W,
                    onKeyDown: (pe) => {
                      pe.key === "Enter" && W(), pe.key === "Escape" && O(null);
                    },
                    className: "h-7",
                    autoFocus: !0,
                    onClick: (pe) => pe.stopPropagation()
                  }
                ) : /* @__PURE__ */ e(a, { variant: "body", className: "truncate", children: B.name }) }),
                /* @__PURE__ */ t("div", { className: "flex items-center gap-4 text-sm text-muted-foreground", children: [
                  B.starred && /* @__PURE__ */ e($e, { className: "h-4 w-4 fill-yellow-400 text-yellow-400" }),
                  B.shared && /* @__PURE__ */ e(ct, { className: "h-4 w-4" }),
                  /* @__PURE__ */ e("span", { className: "w-20 text-right", children: Zl(B.size) }),
                  /* @__PURE__ */ e("span", { className: "w-24 text-right", children: ei(B.modifiedAt) }),
                  /* @__PURE__ */ e(
                    u,
                    {
                      variant: "ghost",
                      size: "sm",
                      className: "opacity-0 group-hover:opacity-100",
                      onClick: (pe) => {
                        pe.stopPropagation(), k(B);
                      },
                      children: /* @__PURE__ */ e(xs, { className: "h-4 w-4" })
                    }
                  ),
                  /* @__PURE__ */ e(
                    u,
                    {
                      variant: "ghost",
                      size: "sm",
                      className: "opacity-0 group-hover:opacity-100",
                      children: /* @__PURE__ */ e(qt, { className: "h-4 w-4" })
                    }
                  )
                ] })
              ]
            },
            B.id
          );
        }) }) }),
        o && /* @__PURE__ */ e("div", { className: "absolute inset-0 bg-primary/10 border-2 border-dashed border-primary rounded-lg flex items-center justify-center z-50", children: /* @__PURE__ */ t("div", { className: "text-center", children: [
          /* @__PURE__ */ e(lt, { className: "h-12 w-12 text-primary mx-auto mb-2" }),
          /* @__PURE__ */ e(a, { variant: "body", className: "text-primary font-medium", children: "Drop files to upload" })
        ] }) })
      ]
    }
  );
};
ti.displayName = "FileAssetManager";
const ai = {
  search: "Search",
  filters: "Filters",
  clearAll: "Clear all",
  saveSearch: "Save search",
  recentSearches: "Recent searches",
  savedSearches: "Saved searches",
  noResults: "No results found",
  showingResults: "Showing results for"
}, ri = ({
  filters: r,
  query: C,
  activeFilters: i = [],
  results: n = [],
  recentSearches: p = [],
  savedSearches: j = [],
  suggestions: D = [],
  onSearch: E,
  onQueryChange: y,
  onFiltersChange: N,
  onSaveSearch: A,
  onApplySavedSearch: _,
  onDeleteSavedSearch: w,
  onResultSelect: s,
  isLoading: S = !1,
  showFilters: g = !0,
  showSuggestions: m = !0,
  showRecentSearches: d = !0,
  showSavedSearches: M = !0,
  placeholder: K = "Search...",
  enableAI: Y = !1,
  resultCount: h,
  labels: z = ai,
  className: U
}) => {
  const [T, L] = P(""), [G, Q] = P(!1), [v, b] = P(!1), [c, $] = P(/* @__PURE__ */ new Set()), [o, x] = P(""), [f, O] = P(!1), F = C ?? T, de = Ce(() => {
    const q = { ungrouped: [] };
    return r.forEach((le) => {
      const ee = le.group || "ungrouped";
      q[ee] || (q[ee] = []), q[ee].push(le);
    }), q;
  }, [r]), I = te(
    (q) => {
      C === void 0 && L(q), y == null || y(q);
    },
    [C, y]
  ), se = te(() => {
    E == null || E(F, i);
  }, [F, i, E]), oe = te(
    (q) => {
      q.key === "Enter" && se();
    },
    [se]
  ), Z = te(
    (q, le, ee) => {
      const k = i.findIndex((re) => re.filterId === q);
      let W;
      le == null || le === "" || Array.isArray(le) && le.length === 0 ? W = i.filter((re) => re.filterId !== q) : k >= 0 ? (W = [...i], W[k] = { filterId: q, value: le, label: ee }) : W = [...i, { filterId: q, value: le, label: ee }], N == null || N(W);
    },
    [i, N]
  ), V = te(
    (q) => {
      N == null || N(i.filter((le) => le.filterId !== q));
    },
    [i, N]
  ), ie = te(() => {
    I(""), N == null || N([]);
  }, [I, N]), X = te(() => {
    o.trim() && (A == null || A(o.trim(), F, i), x(""), O(!1));
  }, [o, F, i, A]), R = te((q) => {
    $((le) => {
      const ee = new Set(le);
      return ee.has(q) ? ee.delete(q) : ee.add(q), ee;
    });
  }, []), H = (q) => {
    var k;
    const le = i.find((W) => W.filterId === q.id), ee = le == null ? void 0 : le.value;
    switch (q.type) {
      case "select":
      case "multiselect":
        return /* @__PURE__ */ e("div", { className: "space-y-1", children: (k = q.options) == null ? void 0 : k.map((W) => {
          const re = q.type === "multiselect" ? Array.isArray(ee) && ee.includes(W.value) : ee === W.value;
          return /* @__PURE__ */ t(
            "button",
            {
              type: "button",
              className: l(
                "w-full flex items-center justify-between px-2 py-1.5 rounded text-sm",
                "hover:bg-muted/50 transition-colors",
                re && "bg-primary/10 text-primary"
              ),
              onClick: () => {
                if (q.type === "multiselect") {
                  const ge = Array.isArray(ee) ? [...ee] : [];
                  if (re) {
                    const ke = ge.indexOf(W.value);
                    ge.splice(ke, 1);
                  } else
                    ge.push(W.value);
                  Z(q.id, ge.length > 0 ? ge : null, ge.join(", "));
                } else
                  Z(
                    q.id,
                    re ? null : W.value,
                    W.label
                  );
              },
              children: [
                /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
                  W.icon,
                  /* @__PURE__ */ e("span", { children: W.label })
                ] }),
                /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
                  W.count !== void 0 && /* @__PURE__ */ e("span", { className: "text-xs text-muted-foreground", children: W.count }),
                  re && /* @__PURE__ */ e(fe, { className: "h-4 w-4" })
                ] })
              ]
            },
            W.value
          );
        }) });
      case "boolean":
        return /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ e(
            "button",
            {
              type: "button",
              className: l(
                "px-3 py-1.5 rounded text-sm",
                ee === !0 ? "bg-primary text-primary-foreground" : "bg-muted"
              ),
              onClick: () => Z(q.id, ee === !0 ? null : !0, "Yes"),
              children: "Yes"
            }
          ),
          /* @__PURE__ */ e(
            "button",
            {
              type: "button",
              className: l(
                "px-3 py-1.5 rounded text-sm",
                ee === !1 ? "bg-primary text-primary-foreground" : "bg-muted"
              ),
              onClick: () => Z(q.id, ee === !1 ? null : !1, "No"),
              children: "No"
            }
          )
        ] });
      case "text":
        return /* @__PURE__ */ e(
          ue,
          {
            type: "text",
            placeholder: q.placeholder,
            value: ee || "",
            onChange: (W) => Z(q.id, W.target.value || null, W.target.value),
            className: "h-8 text-sm"
          }
        );
      case "date":
        return /* @__PURE__ */ e(
          ue,
          {
            type: "date",
            value: ee || "",
            onChange: (W) => Z(q.id, W.target.value || null, W.target.value),
            className: "h-8 text-sm"
          }
        );
      case "dateRange":
        return /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ e(
            ue,
            {
              type: "date",
              placeholder: "From",
              value: (ee == null ? void 0 : ee.from) || "",
              onChange: (W) => Z(
                q.id,
                { ...ee, from: W.target.value },
                `${W.target.value} - ${(ee == null ? void 0 : ee.to) || ""}`
              ),
              className: "h-8 text-sm flex-1"
            }
          ),
          /* @__PURE__ */ e("span", { className: "text-muted-foreground", children: "-" }),
          /* @__PURE__ */ e(
            ue,
            {
              type: "date",
              placeholder: "To",
              value: (ee == null ? void 0 : ee.to) || "",
              onChange: (W) => Z(
                q.id,
                { ...ee, to: W.target.value },
                `${(ee == null ? void 0 : ee.from) || ""} - ${W.target.value}`
              ),
              className: "h-8 text-sm flex-1"
            }
          )
        ] });
      case "range":
        return /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ e(
            ue,
            {
              type: "number",
              placeholder: "Min",
              min: q.min,
              max: q.max,
              value: (ee == null ? void 0 : ee.min) || "",
              onChange: (W) => Z(
                q.id,
                { ...ee, min: W.target.value ? Number(W.target.value) : void 0 },
                `${W.target.value || q.min} - ${(ee == null ? void 0 : ee.max) || q.max}`
              ),
              className: "h-8 text-sm flex-1"
            }
          ),
          /* @__PURE__ */ e("span", { className: "text-muted-foreground", children: "-" }),
          /* @__PURE__ */ e(
            ue,
            {
              type: "number",
              placeholder: "Max",
              min: q.min,
              max: q.max,
              value: (ee == null ? void 0 : ee.max) || "",
              onChange: (W) => Z(
                q.id,
                { ...ee, max: W.target.value ? Number(W.target.value) : void 0 },
                `${(ee == null ? void 0 : ee.min) || q.min} - ${W.target.value || q.max}`
              ),
              className: "h-8 text-sm flex-1"
            }
          )
        ] });
      default:
        return null;
    }
  }, ce = v && (m || d || M);
  return /* @__PURE__ */ t("div", { className: l("relative", U), children: [
    /* @__PURE__ */ t("div", { className: "relative", children: [
      /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ t("div", { className: "relative flex-1", children: [
          /* @__PURE__ */ e(we, { className: "absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" }),
          Y && /* @__PURE__ */ e(Te, { className: "absolute left-9 top-1/2 -translate-y-1/2 h-4 w-4 text-purple-500" }),
          /* @__PURE__ */ e(
            ue,
            {
              type: "text",
              placeholder: K,
              value: F,
              onChange: (q) => I(q.target.value),
              onFocus: () => b(!0),
              onBlur: () => setTimeout(() => b(!1), 200),
              onKeyDown: oe,
              className: l("h-10", Y ? "pl-14" : "pl-10", "pr-10")
            }
          ),
          F && /* @__PURE__ */ e(
            "button",
            {
              type: "button",
              className: "absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground",
              onClick: () => I(""),
              children: /* @__PURE__ */ e(he, { className: "h-4 w-4" })
            }
          )
        ] }),
        g && /* @__PURE__ */ t(
          u,
          {
            variant: G ? "primary" : "outline",
            onClick: () => Q(!G),
            className: "gap-2",
            children: [
              /* @__PURE__ */ e(Ss, { className: "h-4 w-4" }),
              z.filters,
              i.length > 0 && /* @__PURE__ */ e(ae, { variant: "default", className: "ml-1", children: i.length })
            ]
          }
        ),
        /* @__PURE__ */ t(u, { variant: "primary", onClick: se, isLoading: S, children: [
          /* @__PURE__ */ e(we, { className: "h-4 w-4 mr-1" }),
          z.search
        ] })
      ] }),
      ce && /* @__PURE__ */ t(ne, { className: "absolute top-full left-0 right-0 mt-1 z-50 p-2 shadow-lg", children: [
        d && p.length > 0 && /* @__PURE__ */ t("div", { className: "mb-2", children: [
          /* @__PURE__ */ e(a, { variant: "caption", className: "px-2 text-muted-foreground font-medium", children: z.recentSearches }),
          /* @__PURE__ */ e("div", { className: "mt-1", children: p.slice(0, 5).map((q, le) => /* @__PURE__ */ t(
            "button",
            {
              type: "button",
              className: "w-full flex items-center gap-2 px-2 py-1.5 rounded hover:bg-muted/50 text-sm",
              onClick: () => {
                I(q), se();
              },
              children: [
                /* @__PURE__ */ e(Ge, { className: "h-4 w-4 text-muted-foreground" }),
                q
              ]
            },
            le
          )) })
        ] }),
        M && j.length > 0 && /* @__PURE__ */ t("div", { className: "mb-2", children: [
          /* @__PURE__ */ e(a, { variant: "caption", className: "px-2 text-muted-foreground font-medium", children: z.savedSearches }),
          /* @__PURE__ */ e("div", { className: "mt-1", children: j.map((q) => /* @__PURE__ */ t(
            "button",
            {
              type: "button",
              className: "w-full flex items-center justify-between px-2 py-1.5 rounded hover:bg-muted/50 text-sm",
              onClick: () => _ == null ? void 0 : _(q),
              children: [
                /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
                  /* @__PURE__ */ e(Oa, { className: "h-4 w-4 text-muted-foreground" }),
                  q.name
                ] }),
                /* @__PURE__ */ t(ae, { variant: "default", className: "text-xs", children: [
                  q.filters.length,
                  " filters"
                ] })
              ]
            },
            q.id
          )) })
        ] }),
        m && D.length > 0 && /* @__PURE__ */ e("div", { children: D.map((q, le) => /* @__PURE__ */ t(
          "button",
          {
            type: "button",
            className: "w-full flex items-center gap-2 px-2 py-1.5 rounded hover:bg-muted/50 text-sm",
            onClick: () => {
              I(q.text), se();
            },
            children: [
              q.icon || /* @__PURE__ */ e(we, { className: "h-4 w-4 text-muted-foreground" }),
              /* @__PURE__ */ e("span", { children: q.text }),
              q.metadata && /* @__PURE__ */ e("span", { className: "text-xs text-muted-foreground ml-auto", children: q.metadata })
            ]
          },
          le
        )) })
      ] })
    ] }),
    i.length > 0 && /* @__PURE__ */ t("div", { className: "flex items-center gap-2 mt-3 flex-wrap", children: [
      i.map((q) => {
        const le = r.find((ee) => ee.id === q.filterId);
        return /* @__PURE__ */ t(
          ae,
          {
            variant: "default",
            className: "flex items-center gap-1 px-2 py-1",
            children: [
              /* @__PURE__ */ t("span", { className: "text-muted-foreground", children: [
                le == null ? void 0 : le.label,
                ":"
              ] }),
              /* @__PURE__ */ e("span", { children: q.label }),
              /* @__PURE__ */ e(
                "button",
                {
                  type: "button",
                  className: "ml-1 hover:text-foreground",
                  onClick: () => V(q.filterId),
                  children: /* @__PURE__ */ e(he, { className: "h-3 w-3" })
                }
              )
            ]
          },
          q.filterId
        );
      }),
      /* @__PURE__ */ t(u, { variant: "ghost", size: "sm", onClick: ie, className: "text-xs", children: [
        /* @__PURE__ */ e(Qe, { className: "h-3 w-3 mr-1" }),
        z.clearAll
      ] }),
      A && /* @__PURE__ */ t(u, { variant: "ghost", size: "sm", onClick: () => O(!0), className: "text-xs", children: [
        /* @__PURE__ */ e($e, { className: "h-3 w-3 mr-1" }),
        z.saveSearch
      ] })
    ] }),
    f && /* @__PURE__ */ t(ne, { className: "mt-3 p-4", children: [
      /* @__PURE__ */ e(a, { variant: "body", className: "font-medium mb-2", children: "Save this search" }),
      /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ e(
          ue,
          {
            type: "text",
            placeholder: "Search name...",
            value: o,
            onChange: (q) => x(q.target.value),
            className: "flex-1"
          }
        ),
        /* @__PURE__ */ e(u, { variant: "primary", onClick: X, disabled: !o.trim(), children: "Save" }),
        /* @__PURE__ */ e(u, { variant: "ghost", onClick: () => O(!1), children: "Cancel" })
      ] })
    ] }),
    g && G && /* @__PURE__ */ t(ne, { className: "mt-3 p-4", children: [
      /* @__PURE__ */ t("div", { className: "flex items-center justify-between mb-4", children: [
        /* @__PURE__ */ t(a, { variant: "body", className: "font-medium flex items-center gap-2", children: [
          /* @__PURE__ */ e(Je, { className: "h-4 w-4" }),
          z.filters
        ] }),
        i.length > 0 && /* @__PURE__ */ t(u, { variant: "ghost", size: "sm", onClick: ie, children: [
          /* @__PURE__ */ e(Qe, { className: "h-4 w-4 mr-1" }),
          z.clearAll
        ] })
      ] }),
      /* @__PURE__ */ e("div", { className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4", children: Object.entries(de).map(([q, le]) => /* @__PURE__ */ t("div", { children: [
        q !== "ungrouped" && /* @__PURE__ */ t(
          "button",
          {
            type: "button",
            className: "w-full flex items-center justify-between mb-2 text-sm font-medium text-muted-foreground",
            onClick: () => R(q),
            children: [
              q,
              c.has(q) ? /* @__PURE__ */ e(Ie, { className: "h-4 w-4" }) : /* @__PURE__ */ e(xe, { className: "h-4 w-4" })
            ]
          }
        ),
        (q === "ungrouped" || c.has(q)) && le.map((ee) => /* @__PURE__ */ t("div", { className: "mb-4", children: [
          /* @__PURE__ */ e(a, { variant: "caption", className: "font-medium mb-2 block", children: ee.label }),
          H(ee)
        ] }, ee.id))
      ] }, q)) })
    ] }),
    h !== void 0 && F && /* @__PURE__ */ e("div", { className: "mt-4", children: /* @__PURE__ */ t(a, { variant: "caption", className: "text-muted-foreground", children: [
      z.showingResults,
      ' "',
      F,
      '" - ',
      h,
      " results"
    ] }) }),
    n.length > 0 && /* @__PURE__ */ e("div", { className: "mt-4 space-y-2", children: n.map((q) => /* @__PURE__ */ e(
      ne,
      {
        className: "p-3 cursor-pointer hover:bg-muted/50 transition-colors",
        onClick: () => s == null ? void 0 : s(q),
        children: /* @__PURE__ */ t("div", { className: "flex items-start gap-3", children: [
          q.icon && /* @__PURE__ */ e("div", { className: "shrink-0 mt-0.5", children: q.icon }),
          /* @__PURE__ */ t("div", { className: "flex-1 min-w-0", children: [
            /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ e(a, { variant: "body", className: "font-medium truncate", children: q.title }),
              q.type && /* @__PURE__ */ e(ae, { variant: "default", className: "text-xs", children: q.type })
            ] }),
            q.description && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground line-clamp-2", children: q.description }),
            q.matchedFields && q.matchedFields.length > 0 && /* @__PURE__ */ t("div", { className: "flex items-center gap-1 mt-1", children: [
              /* @__PURE__ */ e(st, { className: "h-3 w-3 text-muted-foreground" }),
              /* @__PURE__ */ t(a, { variant: "caption", className: "text-muted-foreground", children: [
                "Matched: ",
                q.matchedFields.join(", ")
              ] })
            ] })
          ] })
        ] })
      },
      q.id
    )) }),
    F && n.length === 0 && !S && /* @__PURE__ */ t("div", { className: "mt-8 text-center", children: [
      /* @__PURE__ */ e(we, { className: "h-12 w-12 text-muted-foreground mx-auto mb-4" }),
      /* @__PURE__ */ e(a, { variant: "body", className: "text-muted-foreground", children: z.noResults })
    ] })
  ] });
};
ri.displayName = "AdvancedSearch";
const si = {
  title: "Keyboard Shortcuts",
  search: "Search shortcuts...",
  noResults: "No shortcuts found",
  resetDefaults: "Reset to defaults",
  customize: "Customize",
  pressKeys: "Press new key combination...",
  cancel: "Cancel",
  save: "Save"
}, li = {
  cmd: /* @__PURE__ */ e(it, { className: "h-3 w-3" }),
  command: /* @__PURE__ */ e(it, { className: "h-3 w-3" }),
  meta: /* @__PURE__ */ e(it, { className: "h-3 w-3" }),
  ctrl: "Ctrl",
  control: "Ctrl",
  alt: "Alt",
  option: "Alt",
  shift: "⇧",
  enter: /* @__PURE__ */ e(Ft, { className: "h-3 w-3" }),
  return: /* @__PURE__ */ e(Ft, { className: "h-3 w-3" }),
  backspace: /* @__PURE__ */ e(nr, { className: "h-3 w-3" }),
  delete: "Del",
  up: /* @__PURE__ */ e(ja, { className: "h-3 w-3" }),
  down: /* @__PURE__ */ e(za, { className: "h-3 w-3" }),
  left: /* @__PURE__ */ e(ca, { className: "h-3 w-3" }),
  right: /* @__PURE__ */ e(Fe, { className: "h-3 w-3" }),
  space: "Space",
  tab: "Tab",
  esc: "Esc",
  escape: "Esc"
}, ii = ({
  shortcuts: r,
  categories: C = [],
  activeShortcut: i,
  onShortcutClick: n,
  onCustomize: p,
  onResetDefaults: j,
  searchable: D = !0,
  customizable: E = !1,
  collapsedByDefault: y = !1,
  platform: N,
  showDescriptions: A = !0,
  compact: _ = !1,
  labels: w = si,
  className: s
}) => {
  const [S, g] = P(""), [m, d] = P(() => y ? /* @__PURE__ */ new Set() : new Set(C.map((x) => x.id).concat(["uncategorized"]))), [M, K] = P(null), [Y, h] = P([]), z = Ce(() => {
    if (N) return N;
    if (typeof navigator < "u") {
      const x = navigator.userAgent.toLowerCase();
      return x.includes("mac") ? "mac" : x.includes("win") ? "windows" : "linux";
    }
    return "mac";
  }, [N]), U = Ce(() => {
    if (!S.trim()) return r;
    const x = S.toLowerCase();
    return r.filter(
      (f) => {
        var O;
        return f.description.toLowerCase().includes(x) || f.keys.some((F) => F.toLowerCase().includes(x)) || ((O = f.category) == null ? void 0 : O.toLowerCase().includes(x));
      }
    );
  }, [r, S]), T = Ce(() => {
    const x = { uncategorized: [] };
    return C.forEach((f) => {
      x[f.id] = [];
    }), U.forEach((f) => {
      const O = f.category || "uncategorized";
      x[O] || (x[O] = []), x[O].push(f);
    }), x;
  }, [U, C]), L = te((x) => {
    d((f) => {
      const O = new Set(f);
      return O.has(x) ? O.delete(x) : O.add(x), O;
    });
  }, []), G = te((x) => {
    K(x), h([]);
  }, []), Q = te(() => {
    K(null), h([]);
  }, []), v = te(() => {
    M && Y.length > 0 && (p == null || p(M, Y)), K(null), h([]);
  }, [M, Y, p]);
  qe(() => {
    if (!M) return;
    const x = (f) => {
      f.preventDefault(), f.stopPropagation();
      const O = [];
      (f.metaKey || f.ctrlKey) && O.push(z === "mac" ? "cmd" : "ctrl"), f.altKey && O.push("alt"), f.shiftKey && O.push("shift"), ["Meta", "Control", "Alt", "Shift"].includes(f.key) || O.push(f.key.toLowerCase()), O.length > 0 && h(O);
    };
    return window.addEventListener("keydown", x), () => window.removeEventListener("keydown", x);
  }, [M, z]);
  const b = (x) => {
    const f = li[x.toLowerCase()] || x.toUpperCase();
    return /* @__PURE__ */ e(
      "kbd",
      {
        className: l(
          "inline-flex items-center justify-center rounded border",
          "bg-muted text-muted-foreground",
          "font-mono text-xs font-medium",
          _ ? "min-w-[20px] h-5 px-1" : "min-w-[24px] h-6 px-1.5"
        ),
        children: f
      }
    );
  }, c = (x) => /* @__PURE__ */ e("div", { className: "flex items-center gap-1", children: x.map((f, O) => /* @__PURE__ */ t(Ae.Fragment, { children: [
    b(f),
    O < x.length - 1 && /* @__PURE__ */ e("span", { className: "text-muted-foreground text-xs", children: "+" })
  ] }, O)) }), $ = (x) => {
    const f = M === x.id, O = i === x.id;
    return /* @__PURE__ */ t(
      "div",
      {
        className: l(
          "flex items-center justify-between gap-4",
          _ ? "py-1.5" : "py-2",
          "px-2 rounded",
          "hover:bg-muted/50 transition-colors",
          O && "bg-primary/10 ring-1 ring-primary/20",
          x.enabled === !1 && "opacity-50"
        ),
        onClick: () => !f && (n == null ? void 0 : n(x)),
        children: [
          /* @__PURE__ */ t("div", { className: "flex-1 min-w-0", children: [
            /* @__PURE__ */ e(
              a,
              {
                variant: _ ? "caption" : "body",
                className: l("truncate", !A && "font-medium"),
                children: x.description
              }
            ),
            A && x.when && /* @__PURE__ */ t(a, { variant: "caption", className: "text-muted-foreground", children: [
              "When: ",
              x.when
            ] })
          ] }),
          /* @__PURE__ */ e("div", { className: "flex items-center gap-2", children: f ? /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
            Y.length > 0 ? c(Y) : /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground italic", children: w.pressKeys }),
            /* @__PURE__ */ e(u, { variant: "ghost", size: "sm", onClick: Q, children: /* @__PURE__ */ e(he, { className: "h-3 w-3" }) }),
            /* @__PURE__ */ e(
              u,
              {
                variant: "primary",
                size: "sm",
                onClick: v,
                disabled: Y.length === 0,
                children: w.save
              }
            )
          ] }) : /* @__PURE__ */ t(me, { children: [
            c(x.keys),
            E && x.customizable !== !1 && /* @__PURE__ */ e(
              u,
              {
                variant: "ghost",
                size: "sm",
                onClick: (F) => {
                  F.stopPropagation(), G(x.id);
                },
                className: "opacity-0 group-hover:opacity-100 transition-opacity",
                children: /* @__PURE__ */ e(Oe, { className: "h-3 w-3" })
              }
            )
          ] }) })
        ]
      },
      x.id
    );
  }, o = (x, f) => {
    if (f.length === 0) return null;
    const O = C.find((I) => I.id === x), F = m.has(x), de = (O == null ? void 0 : O.name) || "Other";
    return /* @__PURE__ */ t("div", { className: "mb-4", children: [
      /* @__PURE__ */ t(
        "button",
        {
          type: "button",
          className: l(
            "w-full flex items-center gap-2 py-2 px-2 rounded",
            "hover:bg-muted/50 transition-colors",
            "text-left"
          ),
          onClick: () => L(x),
          children: [
            F ? /* @__PURE__ */ e(xe, { className: "h-4 w-4 text-muted-foreground" }) : /* @__PURE__ */ e(Ne, { className: "h-4 w-4 text-muted-foreground" }),
            O == null ? void 0 : O.icon,
            /* @__PURE__ */ e(a, { variant: "body", className: "font-medium", children: de }),
            /* @__PURE__ */ e(ae, { variant: "default", className: "ml-auto text-xs", children: f.length })
          ]
        }
      ),
      F && /* @__PURE__ */ e("div", { className: "ml-6 mt-1 space-y-1 group", children: f.map($) })
    ] }, x);
  };
  return /* @__PURE__ */ t(ne, { className: l("overflow-hidden", s), variant: "elevated", children: [
    /* @__PURE__ */ t("div", { className: "p-4 border-b", children: [
      /* @__PURE__ */ t("div", { className: "flex items-center justify-between mb-4", children: [
        /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ e(Yt, { className: "h-5 w-5 text-primary" }),
          /* @__PURE__ */ e(a, { variant: "h4", className: "font-semibold", children: w.title })
        ] }),
        E && j && /* @__PURE__ */ t(u, { variant: "ghost", size: "sm", onClick: j, children: [
          /* @__PURE__ */ e(Xe, { className: "h-4 w-4 mr-1" }),
          w.resetDefaults
        ] })
      ] }),
      /* @__PURE__ */ t("div", { className: "flex items-center gap-2 mb-4", children: [
        /* @__PURE__ */ e(Dt, { className: "h-4 w-4 text-muted-foreground" }),
        /* @__PURE__ */ t(a, { variant: "caption", className: "text-muted-foreground", children: [
          "Showing shortcuts for",
          " ",
          /* @__PURE__ */ e(ae, { variant: "default", className: "text-xs", children: z === "mac" ? "macOS" : z === "windows" ? "Windows" : "Linux" })
        ] })
      ] }),
      D && /* @__PURE__ */ t("div", { className: "relative", children: [
        /* @__PURE__ */ e(we, { className: "absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" }),
        /* @__PURE__ */ e(
          ue,
          {
            type: "text",
            placeholder: w.search,
            value: S,
            onChange: (x) => g(x.target.value),
            className: "pl-10"
          }
        ),
        S && /* @__PURE__ */ e(
          "button",
          {
            type: "button",
            className: "absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground",
            onClick: () => g(""),
            children: /* @__PURE__ */ e(he, { className: "h-4 w-4" })
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ e("div", { className: "p-4 max-h-[500px] overflow-y-auto", children: U.length === 0 ? /* @__PURE__ */ t("div", { className: "text-center py-8", children: [
      /* @__PURE__ */ e(Yt, { className: "h-12 w-12 text-muted-foreground mx-auto mb-4" }),
      /* @__PURE__ */ e(a, { variant: "body", className: "text-muted-foreground", children: w.noResults })
    ] }) : C.length > 0 ? /* @__PURE__ */ e(me, { children: Object.entries(T).map(
      ([x, f]) => o(x, f)
    ) }) : /* @__PURE__ */ e("div", { className: "space-y-1 group", children: U.map($) }) }),
    /* @__PURE__ */ e("div", { className: "p-4 border-t bg-muted/30", children: /* @__PURE__ */ t("div", { className: "flex items-center gap-2 text-muted-foreground", children: [
      /* @__PURE__ */ e(Dt, { className: "h-4 w-4 shrink-0" }),
      /* @__PURE__ */ t(a, { variant: "caption", children: [
        "Press",
        " ",
        /* @__PURE__ */ e("kbd", { className: "inline-flex items-center justify-center rounded border bg-background px-1 text-xs", children: z === "mac" ? "⌘" : "Ctrl" }),
        " ",
        "+",
        " ",
        /* @__PURE__ */ e("kbd", { className: "inline-flex items-center justify-center rounded border bg-background px-1 text-xs", children: "/" }),
        " ",
        "anywhere to open this panel"
      ] })
    ] }) })
  ] });
};
ii.displayName = "KeyboardShortcuts";
const ni = {
  title: "What's New",
  feature: "New Feature",
  improvement: "Improvement",
  bugfix: "Bug Fix",
  breaking: "Breaking Change",
  security: "Security",
  deprecation: "Deprecation",
  performance: "Performance",
  new: "New",
  showMore: "Show more updates",
  showLess: "Show less",
  noChanges: "No changelog entries",
  subscribeUpdates: "Subscribe to updates",
  unsubscribe: "Unsubscribe"
}, aa = {
  feature: {
    icon: /* @__PURE__ */ e(Te, { className: "h-4 w-4" }),
    color: "text-purple-600 dark:text-purple-400",
    bgColor: "bg-purple-100 dark:bg-purple-900/30"
  },
  improvement: {
    icon: /* @__PURE__ */ e(Be, { className: "h-4 w-4" }),
    color: "text-blue-600 dark:text-blue-400",
    bgColor: "bg-blue-100 dark:bg-blue-900/30"
  },
  bugfix: {
    icon: /* @__PURE__ */ e(Ka, { className: "h-4 w-4" }),
    color: "text-green-600 dark:text-green-400",
    bgColor: "bg-green-100 dark:bg-green-900/30"
  },
  breaking: {
    icon: /* @__PURE__ */ e(ze, { className: "h-4 w-4" }),
    color: "text-red-600 dark:text-red-400",
    bgColor: "bg-red-100 dark:bg-red-900/30"
  },
  security: {
    icon: /* @__PURE__ */ e(Ue, { className: "h-4 w-4" }),
    color: "text-orange-600 dark:text-orange-400",
    bgColor: "bg-orange-100 dark:bg-orange-900/30"
  },
  deprecation: {
    icon: /* @__PURE__ */ e(ms, { className: "h-4 w-4" }),
    color: "text-yellow-600 dark:text-yellow-400",
    bgColor: "bg-yellow-100 dark:bg-yellow-900/30"
  },
  performance: {
    icon: /* @__PURE__ */ e(ys, { className: "h-4 w-4" }),
    color: "text-cyan-600 dark:text-cyan-400",
    bgColor: "bg-cyan-100 dark:bg-cyan-900/30"
  }
}, ci = ({
  entries: r = [],
  currentVersion: C,
  onEntryClick: i,
  onLinkClick: n,
  onNotificationToggle: p,
  notificationsEnabled: j = !0,
  showVersionBadge: D = !0,
  showDate: E = !0,
  showFilters: y = !0,
  showNotificationToggle: N = !0,
  expandable: A = !0,
  initialExpandedIds: _ = [],
  maxInitialEntries: w = 5,
  labels: s = ni,
  className: S
}) => {
  const [g, m] = P(
    new Set(_)
  ), [d, M] = P(/* @__PURE__ */ new Set()), [K, Y] = P(!1), h = te((c) => Array.isArray(c.changes) ? c.changes : [], []), z = Ce(() => d.size === 0 ? r : r.filter(
    (c) => h(c).some(($) => d.has($.type))
  ), [r, d, h]), U = Ce(() => K ? z : z.slice(0, w), [z, K, w]), T = te((c) => {
    A && m(($) => {
      const o = new Set($);
      return o.has(c) ? o.delete(c) : o.add(c), o;
    });
  }, [A]), L = te((c) => {
    M(($) => {
      const o = new Set($);
      return o.has(c) ? o.delete(c) : o.add(c), o;
    });
  }, []), G = (c) => new Date(c).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric"
  }), Q = (c) => {
    const $ = aa[c.type];
    return /* @__PURE__ */ t(
      "div",
      {
        className: "flex items-start gap-3 py-3 border-b last:border-b-0",
        children: [
          /* @__PURE__ */ e("div", { className: l("rounded-full p-1.5 shrink-0", $.bgColor, $.color), children: $.icon }),
          /* @__PURE__ */ t("div", { className: "flex-1 min-w-0", children: [
            /* @__PURE__ */ t("div", { className: "flex items-center gap-2 flex-wrap", children: [
              /* @__PURE__ */ e(a, { variant: "body", className: "font-medium", children: c.title }),
              /* @__PURE__ */ e(
                ae,
                {
                  variant: "default",
                  className: l("text-xs", $.color, $.bgColor),
                  children: s[c.type] || c.type
                }
              )
            ] }),
            /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground mt-1", children: c.description }),
            c.tags && c.tags.length > 0 && /* @__PURE__ */ t("div", { className: "flex items-center gap-1 mt-2 flex-wrap", children: [
              /* @__PURE__ */ e(st, { className: "h-3 w-3 text-muted-foreground" }),
              c.tags.map((o) => /* @__PURE__ */ e(ae, { variant: "default", className: "text-xs", children: o }, o))
            ] }),
            c.image && /* @__PURE__ */ e("div", { className: "mt-3 rounded-lg overflow-hidden border", children: /* @__PURE__ */ e(
              "img",
              {
                src: c.image,
                alt: c.title,
                className: "w-full h-auto"
              }
            ) }),
            c.link && /* @__PURE__ */ t(
              u,
              {
                variant: "ghost",
                size: "sm",
                className: "mt-2 -ml-2 text-primary",
                onClick: () => n == null ? void 0 : n(c.link),
                children: [
                  "Learn more",
                  /* @__PURE__ */ e(at, { className: "h-3 w-3 ml-1" })
                ]
              }
            )
          ] })
        ]
      },
      c.id
    );
  }, v = (c) => {
    const $ = g.has(c.id), o = C === c.version, x = d.size === 0 ? h(c) : h(c).filter((f) => d.has(f.type));
    return x.length === 0 ? null : /* @__PURE__ */ t(
      ne,
      {
        className: l(
          "overflow-hidden transition-all",
          c.isPinned && "ring-2 ring-primary/20",
          c.isNew && "ring-2 ring-green-500/20"
        ),
        children: [
          /* @__PURE__ */ t(
            "button",
            {
              type: "button",
              className: l(
                "w-full flex items-center justify-between p-4",
                "hover:bg-muted/50 transition-colors",
                "text-left"
              ),
              onClick: () => A ? T(c.id) : i == null ? void 0 : i(c),
              children: [
                /* @__PURE__ */ t("div", { className: "flex items-center gap-3", children: [
                  c.isPinned && /* @__PURE__ */ e($e, { className: "h-4 w-4 text-yellow-500 fill-yellow-500" }),
                  /* @__PURE__ */ t("div", { children: [
                    /* @__PURE__ */ t("div", { className: "flex items-center gap-2 flex-wrap", children: [
                      D && /* @__PURE__ */ t(
                        ae,
                        {
                          variant: "default",
                          className: l(o && "bg-green-500 text-white"),
                          children: [
                            "v",
                            c.version
                          ]
                        }
                      ),
                      c.isNew && /* @__PURE__ */ e(ae, { variant: "default", className: "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400", children: s.new }),
                      c.title && /* @__PURE__ */ e(a, { variant: "body", className: "font-semibold", children: c.title })
                    ] }),
                    E && /* @__PURE__ */ t("div", { className: "flex items-center gap-1 mt-1 text-muted-foreground", children: [
                      /* @__PURE__ */ e(Ht, { className: "h-3 w-3" }),
                      /* @__PURE__ */ e(a, { variant: "caption", children: G(c.date) })
                    ] })
                  ] })
                ] }),
                /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
                  /* @__PURE__ */ t(ae, { variant: "default", className: "text-xs", children: [
                    x.length,
                    " changes"
                  ] }),
                  A && ($ ? /* @__PURE__ */ e(Ie, { className: "h-4 w-4 text-muted-foreground" }) : /* @__PURE__ */ e(xe, { className: "h-4 w-4 text-muted-foreground" }))
                ] })
              ]
            }
          ),
          c.summary && !$ && /* @__PURE__ */ e("div", { className: "px-4 pb-4", children: /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: c.summary }) }),
          ($ || !A) && /* @__PURE__ */ t("div", { className: "px-4 pb-4 border-t", children: [
            c.summary && /* @__PURE__ */ e(a, { variant: "body", className: "text-muted-foreground py-3 border-b", children: c.summary }),
            /* @__PURE__ */ e("div", { className: "divide-y", children: x.map(Q) })
          ] })
        ]
      },
      c.id
    );
  }, b = Ce(() => {
    const c = /* @__PURE__ */ new Set();
    return r.forEach(($) => {
      h($).forEach((o) => c.add(o.type));
    }), Array.from(c);
  }, [r, h]);
  return /* @__PURE__ */ t("div", { className: l("space-y-4", S), children: [
    /* @__PURE__ */ t("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ e(Te, { className: "h-5 w-5 text-primary" }),
        /* @__PURE__ */ e(a, { variant: "h4", className: "font-semibold", children: s.title }),
        C && /* @__PURE__ */ t(ae, { variant: "default", className: "ml-2", children: [
          "Current: v",
          C
        ] })
      ] }),
      N && p && /* @__PURE__ */ e(
        u,
        {
          variant: j ? "outline" : "ghost",
          size: "sm",
          onClick: () => p(!j),
          children: j ? /* @__PURE__ */ t(me, { children: [
            /* @__PURE__ */ e(We, { className: "h-4 w-4 mr-1" }),
            s.unsubscribe
          ] }) : /* @__PURE__ */ t(me, { children: [
            /* @__PURE__ */ e(da, { className: "h-4 w-4 mr-1" }),
            s.subscribeUpdates
          ] })
        }
      )
    ] }),
    y && b.length > 1 && /* @__PURE__ */ t("div", { className: "flex items-center gap-2 flex-wrap", children: [
      /* @__PURE__ */ e(Je, { className: "h-4 w-4 text-muted-foreground" }),
      b.map((c) => {
        const $ = aa[c], o = d.has(c);
        return /* @__PURE__ */ t(
          u,
          {
            variant: o ? "primary" : "outline",
            size: "sm",
            onClick: () => L(c),
            className: l(
              "gap-1",
              !o && $.color
            ),
            children: [
              $.icon,
              s[c] || c
            ]
          },
          c
        );
      }),
      d.size > 0 && /* @__PURE__ */ e(
        u,
        {
          variant: "ghost",
          size: "sm",
          onClick: () => M(/* @__PURE__ */ new Set()),
          children: "Clear"
        }
      )
    ] }),
    /* @__PURE__ */ e("div", { className: "space-y-4", children: U.length === 0 ? /* @__PURE__ */ t(ne, { className: "p-8 text-center", children: [
      /* @__PURE__ */ e(Me, { className: "h-12 w-12 text-muted-foreground mx-auto mb-4" }),
      /* @__PURE__ */ e(a, { variant: "body", className: "text-muted-foreground", children: s.noChanges })
    ] }) : U.map(v) }),
    z.length > w && /* @__PURE__ */ e("div", { className: "flex justify-center", children: /* @__PURE__ */ e(
      u,
      {
        variant: "ghost",
        onClick: () => Y(!K),
        className: "gap-1",
        children: K ? /* @__PURE__ */ t(me, { children: [
          /* @__PURE__ */ e(Ie, { className: "h-4 w-4" }),
          s.showLess
        ] }) : /* @__PURE__ */ t(me, { children: [
          s.showMore,
          " (",
          z.length - w,
          " more)",
          /* @__PURE__ */ e(xe, { className: "h-4 w-4" })
        ] })
      }
    ) })
  ] });
};
ci.displayName = "ChangelogFeed";
const di = {
  title: "API Keys",
  createKey: "Create API Key",
  keyName: "Key Name",
  scopes: "Scopes",
  expiresAt: "Expires",
  create: "Create",
  cancel: "Cancel",
  revoke: "Revoke",
  regenerate: "Regenerate",
  delete: "Delete",
  copyKey: "Copy",
  copied: "Copied!",
  active: "Active",
  expired: "Expired",
  revoked: "Revoked",
  pending: "Pending",
  neverExpires: "Never expires",
  noKeys: "No API keys yet",
  createdAt: "Created",
  lastUsed: "Last used",
  never: "Never"
}, oi = {
  active: {
    icon: /* @__PURE__ */ e(Ye, { className: "h-4 w-4" }),
    color: "text-green-600 dark:text-green-400",
    bgColor: "bg-green-100 dark:bg-green-900/30"
  },
  expired: {
    icon: /* @__PURE__ */ e(Me, { className: "h-4 w-4" }),
    color: "text-yellow-600 dark:text-yellow-400",
    bgColor: "bg-yellow-100 dark:bg-yellow-900/30"
  },
  revoked: {
    icon: /* @__PURE__ */ e(et, { className: "h-4 w-4" }),
    color: "text-red-600 dark:text-red-400",
    bgColor: "bg-red-100 dark:bg-red-900/30"
  },
  pending: {
    icon: /* @__PURE__ */ e(ye, { className: "h-4 w-4 animate-spin" }),
    color: "text-blue-600 dark:text-blue-400",
    bgColor: "bg-blue-100 dark:bg-blue-900/30"
  }
}, mi = ({
  apiKeys: r,
  availableScopes: C = [],
  maxKeys: i = 0,
  onCreateKey: n,
  onRevokeKey: p,
  onRegenerateKey: j,
  onDeleteKey: D,
  onCopyKey: E,
  isLoading: y = !1,
  showUsage: N = !0,
  showLastUsed: A = !0,
  showScopes: _ = !0,
  allowRegenerate: w = !0,
  labels: s = di,
  className: S
}) => {
  var Z;
  const [g, m] = P(!1), [d, M] = P(""), [K, Y] = P(/* @__PURE__ */ new Set()), [h, z] = P(""), [U, T] = P(null), [L, G] = P(/* @__PURE__ */ new Set()), [Q, v] = P(null), [b, c] = P(!1), [$, o] = P(null), x = i === 0 || r.length < i, f = te((V) => {
    Y((ie) => {
      const X = new Set(ie);
      return X.has(V) ? X.delete(V) : X.add(V), X;
    });
  }, []), O = te(async () => {
    if (!(!d.trim() || !n)) {
      c(!0);
      try {
        const V = await n({
          name: d.trim(),
          scopes: Array.from(K),
          expiresAt: h ? new Date(h) : void 0
        });
        T(V), M(""), Y(/* @__PURE__ */ new Set()), z("");
      } finally {
        c(!1);
      }
    }
  }, [d, K, h, n]), F = te(
    async (V) => {
      const ie = V.fullKey || V.keyPrefix;
      await navigator.clipboard.writeText(ie), v(V.id), E == null || E(ie), setTimeout(() => v(null), 2e3);
    },
    [E]
  ), de = te((V) => {
    G((ie) => {
      const X = new Set(ie);
      return X.has(V) ? X.delete(V) : X.add(V), X;
    });
  }, []), I = (V) => new Date(V).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric"
  }), se = (V) => {
    const X = (/* @__PURE__ */ new Date()).getTime() - new Date(V).getTime(), R = Math.floor(X / (1e3 * 60 * 60 * 24));
    return R === 0 ? "Today" : R === 1 ? "Yesterday" : R < 7 ? `${R} days ago` : R < 30 ? `${Math.floor(R / 7)} weeks ago` : I(V);
  }, oe = (V) => {
    const ie = oi[V.status], X = L.has(V.id), R = Q === V.id, H = $ === V.id;
    return /* @__PURE__ */ e(ne, { className: "p-4", children: /* @__PURE__ */ t("div", { className: "flex items-start justify-between", children: [
      /* @__PURE__ */ t("div", { className: "flex items-start gap-3", children: [
        /* @__PURE__ */ e("div", { className: l("rounded-full p-2", ie.bgColor, ie.color), children: /* @__PURE__ */ e(nt, { className: "h-4 w-4" }) }),
        /* @__PURE__ */ t("div", { children: [
          /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ e(a, { variant: "body", className: "font-medium", children: V.name }),
            /* @__PURE__ */ t(ae, { variant: "default", className: l("text-xs", ie.color, ie.bgColor), children: [
              ie.icon,
              /* @__PURE__ */ e("span", { className: "ml-1", children: s[V.status] })
            ] })
          ] }),
          /* @__PURE__ */ t("div", { className: "flex items-center gap-2 mt-2", children: [
            /* @__PURE__ */ e("code", { className: "text-sm bg-muted px-2 py-1 rounded font-mono", children: X && V.fullKey ? V.fullKey : V.keyPrefix + "•••••••••••••" }),
            V.fullKey && /* @__PURE__ */ e(
              u,
              {
                variant: "ghost",
                size: "sm",
                onClick: () => de(V.id),
                children: X ? /* @__PURE__ */ e(It, { className: "h-4 w-4" }) : /* @__PURE__ */ e(Ve, { className: "h-4 w-4" })
              }
            ),
            /* @__PURE__ */ e(u, { variant: "ghost", size: "sm", onClick: () => F(V), children: R ? /* @__PURE__ */ e(Ye, { className: "h-4 w-4 text-green-500" }) : /* @__PURE__ */ e(Ke, { className: "h-4 w-4" }) })
          ] }),
          _ && V.scopes.length > 0 && /* @__PURE__ */ t("div", { className: "flex items-center gap-1 mt-2 flex-wrap", children: [
            /* @__PURE__ */ e(Ue, { className: "h-3 w-3 text-muted-foreground" }),
            V.scopes.map((ce) => /* @__PURE__ */ e(ae, { variant: "default", className: "text-xs", children: ce }, ce))
          ] }),
          /* @__PURE__ */ t("div", { className: "flex items-center gap-4 mt-2 text-xs text-muted-foreground", children: [
            /* @__PURE__ */ t("span", { className: "flex items-center gap-1", children: [
              /* @__PURE__ */ e(Ht, { className: "h-3 w-3" }),
              s.createdAt,
              ": ",
              I(V.createdAt)
            ] }),
            V.expiresAt && /* @__PURE__ */ t("span", { className: "flex items-center gap-1", children: [
              /* @__PURE__ */ e(Me, { className: "h-3 w-3" }),
              s.expiresAt,
              ": ",
              I(V.expiresAt)
            ] }),
            A && /* @__PURE__ */ t("span", { className: "flex items-center gap-1", children: [
              /* @__PURE__ */ e(Ge, { className: "h-3 w-3" }),
              s.lastUsed,
              ":",
              " ",
              V.lastUsedAt ? se(V.lastUsedAt) : s.never
            ] }),
            N && V.usageCount !== void 0 && /* @__PURE__ */ t("span", { children: [
              V.usageCount.toLocaleString(),
              " requests"
            ] })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ t("div", { className: "relative", children: [
        /* @__PURE__ */ e(
          u,
          {
            variant: "ghost",
            size: "sm",
            onClick: () => o(H ? null : V.id),
            children: /* @__PURE__ */ e(qt, { className: "h-4 w-4" })
          }
        ),
        H && /* @__PURE__ */ t(ne, { className: "absolute right-0 top-full mt-1 w-48 p-1 shadow-lg z-10", children: [
          w && V.status === "active" && j && /* @__PURE__ */ t(
            "button",
            {
              type: "button",
              className: "w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-muted rounded",
              onClick: () => {
                j(V.id), o(null);
              },
              children: [
                /* @__PURE__ */ e(Xe, { className: "h-4 w-4" }),
                s.regenerate
              ]
            }
          ),
          V.status === "active" && p && /* @__PURE__ */ t(
            "button",
            {
              type: "button",
              className: "w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-muted rounded text-yellow-600",
              onClick: () => {
                p(V.id), o(null);
              },
              children: [
                /* @__PURE__ */ e(et, { className: "h-4 w-4" }),
                s.revoke
              ]
            }
          ),
          D && /* @__PURE__ */ t(
            "button",
            {
              type: "button",
              className: "w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-muted rounded text-red-600",
              onClick: () => {
                D(V.id), o(null);
              },
              children: [
                /* @__PURE__ */ e(Re, { className: "h-4 w-4" }),
                s.delete
              ]
            }
          )
        ] })
      ] })
    ] }) }, V.id);
  };
  return /* @__PURE__ */ t("div", { className: l("space-y-4", S), children: [
    /* @__PURE__ */ t("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ e(nt, { className: "h-5 w-5 text-primary" }),
        /* @__PURE__ */ e(a, { variant: "h4", className: "font-semibold", children: s.title }),
        /* @__PURE__ */ t(ae, { variant: "default", children: [
          r.length,
          " keys"
        ] })
      ] }),
      x && n && /* @__PURE__ */ t(
        u,
        {
          variant: "primary",
          onClick: () => m(!0),
          disabled: g || y,
          children: [
            /* @__PURE__ */ e(Pe, { className: "h-4 w-4 mr-1" }),
            s.createKey
          ]
        }
      )
    ] }),
    g && /* @__PURE__ */ t(ne, { className: "p-4", children: [
      /* @__PURE__ */ e(a, { variant: "body", className: "font-medium mb-4", children: s.createKey }),
      /* @__PURE__ */ t("div", { className: "space-y-4", children: [
        /* @__PURE__ */ t("div", { children: [
          /* @__PURE__ */ e("label", { className: "block text-sm font-medium mb-1", children: s.keyName }),
          /* @__PURE__ */ e(
            ue,
            {
              type: "text",
              placeholder: "e.g., Production API Key",
              value: d,
              onChange: (V) => M(V.target.value)
            }
          )
        ] }),
        C.length > 0 && /* @__PURE__ */ t("div", { children: [
          /* @__PURE__ */ e("label", { className: "block text-sm font-medium mb-2", children: s.scopes }),
          /* @__PURE__ */ e("div", { className: "flex flex-wrap gap-2", children: C.map((V) => /* @__PURE__ */ e(
            u,
            {
              variant: K.has(V.id) ? "primary" : "outline",
              size: "sm",
              onClick: () => f(V.id),
              children: V.name
            },
            V.id
          )) })
        ] }),
        /* @__PURE__ */ t("div", { children: [
          /* @__PURE__ */ t("label", { className: "block text-sm font-medium mb-1", children: [
            s.expiresAt,
            " (optional)"
          ] }),
          /* @__PURE__ */ e(
            ue,
            {
              type: "date",
              value: h,
              onChange: (V) => z(V.target.value),
              min: (/* @__PURE__ */ new Date()).toISOString().split("T")[0]
            }
          ),
          /* @__PURE__ */ t(a, { variant: "caption", className: "text-muted-foreground mt-1", children: [
            "Leave blank for ",
            (Z = s.neverExpires) == null ? void 0 : Z.toLowerCase()
          ] })
        ] }),
        /* @__PURE__ */ t("div", { className: "flex items-center gap-2 justify-end", children: [
          /* @__PURE__ */ e(
            u,
            {
              variant: "ghost",
              onClick: () => {
                m(!1), T(null);
              },
              children: s.cancel
            }
          ),
          /* @__PURE__ */ e(
            u,
            {
              variant: "primary",
              onClick: O,
              disabled: !d.trim() || b,
              isLoading: b,
              children: s.create
            }
          )
        ] })
      ] })
    ] }),
    U && U.fullKey && /* @__PURE__ */ e(ne, { className: "p-4 border-green-500 bg-green-50 dark:bg-green-900/20", children: /* @__PURE__ */ t("div", { className: "flex items-start gap-3", children: [
      /* @__PURE__ */ e(Ye, { className: "h-5 w-5 text-green-600 shrink-0 mt-0.5" }),
      /* @__PURE__ */ t("div", { className: "flex-1", children: [
        /* @__PURE__ */ e(a, { variant: "body", className: "font-medium text-green-800 dark:text-green-200", children: "API Key Created Successfully" }),
        /* @__PURE__ */ e(a, { variant: "caption", className: "text-green-700 dark:text-green-300 mt-1", children: "Make sure to copy your API key now. You won't be able to see it again!" }),
        /* @__PURE__ */ t("div", { className: "flex items-center gap-2 mt-3", children: [
          /* @__PURE__ */ e("code", { className: "flex-1 text-sm bg-white dark:bg-green-900/30 px-3 py-2 rounded font-mono break-all", children: U.fullKey }),
          /* @__PURE__ */ t(u, { variant: "outline", size: "sm", onClick: () => F(U), children: [
            /* @__PURE__ */ e(Ke, { className: "h-4 w-4 mr-1" }),
            Q === U.id ? s.copied : s.copyKey
          ] })
        ] })
      ] }),
      /* @__PURE__ */ e(
        u,
        {
          variant: "ghost",
          size: "sm",
          onClick: () => {
            T(null), m(!1);
          },
          children: /* @__PURE__ */ e(et, { className: "h-4 w-4" })
        }
      )
    ] }) }),
    y ? /* @__PURE__ */ e("div", { className: "flex items-center justify-center py-12", children: /* @__PURE__ */ e(ye, { className: "h-8 w-8 animate-spin text-primary" }) }) : r.length === 0 ? /* @__PURE__ */ t(ne, { className: "p-8 text-center", children: [
      /* @__PURE__ */ e(nt, { className: "h-12 w-12 text-muted-foreground mx-auto mb-4" }),
      /* @__PURE__ */ e(a, { variant: "body", className: "text-muted-foreground", children: s.noKeys }),
      /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground mt-1", children: "Create your first API key to get started" })
    ] }) : /* @__PURE__ */ e("div", { className: "space-y-3", children: r.map(oe) }),
    /* @__PURE__ */ e(ne, { className: "p-4 bg-yellow-50 dark:bg-yellow-900/20 border-yellow-200 dark:border-yellow-800", children: /* @__PURE__ */ t("div", { className: "flex items-start gap-3", children: [
      /* @__PURE__ */ e(ze, { className: "h-5 w-5 text-yellow-600 shrink-0" }),
      /* @__PURE__ */ t("div", { children: [
        /* @__PURE__ */ e(a, { variant: "body", className: "font-medium text-yellow-800 dark:text-yellow-200", children: "Keep your API keys secure" }),
        /* @__PURE__ */ e(a, { variant: "caption", className: "text-yellow-700 dark:text-yellow-300", children: "Never share your API keys in public repositories or client-side code. Use environment variables and secrets management." })
      ] })
    ] }) })
  ] });
};
mi.displayName = "ApiKeyManager";
const hi = {
  title: "Webhooks",
  createWebhook: "Add Webhook",
  webhookName: "Name",
  webhookUrl: "Endpoint URL",
  events: "Events",
  secret: "Secret (optional)",
  headers: "Custom Headers",
  create: "Create",
  update: "Update",
  cancel: "Cancel",
  delete: "Delete",
  test: "Test",
  pause: "Pause",
  resume: "Resume",
  active: "Active",
  paused: "Paused",
  failing: "Failing",
  disabled: "Disabled",
  noWebhooks: "No webhooks configured",
  deliveryHistory: "Recent Deliveries",
  viewDetails: "View Details",
  retry: "Retry"
}, ui = {
  active: {
    icon: /* @__PURE__ */ e(Ye, { className: "h-4 w-4" }),
    color: "text-green-600 dark:text-green-400",
    bgColor: "bg-green-100 dark:bg-green-900/30"
  },
  paused: {
    icon: /* @__PURE__ */ e(la, { className: "h-4 w-4" }),
    color: "text-yellow-600 dark:text-yellow-400",
    bgColor: "bg-yellow-100 dark:bg-yellow-900/30"
  },
  failing: {
    icon: /* @__PURE__ */ e(ze, { className: "h-4 w-4" }),
    color: "text-red-600 dark:text-red-400",
    bgColor: "bg-red-100 dark:bg-red-900/30"
  },
  disabled: {
    icon: /* @__PURE__ */ e(et, { className: "h-4 w-4" }),
    color: "text-gray-600 dark:text-gray-400",
    bgColor: "bg-gray-100 dark:bg-gray-900/30"
  }
}, pi = ({
  webhooks: r,
  availableEvents: C,
  maxWebhooks: i = 0,
  onCreateWebhook: n,
  onUpdateWebhook: p,
  onDeleteWebhook: j,
  onToggleStatus: D,
  onTestWebhook: E,
  onViewDelivery: y,
  onRetryDelivery: N,
  isLoading: A = !1,
  showDeliveryHistory: _ = !0,
  showTestButton: w = !0,
  labels: s = hi,
  className: S
}) => {
  const [g, m] = P(!1), [d, M] = P(null), [K, Y] = P(/* @__PURE__ */ new Set()), [h, z] = P(/* @__PURE__ */ new Set()), [U, T] = P(/* @__PURE__ */ new Set()), [L, G] = P(""), [Q, v] = P(""), [b, c] = P(""), [$, o] = P(/* @__PURE__ */ new Set()), [x, f] = P([]), O = i === 0 || r.length < i, F = te(() => {
    G(""), v(""), c(""), o(/* @__PURE__ */ new Set()), f([]);
  }, []), de = te((k) => {
    M(k.id), G(k.name), v(k.url), c(k.secret || ""), o(new Set(k.events)), f(
      k.headers ? Object.entries(k.headers).map(([W, re]) => ({ key: W, value: re })) : []
    );
  }, []), I = te(() => {
    M(null), m(!1), F();
  }, [F]), se = te((k) => {
    o((W) => {
      const re = new Set(W);
      return re.has(k) ? re.delete(k) : re.add(k), re;
    });
  }, []), oe = te(() => {
    f((k) => [...k, { key: "", value: "" }]);
  }, []), Z = te((k, W, re) => {
    f((ge) => {
      const ke = [...ge];
      return ke[k] = { ...ke[k], [W]: re }, ke;
    });
  }, []), V = te((k) => {
    f((W) => W.filter((re, ge) => ge !== k));
  }, []), ie = te(() => {
    if (!L.trim() || !Q.trim() || $.size === 0) return;
    const k = x.reduce((W, { key: re, value: ge }) => (re.trim() && ge.trim() && (W[re.trim()] = ge.trim()), W), {});
    d ? p == null || p(d, {
      name: L.trim(),
      url: Q.trim(),
      secret: b || void 0,
      events: Array.from($),
      headers: Object.keys(k).length > 0 ? k : void 0
    }) : n == null || n({
      name: L.trim(),
      url: Q.trim(),
      secret: b || void 0,
      events: Array.from($),
      headers: Object.keys(k).length > 0 ? k : void 0
    }), I();
  }, [L, Q, b, $, x, d, n, p, I]), X = te((k) => {
    Y((W) => {
      const re = new Set(W);
      return re.has(k) ? re.delete(k) : re.add(k), re;
    });
  }, []), R = te(
    async (k) => {
      if (E) {
        z((W) => new Set(W).add(k));
        try {
          await E(k);
        } finally {
          z((W) => {
            const re = new Set(W);
            return re.delete(k), re;
          });
        }
      }
    },
    [E]
  ), H = te((k) => {
    T((W) => {
      const re = new Set(W);
      return re.has(k) ? re.delete(k) : re.add(k), re;
    });
  }, []), ce = (k) => new Date(k).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  }), q = C.reduce((k, W) => {
    const re = W.category || "Other";
    return k[re] || (k[re] = []), k[re].push(W), k;
  }, {}), le = () => /* @__PURE__ */ t(ne, { className: "p-4", children: [
    /* @__PURE__ */ e(a, { variant: "body", className: "font-medium mb-4", children: d ? "Edit Webhook" : s.createWebhook }),
    /* @__PURE__ */ t("div", { className: "space-y-4", children: [
      /* @__PURE__ */ t("div", { children: [
        /* @__PURE__ */ e("label", { className: "block text-sm font-medium mb-1", children: s.webhookName }),
        /* @__PURE__ */ e(
          ue,
          {
            type: "text",
            placeholder: "e.g., Order Notifications",
            value: L,
            onChange: (k) => G(k.target.value)
          }
        )
      ] }),
      /* @__PURE__ */ t("div", { children: [
        /* @__PURE__ */ e("label", { className: "block text-sm font-medium mb-1", children: s.webhookUrl }),
        /* @__PURE__ */ e(
          ue,
          {
            type: "url",
            placeholder: "https://api.example.com/webhooks",
            value: Q,
            onChange: (k) => v(k.target.value)
          }
        )
      ] }),
      /* @__PURE__ */ t("div", { children: [
        /* @__PURE__ */ e("label", { className: "block text-sm font-medium mb-1", children: s.secret }),
        /* @__PURE__ */ e(
          ue,
          {
            type: "password",
            placeholder: "Optional signing secret",
            value: b,
            onChange: (k) => c(k.target.value)
          }
        ),
        /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground mt-1", children: "Used to sign webhook payloads for verification" })
      ] }),
      /* @__PURE__ */ t("div", { children: [
        /* @__PURE__ */ e("label", { className: "block text-sm font-medium mb-2", children: s.events }),
        /* @__PURE__ */ e("div", { className: "space-y-3 max-h-60 overflow-y-auto", children: Object.entries(q).map(([k, W]) => /* @__PURE__ */ t("div", { children: [
          /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground font-medium", children: k }),
          /* @__PURE__ */ e("div", { className: "mt-1 space-y-1", children: W.map((re) => /* @__PURE__ */ t(
            "button",
            {
              type: "button",
              className: l(
                "w-full flex items-center justify-between px-3 py-2 rounded text-sm",
                "hover:bg-muted/50 transition-colors",
                $.has(re.id) && "bg-primary/10 text-primary"
              ),
              onClick: () => se(re.id),
              children: [
                /* @__PURE__ */ t("div", { className: "text-left", children: [
                  /* @__PURE__ */ e("div", { className: "font-medium", children: re.name }),
                  re.description && /* @__PURE__ */ e("div", { className: "text-xs text-muted-foreground", children: re.description })
                ] }),
                $.has(re.id) && /* @__PURE__ */ e(Ye, { className: "h-4 w-4" })
              ]
            },
            re.id
          )) })
        ] }, k)) })
      ] }),
      /* @__PURE__ */ t("div", { children: [
        /* @__PURE__ */ t("div", { className: "flex items-center justify-between mb-2", children: [
          /* @__PURE__ */ e("label", { className: "text-sm font-medium", children: s.headers }),
          /* @__PURE__ */ t(u, { variant: "ghost", size: "sm", onClick: oe, children: [
            /* @__PURE__ */ e(Pe, { className: "h-4 w-4 mr-1" }),
            "Add Header"
          ] })
        ] }),
        x.map((k, W) => /* @__PURE__ */ t("div", { className: "flex items-center gap-2 mb-2", children: [
          /* @__PURE__ */ e(
            ue,
            {
              type: "text",
              placeholder: "Header name",
              value: k.key,
              onChange: (re) => Z(W, "key", re.target.value),
              className: "flex-1"
            }
          ),
          /* @__PURE__ */ e(
            ue,
            {
              type: "text",
              placeholder: "Value",
              value: k.value,
              onChange: (re) => Z(W, "value", re.target.value),
              className: "flex-1"
            }
          ),
          /* @__PURE__ */ e(u, { variant: "ghost", size: "sm", onClick: () => V(W), children: /* @__PURE__ */ e(Re, { className: "h-4 w-4" }) })
        ] }, W))
      ] }),
      /* @__PURE__ */ t("div", { className: "flex items-center gap-2 justify-end", children: [
        /* @__PURE__ */ e(u, { variant: "ghost", onClick: I, children: s.cancel }),
        /* @__PURE__ */ e(
          u,
          {
            variant: "primary",
            onClick: ie,
            disabled: !L.trim() || !Q.trim() || $.size === 0,
            children: d ? s.update : s.create
          }
        )
      ] })
    ] })
  ] }), ee = (k) => {
    const W = ui[k.status], re = K.has(k.id), ge = h.has(k.id), ke = U.has(k.id);
    return /* @__PURE__ */ t(ne, { className: "overflow-hidden", children: [
      /* @__PURE__ */ e(
        "div",
        {
          className: "p-4 cursor-pointer hover:bg-muted/30 transition-colors",
          onClick: () => X(k.id),
          children: /* @__PURE__ */ t("div", { className: "flex items-center justify-between", children: [
            /* @__PURE__ */ t("div", { className: "flex items-center gap-3", children: [
              /* @__PURE__ */ e("div", { className: l("rounded-full p-2", W.bgColor, W.color), children: /* @__PURE__ */ e(Ct, { className: "h-4 w-4" }) }),
              /* @__PURE__ */ t("div", { children: [
                /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
                  /* @__PURE__ */ e(a, { variant: "body", className: "font-medium", children: k.name }),
                  /* @__PURE__ */ t(ae, { variant: "default", className: l("text-xs", W.color, W.bgColor), children: [
                    W.icon,
                    /* @__PURE__ */ e("span", { className: "ml-1", children: s[k.status] })
                  ] })
                ] }),
                /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: k.url })
              ] })
            ] }),
            /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
              k.successRate !== void 0 && /* @__PURE__ */ t(
                ae,
                {
                  variant: "default",
                  className: l(
                    "text-xs",
                    k.successRate >= 95 ? "bg-green-100 text-green-700" : k.successRate >= 80 ? "bg-yellow-100 text-yellow-700" : "bg-red-100 text-red-700"
                  ),
                  children: [
                    k.successRate.toFixed(1),
                    "% success"
                  ]
                }
              ),
              re ? /* @__PURE__ */ e(Ie, { className: "h-4 w-4 text-muted-foreground" }) : /* @__PURE__ */ e(xe, { className: "h-4 w-4 text-muted-foreground" })
            ] })
          ] })
        }
      ),
      re && /* @__PURE__ */ t("div", { className: "border-t px-4 py-4 space-y-4", children: [
        /* @__PURE__ */ t("div", { children: [
          /* @__PURE__ */ e(a, { variant: "caption", className: "font-medium text-muted-foreground", children: "Subscribed Events" }),
          /* @__PURE__ */ e("div", { className: "flex flex-wrap gap-1 mt-1", children: k.events.map((B) => /* @__PURE__ */ e(ae, { variant: "default", className: "text-xs", children: B }, B)) })
        ] }),
        k.secret && /* @__PURE__ */ t("div", { children: [
          /* @__PURE__ */ e(a, { variant: "caption", className: "font-medium text-muted-foreground", children: "Secret" }),
          /* @__PURE__ */ t("div", { className: "flex items-center gap-2 mt-1", children: [
            /* @__PURE__ */ e("code", { className: "text-sm bg-muted px-2 py-1 rounded font-mono", children: ke ? k.secret : "••••••••••••" }),
            /* @__PURE__ */ e(
              u,
              {
                variant: "ghost",
                size: "sm",
                onClick: () => H(k.id),
                children: ke ? /* @__PURE__ */ e(It, { className: "h-4 w-4" }) : /* @__PURE__ */ e(Ve, { className: "h-4 w-4" })
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ t("div", { className: "flex items-center gap-4 text-xs text-muted-foreground", children: [
          /* @__PURE__ */ t("span", { className: "flex items-center gap-1", children: [
            /* @__PURE__ */ e(Me, { className: "h-3 w-3" }),
            "Created: ",
            ce(k.createdAt)
          ] }),
          k.lastTriggeredAt && /* @__PURE__ */ t("span", { className: "flex items-center gap-1", children: [
            /* @__PURE__ */ e(tt, { className: "h-3 w-3" }),
            "Last triggered: ",
            ce(k.lastTriggeredAt)
          ] }),
          k.deliveryCount !== void 0 && /* @__PURE__ */ t("span", { children: [
            k.deliveryCount.toLocaleString(),
            " deliveries"
          ] })
        ] }),
        _ && k.recentDeliveries && k.recentDeliveries.length > 0 && /* @__PURE__ */ t("div", { children: [
          /* @__PURE__ */ e(a, { variant: "caption", className: "font-medium text-muted-foreground", children: s.deliveryHistory }),
          /* @__PURE__ */ e("div", { className: "mt-2 space-y-2", children: k.recentDeliveries.slice(0, 5).map((B) => /* @__PURE__ */ t(
            "div",
            {
              className: "flex items-center justify-between p-2 bg-muted/30 rounded",
              children: [
                /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
                  B.status === "success" ? /* @__PURE__ */ e(Ye, { className: "h-4 w-4 text-green-500" }) : B.status === "failed" ? /* @__PURE__ */ e(et, { className: "h-4 w-4 text-red-500" }) : /* @__PURE__ */ e(ye, { className: "h-4 w-4 animate-spin text-blue-500" }),
                  /* @__PURE__ */ e("span", { className: "text-sm", children: B.event }),
                  B.statusCode && /* @__PURE__ */ e(ae, { variant: "default", className: "text-xs", children: B.statusCode }),
                  B.responseTime && /* @__PURE__ */ t("span", { className: "text-xs text-muted-foreground", children: [
                    B.responseTime,
                    "ms"
                  ] })
                ] }),
                /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
                  /* @__PURE__ */ e("span", { className: "text-xs text-muted-foreground", children: ce(B.timestamp) }),
                  B.status === "failed" && N && /* @__PURE__ */ e(
                    u,
                    {
                      variant: "ghost",
                      size: "sm",
                      onClick: () => N(k.id, B.id),
                      children: /* @__PURE__ */ e(Xe, { className: "h-3 w-3" })
                    }
                  ),
                  y && /* @__PURE__ */ e(
                    u,
                    {
                      variant: "ghost",
                      size: "sm",
                      onClick: () => y(B),
                      children: /* @__PURE__ */ e(at, { className: "h-3 w-3" })
                    }
                  )
                ] })
              ]
            },
            B.id
          )) })
        ] }),
        /* @__PURE__ */ t("div", { className: "flex items-center gap-2 pt-2 border-t", children: [
          w && E && /* @__PURE__ */ t(
            u,
            {
              variant: "outline",
              size: "sm",
              onClick: () => R(k.id),
              disabled: ge || k.status !== "active",
              isLoading: ge,
              children: [
                /* @__PURE__ */ e(tt, { className: "h-4 w-4 mr-1" }),
                s.test
              ]
            }
          ),
          D && /* @__PURE__ */ e(
            u,
            {
              variant: "outline",
              size: "sm",
              onClick: () => D(
                k.id,
                k.status === "active" ? "paused" : "active"
              ),
              children: k.status === "active" ? /* @__PURE__ */ t(me, { children: [
                /* @__PURE__ */ e(la, { className: "h-4 w-4 mr-1" }),
                s.pause
              ] }) : /* @__PURE__ */ t(me, { children: [
                /* @__PURE__ */ e(ka, { className: "h-4 w-4 mr-1" }),
                s.resume
              ] })
            }
          ),
          p && /* @__PURE__ */ t(u, { variant: "outline", size: "sm", onClick: () => de(k), children: [
            /* @__PURE__ */ e(Na, { className: "h-4 w-4 mr-1" }),
            "Edit"
          ] }),
          j && /* @__PURE__ */ t(
            u,
            {
              variant: "ghost",
              size: "sm",
              className: "text-red-600 hover:text-red-700",
              onClick: () => j(k.id),
              children: [
                /* @__PURE__ */ e(Re, { className: "h-4 w-4 mr-1" }),
                s.delete
              ]
            }
          )
        ] })
      ] })
    ] }, k.id);
  };
  return /* @__PURE__ */ t("div", { className: l("space-y-4", S), children: [
    /* @__PURE__ */ t("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ e(Ct, { className: "h-5 w-5 text-primary" }),
        /* @__PURE__ */ e(a, { variant: "h4", className: "font-semibold", children: s.title }),
        /* @__PURE__ */ t(ae, { variant: "default", children: [
          r.length,
          " webhooks"
        ] })
      ] }),
      O && n && !g && !d && /* @__PURE__ */ t(u, { variant: "primary", onClick: () => m(!0), disabled: A, children: [
        /* @__PURE__ */ e(Pe, { className: "h-4 w-4 mr-1" }),
        s.createWebhook
      ] })
    ] }),
    (g || d) && le(),
    A ? /* @__PURE__ */ e("div", { className: "flex items-center justify-center py-12", children: /* @__PURE__ */ e(ye, { className: "h-8 w-8 animate-spin text-primary" }) }) : r.length === 0 ? /* @__PURE__ */ t(ne, { className: "p-8 text-center", children: [
      /* @__PURE__ */ e(Ct, { className: "h-12 w-12 text-muted-foreground mx-auto mb-4" }),
      /* @__PURE__ */ e(a, { variant: "body", className: "text-muted-foreground", children: s.noWebhooks }),
      /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground mt-1", children: "Create your first webhook to receive real-time event notifications" })
    ] }) : /* @__PURE__ */ e("div", { className: "space-y-3", children: r.map(ee) })
  ] });
};
pi.displayName = "WebhookConfigurator";
const fi = {
  title: "Audit Log",
  search: "Search events...",
  filters: "Filters",
  export: "Export",
  noEvents: "No audit events found",
  viewDetails: "View Details",
  copyId: "Copy ID",
  showing: "Showing",
  of: "of",
  events: "events",
  clearFilters: "Clear filters"
}, ra = {
  info: {
    color: "text-blue-600 dark:text-blue-400",
    bgColor: "bg-blue-100 dark:bg-blue-900/30"
  },
  warning: {
    color: "text-yellow-600 dark:text-yellow-400",
    bgColor: "bg-yellow-100 dark:bg-yellow-900/30"
  },
  error: {
    color: "text-red-600 dark:text-red-400",
    bgColor: "bg-red-100 dark:bg-red-900/30"
  },
  critical: {
    color: "text-purple-600 dark:text-purple-400",
    bgColor: "bg-purple-100 dark:bg-purple-900/30"
  }
}, sa = {
  auth: /* @__PURE__ */ e(nt, { className: "h-4 w-4" }),
  data: /* @__PURE__ */ e(rt, { className: "h-4 w-4" }),
  system: /* @__PURE__ */ e(Oe, { className: "h-4 w-4" }),
  security: /* @__PURE__ */ e(Ue, { className: "h-4 w-4" }),
  admin: /* @__PURE__ */ e(Oe, { className: "h-4 w-4" }),
  user: /* @__PURE__ */ e(ft, { className: "h-4 w-4" })
}, gi = ({
  events: r,
  totalCount: C,
  currentPage: i = 1,
  pageSize: n = 25,
  filters: p = {},
  availableActions: j = [],
  availableActors: D = [],
  onFiltersChange: E,
  onPageChange: y,
  onExport: N,
  onViewDetails: A,
  onCopyEventId: _,
  isLoading: w = !1,
  showFilters: s = !0,
  showExport: S = !0,
  showPagination: g = !0,
  expandable: m = !0,
  labels: d = fi,
  className: M
}) => {
  const [K, Y] = P(/* @__PURE__ */ new Set()), [h, z] = P(!1), [U, T] = P(p.search || ""), [L, G] = P(
    new Set(p.categories || [])
  ), [Q, v] = P(
    new Set(p.severities || [])
  ), [b, c] = P(null), $ = C ? Math.ceil(C / n) : 1, o = (i - 1) * n + 1, x = Math.min(i * n, C || r.length), f = te((R) => {
    m && Y((H) => {
      const ce = new Set(H);
      return ce.has(R) ? ce.delete(R) : ce.add(R), ce;
    });
  }, [m]), O = te(() => {
    E == null || E({
      ...p,
      search: U || void 0
    });
  }, [U, p, E]), F = te(
    (R) => {
      R.key === "Enter" && O();
    },
    [O]
  ), de = te(
    (R) => {
      const H = new Set(L);
      H.has(R) ? H.delete(R) : H.add(R), G(H), E == null || E({
        ...p,
        categories: H.size > 0 ? Array.from(H) : void 0
      });
    },
    [L, p, E]
  ), I = te(
    (R) => {
      const H = new Set(Q);
      H.has(R) ? H.delete(R) : H.add(R), v(H), E == null || E({
        ...p,
        severities: H.size > 0 ? Array.from(H) : void 0
      });
    },
    [Q, p, E]
  ), se = te(() => {
    T(""), G(/* @__PURE__ */ new Set()), v(/* @__PURE__ */ new Set()), E == null || E({});
  }, [E]), oe = te(
    async (R) => {
      await navigator.clipboard.writeText(R), c(R), _ == null || _(R), setTimeout(() => c(null), 2e3);
    },
    [_]
  ), Z = (R) => new Date(R).toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  }), V = (R) => {
    const ce = (/* @__PURE__ */ new Date()).getTime() - new Date(R).getTime(), q = Math.floor(ce / 1e3), le = Math.floor(q / 60), ee = Math.floor(le / 60), k = Math.floor(ee / 24);
    return q < 60 ? "Just now" : le < 60 ? `${le}m ago` : ee < 24 ? `${ee}h ago` : k < 7 ? `${k}d ago` : Z(R);
  }, ie = U || L.size > 0 || Q.size > 0, X = (R) => {
    const H = ra[R.severity], ce = K.has(R.id), q = b === R.id;
    return /* @__PURE__ */ t("div", { className: "border-b last:border-b-0", children: [
      /* @__PURE__ */ t(
        "div",
        {
          className: l(
            "flex items-center gap-4 px-4 py-3",
            "hover:bg-muted/30 transition-colors",
            m && "cursor-pointer"
          ),
          onClick: () => f(R.id),
          children: [
            /* @__PURE__ */ e("div", { className: l("w-1 h-8 rounded-full", H.bgColor) }),
            /* @__PURE__ */ e("div", { className: l("rounded-full p-2", H.bgColor, H.color), children: sa[R.category] }),
            /* @__PURE__ */ t("div", { className: "flex-1 min-w-0", children: [
              /* @__PURE__ */ t("div", { className: "flex items-center gap-2 flex-wrap", children: [
                /* @__PURE__ */ e(a, { variant: "body", className: "font-medium", children: R.action }),
                /* @__PURE__ */ e(ae, { variant: "default", className: "text-xs", children: R.category }),
                /* @__PURE__ */ e(ae, { variant: "default", className: l("text-xs", H.color, H.bgColor), children: R.severity })
              ] }),
              /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground truncate", children: R.description })
            ] }),
            /* @__PURE__ */ t("div", { className: "hidden md:flex items-center gap-2 min-w-[150px]", children: [
              /* @__PURE__ */ e(ft, { className: "h-4 w-4 text-muted-foreground" }),
              /* @__PURE__ */ t("div", { className: "truncate", children: [
                /* @__PURE__ */ e(a, { variant: "caption", className: "font-medium", children: R.actor.name }),
                R.actor.email && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground block", children: R.actor.email })
              ] })
            ] }),
            /* @__PURE__ */ e("div", { className: "hidden lg:block min-w-[100px] text-right", children: /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: V(R.timestamp) }) }),
            m && /* @__PURE__ */ e("div", { className: "text-muted-foreground", children: ce ? /* @__PURE__ */ e(Ie, { className: "h-4 w-4" }) : /* @__PURE__ */ e(xe, { className: "h-4 w-4" }) })
          ]
        }
      ),
      m && ce && /* @__PURE__ */ t("div", { className: "px-4 pb-4 bg-muted/20", children: [
        /* @__PURE__ */ t("div", { className: "grid grid-cols-1 md:grid-cols-2 gap-4 pt-4", children: [
          /* @__PURE__ */ t("div", { className: "space-y-3", children: [
            /* @__PURE__ */ t("div", { children: [
              /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground font-medium", children: "Event ID" }),
              /* @__PURE__ */ t("div", { className: "flex items-center gap-2 mt-1", children: [
                /* @__PURE__ */ e("code", { className: "text-xs bg-muted px-2 py-1 rounded font-mono", children: R.id }),
                /* @__PURE__ */ e(
                  u,
                  {
                    variant: "ghost",
                    size: "sm",
                    onClick: (le) => {
                      le.stopPropagation(), oe(R.id);
                    },
                    children: q ? /* @__PURE__ */ e(Ye, { className: "h-3 w-3 text-green-500" }) : /* @__PURE__ */ e(Ke, { className: "h-3 w-3" })
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ t("div", { children: [
              /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground font-medium", children: "Timestamp" }),
              /* @__PURE__ */ t("div", { className: "flex items-center gap-1 mt-1", children: [
                /* @__PURE__ */ e(Me, { className: "h-3 w-3 text-muted-foreground" }),
                /* @__PURE__ */ e(a, { variant: "caption", children: Z(R.timestamp) })
              ] })
            ] }),
            R.requestId && /* @__PURE__ */ t("div", { children: [
              /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground font-medium", children: "Request ID" }),
              /* @__PURE__ */ e("code", { className: "text-xs bg-muted px-2 py-1 rounded font-mono block mt-1", children: R.requestId })
            ] })
          ] }),
          /* @__PURE__ */ t("div", { className: "space-y-3", children: [
            /* @__PURE__ */ t("div", { children: [
              /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground font-medium", children: "Actor" }),
              /* @__PURE__ */ t("div", { className: "mt-1 space-y-1", children: [
                /* @__PURE__ */ t("div", { className: "flex items-center gap-1", children: [
                  /* @__PURE__ */ e(ft, { className: "h-3 w-3 text-muted-foreground" }),
                  /* @__PURE__ */ t(a, { variant: "caption", children: [
                    R.actor.name,
                    " (",
                    R.actor.type,
                    ")"
                  ] })
                ] }),
                R.actor.ipAddress && /* @__PURE__ */ t("div", { className: "flex items-center gap-1", children: [
                  /* @__PURE__ */ e(Gr, { className: "h-3 w-3 text-muted-foreground" }),
                  /* @__PURE__ */ e(a, { variant: "caption", children: R.actor.ipAddress }),
                  R.actor.location && /* @__PURE__ */ t(a, { variant: "caption", className: "text-muted-foreground", children: [
                    "(",
                    R.actor.location,
                    ")"
                  ] })
                ] }),
                R.actor.userAgent && /* @__PURE__ */ t("div", { className: "flex items-center gap-1", children: [
                  /* @__PURE__ */ e(xa, { className: "h-3 w-3 text-muted-foreground" }),
                  /* @__PURE__ */ e(a, { variant: "caption", className: "truncate", children: R.actor.userAgent })
                ] })
              ] })
            ] }),
            R.target && /* @__PURE__ */ t("div", { children: [
              /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground font-medium", children: "Target" }),
              /* @__PURE__ */ e("div", { className: "mt-1", children: /* @__PURE__ */ t(a, { variant: "caption", children: [
                R.target.type,
                ": ",
                R.target.name || R.target.id
              ] }) })
            ] })
          ] })
        ] }),
        R.changes && R.changes.length > 0 && /* @__PURE__ */ t("div", { className: "mt-4", children: [
          /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground font-medium", children: "Changes" }),
          /* @__PURE__ */ e("div", { className: "mt-2 space-y-2", children: R.changes.map((le, ee) => /* @__PURE__ */ t(
            "div",
            {
              className: "flex items-center gap-4 text-xs bg-muted/50 p-2 rounded",
              children: [
                /* @__PURE__ */ e("span", { className: "font-medium min-w-[100px]", children: le.field }),
                /* @__PURE__ */ e("span", { className: "text-red-600 line-through", children: JSON.stringify(le.oldValue) }),
                /* @__PURE__ */ e("span", { children: "→" }),
                /* @__PURE__ */ e("span", { className: "text-green-600", children: JSON.stringify(le.newValue) })
              ]
            },
            ee
          )) })
        ] }),
        R.metadata && Object.keys(R.metadata).length > 0 && /* @__PURE__ */ t("div", { className: "mt-4", children: [
          /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground font-medium", children: "Metadata" }),
          /* @__PURE__ */ e("pre", { className: "mt-2 text-xs bg-muted p-2 rounded overflow-x-auto", children: JSON.stringify(R.metadata, null, 2) })
        ] }),
        /* @__PURE__ */ e("div", { className: "flex items-center gap-2 mt-4 pt-4 border-t", children: A && /* @__PURE__ */ t(
          u,
          {
            variant: "outline",
            size: "sm",
            onClick: (le) => {
              le.stopPropagation(), A(R);
            },
            children: [
              /* @__PURE__ */ e(at, { className: "h-4 w-4 mr-1" }),
              d.viewDetails
            ]
          }
        ) })
      ] })
    ] }, R.id);
  };
  return /* @__PURE__ */ t("div", { className: l("space-y-4", M), children: [
    /* @__PURE__ */ t("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ e(Ge, { className: "h-5 w-5 text-primary" }),
        /* @__PURE__ */ e(a, { variant: "h4", className: "font-semibold", children: d.title }),
        C !== void 0 && /* @__PURE__ */ t(ae, { variant: "default", children: [
          C.toLocaleString(),
          " ",
          d.events
        ] })
      ] }),
      /* @__PURE__ */ e("div", { className: "flex items-center gap-2", children: S && N && /* @__PURE__ */ t("div", { className: "relative group", children: [
        /* @__PURE__ */ t(u, { variant: "outline", size: "sm", children: [
          /* @__PURE__ */ e(_e, { className: "h-4 w-4 mr-1" }),
          d.export,
          /* @__PURE__ */ e(xe, { className: "h-4 w-4 ml-1" })
        ] }),
        /* @__PURE__ */ e("div", { className: "absolute right-0 top-full mt-1 hidden group-hover:block", children: /* @__PURE__ */ t(ne, { className: "p-1 shadow-lg", children: [
          /* @__PURE__ */ e(
            "button",
            {
              type: "button",
              className: "w-full px-3 py-2 text-sm hover:bg-muted rounded text-left",
              onClick: () => N("csv"),
              children: "Export as CSV"
            }
          ),
          /* @__PURE__ */ e(
            "button",
            {
              type: "button",
              className: "w-full px-3 py-2 text-sm hover:bg-muted rounded text-left",
              onClick: () => N("json"),
              children: "Export as JSON"
            }
          )
        ] }) })
      ] }) })
    ] }),
    s && /* @__PURE__ */ t(ne, { className: "p-4", children: [
      /* @__PURE__ */ t("div", { className: "flex items-center gap-4", children: [
        /* @__PURE__ */ t("div", { className: "flex-1 relative", children: [
          /* @__PURE__ */ e(we, { className: "absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" }),
          /* @__PURE__ */ e(
            ue,
            {
              type: "text",
              placeholder: d.search,
              value: U,
              onChange: (R) => T(R.target.value),
              onKeyDown: F,
              className: "pl-10"
            }
          )
        ] }),
        /* @__PURE__ */ t(
          u,
          {
            variant: h ? "primary" : "outline",
            onClick: () => z(!h),
            children: [
              /* @__PURE__ */ e(Je, { className: "h-4 w-4 mr-1" }),
              d.filters,
              ie && /* @__PURE__ */ e(ae, { variant: "default", className: "ml-1", children: (L.size || 0) + (Q.size || 0) })
            ]
          }
        )
      ] }),
      h && /* @__PURE__ */ t("div", { className: "mt-4 pt-4 border-t space-y-4", children: [
        /* @__PURE__ */ t("div", { children: [
          /* @__PURE__ */ e(a, { variant: "caption", className: "font-medium text-muted-foreground mb-2 block", children: "Categories" }),
          /* @__PURE__ */ e("div", { className: "flex flex-wrap gap-2", children: ["auth", "data", "system", "security", "admin", "user"].map(
            (R) => /* @__PURE__ */ t(
              u,
              {
                variant: L.has(R) ? "primary" : "outline",
                size: "sm",
                onClick: () => de(R),
                children: [
                  sa[R],
                  /* @__PURE__ */ e("span", { className: "ml-1 capitalize", children: R })
                ]
              },
              R
            )
          ) })
        ] }),
        /* @__PURE__ */ t("div", { children: [
          /* @__PURE__ */ e(a, { variant: "caption", className: "font-medium text-muted-foreground mb-2 block", children: "Severity" }),
          /* @__PURE__ */ e("div", { className: "flex flex-wrap gap-2", children: ["info", "warning", "error", "critical"].map(
            (R) => {
              const H = ra[R];
              return /* @__PURE__ */ e(
                u,
                {
                  variant: Q.has(R) ? "primary" : "outline",
                  size: "sm",
                  className: l(!Q.has(R) && H.color),
                  onClick: () => I(R),
                  children: /* @__PURE__ */ e("span", { className: "capitalize", children: R })
                },
                R
              );
            }
          ) })
        ] }),
        ie && /* @__PURE__ */ t(u, { variant: "ghost", size: "sm", onClick: se, children: [
          /* @__PURE__ */ e(he, { className: "h-4 w-4 mr-1" }),
          d.clearFilters
        ] })
      ] })
    ] }),
    /* @__PURE__ */ e(ne, { className: "overflow-hidden", children: w ? /* @__PURE__ */ e("div", { className: "flex items-center justify-center py-12", children: /* @__PURE__ */ e(ye, { className: "h-8 w-8 animate-spin text-primary" }) }) : r.length === 0 ? /* @__PURE__ */ t("div", { className: "p-8 text-center", children: [
      /* @__PURE__ */ e(Ge, { className: "h-12 w-12 text-muted-foreground mx-auto mb-4" }),
      /* @__PURE__ */ e(a, { variant: "body", className: "text-muted-foreground", children: d.noEvents })
    ] }) : /* @__PURE__ */ e("div", { className: "divide-y", children: r.map(X) }) }),
    g && C !== void 0 && C > n && /* @__PURE__ */ t("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ t(a, { variant: "caption", className: "text-muted-foreground", children: [
        d.showing,
        " ",
        o,
        "-",
        x,
        " ",
        d.of,
        " ",
        C.toLocaleString(),
        " ",
        d.events
      ] }),
      /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ e(
          u,
          {
            variant: "outline",
            size: "sm",
            onClick: () => y == null ? void 0 : y(i - 1),
            disabled: i === 1,
            children: /* @__PURE__ */ e(vt, { className: "h-4 w-4" })
          }
        ),
        /* @__PURE__ */ t(a, { variant: "caption", children: [
          "Page ",
          i,
          " of ",
          $
        ] }),
        /* @__PURE__ */ e(
          u,
          {
            variant: "outline",
            size: "sm",
            onClick: () => y == null ? void 0 : y(i + 1),
            disabled: i === $,
            children: /* @__PURE__ */ e(Ne, { className: "h-4 w-4" })
          }
        )
      ] })
    ] })
  ] });
};
gi.displayName = "AuditLogViewer";
const vi = {
  title: "Workspaces",
  search: "Search workspaces...",
  createWorkspace: "Create Workspace",
  personal: "Personal",
  settings: "Settings",
  manageMembers: "Members",
  leave: "Leave",
  pin: "Pin",
  unpin: "Unpin",
  noWorkspaces: "No workspaces found",
  showMore: "Show more",
  current: "Current"
}, xi = {
  free: {
    color: "text-muted-foreground",
    bgColor: "bg-muted",
    label: "Free"
  },
  starter: {
    color: "text-primary",
    bgColor: "bg-primary/15",
    label: "Starter"
  },
  pro: {
    color: "text-accent-foreground",
    bgColor: "bg-accent",
    label: "Pro"
  },
  enterprise: {
    color: "text-warning",
    bgColor: "bg-warning/15",
    label: "Enterprise"
  }
}, Ni = {
  owner: { icon: /* @__PURE__ */ e(lr, { className: "h-3 w-3" }), label: "Owner" },
  admin: { icon: /* @__PURE__ */ e(Oe, { className: "h-3 w-3" }), label: "Admin" },
  member: { icon: /* @__PURE__ */ e(Se, { className: "h-3 w-3" }), label: "Member" },
  guest: { icon: /* @__PURE__ */ e(Pt, { className: "h-3 w-3" }), label: "Guest" }
}, bi = ({
  workspaces: r,
  currentWorkspace: C,
  personalWorkspace: i,
  onSwitch: n,
  onCreate: p,
  onSettings: j,
  onManageMembers: D,
  onTogglePin: E,
  onLeave: y,
  isLoading: N = !1,
  isSwitching: A = !1,
  showSearch: _ = !0,
  showMemberCount: w = !0,
  showPlan: s = !0,
  showLastAccessed: S = !1,
  maxVisible: g = 10,
  labels: m = vi,
  triggerStyle: d = "dropdown",
  className: M
}) => {
  const [K, Y] = P(""), [h, z] = P(!1), [U, T] = P(null), L = Ce(() => {
    let c = r;
    if (K.trim()) {
      const $ = K.toLowerCase();
      c = c.filter(
        (o) => {
          var x;
          return o.name.toLowerCase().includes($) || ((x = o.slug) == null ? void 0 : x.toLowerCase().includes($));
        }
      );
    }
    return [...c].sort(($, o) => $.isPinned && !o.isPinned ? -1 : !$.isPinned && o.isPinned ? 1 : $.lastAccessedAt && o.lastAccessedAt ? new Date(o.lastAccessedAt).getTime() - new Date($.lastAccessedAt).getTime() : $.name.localeCompare(o.name));
  }, [r, K]), G = Ce(() => h ? L : L.slice(0, g), [L, h, g]), Q = (c) => {
    const o = (/* @__PURE__ */ new Date()).getTime() - new Date(c).getTime(), x = Math.floor(o / (1e3 * 60 * 60)), f = Math.floor(x / 24);
    return x < 1 ? "Just now" : x < 24 ? `${x}h ago` : f < 7 ? `${f}d ago` : new Date(c).toLocaleDateString();
  }, v = (c) => c.split(" ").map(($) => $[0]).join("").toUpperCase().slice(0, 2), b = (c) => {
    const $ = (C == null ? void 0 : C.id) === c.id, o = U === c.id, x = xi[c.plan], f = Ni[c.role];
    return /* @__PURE__ */ t(
      "div",
      {
        className: l(
          "relative flex items-center gap-3 p-3 rounded-lg transition-all",
          "hover:bg-muted/50",
          $ && "bg-primary/10 ring-1 ring-primary/20"
        ),
        onMouseEnter: () => T(c.id),
        onMouseLeave: () => T(null),
        children: [
          /* @__PURE__ */ e(
            "div",
            {
              className: l(
                "w-10 h-10 rounded-lg flex items-center justify-center shrink-0",
                "text-sm font-semibold",
                c.logo ? "" : "bg-muted"
              ),
              children: c.logo ? /* @__PURE__ */ e(
                "img",
                {
                  src: c.logo,
                  alt: c.name,
                  className: "w-full h-full rounded-lg object-cover"
                }
              ) : c.isPersonal ? /* @__PURE__ */ e(Vt, { className: "h-5 w-5 text-muted-foreground" }) : v(c.name)
            }
          ),
          /* @__PURE__ */ t(
            "div",
            {
              className: "flex-1 min-w-0 cursor-pointer",
              onClick: () => !A && (n == null ? void 0 : n(c)),
              children: [
                /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
                  /* @__PURE__ */ e(a, { variant: "body", className: "font-medium truncate", children: c.name }),
                  c.isPinned && /* @__PURE__ */ e($e, { className: "h-3 w-3 fill-warning text-warning" }),
                  $ && /* @__PURE__ */ e(ae, { variant: "default", className: "text-xs bg-primary/20 text-primary", children: m.current })
                ] }),
                /* @__PURE__ */ t("div", { className: "flex items-center gap-2 mt-0.5", children: [
                  s && /* @__PURE__ */ e(ae, { variant: "default", className: l("text-xs", x.color, x.bgColor), children: x.label }),
                  /* @__PURE__ */ t("span", { className: l("flex items-center gap-0.5 text-xs", f.icon && "text-muted-foreground"), children: [
                    f.icon,
                    f.label
                  ] }),
                  w && c.memberCount !== void 0 && /* @__PURE__ */ t("span", { className: "flex items-center gap-0.5 text-xs text-muted-foreground", children: [
                    /* @__PURE__ */ e(Se, { className: "h-3 w-3" }),
                    c.memberCount
                  ] }),
                  S && c.lastAccessedAt && /* @__PURE__ */ e("span", { className: "text-xs text-muted-foreground", children: Q(c.lastAccessedAt) })
                ] })
              ]
            }
          ),
          o && !$ && /* @__PURE__ */ e("div", { className: "flex items-center gap-1", children: n && /* @__PURE__ */ e(
            u,
            {
              variant: "ghost",
              size: "sm",
              onClick: () => n(c),
              disabled: A,
              children: /* @__PURE__ */ e(Fe, { className: "h-4 w-4" })
            }
          ) }),
          $ && /* @__PURE__ */ e(fe, { className: "h-5 w-5 text-primary shrink-0" }),
          (o || $) && (j || D || E || y) && /* @__PURE__ */ e("div", { className: "absolute right-2 top-2 flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity", children: j && /* @__PURE__ */ e(
            u,
            {
              variant: "ghost",
              size: "sm",
              onClick: (O) => {
                O.stopPropagation(), j(c);
              },
              children: /* @__PURE__ */ e(Oe, { className: "h-3 w-3" })
            }
          ) })
        ]
      },
      c.id
    );
  };
  return /* @__PURE__ */ t(ne, { className: l("overflow-hidden", M), variant: "elevated", children: [
    /* @__PURE__ */ t("div", { className: "p-4 border-b", children: [
      /* @__PURE__ */ t("div", { className: "flex items-center justify-between mb-3", children: [
        /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ e(Vt, { className: "h-5 w-5 text-primary" }),
          /* @__PURE__ */ e(a, { variant: "h4", className: "font-semibold", children: m.title })
        ] }),
        p && /* @__PURE__ */ t(u, { variant: "ghost", size: "sm", onClick: p, children: [
          /* @__PURE__ */ e(Pe, { className: "h-4 w-4 mr-1" }),
          m.createWorkspace
        ] })
      ] }),
      _ && /* @__PURE__ */ t("div", { className: "relative", children: [
        /* @__PURE__ */ e(we, { className: "absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" }),
        /* @__PURE__ */ e(
          ue,
          {
            type: "text",
            placeholder: m.search,
            value: K,
            onChange: (c) => Y(c.target.value),
            className: "pl-10"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ e("div", { className: "p-2 max-h-[400px] overflow-y-auto", children: N ? /* @__PURE__ */ e("div", { className: "flex items-center justify-center py-8", children: /* @__PURE__ */ e(ye, { className: "h-6 w-6 animate-spin text-primary" }) }) : L.length === 0 ? /* @__PURE__ */ t("div", { className: "py-8 text-center", children: [
      /* @__PURE__ */ e(ua, { className: "h-12 w-12 text-muted-foreground mx-auto mb-4" }),
      /* @__PURE__ */ e(a, { variant: "body", className: "text-muted-foreground", children: m.noWorkspaces })
    ] }) : /* @__PURE__ */ t(me, { children: [
      i && !K && /* @__PURE__ */ t("div", { className: "mb-2", children: [
        /* @__PURE__ */ e(a, { variant: "caption", className: "px-3 text-muted-foreground font-medium", children: m.personal }),
        b(i)
      ] }),
      /* @__PURE__ */ e("div", { className: "space-y-1", children: G.filter((c) => !i || c.id !== i.id).map(b) }),
      L.length > g && !h && /* @__PURE__ */ t(
        u,
        {
          variant: "ghost",
          className: "w-full mt-2",
          onClick: () => z(!0),
          children: [
            /* @__PURE__ */ e(xe, { className: "h-4 w-4 mr-1" }),
            m.showMore,
            " (",
            L.length - g,
            " more)"
          ]
        }
      )
    ] }) }),
    C && (j || D || y) && /* @__PURE__ */ e("div", { className: "p-2 border-t bg-muted/30", children: /* @__PURE__ */ t("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: C.name }),
      /* @__PURE__ */ t("div", { className: "flex items-center gap-1", children: [
        j && /* @__PURE__ */ t(
          u,
          {
            variant: "ghost",
            size: "sm",
            onClick: () => j(C),
            children: [
              /* @__PURE__ */ e(Oe, { className: "h-4 w-4 mr-1" }),
              m.settings
            ]
          }
        ),
        D && /* @__PURE__ */ t(
          u,
          {
            variant: "ghost",
            size: "sm",
            onClick: () => D(C),
            children: [
              /* @__PURE__ */ e(Se, { className: "h-4 w-4 mr-1" }),
              m.manageMembers
            ]
          }
        ),
        y && C.role !== "owner" && /* @__PURE__ */ t(
          u,
          {
            variant: "ghost",
            size: "sm",
            className: "text-destructive",
            onClick: () => y(C),
            children: [
              /* @__PURE__ */ e(Wr, { className: "h-4 w-4 mr-1" }),
              m.leave
            ]
          }
        )
      ] })
    ] }) }),
    A && /* @__PURE__ */ e("div", { className: "absolute inset-0 bg-background/80 flex items-center justify-center", children: /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ e(ye, { className: "h-5 w-5 animate-spin text-primary" }),
      /* @__PURE__ */ e(a, { variant: "body", children: "Switching workspace..." })
    ] }) })
  ] });
};
bi.displayName = "WorkspaceSwitcher";
const yi = {
  title: "Preferences",
  theme: "Theme",
  light: "Light",
  dark: "Dark",
  system: "System",
  save: "Save Changes",
  reset: "Reset",
  resetAll: "Reset All",
  unsavedChanges: "You have unsaved changes",
  requiresRestart: "Requires restart",
  experimental: "Experimental"
}, wi = [
  { mode: "light", icon: /* @__PURE__ */ e(Hs, { className: "h-4 w-4" }), label: "Light" },
  { mode: "dark", icon: /* @__PURE__ */ e(ns, { className: "h-4 w-4" }), label: "Dark" },
  { mode: "system", icon: /* @__PURE__ */ e(xa, { className: "h-4 w-4" }), label: "System" }
], ki = ({
  sections: r,
  themeMode: C = "system",
  onThemeChange: i,
  onPreferenceChange: n,
  onSave: p,
  onReset: j,
  onResetSection: D,
  isLoading: E = !1,
  isSaving: y = !1,
  hasChanges: N = !1,
  showThemeSelector: A = !0,
  showSaveButton: _ = !0,
  showResetButton: w = !0,
  compact: s = !1,
  labels: S = yi,
  className: g
}) => {
  const [m, d] = P(
    r.length > 0 ? r[0].id : null
  ), [M, K] = P(/* @__PURE__ */ new Set());
  te((v) => {
    K((b) => {
      const c = new Set(b);
      return c.has(v) ? c.delete(v) : c.add(v), c;
    });
  }, []);
  const Y = (v, b) => /* @__PURE__ */ e(
    "button",
    {
      type: "button",
      className: l(
        "relative inline-flex h-6 w-11 items-center rounded-full transition-colors",
        v.value ? "bg-primary" : "bg-muted",
        v.disabled && "opacity-50 cursor-not-allowed"
      ),
      onClick: () => !v.disabled && (n == null ? void 0 : n(b, v.id, !v.value)),
      disabled: v.disabled,
      children: /* @__PURE__ */ e(
        "span",
        {
          className: l(
            "inline-block h-4 w-4 transform rounded-full bg-white transition-transform",
            v.value ? "translate-x-6" : "translate-x-1"
          )
        }
      )
    }
  ), h = (v, b) => {
    var c;
    return /* @__PURE__ */ e(
      "select",
      {
        value: v.value,
        onChange: ($) => n == null ? void 0 : n(b, v.id, $.target.value),
        disabled: v.disabled,
        className: l(
          "px-3 py-2 rounded-md border bg-background text-sm",
          "focus:outline-none focus:ring-2 focus:ring-primary/20",
          v.disabled && "opacity-50 cursor-not-allowed"
        ),
        children: (c = v.options) == null ? void 0 : c.map(($) => /* @__PURE__ */ e("option", { value: $.value, children: $.label }, $.value))
      }
    );
  }, z = (v, b) => {
    var c;
    return /* @__PURE__ */ e("div", { className: "flex flex-wrap gap-2", children: (c = v.options) == null ? void 0 : c.map(($) => /* @__PURE__ */ t(
      "button",
      {
        type: "button",
        className: l(
          "flex items-center gap-2 px-3 py-2 rounded-md border transition-colors",
          v.value === $.value ? "bg-primary text-primary-foreground border-primary" : "bg-background hover:bg-muted",
          v.disabled && "opacity-50 cursor-not-allowed"
        ),
        onClick: () => !v.disabled && (n == null ? void 0 : n(b, v.id, $.value)),
        disabled: v.disabled,
        children: [
          $.icon,
          /* @__PURE__ */ e("span", { className: "text-sm", children: $.label }),
          v.value === $.value && /* @__PURE__ */ e(fe, { className: "h-4 w-4 ml-1" })
        ]
      },
      $.value
    )) });
  }, U = (v, b) => /* @__PURE__ */ t("div", { className: "flex items-center gap-3", children: [
    /* @__PURE__ */ e(
      "input",
      {
        type: "range",
        min: v.min || 0,
        max: v.max || 100,
        step: v.step || 1,
        value: v.value,
        onChange: (c) => n == null ? void 0 : n(b, v.id, Number(c.target.value)),
        disabled: v.disabled,
        className: l(
          "flex-1 h-2 bg-muted rounded-lg appearance-none cursor-pointer",
          v.disabled && "opacity-50 cursor-not-allowed"
        )
      }
    ),
    /* @__PURE__ */ e("span", { className: "text-sm font-medium min-w-[40px] text-right", children: v.value })
  ] }), T = (v, b) => /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ e(
      "input",
      {
        type: "color",
        value: v.value,
        onChange: (c) => n == null ? void 0 : n(b, v.id, c.target.value),
        disabled: v.disabled,
        className: l(
          "w-10 h-10 rounded-md border cursor-pointer",
          v.disabled && "opacity-50 cursor-not-allowed"
        )
      }
    ),
    /* @__PURE__ */ e(
      ue,
      {
        type: "text",
        value: v.value,
        onChange: (c) => n == null ? void 0 : n(b, v.id, c.target.value),
        disabled: v.disabled,
        className: "w-28 font-mono text-sm"
      }
    )
  ] }), L = (v, b) => /* @__PURE__ */ e(
    ue,
    {
      type: "text",
      value: v.value,
      placeholder: v.placeholder,
      onChange: (c) => n == null ? void 0 : n(b, v.id, c.target.value),
      disabled: v.disabled,
      className: "max-w-xs"
    }
  ), G = (v, b) => /* @__PURE__ */ t(
    "div",
    {
      className: l(
        "flex items-start justify-between gap-4",
        s ? "py-3" : "py-4",
        "border-b last:border-b-0"
      ),
      children: [
        /* @__PURE__ */ t("div", { className: "flex-1 min-w-0", children: [
          /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ e(a, { variant: "body", className: "font-medium", children: v.label }),
            v.requiresRestart && /* @__PURE__ */ t(ae, { variant: "default", className: "text-xs bg-yellow-100 text-yellow-700", children: [
              /* @__PURE__ */ e(ze, { className: "h-3 w-3 mr-1" }),
              S.requiresRestart
            ] }),
            v.experimental && /* @__PURE__ */ e(ae, { variant: "default", className: "text-xs bg-purple-100 text-purple-700", children: S.experimental })
          ] }),
          v.description && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground mt-1", children: v.description })
        ] }),
        /* @__PURE__ */ t("div", { className: "shrink-0", children: [
          v.type === "toggle" && Y(v, b),
          v.type === "select" && h(v, b),
          v.type === "radio" && z(v, b),
          v.type === "range" && U(v, b),
          v.type === "color" && T(v, b),
          v.type === "text" && L(v, b)
        ] })
      ]
    },
    v.id
  ), Q = (v) => {
    const b = m === v.id;
    return /* @__PURE__ */ t(ne, { className: "overflow-hidden", children: [
      /* @__PURE__ */ t(
        "button",
        {
          type: "button",
          className: l(
            "w-full flex items-center justify-between p-4",
            "hover:bg-muted/30 transition-colors",
            "text-left"
          ),
          onClick: () => d(b ? null : v.id),
          children: [
            /* @__PURE__ */ t("div", { className: "flex items-center gap-3", children: [
              v.icon && /* @__PURE__ */ e("div", { className: "text-primary", children: v.icon }),
              /* @__PURE__ */ t("div", { children: [
                /* @__PURE__ */ e(a, { variant: "body", className: "font-medium", children: v.title }),
                v.description && /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: v.description })
              ] })
            ] }),
            /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
              D && /* @__PURE__ */ e(
                u,
                {
                  variant: "ghost",
                  size: "sm",
                  onClick: (c) => {
                    c.stopPropagation(), D(v.id);
                  },
                  className: "opacity-0 group-hover:opacity-100",
                  children: /* @__PURE__ */ e(Qe, { className: "h-4 w-4" })
                }
              ),
              /* @__PURE__ */ e(
                Ne,
                {
                  className: l(
                    "h-5 w-5 text-muted-foreground transition-transform",
                    b && "rotate-90"
                  )
                }
              )
            ] })
          ]
        }
      ),
      b && /* @__PURE__ */ e("div", { className: "px-4 pb-4 border-t", children: v.settings.map((c) => G(c, v.id)) })
    ] }, v.id);
  };
  return /* @__PURE__ */ t("div", { className: l("space-y-4", g), children: [
    /* @__PURE__ */ t("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ e(Oe, { className: "h-5 w-5 text-primary" }),
        /* @__PURE__ */ e(a, { variant: "h4", className: "font-semibold", children: S.title })
      ] }),
      w && j && /* @__PURE__ */ t(u, { variant: "ghost", size: "sm", onClick: j, children: [
        /* @__PURE__ */ e(Qe, { className: "h-4 w-4 mr-1" }),
        S.resetAll
      ] })
    ] }),
    N && /* @__PURE__ */ e(ne, { className: "p-3 border-yellow-200 bg-yellow-50 dark:bg-yellow-900/20", children: /* @__PURE__ */ t("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ e(ze, { className: "h-4 w-4 text-yellow-600" }),
        /* @__PURE__ */ e(a, { variant: "body", className: "text-yellow-800 dark:text-yellow-200", children: S.unsavedChanges })
      ] }),
      _ && p && /* @__PURE__ */ t(u, { variant: "primary", size: "sm", onClick: p, isLoading: y, children: [
        /* @__PURE__ */ e(Tt, { className: "h-4 w-4 mr-1" }),
        S.save
      ] })
    ] }) }),
    A && i && /* @__PURE__ */ e(ne, { className: "p-4", children: /* @__PURE__ */ t("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ t("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ e(us, { className: "h-5 w-5 text-primary" }),
        /* @__PURE__ */ t("div", { children: [
          /* @__PURE__ */ e(a, { variant: "body", className: "font-medium", children: S.theme }),
          /* @__PURE__ */ e(a, { variant: "caption", className: "text-muted-foreground", children: "Choose your preferred color theme" })
        ] })
      ] }),
      /* @__PURE__ */ e("div", { className: "flex items-center gap-1 p-1 bg-muted rounded-lg", children: wi.map((v) => /* @__PURE__ */ t(
        "button",
        {
          type: "button",
          className: l(
            "flex items-center gap-2 px-3 py-2 rounded-md transition-colors",
            C === v.mode ? "bg-background shadow-sm" : "hover:bg-muted-foreground/10"
          ),
          onClick: () => i(v.mode),
          children: [
            v.icon,
            /* @__PURE__ */ e("span", { className: "text-sm", children: S[v.mode] || v.label })
          ]
        },
        v.mode
      )) })
    ] }) }),
    E ? /* @__PURE__ */ e("div", { className: "flex items-center justify-center py-12", children: /* @__PURE__ */ e(ye, { className: "h-8 w-8 animate-spin text-primary" }) }) : (
      /* Preference Sections */
      /* @__PURE__ */ e("div", { className: "space-y-3", children: r.map(Q) })
    ),
    _ && p && N && /* @__PURE__ */ e("div", { className: "sticky bottom-0 pt-4 pb-2 bg-gradient-to-t from-background to-transparent", children: /* @__PURE__ */ t(
      u,
      {
        variant: "primary",
        className: "w-full",
        onClick: p,
        isLoading: y,
        children: [
          /* @__PURE__ */ e(Tt, { className: "h-4 w-4 mr-1" }),
          S.save
        ]
      }
    ) })
  ] });
};
ki.displayName = "PreferencesPanel";
const Ci = {
  next: "Next",
  back: "Back",
  skip: "Skip",
  finish: "Finish",
  dismiss: "Dismiss",
  stepOf: "of",
  startTour: "Start Tour",
  resumeTour: "Resume Tour"
}, Mi = ({
  steps: r,
  tourId: C,
  title: i,
  initialStep: n = 0,
  isActive: p = !1,
  onStart: j,
  onComplete: D,
  onDismiss: E,
  onStepChange: y,
  onProgressUpdate: N,
  showProgress: A = !0,
  showStepNumbers: _ = !0,
  allowSkip: w = !0,
  allowDismiss: s = !0,
  showSpotlight: S = !0,
  spotlightOpacity: g = 0.75,
  autoAdvanceDelay: m = 0,
  labels: d = Ci,
  className: M
}) => {
  const [K, Y] = P(n), [h, z] = P(/* @__PURE__ */ new Set()), [U, T] = P(p), [L, G] = P(null), [Q, v] = P(!1), b = Ee(null), c = Ee(null), $ = r[K], o = K === 0, x = K === r.length - 1, f = (K + 1) / r.length * 100, O = te(() => ({
    tourId: C,
    completedSteps: Array.from(h),
    currentStep: K,
    startedAt: /* @__PURE__ */ new Date(),
    completedAt: x && h.has($ == null ? void 0 : $.id) ? /* @__PURE__ */ new Date() : void 0
  }), [C, h, K, $, x]), F = te(() => {
    if (!($ != null && $.target)) {
      G(null);
      return;
    }
    const X = document.querySelector($.target);
    if (X) {
      const R = X.getBoundingClientRect();
      G(R);
    } else
      G(null);
  }, [$]), de = te(() => {
    if (!L || ($ == null ? void 0 : $.placement) === "center")
      return {
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
      };
    const X = ($ == null ? void 0 : $.spotlightPadding) || 12, R = 360, H = 200;
    switch ($ == null ? void 0 : $.placement) {
      case "top":
        return {
          top: `${L.top - H - X}px`,
          left: `${L.left + L.width / 2}px`,
          transform: "translateX(-50%)"
        };
      case "bottom":
        return {
          top: `${L.bottom + X}px`,
          left: `${L.left + L.width / 2}px`,
          transform: "translateX(-50%)"
        };
      case "left":
        return {
          top: `${L.top + L.height / 2}px`,
          left: `${L.left - R - X}px`,
          transform: "translateY(-50%)"
        };
      case "right":
        return {
          top: `${L.top + L.height / 2}px`,
          left: `${L.right + X}px`,
          transform: "translateY(-50%)"
        };
      default:
        return {
          top: `${L.bottom + X}px`,
          left: `${L.left + L.width / 2}px`,
          transform: "translateX(-50%)"
        };
    }
  }, [L, $]), I = te(
    async (X) => {
      if (X < 0 || X >= r.length) return;
      const R = r[X];
      R.beforeShow && !await R.beforeShow() || (v(!0), Y(X), y == null || y(X, R), N == null || N(O()), setTimeout(() => {
        var H;
        (H = R.afterShow) == null || H.call(R), v(!1);
      }, 300));
    },
    [r, y, N, O]
  ), se = te(() => {
    $ && z((X) => new Set(X).add($.id)), x ? (D == null || D(O()), T(!1)) : I(K + 1);
  }, [$, x, K, I, D, O]), oe = te(() => {
    I(K - 1);
  }, [K, I]), Z = te(() => {
    ($ == null ? void 0 : $.canSkip) !== !1 && w && se();
  }, [$, w, se]), V = te(() => {
    E == null || E(O()), T(!1);
  }, [E, O]);
  if (te(() => {
    T(!0), Y(0), z(/* @__PURE__ */ new Set()), j == null || j();
  }, [j]), qe(() => (F(), window.addEventListener("resize", F), window.addEventListener("scroll", F, !0), () => {
    window.removeEventListener("resize", F), window.removeEventListener("scroll", F, !0);
  }), [F, K]), qe(() => (m > 0 && !($ != null && $.waitForInteraction) && (c.current = setTimeout(se, m)), () => {
    c.current && clearTimeout(c.current);
  }), [K, m, se, $]), qe(() => {
    T(p);
  }, [p]), !U || !$)
    return null;
  const ie = de();
  return /* @__PURE__ */ t(me, { children: [
    S && $.showSpotlight !== !1 && L && /* @__PURE__ */ e("div", { className: "fixed inset-0 z-50 pointer-events-none", children: /* @__PURE__ */ t("svg", { className: "w-full h-full", children: [
      /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ t("mask", { id: `spotlight-mask-${C}`, children: [
        /* @__PURE__ */ e("rect", { x: "0", y: "0", width: "100%", height: "100%", fill: "white" }),
        /* @__PURE__ */ e(
          "rect",
          {
            x: L.left - ($.spotlightPadding || 8),
            y: L.top - ($.spotlightPadding || 8),
            width: L.width + ($.spotlightPadding || 8) * 2,
            height: L.height + ($.spotlightPadding || 8) * 2,
            rx: "8",
            fill: "black"
          }
        )
      ] }) }),
      /* @__PURE__ */ e(
        "rect",
        {
          x: "0",
          y: "0",
          width: "100%",
          height: "100%",
          fill: "hsl(var(--ds-background))",
          fillOpacity: g,
          mask: `url(#spotlight-mask-${C})`,
          className: "pointer-events-auto",
          onClick: s ? V : void 0
        }
      )
    ] }) }),
    /* @__PURE__ */ t(
      "div",
      {
        ref: b,
        className: l(
          "fixed z-50 w-[360px] transition-all duration-300",
          Q && "opacity-0 scale-95",
          !Q && "opacity-100 scale-100",
          M
        ),
        style: ie,
        children: [
          /* @__PURE__ */ t(ne, { className: "shadow-2xl", variant: "elevated", children: [
            /* @__PURE__ */ t("div", { className: "p-4 border-b", children: [
              /* @__PURE__ */ t("div", { className: "flex items-center justify-between", children: [
                /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
                  i && /* @__PURE__ */ t(ae, { variant: "default", className: "bg-primary/10 text-primary", children: [
                    /* @__PURE__ */ e(Te, { className: "h-3 w-3 mr-1" }),
                    i
                  ] }),
                  _ && /* @__PURE__ */ t(a, { variant: "caption", className: "text-muted-foreground", children: [
                    K + 1,
                    " ",
                    d.stepOf,
                    " ",
                    r.length
                  ] })
                ] }),
                s && /* @__PURE__ */ e(u, { variant: "ghost", size: "sm", onClick: V, children: /* @__PURE__ */ e(he, { className: "h-4 w-4" }) })
              ] }),
              A && /* @__PURE__ */ e(na, { value: f, className: "h-1 mt-3" })
            ] }),
            /* @__PURE__ */ e("div", { className: "p-4", children: /* @__PURE__ */ t("div", { className: "flex items-start gap-3", children: [
              /* @__PURE__ */ e("div", { className: "rounded-full p-2 bg-primary/10 text-primary shrink-0", children: /* @__PURE__ */ e(Os, { className: "h-5 w-5" }) }),
              /* @__PURE__ */ t("div", { className: "flex-1", children: [
                /* @__PURE__ */ e(a, { variant: "h4", className: "font-semibold mb-2", children: $.title }),
                typeof $.content == "string" ? /* @__PURE__ */ e(a, { variant: "body", className: "text-muted-foreground", children: $.content }) : $.content,
                $.image && /* @__PURE__ */ e(
                  "img",
                  {
                    src: $.image,
                    alt: $.title,
                    className: "mt-4 rounded-lg w-full"
                  }
                ),
                $.video && /* @__PURE__ */ e(
                  "video",
                  {
                    src: $.video,
                    controls: !0,
                    className: "mt-4 rounded-lg w-full"
                  }
                ),
                $.actions && $.actions.length > 0 && /* @__PURE__ */ e("div", { className: "flex items-center gap-2 mt-4", children: $.actions.map((X, R) => /* @__PURE__ */ e(
                  u,
                  {
                    variant: X.variant || "outline",
                    size: "sm",
                    onClick: X.action,
                    children: X.label
                  },
                  R
                )) })
              ] })
            ] }) }),
            /* @__PURE__ */ e("div", { className: "p-4 border-t bg-muted/30", children: /* @__PURE__ */ t("div", { className: "flex items-center justify-between", children: [
              /* @__PURE__ */ e("div", { children: !o && /* @__PURE__ */ t(u, { variant: "ghost", size: "sm", onClick: oe, children: [
                /* @__PURE__ */ e(vt, { className: "h-4 w-4 mr-1" }),
                d.back
              ] }) }),
              /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: [
                w && !x && $.canSkip !== !1 && /* @__PURE__ */ t(u, { variant: "ghost", size: "sm", onClick: Z, children: [
                  /* @__PURE__ */ e(Ca, { className: "h-4 w-4 mr-1" }),
                  d.skip
                ] }),
                /* @__PURE__ */ e(u, { variant: "primary", size: "sm", onClick: se, children: x ? /* @__PURE__ */ t(me, { children: [
                  /* @__PURE__ */ e(fe, { className: "h-4 w-4 mr-1" }),
                  d.finish
                ] }) : /* @__PURE__ */ t(me, { children: [
                  d.next,
                  /* @__PURE__ */ e(Ne, { className: "h-4 w-4 ml-1" })
                ] }) })
              ] })
            ] }) })
          ] }),
          L && $.placement !== "center" && /* @__PURE__ */ e(
            "div",
            {
              className: l(
                "absolute w-3 h-3 bg-card rotate-45 border",
                $.placement === "top" && "bottom-[-6px] left-1/2 -translate-x-1/2 border-t-0 border-l-0",
                $.placement === "bottom" && "top-[-6px] left-1/2 -translate-x-1/2 border-b-0 border-r-0",
                $.placement === "left" && "right-[-6px] top-1/2 -translate-y-1/2 border-l-0 border-b-0",
                $.placement === "right" && "left-[-6px] top-1/2 -translate-y-1/2 border-r-0 border-t-0"
              )
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ e("div", { className: "fixed bottom-4 left-1/2 -translate-x-1/2 z-50", children: /* @__PURE__ */ e("div", { className: "flex items-center gap-1.5 p-2 bg-background rounded-full shadow-lg border", children: r.map((X, R) => /* @__PURE__ */ e(
      "button",
      {
        type: "button",
        className: l(
          "w-2 h-2 rounded-full transition-all",
          R === K ? "w-6 bg-primary" : h.has(X.id) ? "bg-success" : "bg-muted hover:bg-muted-foreground/30"
        ),
        onClick: () => I(R),
        title: X.title
      },
      X.id
    )) }) })
  ] });
};
Mi.displayName = "GuidedTour";
export {
  tl as A,
  al as B,
  nl as C,
  rl as D,
  cl as E,
  ll as F,
  Mi as G,
  rt as H,
  dl as I,
  ii as K,
  Jl as M,
  kl as N,
  ml as O,
  vl as P,
  sl as Q,
  Xe as R,
  il as S,
  hl as T,
  gl as U,
  Il as V,
  pi as W,
  ol as a,
  tn as b,
  bt as c,
  an as d,
  rn as e,
  sn as f,
  pl as g,
  fl as h,
  Nl as i,
  bl as j,
  wl as k,
  Ml as l,
  jl as m,
  _l as n,
  Ll as o,
  Kl as p,
  Bl as q,
  Wl as r,
  Ql as s,
  ti as t,
  ri as u,
  ci as v,
  mi as w,
  gi as x,
  bi as y,
  ki as z
};
